/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/workbench/workbench.web.main.nls", {
	"vs/base/browser/ui/actionbar/actionViewItems": [
		"{0} ({1})"
	],
	"vs/base/browser/ui/dialog/dialog": [
		"OK",
		"Info",
		"Error",
		"Warning",
		"In Progress",
		"Close Dialog"
	],
	"vs/base/browser/ui/findinput/findInput": [
		"input"
	],
	"vs/base/browser/ui/findinput/findInputCheckboxes": [
		"Match Case",
		"Match Whole Word",
		"Use Regular Expression"
	],
	"vs/base/browser/ui/findinput/replaceInput": [
		"input",
		"Preserve Case"
	],
	"vs/base/browser/ui/iconLabel/iconLabelHover": [
		"Loading..."
	],
	"vs/base/browser/ui/inputbox/inputBox": [
		"Error: {0}",
		"Warning: {0}",
		"Info: {0}",
		"for history"
	],
	"vs/base/browser/ui/keybindingLabel/keybindingLabel": [
		"Unbound"
	],
	"vs/base/browser/ui/menu/menubar": [
		"Application Menu",
		"More"
	],
	"vs/base/browser/ui/selectBox/selectBoxCustom": [
		"Select Box"
	],
	"vs/base/browser/ui/splitview/paneview": [
		"{0} Section"
	],
	"vs/base/browser/ui/toolbar/toolbar": [
		"More Actions..."
	],
	"vs/base/browser/ui/tree/abstractTree": [
		"Clear",
		"Disable Filter on Type",
		"Enable Filter on Type",
		"No elements found",
		"Matched {0} out of {1} elements"
	],
	"vs/base/browser/ui/tree/treeDefaults": [
		"Collapse All"
	],
	"vs/base/common/actions": [
		"(empty)"
	],
	"vs/base/common/date": [
		"in {0}",
		"now",
		"{0} second ago",
		"{0} sec ago",
		"{0} seconds ago",
		"{0} secs ago",
		"{0} second",
		"{0} sec",
		"{0} seconds",
		"{0} secs",
		"{0} minute ago",
		"{0} min ago",
		"{0} minutes ago",
		"{0} mins ago",
		"{0} minute",
		"{0} min",
		"{0} minutes",
		"{0} mins",
		"{0} hour ago",
		"{0} hr ago",
		"{0} hours ago",
		"{0} hrs ago",
		"{0} hour",
		"{0} hr",
		"{0} hours",
		"{0} hrs",
		"{0} day ago",
		"{0} days ago",
		"{0} day",
		"{0} days",
		"{0} week ago",
		"{0} wk ago",
		"{0} weeks ago",
		"{0} wks ago",
		"{0} week",
		"{0} wk",
		"{0} weeks",
		"{0} wks",
		"{0} month ago",
		"{0} mo ago",
		"{0} months ago",
		"{0} mos ago",
		"{0} month",
		"{0} mo",
		"{0} months",
		"{0} mos",
		"{0} year ago",
		"{0} yr ago",
		"{0} years ago",
		"{0} yrs ago",
		"{0} year",
		"{0} yr",
		"{0} years",
		"{0} yrs"
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"A system error occurred ({0})",
		"An unknown error occurred. Please consult the log for more details.",
		"An unknown error occurred. Please consult the log for more details.",
		"{0} ({1} errors in total)",
		"An unknown error occurred. Please consult the log for more details."
	],
	"vs/base/common/jsonErrorMessages": [
		"Invalid symbol",
		"Invalid number format",
		"Property name expected",
		"Value expected",
		"Colon expected",
		"Comma expected",
		"Closing brace expected",
		"Closing bracket expected",
		"End of file expected"
	],
	"vs/base/common/keybindingLabels": [
		"Ctrl",
		"Shift",
		"Alt",
		"Windows",
		"Ctrl",
		"Shift",
		"Alt",
		"Super",
		"Control",
		"Shift",
		"Option",
		"Command",
		"Control",
		"Shift",
		"Alt",
		"Windows",
		"Control",
		"Shift",
		"Alt",
		"Super"
	],
	"vs/base/parts/quickinput/browser/quickInput": [
		"Back",
		"Press 'Enter' to confirm your input or 'Escape' to cancel",
		"{0}/{1}",
		"Type to narrow down results.",
		"{0} (Press 'Enter' to confirm or 'Escape' to cancel)",
		"{0} Results",
		"{0} Selected",
		"OK",
		"Custom",
		"Back ({0})",
		"Back"
	],
	"vs/base/parts/quickinput/browser/quickInputList": [
		"Quick Input"
	],
	"vs/editor/browser/controller/textAreaHandler": [
		"editor",
		"The editor is not accessible at this time. Press {0} for options."
	],
	"vs/editor/browser/coreCommands": [
		"Stick to the end even when going to longer lines",
		"Stick to the end even when going to longer lines",
		"Removed secondary cursors"
	],
	"vs/editor/browser/editorExtensions": [
		"&&Undo",
		"Undo",
		"&&Redo",
		"Redo",
		"&&Select All",
		"Select All"
	],
	"vs/editor/browser/widget/codeEditorWidget": [
		"The number of cursors has been limited to {0}."
	],
	"vs/editor/browser/widget/diffEditorWidget": [
		"Line decoration for inserts in the diff editor.",
		"Line decoration for removals in the diff editor.",
		"Cannot compare files because one file is too large."
	],
	"vs/editor/browser/widget/diffReview": [
		"Icon for 'Insert' in diff review.",
		"Icon for 'Remove' in diff review.",
		"Icon for 'Close' in diff review.",
		"Close",
		"no lines changed",
		"1 line changed",
		"{0} lines changed",
		"Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}",
		"blank",
		"{0} unchanged line {1}",
		"{0} original line {1} modified line {2}",
		"+ {0} modified line {1}",
		"- {0} original line {1}",
		"Go to Next Difference",
		"Go to Previous Difference"
	],
	"vs/editor/browser/widget/inlineDiffMargin": [
		"Copy deleted lines",
		"Copy deleted line",
		"Copy changed lines",
		"Copy changed line",
		"Copy deleted line ({0})",
		"Copy changed line ({0})",
		"Revert this change",
		"Copy deleted line ({0})",
		"Copy changed line ({0})"
	],
	"vs/editor/common/config/editorConfigurationSchema": [
		"Editor",
		"The number of spaces a tab is equal to. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.",
		"Insert spaces when pressing `Tab`. This setting is overridden based on the file contents when `#editor.detectIndentation#` is on.",
		"Controls whether `#editor.tabSize#` and `#editor.insertSpaces#` will be automatically detected when a file is opened based on the file contents.",
		"Remove trailing auto inserted whitespace.",
		"Special handling for large files to disable certain memory intensive features.",
		"Controls whether completions should be computed based on words in the document.",
		"Only suggest words from the active document.",
		"Suggest words from all open documents of the same language.",
		"Suggest words from all open documents.",
		"Controls from which documents word based completions are computed.",
		"Semantic highlighting enabled for all color themes.",
		"Semantic highlighting disabled for all color themes.",
		"Semantic highlighting is configured by the current color theme's `semanticHighlighting` setting.",
		"Controls whether the semanticHighlighting is shown for the languages that support it.",
		"Keep peek editors open even when double clicking their content or when hitting `Escape`.",
		"Lines above this length will not be tokenized for performance reasons",
		"Defines the bracket symbols that increase or decrease the indentation.",
		"The opening bracket character or string sequence.",
		"The closing bracket character or string sequence.",
		"Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled.",
		"The opening bracket character or string sequence.",
		"The closing bracket character or string sequence.",
		"Timeout in milliseconds after which diff computation is cancelled. Use 0 for no timeout.",
		"Maximum file size in MB for which to compute diffs. Use 0 for no limit.",
		"Controls whether the diff editor shows the diff side by side or inline.",
		"When enabled, the diff editor ignores changes in leading or trailing whitespace.",
		"Controls whether the diff editor shows +/- indicators for added/removed changes.",
		"Controls whether the editor shows CodeLens.",
		"Lines will never wrap.",
		"Lines will wrap at the viewport width.",
		"Lines will wrap according to the `#editor.wordWrap#` setting."
	],
	"vs/editor/common/config/editorOptions": [
		"The editor will use platform APIs to detect when a Screen Reader is attached.",
		"The editor will be permanently optimized for usage with a Screen Reader. Word wrapping will be disabled.",
		"The editor will never be optimized for usage with a Screen Reader.",
		"Controls whether the editor should run in a mode where it is optimized for screen readers. Setting to on will disable word wrapping.",
		"Controls whether a space character is inserted when commenting.",
		"Controls if empty lines should be ignored with toggle, add or remove actions for line comments.",
		"Controls whether copying without a selection copies the current line.",
		"Controls whether the cursor should jump to find matches while typing.",
		"Never seed search string from the editor selection.",
		"Always seed search string from the editor selection, including word at cursor position.",
		"Only seed search string from the editor selection.",
		"Controls whether the search string in the Find Widget is seeded from the editor selection.",
		"Never turn on Find in Selection automatically (default).",
		"Always turn on Find in Selection automatically.",
		"Turn on Find in Selection automatically when multiple lines of content are selected.",
		"Controls the condition for turning on Find in Selection automatically.",
		"Controls whether the Find Widget should read or modify the shared find clipboard on macOS.",
		"Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.",
		"Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.",
		"Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.",
		"Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.",
		"Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property.",
		"Controls the font size in pixels.",
		"Only \"normal\" and \"bold\" keywords or numbers between 1 and 1000 are allowed.",
		"Controls the font weight. Accepts \"normal\" and \"bold\" keywords or numbers between 1 and 1000.",
		"Show peek view of the results (default)",
		"Go to the primary result and show a peek view",
		"Go to the primary result and enable peek-less navigation to others",
		"This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.",
		"Controls the behavior the 'Go to Definition'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Declaration'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Implementations'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to References'-command when multiple target locations exist.",
		"Alternative command id that is being executed when the result of 'Go to Definition' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Reference' is the current location.",
		"Controls whether the hover is shown.",
		"Controls the delay in milliseconds after which the hover is shown.",
		"Controls whether the hover should remain visible when mouse is moved over it.",
		"Prefer showing hovers above the line, if there's space.",
		"Enables the code action lightbulb in the editor.",
		"Enables the inlay hints in the editor.",
		"Controls font size of inlay hints in the editor. A default of 90% of `#editor.fontSize#` is used when the configured value is less than `5` or greater than the editor font size.",
		"Controls font family of inlay hints in the editor. When set to empty, the `#editor.fontFamily#` is used.",
		"Controls the line height. \n - Use 0 to automatically compute the line height from the font size.\n - Values between 0 and 8 will be used as a multiplier with the font size.\n - Values greater than or equal to 8 will be used as effective values.",
		"Controls whether the minimap is shown.",
		"The minimap has the same size as the editor contents (and might scroll).",
		"The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling).",
		"The minimap will shrink as necessary to never be larger than the editor (no scrolling).",
		"Controls the size of the minimap.",
		"Controls the side where to render the minimap.",
		"Controls when the minimap slider is shown.",
		"Scale of content drawn in the minimap: 1, 2 or 3.",
		"Render the actual characters on a line as opposed to color blocks.",
		"Limit the width of the minimap to render at most a certain number of columns.",
		"Controls the amount of space between the top edge of the editor and the first line.",
		"Controls the amount of space between the bottom edge of the editor and the last line.",
		"Enables a pop-up that shows parameter documentation and type information as you type.",
		"Controls whether the parameter hints menu cycles or closes when reaching the end of the list.",
		"Enable quick suggestions inside strings.",
		"Enable quick suggestions inside comments.",
		"Enable quick suggestions outside of strings and comments.",
		"Controls whether suggestions should automatically show up while typing.",
		"Line numbers are not rendered.",
		"Line numbers are rendered as absolute number.",
		"Line numbers are rendered as distance in lines to cursor position.",
		"Line numbers are rendered every 10 lines.",
		"Controls the display of line numbers.",
		"Number of monospace characters at which this editor ruler will render.",
		"Color of this editor ruler.",
		"Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.",
		"The vertical scrollbar will be visible only when necessary.",
		"The vertical scrollbar will always be visible.",
		"The vertical scrollbar will always be hidden.",
		"Controls the visibility of the vertical scrollbar.",
		"The horizontal scrollbar will be visible only when necessary.",
		"The horizontal scrollbar will always be visible.",
		"The horizontal scrollbar will always be hidden.",
		"Controls the visibility of the horizontal scrollbar.",
		"The width of the vertical scrollbar.",
		"The height of the horizontal scrollbar.",
		"Controls whether clicks scroll by page or jump to click position.",
		"Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.",
		"Controls whether characters that just reserve space or have no width at all are highlighted.",
		"Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.",
		"Controls whether characters in comments should also be subject to unicode highlighting.",
		"Controls whether characters in strings should also be subject to unicode highlighting.",
		"Defines allowed characters that are not being highlighted.",
		"Unicode characters that are common in allowed locales are not being highlighted.",
		"Controls whether to automatically show inline suggestions in the editor.",
		"Controls whether bracket pair colorization is enabled or not. Use 'workbench.colorCustomizations' to override the bracket highlight colors.",
		"Enables bracket pair guides.",
		"Enables bracket pair guides only for the active bracket pair.",
		"Disables bracket pair guides.",
		"Controls whether bracket pair guides are enabled or not.",
		"Enables horizontal guides as addition to vertical bracket pair guides.",
		"Enables horizontal guides only for the active bracket pair.",
		"Disables horizontal bracket pair guides.",
		"Controls whether horizontal bracket pair guides are enabled or not.",
		"Controls whether the editor should highlight the active bracket pair.",
		"Controls whether the editor should render indent guides.",
		"Controls whether the editor should highlight the active indent guide.",
		"Insert suggestion without overwriting text right of the cursor.",
		"Insert suggestion and overwrite text right of the cursor.",
		"Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.",
		"Controls whether filtering and sorting suggestions accounts for small typos.",
		"Controls whether sorting favors words that appear close to the cursor.",
		"Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).",
		"Controls whether an active snippet prevents quick suggestions.",
		"Controls whether to show or hide icons in suggestions.",
		"Controls the visibility of the status bar at the bottom of the suggest widget.",
		"Controls whether to preview the suggestion outcome in the editor.",
		"Controls whether suggest details show inline with the label or only in the details widget",
		"This setting is deprecated. The suggest widget can now be resized.",
		"This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.",
		"When enabled IntelliSense shows `method`-suggestions.",
		"When enabled IntelliSense shows `function`-suggestions.",
		"When enabled IntelliSense shows `constructor`-suggestions.",
		"When enabled IntelliSense shows `deprecated`-suggestions.",
		"When enabled IntelliSense shows `field`-suggestions.",
		"When enabled IntelliSense shows `variable`-suggestions.",
		"When enabled IntelliSense shows `class`-suggestions.",
		"When enabled IntelliSense shows `struct`-suggestions.",
		"When enabled IntelliSense shows `interface`-suggestions.",
		"When enabled IntelliSense shows `module`-suggestions.",
		"When enabled IntelliSense shows `property`-suggestions.",
		"When enabled IntelliSense shows `event`-suggestions.",
		"When enabled IntelliSense shows `operator`-suggestions.",
		"When enabled IntelliSense shows `unit`-suggestions.",
		"When enabled IntelliSense shows `value`-suggestions.",
		"When enabled IntelliSense shows `constant`-suggestions.",
		"When enabled IntelliSense shows `enum`-suggestions.",
		"When enabled IntelliSense shows `enumMember`-suggestions.",
		"When enabled IntelliSense shows `keyword`-suggestions.",
		"When enabled IntelliSense shows `text`-suggestions.",
		"When enabled IntelliSense shows `color`-suggestions.",
		"When enabled IntelliSense shows `file`-suggestions.",
		"When enabled IntelliSense shows `reference`-suggestions.",
		"When enabled IntelliSense shows `customcolor`-suggestions.",
		"When enabled IntelliSense shows `folder`-suggestions.",
		"When enabled IntelliSense shows `typeParameter`-suggestions.",
		"When enabled IntelliSense shows `snippet`-suggestions.",
		"When enabled IntelliSense shows `user`-suggestions.",
		"When enabled IntelliSense shows `issues`-suggestions.",
		"Whether leading and trailing whitespace should always be selected.",
		"Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`;`) can be a commit character that accepts a suggestion and types that character.",
		"Only accept a suggestion with `Enter` when it makes a textual change.",
		"Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.",
		"Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default.",
		"Editor content",
		"Use language configurations to determine when to autoclose brackets.",
		"Autoclose brackets only when the cursor is to the left of whitespace.",
		"Controls whether the editor should automatically close brackets after the user adds an opening bracket.",
		"Remove adjacent closing quotes or brackets only if they were automatically inserted.",
		"Controls whether the editor should remove adjacent closing quotes or brackets when deleting.",
		"Type over closing quotes or brackets only if they were automatically inserted.",
		"Controls whether the editor should type over closing quotes or brackets.",
		"Use language configurations to determine when to autoclose quotes.",
		"Autoclose quotes only when the cursor is to the left of whitespace.",
		"Controls whether the editor should automatically close quotes after the user adds an opening quote.",
		"The editor will not insert indentation automatically.",
		"The editor will keep the current line's indentation.",
		"The editor will keep the current line's indentation and honor language defined brackets.",
		"The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages.",
		"The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.",
		"Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.",
		"Use language configurations to determine when to automatically surround selections.",
		"Surround with quotes but not brackets.",
		"Surround with brackets but not quotes.",
		"Controls whether the editor should automatically surround selections when typing quotes or brackets.",
		"Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.",
		"Controls whether the editor shows CodeLens.",
		"Controls the font family for CodeLens.",
		"Controls the font size in pixels for CodeLens. When set to `0`, 90% of `#editor.fontSize#` is used.",
		"Controls whether the editor should render the inline color decorators and color picker.",
		"Enable that the selection with the mouse and keys is doing column selection.",
		"Controls whether syntax highlighting should be copied into the clipboard.",
		"Control the cursor animation style.",
		"Controls whether the smooth caret animation should be enabled.",
		"Controls the cursor style.",
		"Controls the minimal number of visible leading and trailing lines surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.",
		"`cursorSurroundingLines` is enforced only when triggered via the keyboard or API.",
		"`cursorSurroundingLines` is enforced always.",
		"Controls when `cursorSurroundingLines` should be enforced.",
		"Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.",
		"Controls whether the editor should allow moving selections via drag and drop.",
		"Scrolling speed multiplier when pressing `Alt`.",
		"Controls whether the editor has code folding enabled.",
		"Use a language-specific folding strategy if available, else the indentation-based one.",
		"Use the indentation-based folding strategy.",
		"Controls the strategy for computing folding ranges.",
		"Controls whether the editor should highlight folded ranges.",
		"Controls whether the editor automatically collapses import ranges.",
		"The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.",
		"Controls whether clicking on the empty content after a folded line will unfold the line.",
		"Controls the font family.",
		"Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.",
		"Controls whether the editor should automatically format the line after typing.",
		"Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.",
		"Controls whether the cursor should be hidden in the overview ruler.",
		"Controls the letter spacing in pixels.",
		"Controls whether the editor has linked editing enabled. Depending on the language, related symbols, e.g. HTML tags, are updated while editing.",
		"Controls whether the editor should detect links and make them clickable.",
		"Highlight matching brackets.",
		"A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.",
		"Zoom the font of the editor when using mouse wheel and holding `Ctrl`.",
		"Merge multiple cursors when they are overlapping.",
		"Maps to `Control` on Windows and Linux and to `Command` on macOS.",
		"Maps to `Alt` on Windows and Linux and to `Option` on macOS.",
		"The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the multicursor modifier. [Read more](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).",
		"Each cursor pastes a single line of the text.",
		"Each cursor pastes the full text.",
		"Controls pasting when the line count of the pasted text matches the cursor count.",
		"Controls whether the editor should highlight semantic symbol occurrences.",
		"Controls whether a border should be drawn around the overview ruler.",
		"Focus the tree when opening peek",
		"Focus the editor when opening peek",
		"Controls whether to focus the inline editor or the tree in the peek widget.",
		"Controls whether the Go to Definition mouse gesture always opens the peek widget.",
		"Controls the delay in milliseconds after which quick suggestions will show up.",
		"Controls whether the editor auto renames on type.",
		"Deprecated, use `editor.linkedEditing` instead.",
		"Controls whether the editor should render control characters.",
		"Render last line number when the file ends with a newline.",
		"Highlights both the gutter and the current line.",
		"Controls how the editor should render the current line highlight.",
		"Controls if the editor should render the current line highlight only when the editor is focused.",
		"Render whitespace characters except for single spaces between words.",
		"Render whitespace characters only on selected text.",
		"Render only trailing whitespace characters.",
		"Controls how the editor should render whitespace characters.",
		"Controls whether selections should have rounded corners.",
		"Controls the number of extra characters beyond which the editor will scroll horizontally.",
		"Controls whether the editor will scroll beyond the last line.",
		"Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.",
		"Controls whether the Linux primary clipboard should be supported.",
		"Controls whether the editor should highlight matches similar to the selection.",
		"Always show the folding controls.",
		"Only show the folding controls when the mouse is over the gutter.",
		"Controls when the folding controls on the gutter are shown.",
		"Controls fading out of unused code.",
		"Controls strikethrough deprecated variables.",
		"Show snippet suggestions on top of other suggestions.",
		"Show snippet suggestions below other suggestions.",
		"Show snippets suggestions with other suggestions.",
		"Do not show snippet suggestions.",
		"Controls whether snippets are shown with other suggestions and how they are sorted.",
		"Controls whether the editor will scroll using an animation.",
		"Font size for the suggest widget. When set to `0`, the value of `#editor.fontSize#` is used.",
		"Line height for the suggest widget. When set to `0`, the value of `#editor.lineHeight#` is used. The minimum value is 8.",
		"Controls whether suggestions should automatically show up when typing trigger characters.",
		"Always select the first suggestion.",
		"Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently.",
		"Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.",
		"Controls how suggestions are pre-selected when showing the suggest list.",
		"Tab complete will insert the best matching suggestion when pressing tab.",
		"Disable tab completions.",
		"Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.",
		"Enables tab completions.",
		"Unusual line terminators are automatically removed.",
		"Unusual line terminators are ignored.",
		"Unusual line terminators prompt to be removed.",
		"Remove unusual line terminators that might cause problems.",
		"Inserting and deleting whitespace follows tab stops.",
		"Characters that will be used as word separators when doing word related navigations or operations.",
		"Lines will never wrap.",
		"Lines will wrap at the viewport width.",
		"Lines will wrap at `#editor.wordWrapColumn#`.",
		"Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.",
		"Controls how lines should wrap.",
		"Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.",
		"No indentation. Wrapped lines begin at column 1.",
		"Wrapped lines get the same indentation as the parent.",
		"Wrapped lines get +1 indentation toward the parent.",
		"Wrapped lines get +2 indentation toward the parent.",
		"Controls the indentation of wrapped lines.",
		"Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width.",
		"Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.",
		"Controls the algorithm that computes wrapping points."
	],
	"vs/editor/common/core/editorColorRegistry": [
		"Background color for the highlight of line at the cursor position.",
		"Background color for the border around the line at the cursor position.",
		"Background color of highlighted ranges, like by quick open and find features. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of the border around highlighted ranges.",
		"Background color of highlighted symbol, like for go to definition or go next/previous symbol. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of the border around highlighted symbols.",
		"Color of the editor cursor.",
		"The background color of the editor cursor. Allows customizing the color of a character overlapped by a block cursor.",
		"Color of whitespace characters in the editor.",
		"Color of the editor indentation guides.",
		"Color of the active editor indentation guides.",
		"Color of editor line numbers.",
		"Color of editor active line number",
		"Id is deprecated. Use 'editorLineNumber.activeForeground' instead.",
		"Color of editor active line number",
		"Color of the editor rulers.",
		"Foreground color of editor CodeLens",
		"Background color behind matching brackets",
		"Color for matching brackets boxes",
		"Color of the overview ruler border.",
		"Background color of the editor overview ruler. Only used when the minimap is enabled and placed on the right side of the editor.",
		"Background color of the editor gutter. The gutter contains the glyph margins and the line numbers.",
		"Border color of unnecessary (unused) source code in the editor.",
		"Opacity of unnecessary (unused) source code in the editor. For example, \"#000000c0\" will render the code with 75% opacity. For high contrast themes, use the  'editorUnnecessaryCode.border' theme color to underline unnecessary code instead of fading it out.",
		"Border color of ghost text in the editor.",
		"Foreground color of the ghost text in the editor.",
		"Background color of the ghost text in the editor.",
		"Overview ruler marker color for range highlights. The color must not be opaque so as not to hide underlying decorations.",
		"Overview ruler marker color for errors.",
		"Overview ruler marker color for warnings.",
		"Overview ruler marker color for infos.",
		"Foreground color of brackets (1). Requires enabling bracket pair colorization.",
		"Foreground color of brackets (2). Requires enabling bracket pair colorization.",
		"Foreground color of brackets (3). Requires enabling bracket pair colorization.",
		"Foreground color of brackets (4). Requires enabling bracket pair colorization.",
		"Foreground color of brackets (5). Requires enabling bracket pair colorization.",
		"Foreground color of brackets (6). Requires enabling bracket pair colorization.",
		"Foreground color of unexpected brackets.",
		"Background color of inactive bracket pair guides (1). Requires enabling bracket pair guides.",
		"Background color of inactive bracket pair guides (2). Requires enabling bracket pair guides.",
		"Background color of inactive bracket pair guides (3). Requires enabling bracket pair guides.",
		"Background color of inactive bracket pair guides (4). Requires enabling bracket pair guides.",
		"Background color of inactive bracket pair guides (5). Requires enabling bracket pair guides.",
		"Background color of inactive bracket pair guides (6). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (1). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (2). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (3). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (4). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (5). Requires enabling bracket pair guides.",
		"Background color of active bracket pair guides (6). Requires enabling bracket pair guides.",
		"Border color used to highlight unicode characters."
	],
	"vs/editor/common/editorContextKeys": [
		"Whether the editor text has focus (cursor is blinking)",
		"Whether the editor or an editor widget has focus (e.g. focus is in the find widget)",
		"Whether an editor or a rich text input has focus (cursor is blinking)",
		"Whether the editor is read only",
		"Whether the context is a diff editor",
		"Whether `editor.columnSelection` is enabled",
		"Whether the editor has text selected",
		"Whether the editor has multiple selections",
		"Whether `Tab` will move focus out of the editor",
		"Whether the editor hover is visible",
		"Whether the editor is part of a larger editor (e.g. notebooks)",
		"The language identifier of the editor",
		"Whether the editor has a completion item provider",
		"Whether the editor has a code actions provider",
		"Whether the editor has a code lens provider",
		"Whether the editor has a definition provider",
		"Whether the editor has a declaration provider",
		"Whether the editor has an implementation provider",
		"Whether the editor has a type definition provider",
		"Whether the editor has a hover provider",
		"Whether the editor has a document highlight provider",
		"Whether the editor has a document symbol provider",
		"Whether the editor has a reference provider",
		"Whether the editor has a rename provider",
		"Whether the editor has a signature help provider",
		"Whether the editor has an inline hints provider",
		"Whether the editor has a document formatting provider",
		"Whether the editor has a document selection formatting provider",
		"Whether the editor has multiple document formatting providers",
		"Whether the editor has multiple document selection formatting providers"
	],
	"vs/editor/common/languages/modesRegistry": [
		"Plain Text"
	],
	"vs/editor/common/model/editStack": [
		"Typing"
	],
	"vs/editor/common/standaloneStrings": [
		"No selection",
		"Line {0}, Column {1} ({2} selected)",
		"Line {0}, Column {1}",
		"{0} selections ({1} characters selected)",
		"{0} selections",
		"Now changing the setting `accessibilitySupport` to 'on'.",
		"Now opening the Editor Accessibility documentation page.",
		" in a read-only pane of a diff editor.",
		" in a pane of a diff editor.",
		" in a read-only code editor",
		" in a code editor",
		"To configure the editor to be optimized for usage with a Screen Reader press Command+E now.",
		"To configure the editor to be optimized for usage with a Screen Reader press Control+E now.",
		"The editor is configured to be optimized for usage with a Screen Reader.",
		"The editor is configured to never be optimized for usage with a Screen Reader, which is not the case at this time.",
		"Pressing Tab in the current editor will move focus to the next focusable element. Toggle this behavior by pressing {0}.",
		"Pressing Tab in the current editor will move focus to the next focusable element. The command {0} is currently not triggerable by a keybinding.",
		"Pressing Tab in the current editor will insert the tab character. Toggle this behavior by pressing {0}.",
		"Pressing Tab in the current editor will insert the tab character. The command {0} is currently not triggerable by a keybinding.",
		"Press Command+H now to open a browser window with more information related to editor accessibility.",
		"Press Control+H now to open a browser window with more information related to editor accessibility.",
		"You can dismiss this tooltip and return to the editor by pressing Escape or Shift+Escape.",
		"Show Accessibility Help",
		"Developer: Inspect Tokens",
		"Go to Line/Column...",
		"Show all Quick Access Providers",
		"Command Palette",
		"Show And Run Commands",
		"Go to Symbol...",
		"Go to Symbol by Category...",
		"Editor content",
		"Press Alt+F1 for Accessibility Options.",
		"Toggle High Contrast Theme",
		"Made {0} edits in {1} files"
	],
	"vs/editor/contrib/anchorSelect/browser/anchorSelect": [
		"Selection Anchor",
		"Anchor set at {0}:{1}",
		"Set Selection Anchor",
		"Go to Selection Anchor",
		"Select from Anchor to Cursor",
		"Cancel Selection Anchor"
	],
	"vs/editor/contrib/bracketMatching/browser/bracketMatching": [
		"Overview ruler marker color for matching brackets.",
		"Go to Bracket",
		"Select to Bracket",
		"Go to &&Bracket"
	],
	"vs/editor/contrib/caretOperations/browser/caretOperations": [
		"Move Selected Text Left",
		"Move Selected Text Right"
	],
	"vs/editor/contrib/caretOperations/browser/transpose": [
		"Transpose Letters"
	],
	"vs/editor/contrib/clipboard/browser/clipboard": [
		"Cu&&t",
		"Cut",
		"Cut",
		"Cut",
		"&&Copy",
		"Copy",
		"Copy",
		"Copy",
		"Copy As",
		"Copy As",
		"&&Paste",
		"Paste",
		"Paste",
		"Paste",
		"Copy With Syntax Highlighting"
	],
	"vs/editor/contrib/codeAction/browser/codeActionCommands": [
		"Kind of the code action to run.",
		"Controls when the returned actions are applied.",
		"Always apply the first returned code action.",
		"Apply the first returned code action if it is the only one.",
		"Do not apply the returned code actions.",
		"Controls if only preferred code actions should be returned.",
		"An unknown error occurred while applying the code action",
		"Quick Fix...",
		"No code actions available",
		"No preferred code actions for '{0}' available",
		"No code actions for '{0}' available",
		"No preferred code actions available",
		"No code actions available",
		"Refactor...",
		"No preferred refactorings for '{0}' available",
		"No refactorings for '{0}' available",
		"No preferred refactorings available",
		"No refactorings available",
		"Source Action...",
		"No preferred source actions for '{0}' available",
		"No source actions for '{0}' available",
		"No preferred source actions available",
		"No source actions available",
		"Organize Imports",
		"No organize imports action available",
		"Fix All",
		"No fix all action available",
		"Auto Fix...",
		"No auto fixes available"
	],
	"vs/editor/contrib/codeAction/browser/lightBulbWidget": [
		"Show Code Actions. Preferred Quick Fix Available ({0})",
		"Show Code Actions ({0})",
		"Show Code Actions"
	],
	"vs/editor/contrib/codelens/browser/codelensController": [
		"Show CodeLens Commands For Current Line"
	],
	"vs/editor/contrib/colorPicker/browser/colorPickerWidget": [
		"Click to toggle color options (rgb/hsl/hex)"
	],
	"vs/editor/contrib/comment/browser/comment": [
		"Toggle Line Comment",
		"&&Toggle Line Comment",
		"Add Line Comment",
		"Remove Line Comment",
		"Toggle Block Comment",
		"Toggle &&Block Comment"
	],
	"vs/editor/contrib/contextmenu/browser/contextmenu": [
		"Show Editor Context Menu"
	],
	"vs/editor/contrib/cursorUndo/browser/cursorUndo": [
		"Cursor Undo",
		"Cursor Redo"
	],
	"vs/editor/contrib/editorState/browser/keybindingCancellation": [
		"Whether the editor runs a cancellable operation, e.g. like 'Peek References'"
	],
	"vs/editor/contrib/find/browser/findController": [
		"Find",
		"&&Find",
		"Overrides \"Use Regular Expression\" flag.\nThe flag will not be saved for the future.\n0: Do Nothing\n1: True\n2: False",
		"Overrides \"Match Whole Word\" flag.\nThe flag will not be saved for the future.\n0: Do Nothing\n1: True\n2: False",
		"Overrides \"Math Case\" flag.\nThe flag will not be saved for the future.\n0: Do Nothing\n1: True\n2: False",
		"Overrides \"Preserve Case\" flag.\nThe flag will not be saved for the future.\n0: Do Nothing\n1: True\n2: False",
		"Find With Arguments",
		"Find With Selection",
		"Find Next",
		"Find Previous",
		"Find Next Selection",
		"Find Previous Selection",
		"Replace",
		"&&Replace"
	],
	"vs/editor/contrib/find/browser/findWidget": [
		"Icon for 'Find in Selection' in the editor find widget.",
		"Icon to indicate that the editor find widget is collapsed.",
		"Icon to indicate that the editor find widget is expanded.",
		"Icon for 'Replace' in the editor find widget.",
		"Icon for 'Replace All' in the editor find widget.",
		"Icon for 'Find Previous' in the editor find widget.",
		"Icon for 'Find Next' in the editor find widget.",
		"Find",
		"Find",
		"Previous Match",
		"Next Match",
		"Find in Selection",
		"Close",
		"Replace",
		"Replace",
		"Replace",
		"Replace All",
		"Toggle Replace",
		"Only the first {0} results are highlighted, but all find operations work on the entire text.",
		"{0} of {1}",
		"No results",
		"{0} found",
		"{0} found for '{1}'",
		"{0} found for '{1}', at {2}",
		"{0} found for '{1}'",
		"Ctrl+Enter now inserts line break instead of replacing all. You can modify the keybinding for editor.action.replaceAll to override this behavior."
	],
	"vs/editor/contrib/folding/browser/folding": [
		"The number of foldable regions is limited to a maximum of {0}. Increase configuration option ['Folding Maximum Regions'](command:workbench.action.openSettings?[\"editor.foldingMaximumRegions\"]) to enable more.",
		"Unfold",
		"Unfold Recursively",
		"Fold",
		"Toggle Fold",
		"Fold Recursively",
		"Fold All Block Comments",
		"Fold All Regions",
		"Unfold All Regions",
		"Fold All Regions Except Selected",
		"Unfold All Regions Except Selected",
		"Fold All",
		"Unfold All",
		"Go to Parent Fold",
		"Go to Previous Folding Range",
		"Go to Next Folding Range",
		"Fold Level {0}",
		"Background color behind folded ranges. The color must not be opaque so as not to hide underlying decorations.",
		"Color of the folding control in the editor gutter."
	],
	"vs/editor/contrib/folding/browser/foldingDecorations": [
		"Icon for expanded ranges in the editor glyph margin.",
		"Icon for collapsed ranges in the editor glyph margin."
	],
	"vs/editor/contrib/fontZoom/browser/fontZoom": [
		"Editor Font Zoom In",
		"Editor Font Zoom Out",
		"Editor Font Zoom Reset"
	],
	"vs/editor/contrib/format/browser/format": [
		"Made 1 formatting edit on line {0}",
		"Made {0} formatting edits on line {1}",
		"Made 1 formatting edit between lines {0} and {1}",
		"Made {0} formatting edits between lines {1} and {2}"
	],
	"vs/editor/contrib/format/browser/formatActions": [
		"Format Document",
		"Format Selection"
	],
	"vs/editor/contrib/gotoError/browser/gotoError": [
		"Go to Next Problem (Error, Warning, Info)",
		"Icon for goto next marker.",
		"Go to Previous Problem (Error, Warning, Info)",
		"Icon for goto previous marker.",
		"Go to Next Problem in Files (Error, Warning, Info)",
		"Next &&Problem",
		"Go to Previous Problem in Files (Error, Warning, Info)",
		"Previous &&Problem"
	],
	"vs/editor/contrib/gotoError/browser/gotoErrorWidget": [
		"Error",
		"Warning",
		"Info",
		"Hint",
		"{0} at {1}. ",
		"{0} of {1} problems",
		"{0} of {1} problem",
		"Editor marker navigation widget error color.",
		"Editor marker navigation widget error heading background.",
		"Editor marker navigation widget warning color.",
		"Editor marker navigation widget warning heading background.",
		"Editor marker navigation widget info color.",
		"Editor marker navigation widget info heading background.",
		"Editor marker navigation widget background."
	],
	"vs/editor/contrib/gotoSymbol/browser/goToCommands": [
		"Peek",
		"Definitions",
		"No definition found for '{0}'",
		"No definition found",
		"Go to Definition",
		"Open Definition to the Side",
		"Peek Definition",
		"Declarations",
		"No declaration found for '{0}'",
		"No declaration found",
		"Go to Declaration",
		"No declaration found for '{0}'",
		"No declaration found",
		"Peek Declaration",
		"Type Definitions",
		"No type definition found for '{0}'",
		"No type definition found",
		"Go to Type Definition",
		"Peek Type Definition",
		"Implementations",
		"No implementation found for '{0}'",
		"No implementation found",
		"Go to Implementations",
		"Peek Implementations",
		"No references found for '{0}'",
		"No references found",
		"Go to References",
		"References",
		"Peek References",
		"References",
		"Go to Any Symbol",
		"Locations",
		"No results for '{0}'",
		"References",
		"Go to &&Definition",
		"Go to &&Declaration",
		"Go to &&Type Definition",
		"Go to &&Implementations",
		"Go to &&References"
	],
	"vs/editor/contrib/gotoSymbol/browser/link/goToDefinitionAtPosition": [
		"Click to show {0} definitions."
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesController": [
		"Whether reference peek is visible, like 'Peek References' or 'Peek Definition'",
		"Loading...",
		"{0} ({1})"
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesTree": [
		"{0} references",
		"{0} reference",
		"References"
	],
	"vs/editor/contrib/gotoSymbol/browser/peek/referencesWidget": [
		"no preview available",
		"No results",
		"References"
	],
	"vs/editor/contrib/gotoSymbol/browser/referencesModel": [
		"symbol in {0} on line {1} at column {2}",
		"symbol in {0} on line {1} at column {2}, {3}",
		"1 symbol in {0}, full path {1}",
		"{0} symbols in {1}, full path {2}",
		"No results found",
		"Found 1 symbol in {0}",
		"Found {0} symbols in {1}",
		"Found {0} symbols in {1} files"
	],
	"vs/editor/contrib/gotoSymbol/browser/symbolNavigation": [
		"Whether there are symbol locations that can be navigated via keyboard-only.",
		"Symbol {0} of {1}, {2} for next",
		"Symbol {0} of {1}"
	],
	"vs/editor/contrib/hover/browser/hover": [
		"Show Hover",
		"Show Definition Preview Hover"
	],
	"vs/editor/contrib/hover/browser/markdownHoverParticipant": [
		"Loading...",
		"Tokenization is skipped for long lines for performance reasons. This can be configured via `editor.maxTokenizationLineLength`."
	],
	"vs/editor/contrib/hover/browser/markerHoverParticipant": [
		"View Problem",
		"No quick fixes available",
		"Checking for quick fixes...",
		"No quick fixes available",
		"Quick Fix..."
	],
	"vs/editor/contrib/inPlaceReplace/browser/inPlaceReplace": [
		"Replace with Previous Value",
		"Replace with Next Value"
	],
	"vs/editor/contrib/indentation/browser/indentation": [
		"Convert Indentation to Spaces",
		"Convert Indentation to Tabs",
		"Configured Tab Size",
		"Select Tab Size for Current File",
		"Indent Using Tabs",
		"Indent Using Spaces",
		"Detect Indentation from Content",
		"Reindent Lines",
		"Reindent Selected Lines"
	],
	"vs/editor/contrib/inlayHints/browser/inlayHintsHover": [
		"cmd + click",
		"ctrl + click",
		"option + click",
		"alt + click",
		"Go to Definition ({0}), right click for more",
		"Go to Definition ({0})",
		"Execute Command"
	],
	"vs/editor/contrib/inlineCompletions/browser/ghostTextController": [
		"Whether an inline suggestion is visible",
		"Whether the inline suggestion starts with whitespace",
		"Whether the inline suggestion starts with whitespace that is less than what would be inserted by tab",
		"Show Next Inline Suggestion",
		"Show Previous Inline Suggestion",
		"Trigger Inline Suggestion"
	],
	"vs/editor/contrib/inlineCompletions/browser/inlineCompletionsHoverParticipant": [
		"Next",
		"Previous",
		"Accept",
		"Suggestion:"
	],
	"vs/editor/contrib/lineSelection/browser/lineSelection": [
		"Expand Line Selection"
	],
	"vs/editor/contrib/linesOperations/browser/linesOperations": [
		"Copy Line Up",
		"&&Copy Line Up",
		"Copy Line Down",
		"Co&&py Line Down",
		"Duplicate Selection",
		"&&Duplicate Selection",
		"Move Line Up",
		"Mo&&ve Line Up",
		"Move Line Down",
		"Move &&Line Down",
		"Sort Lines Ascending",
		"Sort Lines Descending",
		"Delete Duplicate Lines",
		"Trim Trailing Whitespace",
		"Delete Line",
		"Indent Line",
		"Outdent Line",
		"Insert Line Above",
		"Insert Line Below",
		"Delete All Left",
		"Delete All Right",
		"Join Lines",
		"Transpose characters around the cursor",
		"Transform to Uppercase",
		"Transform to Lowercase",
		"Transform to Title Case",
		"Transform to Snake Case"
	],
	"vs/editor/contrib/linkedEditing/browser/linkedEditing": [
		"Start Linked Editing",
		"Background color when the editor auto renames on type."
	],
	"vs/editor/contrib/links/browser/links": [
		"Failed to open this link because it is not well-formed: {0}",
		"Failed to open this link because its target is missing.",
		"Execute command",
		"Follow link",
		"cmd + click",
		"ctrl + click",
		"option + click",
		"alt + click",
		"Execute command {0}",
		"Open Link"
	],
	"vs/editor/contrib/message/browser/messageController": [
		"Whether the editor is currently showing an inline message",
		"Cannot edit in read-only editor"
	],
	"vs/editor/contrib/multicursor/browser/multicursor": [
		"Cursor added: {0}",
		"Cursors added: {0}",
		"Add Cursor Above",
		"&&Add Cursor Above",
		"Add Cursor Below",
		"A&&dd Cursor Below",
		"Add Cursors to Line Ends",
		"Add C&&ursors to Line Ends",
		"Add Cursors To Bottom",
		"Add Cursors To Top",
		"Add Selection To Next Find Match",
		"Add &&Next Occurrence",
		"Add Selection To Previous Find Match",
		"Add P&&revious Occurrence",
		"Move Last Selection To Next Find Match",
		"Move Last Selection To Previous Find Match",
		"Select All Occurrences of Find Match",
		"Select All &&Occurrences",
		"Change All Occurrences"
	],
	"vs/editor/contrib/parameterHints/browser/parameterHints": [
		"Trigger Parameter Hints"
	],
	"vs/editor/contrib/parameterHints/browser/parameterHintsWidget": [
		"Icon for show next parameter hint.",
		"Icon for show previous parameter hint.",
		"{0}, hint",
		"Foreground color of the active item in the parameter hint."
	],
	"vs/editor/contrib/peekView/browser/peekView": [
		"Whether the current code editor is embedded inside peek",
		"Close",
		"Background color of the peek view title area.",
		"Color of the peek view title.",
		"Color of the peek view title info.",
		"Color of the peek view borders and arrow.",
		"Background color of the peek view result list.",
		"Foreground color for line nodes in the peek view result list.",
		"Foreground color for file nodes in the peek view result list.",
		"Background color of the selected entry in the peek view result list.",
		"Foreground color of the selected entry in the peek view result list.",
		"Background color of the peek view editor.",
		"Background color of the gutter in the peek view editor.",
		"Match highlight color in the peek view result list.",
		"Match highlight color in the peek view editor.",
		"Match highlight border in the peek view editor."
	],
	"vs/editor/contrib/quickAccess/browser/gotoLineQuickAccess": [
		"Open a text editor first to go to a line.",
		"Go to line {0} and character {1}.",
		"Go to line {0}.",
		"Current Line: {0}, Character: {1}. Type a line number between 1 and {2} to navigate to.",
		"Current Line: {0}, Character: {1}. Type a line number to navigate to."
	],
	"vs/editor/contrib/quickAccess/browser/gotoSymbolQuickAccess": [
		"To go to a symbol, first open a text editor with symbol information.",
		"The active text editor does not provide symbol information.",
		"No matching editor symbols",
		"No editor symbols",
		"Open to the Side",
		"Open to the Bottom",
		"symbols ({0})",
		"properties ({0})",
		"methods ({0})",
		"functions ({0})",
		"constructors ({0})",
		"variables ({0})",
		"classes ({0})",
		"structs ({0})",
		"events ({0})",
		"operators ({0})",
		"interfaces ({0})",
		"namespaces ({0})",
		"packages ({0})",
		"type parameters ({0})",
		"modules ({0})",
		"properties ({0})",
		"enumerations ({0})",
		"enumeration members ({0})",
		"strings ({0})",
		"files ({0})",
		"arrays ({0})",
		"numbers ({0})",
		"booleans ({0})",
		"objects ({0})",
		"keys ({0})",
		"fields ({0})",
		"constants ({0})"
	],
	"vs/editor/contrib/rename/browser/rename": [
		"No result.",
		"An unknown error occurred while resolving rename location",
		"Renaming '{0}'",
		"Renaming {0}",
		"Successfully renamed '{0}' to '{1}'. Summary: {2}",
		"Rename failed to apply edits",
		"Rename failed to compute edits",
		"Rename Symbol",
		"Enable/disable the ability to preview changes before renaming"
	],
	"vs/editor/contrib/rename/browser/renameInputField": [
		"Whether the rename input widget is visible",
		"Rename input. Type new name and press Enter to commit.",
		"{0} to Rename, {1} to Preview"
	],
	"vs/editor/contrib/smartSelect/browser/smartSelect": [
		"Expand Selection",
		"&&Expand Selection",
		"Shrink Selection",
		"&&Shrink Selection"
	],
	"vs/editor/contrib/snippet/browser/snippetController2": [
		"Whether the editor in current in snippet mode",
		"Whether there is a next tab stop when in snippet mode",
		"Whether there is a previous tab stop when in snippet mode"
	],
	"vs/editor/contrib/snippet/browser/snippetVariables": [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat",
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	],
	"vs/editor/contrib/suggest/browser/suggest": [
		"Whether suggestion details are visible",
		"Whether there are multiple suggestions to pick from",
		"Whether inserting the current suggestion yields in a change or has everything already been typed",
		"Whether suggestions are inserted when pressing Enter",
		"Whether the current suggestion has insert and replace behaviour",
		"Whether the default behaviour is to insert or replace",
		"Whether the current suggestion supports to resolve further details"
	],
	"vs/editor/contrib/suggest/browser/suggestController": [
		"Accepting '{0}' made {1} additional edits",
		"Trigger Suggest",
		"Insert",
		"Insert",
		"Replace",
		"Replace",
		"Insert",
		"show less",
		"show more",
		"Reset Suggest Widget Size"
	],
	"vs/editor/contrib/suggest/browser/suggestWidget": [
		"Background color of the suggest widget.",
		"Border color of the suggest widget.",
		"Foreground color of the suggest widget.",
		"Foreground color of the selected entry in the suggest widget.",
		"Icon foreground color of the selected entry in the suggest widget.",
		"Background color of the selected entry in the suggest widget.",
		"Color of the match highlights in the suggest widget.",
		"Color of the match highlights in the suggest widget when an item is focused.",
		"Foreground color of the suggest widget status.",
		"Loading...",
		"No suggestions.",
		"Suggest",
		"{0}{1}, {2}",
		"{0}{1}",
		"{0}, {1}",
		"{0}, docs: {1}"
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetDetails": [
		"Close",
		"Loading..."
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetRenderer": [
		"Icon for more information in the suggest widget.",
		"Read More"
	],
	"vs/editor/contrib/suggest/browser/suggestWidgetStatus": [
		"{0} ({1})"
	],
	"vs/editor/contrib/symbolIcons/browser/symbolIcons": [
		"The foreground color for array symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for boolean symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for class symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for color symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for constant symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for constructor symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for enumerator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for enumerator member symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for event symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for field symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for file symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for folder symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for function symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for interface symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for key symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for keyword symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for method symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for module symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for namespace symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for null symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for number symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for object symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for operator symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for package symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for property symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for reference symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for snippet symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for string symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for struct symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for text symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for type parameter symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for unit symbols. These symbols appear in the outline, breadcrumb, and suggest widget.",
		"The foreground color for variable symbols. These symbols appear in the outline, breadcrumb, and suggest widget."
	],
	"vs/editor/contrib/toggleTabFocusMode/browser/toggleTabFocusMode": [
		"Toggle Tab Key Moves Focus",
		"Pressing Tab will now move focus to the next focusable element",
		"Pressing Tab will now insert the tab character"
	],
	"vs/editor/contrib/tokenization/browser/tokenization": [
		"Developer: Force Retokenize"
	],
	"vs/editor/contrib/unicodeHighlighter/browser/unicodeHighlighter": [
		"Icon shown with a warning message in the extensions editor.",
		"This document contains many non-basic ASCII unicode characters",
		"This document contains many ambiguous unicode characters",
		"This document contains many invisible unicode characters",
		"The character {0} could be confused with the character {1}, which is more common in source code.",
		"The character {0} is invisible.",
		"The character {0} is not a basic ASCII character.",
		"Adjust settings",
		"Disable Highlight In Comments",
		"Disable highlighting of characters in comments",
		"Disable Highlight In Strings",
		"Disable highlighting of characters in strings",
		"Disable Ambiguous Highlight",
		"Disable highlighting of ambiguous characters",
		"Disable Invisible Highlight",
		"Disable highlighting of invisible characters",
		"Disable Non ASCII Highlight",
		"Disable highlighting of non basic ASCII characters",
		"Show Exclude Options",
		"Exclude {0} (invisible character) from being highlighted",
		"Exclude {0} from being highlighted",
		"Allow unicode characters that are more common in the language \"{0}\".",
		"Configure Unicode Highlight Options"
	],
	"vs/editor/contrib/unusualLineTerminators/browser/unusualLineTerminators": [
		"Unusual Line Terminators",
		"Detected unusual line terminators",
		"The file '{0}' contains one or more unusual line terminator characters, like Line Separator (LS) or Paragraph Separator (PS).\n\nIt is recommended to remove them from the file. This can be configured via `editor.unusualLineTerminators`.",
		"Remove Unusual Line Terminators",
		"Ignore"
	],
	"vs/editor/contrib/wordHighlighter/browser/wordHighlighter": [
		"Background color of a symbol during read-access, like reading a variable. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of a symbol during write-access, like writing to a variable. The color must not be opaque so as not to hide underlying decorations.",
		"Border color of a symbol during read-access, like reading a variable.",
		"Border color of a symbol during write-access, like writing to a variable.",
		"Overview ruler marker color for symbol highlights. The color must not be opaque so as not to hide underlying decorations.",
		"Overview ruler marker color for write-access symbol highlights. The color must not be opaque so as not to hide underlying decorations.",
		"Go to Next Symbol Highlight",
		"Go to Previous Symbol Highlight",
		"Trigger Symbol Highlight"
	],
	"vs/editor/contrib/wordOperations/browser/wordOperations": [
		"Delete Word"
	],
	"vs/platform/actions/browser/menuEntryActionViewItem": [
		"{0} ({1})",
		"{0} ({1})"
	],
	"vs/platform/configuration/common/configurationRegistry": [
		"Default Language Configuration Overrides",
		"Configure settings to be overridden for {0} language.",
		"Configure editor settings to be overridden for a language.",
		"This setting does not support per-language configuration.",
		"Configure editor settings to be overridden for a language.",
		"This setting does not support per-language configuration.",
		"Cannot register an empty property",
		"Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.",
		"Cannot register '{0}'. This property is already registered."
	],
	"vs/platform/contextkey/browser/contextKeyService": [
		"A command that returns information about context keys"
	],
	"vs/platform/contextkey/common/contextkeys": [
		"Whether the operating system is macOS",
		"Whether the operating system is Linux",
		"Whether the operating system is Windows",
		"Whether the platform is a web browser",
		"Whether the operating system is macOS on a non-browser platform",
		"Whether the operating system is iOS",
		"Whether keyboard focus is inside an input box"
	],
	"vs/platform/dialogs/common/dialogs": [
		"...1 additional file not shown",
		"...{0} additional files not shown"
	],
	"vs/platform/extensionManagement/common/abstractExtensionManagementService": [
		"Marketplace is not enabled",
		"Marketplace is not enabled",
		"Only Marketplace Extensions can be reinstalled",
		"Can't install '{0}' extension since it was reported to be problematic.",
		"Can't install '{0}' extension because it is no longer supported. It is now part of the '{1}' extension as a pre-release version.",
		"The '{0}' extension is not available in {1} for {2}.",
		"Can't install pre-release version of '{0}' extension because it is not compatible with the current version of {1} (version {2}).",
		"Can't install release version of '{0}' extension because it has no release version.",
		"Can't install '{0}' extension because it is not compatible with the current version of {1} (version {2}).",
		"Cannot uninstall '{0}' extension. '{1}' extension depends on this.",
		"Cannot uninstall '{0}' extension. '{1}' and '{2}' extensions depend on this.",
		"Cannot uninstall '{0}' extension. '{1}', '{2}' and other extension depend on this.",
		"Cannot uninstall '{0}' extension . It includes uninstalling '{1}' extension and '{2}' extension depends on this.",
		"Cannot uninstall '{0}' extension. It includes uninstalling '{1}' extension and '{2}' and '{3}' extensions depend on this.",
		"Cannot uninstall '{0}' extension. It includes uninstalling '{1}' extension and '{2}', '{3}' and other extensions depend on this."
	],
	"vs/platform/extensionManagement/common/extensionManagement": [
		"Extensions",
		"Preferences"
	],
	"vs/platform/extensionManagement/common/extensionManagementCLIService": [
		"Extension '{0}' not found.",
		"Make sure you use the full extension ID, including the publisher, e.g.: {0}",
		"Extensions installed on {0}:",
		"Installing extensions on {0}...",
		"Installing extensions...",
		"Extension '{0}' v{1} is already installed. Use '--force' option to update to latest version or provide '@<version>' to install a specific version, for example: '{2}@1.2.3'.",
		"Extension '{0}' is already installed.",
		"Failed Installing Extensions: {0}",
		"Extension '{0}' was successfully installed.",
		"Cancelled installing extension '{0}'.",
		"Extension '{0}' is already installed.",
		"Updating the extension '{0}' to the version {1}",
		"Installing builtin extension '{0}' v{1}...",
		"Installing builtin extension '{0}'...",
		"Installing extension '{0}' v{1}...",
		"Installing extension '{0}'...",
		"Extension '{0}' v{1} was successfully installed.",
		"Cancelled installing extension '{0}'.",
		"A newer version of extension '{0}' v{1} is already installed. Use '--force' option to downgrade to older version.",
		"Extension '{0}' is a Built-in extension and cannot be uninstalled",
		"Extension '{0}' is marked as a Built-in extension by user. Please use '--force' option to uninstall it.",
		"Uninstalling {0}...",
		"Extension '{0}' was successfully uninstalled from {1}!",
		"Extension '{0}' was successfully uninstalled!",
		"Extension '{0}' is not installed on {1}.",
		"Extension '{0}' is not installed."
	],
	"vs/platform/extensions/common/extensionValidator": [
		"Could not parse `engines.vscode` value {0}. Please use, for example: ^1.22.0, ^1.22.x, etc.",
		"Version specified in `engines.vscode` ({0}) is not specific enough. For vscode versions before 1.0.0, please define at a minimum the major and minor desired version. E.g. ^0.10.0, 0.10.x, 0.11.0, etc.",
		"Version specified in `engines.vscode` ({0}) is not specific enough. For vscode versions after 1.0.0, please define at a minimum the major desired version. E.g. ^1.10.0, 1.10.x, 1.x.x, 2.x.x, etc.",
		"Extension is not compatible with Code {0}. Extension requires: {1}."
	],
	"vs/platform/files/browser/htmlFileSystemProvider": [
		"Rename is only supported for files.",
		"Insufficient permissions. Please retry and allow the operation."
	],
	"vs/platform/files/browser/indexedDBFileSystemProvider": [
		"File does not exist",
		"File is Directory",
		"File is not a directory",
		"Directory is not empty",
		"Internal error occurred in IndexedDB File System Provider. ({0})"
	],
	"vs/platform/files/common/fileService": [
		"Unable to resolve filesystem provider with relative file path '{0}'",
		"No file system provider found for resource '{0}'",
		"Unable to resolve nonexistent file '{0}'",
		"Unable to create file '{0}' that already exists when overwrite flag is not set",
		"Unable to write file '{0}' ({1})",
		"Unable to unlock file '{0}' because provider does not support it.",
		"Unable to write file '{0}' that is actually a directory",
		"File Modified Since",
		"Unable to read file '{0}' ({1})",
		"Unable to read file '{0}' ({1})",
		"Unable to read file '{0}' ({1})",
		"Unable to read file '{0}' that is actually a directory",
		"File not modified since",
		"Unable to read file '{0}' that is too large to open",
		"Unable to copy when source '{0}' is same as target '{1}' with different path case on a case insensitive file system",
		"Unable to move/copy when source '{0}' is parent of target '{1}'.",
		"Unable to move/copy '{0}' because target '{1}' already exists at destination.",
		"Unable to move/copy '{0}' into '{1}' since a file would replace the folder it is contained in.",
		"Unable to create folder '{0}' that already exists but is not a directory",
		"Unable to delete file '{0}' via trash because provider does not support it.",
		"Unable to delete nonexistent file '{0}'",
		"Unable to delete non-empty folder '{0}'.",
		"Unable to modify readonly file '{0}'",
		"Unable to modify readonly file '{0}'"
	],
	"vs/platform/files/common/files": [
		"Unknown Error",
		"{0}B",
		"{0}KB",
		"{0}MB",
		"{0}GB",
		"{0}TB"
	],
	"vs/platform/files/common/io": [
		"To open a file of this size, you need to restart and allow to use more memory",
		"File is too large to open"
	],
	"vs/platform/history/browser/contextScopedHistoryWidget": [
		"Whether suggestion are visible"
	],
	"vs/platform/keybinding/common/abstractKeybindingService": [
		"({0}) was pressed. Waiting for second key of chord...",
		"The key combination ({0}, {1}) is not a command."
	],
	"vs/platform/list/browser/listService": [
		"Workbench",
		"Maps to `Control` on Windows and Linux and to `Command` on macOS.",
		"Maps to `Alt` on Windows and Linux and to `Option` on macOS.",
		"The modifier to be used to add an item in trees and lists to a multi-selection with the mouse (for example in the explorer, open editors and scm view). The 'Open to Side' mouse gestures - if supported - will adapt such that they do not conflict with the multiselect modifier.",
		"Controls how to open items in trees and lists using the mouse (if supported). Note that some trees and lists might choose to ignore this setting if it is not applicable.",
		"Controls whether lists and trees support horizontal scrolling in the workbench. Warning: turning on this setting has a performance implication.",
		"Controls tree indentation in pixels.",
		"Controls whether the tree should render indent guides.",
		"Controls whether lists and trees have smooth scrolling.",
		"A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.",
		"Scrolling speed multiplier when pressing `Alt`.",
		"Simple keyboard navigation focuses elements which match the keyboard input. Matching is done only on prefixes.",
		"Highlight keyboard navigation highlights elements which match the keyboard input. Further up and down navigation will traverse only the highlighted elements.",
		"Filter keyboard navigation will filter out and hide all the elements which do not match the keyboard input.",
		"Controls the keyboard navigation style for lists and trees in the workbench. Can be simple, highlight and filter.",
		"Controls whether keyboard navigation in lists and trees is automatically triggered simply by typing. If set to `false`, keyboard navigation is only triggered when executing the `list.toggleKeyboardNavigation` command, for which you can assign a keyboard shortcut.",
		"Controls how tree folders are expanded when clicking the folder names. Note that some trees and lists might choose to ignore this setting if it is not applicable."
	],
	"vs/platform/localizations/common/localizedStrings": [
		"open",
		"close",
		"find"
	],
	"vs/platform/markers/common/markers": [
		"Error",
		"Warning",
		"Info"
	],
	"vs/platform/quickinput/browser/commandsQuickAccess": [
		"{0}, {1}",
		"recently used",
		"other commands",
		"Command '{0}' resulted in an error ({1})"
	],
	"vs/platform/quickinput/browser/helpQuickAccess": [
		"global commands",
		"editor commands",
		"{0}, {1}"
	],
	"vs/platform/request/common/request": [
		"HTTP",
		"The proxy setting to use. If not set, will be inherited from the `http_proxy` and `https_proxy` environment variables.",
		"Controls whether the proxy server certificate should be verified against the list of supplied CAs.",
		"The value to send as the `Proxy-Authorization` header for every network request.",
		"Disable proxy support for extensions.",
		"Enable proxy support for extensions.",
		"Enable proxy support for extensions, fall back to request options, when no proxy found.",
		"Enable proxy support for extensions, override request options.",
		"Use the proxy support for extensions.",
		"Controls whether CA certificates should be loaded from the OS. (On Windows and macOS, a reload of the window is required after turning this off.)"
	],
	"vs/platform/telemetry/common/telemetryService": [
		"Controls all core and first party extension telemetry. This helps us to better understand how {0} is performing, where improvements need to be made, and how features are being used.",
		"Read more about the [data we collect]({0}).",
		"Read more about the [data we collect]({0}) and our [privacy statement]({1}).",
		"A full restart of the application is necessary for crash reporting changes to take effect.",
		"Crash Reports",
		"Error Telemetry",
		"Usage Data",
		"The following table outlines the data sent with each setting:",
		"****Note:*** If this setting is 'off', no telemetry will be sent regardless of other telemetry settings. If this setting is set to anything except 'off' and telemetry is disabled with deprecated settings, no telemetry will be sent.*",
		"Telemetry",
		"Sends usage data, errors, and crash reports.",
		"Sends general error telemetry and crash reports.",
		"Sends OS level crash reports.",
		"Disables all product telemetry.",
		"Telemetry",
		"Enable diagnostic data to be collected. This helps us to better understand how {0} is performing and where improvements need to be made.",
		"Enable diagnostic data to be collected. This helps us to better understand how {0} is performing and where improvements need to be made. [Read more]({1}) about what we collect and our privacy statement.",
		"If this setting is false, no telemetry will be sent regardless of the new setting's value. Deprecated in favor of the {0} setting."
	],
	"vs/platform/terminal/common/terminalPlatformConfiguration": [
		"An optional set of arguments to run the shell executable with.",
		"Controls whether or not the profile name overrides the auto detected one.",
		"A codicon ID to associate with this terminal.",
		"A theme color ID to associate with this terminal.",
		"An object with environment variables that will be added to the terminal profile process. Set to `null` to delete environment variables from the base environment.",
		"A single path to a shell executable or an array of paths that will be used as fallbacks when one fails.",
		"A single path to a shell executable.",
		"This is deprecated, the new recommended way to configure your default shell is by creating a terminal profile in {0} and setting its profile name as the default in {1}. This will currently take priority over the new profiles settings but that will change in the future.",
		"This is deprecated, the new recommended way to configure your default shell is by creating a terminal profile in {0} and setting its profile name as the default in {1}. This will currently take priority over the new profiles settings but that will change in the future.",
		"This is deprecated, the new recommended way to configure your default shell is by creating a terminal profile in {0} and setting its profile name as the default in {1}. This will currently take priority over the new profiles settings but that will change in the future.",
		"This is deprecated, the new recommended way to configure your automation shell is by creating a terminal automation profile with {0}. This will currently take priority over the new automation profile settings but that will change in the future.",
		"This is deprecated, the new recommended way to configure your automation shell is by creating a terminal automation profile with {0}. This will currently take priority over the new automation profile settings but that will change in the future.",
		"This is deprecated, the new recommended way to configure your automation shell is by creating a terminal automation profile with {0}. This will currently take priority over the new automation profile settings but that will change in the future.",
		"Integrated Terminal",
		"A path that when set will override {0} and ignore {1} values for automation-related terminal usage like tasks and debug.",
		"A path that when set will override {0} and ignore {1} values for automation-related terminal usage like tasks and debug.",
		"A path that when set will override {0} and ignore {1} values for automation-related terminal usage like tasks and debug.",
		"The terminal profile to use on Linux for automation-related terminal usage like tasks and debug. This setting will currently be ignored if {0} is set.",
		"The terminal profile to use on macOS for automation-related terminal usage like tasks and debug. This setting will currently be ignored if {0} is set.",
		"The terminal profile to use for automation-related terminal usage like tasks and debug. This setting will currently be ignored if {0} is set.",
		"The path of the shell that the terminal uses on Linux. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The path of the shell that the terminal uses on macOS. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The path of the shell that the terminal uses on Windows. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The command line arguments to use when on the Linux terminal. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The command line arguments to use when on the macOS terminal. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The command line arguments to use when on the Windows terminal. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The command line arguments to use when on the Windows terminal. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The command line arguments in [command-line format](https://msdn.microsoft.com/en-au/08dfcab2-eb6e-49a4-80eb-87d4076c98c6) to use when on the Windows terminal. [Read more about configuring the shell](https://code.visualstudio.com/docs/editor/integrated-terminal#_terminal-profiles).",
		"The Windows profiles to present when creating a new terminal via the terminal dropdown. Use the {0} property to automatically detect the shell's location. Or set the {1} property manually with an optional {2}.\n\nSet an existing profile to {3} to hide the profile from the list, for example: {4}.",
		"A profile source that will auto detect the paths to the shell.",
		"The extension that contributed this profile.",
		"The id of the extension terminal",
		"The name of the extension terminal",
		"The macOS profiles to present when creating a new terminal via the terminal dropdown. Set the {0} property manually with an optional {1}.\n\nSet an existing profile to {2} to hide the profile from the list, for example: {3}.",
		"The extension that contributed this profile.",
		"The id of the extension terminal",
		"The name of the extension terminal",
		"The Linux profiles to present when creating a new terminal via the terminal dropdown. Set the {0} property manually with an optional {1}.\n\nSet an existing profile to {2} to hide the profile from the list, for example: {3}.",
		"The extension that contributed this profile.",
		"The id of the extension terminal",
		"The name of the extension terminal",
		"Controls whether or not WSL distros are shown in the terminal dropdown",
		"Whether new shells should inherit their environment from VS Code, which may source a login shell to ensure $PATH and other development variables are initialized. This has no effect on Windows.",
		"Controls the maximum amount of lines that will be restored when reconnecting to a persistent terminal session. Increasing this will restore more lines of scrollback at the cost of more memory and increase the time it takes to connect to terminals on start up. This setting requires a restart to take effect and should be set to a value less than or equal to `#terminal.integrated.scrollback#`.",
		"Whether to show hovers for links in the terminal output.",
		"A set of process names to ignore when using the {0} setting.",
		"Integrated Terminal",
		"The default profile used on Linux. This setting will currently be ignored if either {0} or {1} are set.",
		"The default profile used on macOS. This setting will currently be ignored if either {0} or {1} are set.",
		"The default profile used on Windows. This setting will currently be ignored if either {0} or {1} are set."
	],
	"vs/platform/theme/common/colorRegistry": [
		"Overall foreground color. This color is only used if not overridden by a component.",
		"Overall foreground color for error messages. This color is only used if not overridden by a component.",
		"Foreground color for description text providing additional information, for example for a label.",
		"The default color for icons in the workbench.",
		"Overall border color for focused elements. This color is only used if not overridden by a component.",
		"An extra border around elements to separate them from others for greater contrast.",
		"An extra border around active elements to separate them from others for greater contrast.",
		"The background color of text selections in the workbench (e.g. for input fields or text areas). Note that this does not apply to selections within the editor.",
		"Color for text separators.",
		"Foreground color for links in text.",
		"Foreground color for links in text when clicked on and on mouse hover.",
		"Foreground color for preformatted text segments.",
		"Background color for block quotes in text.",
		"Border color for block quotes in text.",
		"Background color for code blocks in text.",
		"Shadow color of widgets such as find/replace inside the editor.",
		"Input box background.",
		"Input box foreground.",
		"Input box border.",
		"Border color of activated options in input fields.",
		"Background color of activated options in input fields.",
		"Background hover color of options in input fields.",
		"Foreground color of activated options in input fields.",
		"Input box foreground color for placeholder text.",
		"Input validation background color for information severity.",
		"Input validation foreground color for information severity.",
		"Input validation border color for information severity.",
		"Input validation background color for warning severity.",
		"Input validation foreground color for warning severity.",
		"Input validation border color for warning severity.",
		"Input validation background color for error severity.",
		"Input validation foreground color for error severity.",
		"Input validation border color for error severity.",
		"Dropdown background.",
		"Dropdown list background.",
		"Dropdown foreground.",
		"Dropdown border.",
		"Background color of checkbox widget.",
		"Foreground color of checkbox widget.",
		"Border color of checkbox widget.",
		"Button foreground color.",
		"Button background color.",
		"Button background color when hovering.",
		"Button border color.",
		"Secondary button foreground color.",
		"Secondary button background color.",
		"Secondary button background color when hovering.",
		"Badge background color. Badges are small information labels, e.g. for search results count.",
		"Badge foreground color. Badges are small information labels, e.g. for search results count.",
		"Scrollbar shadow to indicate that the view is scrolled.",
		"Scrollbar slider background color.",
		"Scrollbar slider background color when hovering.",
		"Scrollbar slider background color when clicked on.",
		"Background color of the progress bar that can show for long running operations.",
		"Background color of error text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of error squigglies in the editor.",
		"Border color of error boxes in the editor.",
		"Background color of warning text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of warning squigglies in the editor.",
		"Border color of warning boxes in the editor.",
		"Background color of info text in the editor. The color must not be opaque so as not to hide underlying decorations.",
		"Foreground color of info squigglies in the editor.",
		"Border color of info boxes in the editor.",
		"Foreground color of hint squigglies in the editor.",
		"Border color of hint boxes in the editor.",
		"Border color of active sashes.",
		"Editor background color.",
		"Editor default foreground color.",
		"Background color of editor widgets, such as find/replace.",
		"Foreground color of editor widgets, such as find/replace.",
		"Border color of editor widgets. The color is only used if the widget chooses to have a border and if the color is not overridden by a widget.",
		"Border color of the resize bar of editor widgets. The color is only used if the widget chooses to have a resize border and if the color is not overridden by a widget.",
		"Quick picker background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker foreground color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker title background color. The quick picker widget is the container for pickers like the command palette.",
		"Quick picker color for grouping labels.",
		"Quick picker color for grouping borders.",
		"Keybinding label background color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label foreground color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border color. The keybinding label is used to represent a keyboard shortcut.",
		"Keybinding label border bottom color. The keybinding label is used to represent a keyboard shortcut.",
		"Color of the editor selection.",
		"Color of the selected text for high contrast.",
		"Color of the selection in an inactive editor. The color must not be opaque so as not to hide underlying decorations.",
		"Color for regions with the same content as the selection. The color must not be opaque so as not to hide underlying decorations.",
		"Border color for regions with the same content as the selection.",
		"Color of the current search match.",
		"Color of the other search matches. The color must not be opaque so as not to hide underlying decorations.",
		"Color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Border color of the current search match.",
		"Border color of the other search matches.",
		"Border color of the range limiting the search. The color must not be opaque so as not to hide underlying decorations.",
		"Color of the Search Editor query matches.",
		"Border color of the Search Editor query matches.",
		"Highlight below the word for which a hover is shown. The color must not be opaque so as not to hide underlying decorations.",
		"Background color of the editor hover.",
		"Foreground color of the editor hover.",
		"Border color of the editor hover.",
		"Background color of the editor hover status bar.",
		"Color of active links.",
		"Foreground color of inline hints",
		"Background color of inline hints",
		"Foreground color of inline hints for types",
		"Background color of inline hints for types",
		"Foreground color of inline hints for parameters",
		"Background color of inline hints for parameters",
		"The color used for the lightbulb actions icon.",
		"The color used for the lightbulb auto fix actions icon.",
		"Background color for text that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for text that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got inserted. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for lines that got removed. The color must not be opaque so as not to hide underlying decorations.",
		"Background color for the margin where lines got inserted.",
		"Background color for the margin where lines got removed.",
		"Diff overview ruler foreground for inserted content.",
		"Diff overview ruler foreground for removed content.",
		"Outline color for the text that got inserted.",
		"Outline color for text that got removed.",
		"Border color between the two text editors.",
		"Color of the diff editor's diagonal fill. The diagonal fill is used in side-by-side diff views.",
		"List/Tree background color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is active. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree icon foreground color for the selected item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree outline color for the focused item when the list/tree is inactive. An active list/tree has keyboard focus, an inactive does not.",
		"List/Tree background when hovering over items using the mouse.",
		"List/Tree foreground when hovering over items using the mouse.",
		"List/Tree drag and drop background when moving items around using the mouse.",
		"List/Tree foreground color of the match highlights when searching inside the list/tree.",
		"List/Tree foreground color of the match highlights on actively focused items when searching inside the list/tree.",
		"List/Tree foreground color for invalid items, for example an unresolved root in explorer.",
		"Foreground color of list items containing errors.",
		"Foreground color of list items containing warnings.",
		"Background color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees.",
		"Outline color of the type filter widget in lists and trees, when there are no matches.",
		"Background color of the filtered match.",
		"Border color of the filtered match.",
		"Tree stroke color for the indentation guides.",
		"Table border color between columns.",
		"Background color for odd table rows.",
		"List/Tree foreground color for items that are deemphasized. ",
		"Please use quickInputList.focusBackground instead",
		"Quick picker foreground color for the focused item.",
		"Quick picker icon foreground color for the focused item.",
		"Quick picker background color for the focused item.",
		"Border color of menus.",
		"Foreground color of menu items.",
		"Background color of menu items.",
		"Foreground color of the selected menu item in menus.",
		"Background color of the selected menu item in menus.",
		"Border color of the selected menu item in menus.",
		"Color of a separator menu item in menus.",
		"Toolbar background when hovering over actions using the mouse",
		"Toolbar outline when hovering over actions using the mouse",
		"Toolbar background when holding the mouse over actions",
		"Highlight background color of a snippet tabstop.",
		"Highlight border color of a snippet tabstop.",
		"Highlight background color of the final tabstop of a snippet.",
		"Highlight border color of the final tabstop of a snippet.",
		"Color of focused breadcrumb items.",
		"Background color of breadcrumb items.",
		"Color of focused breadcrumb items.",
		"Color of selected breadcrumb items.",
		"Background color of breadcrumb item picker.",
		"Current header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Current content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Incoming content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor header background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Common ancestor content background in inline merge-conflicts. The color must not be opaque so as not to hide underlying decorations.",
		"Border color on headers and the splitter in inline merge-conflicts.",
		"Current overview ruler foreground for inline merge-conflicts.",
		"Incoming overview ruler foreground for inline merge-conflicts.",
		"Common ancestor overview ruler foreground for inline merge-conflicts.",
		"Overview ruler marker color for find matches. The color must not be opaque so as not to hide underlying decorations.",
		"Overview ruler marker color for selection highlights. The color must not be opaque so as not to hide underlying decorations.",
		"Minimap marker color for find matches.",
		"Minimap marker color for repeating editor selections.",
		"Minimap marker color for the editor selection.",
		"Minimap marker color for errors.",
		"Minimap marker color for warnings.",
		"Minimap background color.",
		"Opacity of foreground elements rendered in the minimap. For example, \"#000000c0\" will render the elements with 75% opacity.",
		"Minimap slider background color.",
		"Minimap slider background color when hovering.",
		"Minimap slider background color when clicked on.",
		"The color used for the problems error icon.",
		"The color used for the problems warning icon.",
		"The color used for the problems info icon.",
		"The foreground color used in charts.",
		"The color used for horizontal lines in charts.",
		"The red color used in chart visualizations.",
		"The blue color used in chart visualizations.",
		"The yellow color used in chart visualizations.",
		"The orange color used in chart visualizations.",
		"The green color used in chart visualizations.",
		"The purple color used in chart visualizations."
	],
	"vs/platform/theme/common/iconRegistry": [
		"The id of the font to use. If not set, the font that is defined first is used.",
		"The font character associated with the icon definition.",
		"Icon for the close action in widgets.",
		"Icon for goto previous editor location.",
		"Icon for goto next editor location."
	],
	"vs/platform/theme/common/tokenClassificationRegistry": [
		"Colors and styles for the token.",
		"Foreground color for the token.",
		"Token background colors are currently not supported.",
		"Sets the all font styles of the rule: 'italic', 'bold', 'underline' or 'strikethrough' or a combination. All styles that are not listed are unset. The empty string unsets all styles.",
		"Font style must be 'italic', 'bold', 'underline' or 'strikethrough' or a combination. The empty string unsets all styles.",
		"None (clear inherited style)",
		"Sets or unsets the font style to bold. Note, the presence of 'fontStyle' overrides this setting.",
		"Sets or unsets the font style to italic. Note, the presence of 'fontStyle' overrides this setting.",
		"Sets or unsets the font style to underline. Note, the presence of 'fontStyle' overrides this setting.",
		"Sets or unsets the font style to strikethrough. Note, the presence of 'fontStyle' overrides this setting.",
		"Style for comments.",
		"Style for strings.",
		"Style for keywords.",
		"Style for numbers.",
		"Style for expressions.",
		"Style for operators.",
		"Style for namespaces.",
		"Style for types.",
		"Style for structs.",
		"Style for classes.",
		"Style for interfaces.",
		"Style for enums.",
		"Style for type parameters.",
		"Style for functions",
		"Style for member functions",
		"Style for method (member functions)",
		"Style for macros.",
		"Style for variables.",
		"Style for parameters.",
		"Style for properties.",
		"Style for enum members.",
		"Style for events.",
		"Style for decorators & annotations.",
		"Style for labels. ",
		"Style for all symbol declarations.",
		"Style to use for references in documentation.",
		"Style to use for symbols that are static.",
		"Style to use for symbols that are abstract.",
		"Style to use for symbols that are deprecated.",
		"Style to use for write accesses.",
		"Style to use for symbols that are async.",
		"Style to use for symbols that are readonly."
	],
	"vs/platform/undoRedo/common/undoRedoService": [
		"The following files have been closed and modified on disk: {0}.",
		"The following files have been modified in an incompatible way: {0}.",
		"Could not undo '{0}' across all files. {1}",
		"Could not undo '{0}' across all files. {1}",
		"Could not undo '{0}' across all files because changes were made to {1}",
		"Could not undo '{0}' across all files because there is already an undo or redo operation running on {1}",
		"Could not undo '{0}' across all files because an undo or redo operation occurred in the meantime",
		"Would you like to undo '{0}' across all files?",
		"Undo in {0} Files",
		"Undo this File",
		"Cancel",
		"Could not undo '{0}' because there is already an undo or redo operation running.",
		"Would you like to undo '{0}'?",
		"Yes",
		"No",
		"Could not redo '{0}' across all files. {1}",
		"Could not redo '{0}' across all files. {1}",
		"Could not redo '{0}' across all files because changes were made to {1}",
		"Could not redo '{0}' across all files because there is already an undo or redo operation running on {1}",
		"Could not redo '{0}' across all files because an undo or redo operation occurred in the meantime",
		"Could not redo '{0}' because there is already an undo or redo operation running."
	],
	"vs/platform/update/common/update.config.contribution": [
		"Update",
		"Configure whether you receive automatic updates. Requires a restart after change. The updates are fetched from a Microsoft online service.",
		"Disable updates.",
		"Disable automatic background update checks. Updates will be available if you manually check for updates.",
		"Check for updates only on startup. Disable automatic background update checks.",
		"Enable automatic update checks. Code will check for updates automatically and periodically.",
		"Configure whether you receive automatic updates. Requires a restart after change. The updates are fetched from a Microsoft online service.",
		"This setting is deprecated, please use '{0}' instead.",
		"Enable Background Updates on Windows",
		"Enable to download and install new VS Code versions in the background on Windows.",
		"Show Release Notes after an update. The Release Notes are fetched from a Microsoft online service."
	],
	"vs/platform/userDataSync/common/abstractSynchronizer": [
		"Cannot sync {0} as its local version {1} is not compatible with its remote version {2}",
		"Cannot parse sync data as it is not compatible with the current version."
	],
	"vs/platform/userDataSync/common/keybindingsSync": [
		"Unable to sync keybindings because the content in the file is not valid. Please open the file and correct it.",
		"Unable to sync keybindings because the content in the file is not valid. Please open the file and correct it."
	],
	"vs/platform/userDataSync/common/settingsSync": [
		"Unable to sync settings as there are errors/warning in settings file."
	],
	"vs/platform/userDataSync/common/userDataAutoSyncService": [
		"Cannot sync because default service has changed",
		"Cannot sync because sync service has changed",
		"Cannot sync because syncing is turned off in the cloud",
		"Cannot sync because default service has changed",
		"Cannot sync because sync service has changed",
		"Cannot sync because current session is expired",
		"Cannot sync because syncing is turned off on this machine from another machine."
	],
	"vs/platform/userDataSync/common/userDataSync": [
		"Settings Sync",
		"Synchronize keybindings for each platform.",
		"List of extensions to be ignored while synchronizing. The identifier of an extension is always `${publisher}.${name}`. For example: `vscode.csharp`.",
		"Expected format '${publisher}.${name}'. Example: 'vscode.csharp'.",
		"Configure settings to be ignored while synchronizing."
	],
	"vs/platform/userDataSync/common/userDataSyncMachines": [
		"Cannot read machines data as the current version is incompatible. Please update {0} and try again."
	],
	"vs/platform/workspace/common/workspace": [
		"Code Workspace"
	],
	"vs/platform/workspace/common/workspaceTrust": [
		"Trusted",
		"Restricted Mode"
	],
	"vs/workbench/api/browser/mainThreadAuthentication": [
		"This account has not been used by any extensions.",
		"Cancel",
		"Last used this account {0}",
		"Has not used this account",
		"Manage Trusted Extensions",
		"Choose which extensions can access this account",
		"The account '{0}' has been used by: \n\n{1}\n\n Sign out from these extensions?",
		"Sign out of '{0}'?",
		"Sign Out",
		"Cancel",
		"Successfully signed out.",
		"The extension '{0}' wants you to sign in again using {1}.",
		"The extension '{0}' wants to sign in using {1}.",
		"Allow",
		"Cancel"
	],
	"vs/workbench/api/browser/mainThreadCLICommands": [
		"Cannot install the '{0}' extension because it is declared to not run in this setup."
	],
	"vs/workbench/api/browser/mainThreadComments": [
		"View icon of the comments view."
	],
	"vs/workbench/api/browser/mainThreadCustomEditors": [
		"Edit"
	],
	"vs/workbench/api/browser/mainThreadExtensionService": [
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension, which is not loaded. Would you like to reload the window to load the extension?",
		"Reload Window",
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension which is not supported in the current workspace",
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension which is not supported in Restricted Mode",
		"Manage Workspace Trust",
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension which is disabled. Would you like to enable the extension and reload the window?",
		"Enable and Reload",
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension which is disabled.",
		"Cannot activate the '{0}' extension because it depends on the '{1}' extension, which is not installed. Would you like to install the extension and reload the window?",
		"Install and Reload",
		"Cannot activate the '{0}' extension because it depends on an unknown '{1}' extension."
	],
	"vs/workbench/api/browser/mainThreadFileSystemEventService": [
		"Extension '{0}' wants to make refactoring changes with this file creation",
		"Extension '{0}' wants to make refactoring changes with this file copy",
		"Extension '{0}' wants to make refactoring changes with this file move",
		"Extension '{0}' wants to make refactoring changes with this file deletion",
		"{0} extensions want to make refactoring changes with this file creation",
		"{0} extensions want to make refactoring changes with this file copy",
		"{0} extensions want to make refactoring changes with this file move",
		"{0} extensions want to make refactoring changes with this file deletion",
		"Show Preview",
		"Skip Changes",
		"OK",
		"Show Preview",
		"Skip Changes",
		"Don't ask again",
		"Running 'File Create' participants...",
		"Running 'File Rename' participants...",
		"Running 'File Copy' participants...",
		"Running 'File Delete' participants...",
		"Running 'File Write' participants...",
		"Reset choice for 'File operation needs preview'",
		"Timeout in milliseconds after which file participants for create, rename, and delete are cancelled. Use `0` to disable participants."
	],
	"vs/workbench/api/browser/mainThreadMessageService": [
		"{0} (Extension)",
		"Extension",
		"Manage Extension",
		"Cancel",
		"OK"
	],
	"vs/workbench/api/browser/mainThreadProgress": [
		"Manage Extension"
	],
	"vs/workbench/api/browser/mainThreadSaveParticipant": [
		"Aborted onWillSaveTextDocument-event after 1750ms"
	],
	"vs/workbench/api/browser/mainThreadTask": [
		"{0}: {1}"
	],
	"vs/workbench/api/browser/mainThreadTunnelService": [
		"The extension {0} has forwarded port {1}. You'll need to run as superuser to use port {2} locally.",
		"Use Port {0} as Sudo..."
	],
	"vs/workbench/api/browser/mainThreadUriOpeners": [
		"Open using default opener",
		"Could not open uri with '{0}': {1}"
	],
	"vs/workbench/api/browser/mainThreadWebviews": [
		"An error occurred while loading view: {0}"
	],
	"vs/workbench/api/browser/mainThreadWorkspace": [
		"Extension '{0}' added 1 folder to the workspace",
		"Extension '{0}' added {1} folders to the workspace",
		"Extension '{0}' removed 1 folder from the workspace",
		"Extension '{0}' removed {1} folders from the workspace",
		"Extension '{0}' changed folders of the workspace"
	],
	"vs/workbench/api/browser/viewsExtensionPoint": [
		"Unique id used to identify the container in which views can be contributed using 'views' contribution point",
		"Human readable string used to render the container",
		"Path to the container icon. Icons are 24x24 centered on a 50x40 block and have a fill color of 'rgb(215, 218, 224)' or '#d7dae0'. It is recommended that icons be in SVG, though any image file type is accepted.",
		"Contributes views containers to the editor",
		"Contribute views containers to Activity Bar",
		"Contribute views containers to Panel",
		"Type of the view. This can either be `tree` for a tree view based view or `webview` for a webview based view. The default is `tree`.",
		"The view is backed by a `TreeView` created by `createTreeView`.",
		"The view is backed by a `WebviewView` registered by `registerWebviewViewProvider`.",
		"Identifier of the view. This should be unique across all views. It is recommended to include your extension id as part of the view id. Use this to register a data provider through `vscode.window.registerTreeDataProviderForView` API. Also to trigger activating your extension by registering `onView:${id}` event to `activationEvents`.",
		"The human-readable name of the view. Will be shown",
		"Condition which must be true to show this view",
		"Path to the view icon. View icons are displayed when the name of the view cannot be shown. It is recommended that icons be in SVG, though any image file type is accepted.",
		"Human-readable context for when the view is moved out of its original location. By default, the view's container name will be used.",
		"Initial state of the view when the extension is first installed. Once the user has changed the view state by collapsing, moving, or hiding the view, the initial state will not be used again.",
		"The default initial state for the view. In most containers the view will be expanded, however; some built-in containers (explorer, scm, and debug) show all contributed views collapsed regardless of the `visibility`.",
		"The view will not be shown in the view container, but will be discoverable through the views menu and other view entry points and can be un-hidden by the user.",
		"The view will show in the view container, but will be collapsed.",
		"Identifier of the view. This should be unique across all views. It is recommended to include your extension id as part of the view id. Use this to register a data provider through `vscode.window.registerTreeDataProviderForView` API. Also to trigger activating your extension by registering `onView:${id}` event to `activationEvents`.",
		"The human-readable name of the view. Will be shown",
		"Condition which must be true to show this view",
		"Nested group in the viewlet",
		"The name of the remote type associated with this view",
		"Contributes views to the editor",
		"Contributes views to Explorer container in the Activity bar",
		"Contributes views to Debug container in the Activity bar",
		"Contributes views to SCM container in the Activity bar",
		"Contributes views to Test container in the Activity bar",
		"Contributes views to Remote container in the Activity bar. To contribute to this container, enableProposedApi needs to be turned on",
		"Contributes views to contributed views container",
		"views containers must be an array",
		"property `{0}` is mandatory and must be of type `string` with non-empty value. Only alphanumeric characters, '_', and '-' are allowed.",
		"property `{0}` is mandatory and must be of type `string` with non-empty value. Only alphanumeric characters, '_', and '-' are allowed.",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string` with non-empty value",
		"View container '{0}' requires 'enabledApiProposals: [\"contribViewsRemote\"]' to be added to 'Remote'.",
		"View container '{0}' does not exist and all views registered to it will be added to 'Explorer'.",
		"Cannot register multiple views with same id `{0}`",
		"A view with id `{0}` is already registered.",
		"Unknown view type `{0}`.",
		"views must be an array",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be one of {1}"
	],
	"vs/workbench/api/common/configurationExtensionPoint": [
		"A title for the current category of settings. This label will be rendered in the Settings editor as a subheading. If the title is the same as the extension display name, then the category will be grouped under the main extension heading.",
		"When specified, gives the order of this category of settings relative to other categories.",
		"Description of the configuration properties.",
		"Property should not be empty.",
		"Schema of the configuration property.",
		"Configuration that can be configured only in the user settings.",
		"Configuration that can be configured only in the user settings or only in the remote settings.",
		"Configuration that can be configured in the user, remote or workspace settings.",
		"Configuration that can be configured in the user, remote, workspace or folder settings.",
		"Resource configuration that can be configured in language specific settings.",
		"Machine configuration that can be configured also in workspace or folder settings.",
		"Scope in which the configuration is applicable. Available scopes are `application`, `machine`, `window`, `resource`, and `machine-overridable`.",
		"Descriptions for enum values",
		"Descriptions for enum values in the markdown format.",
		"The description in the markdown format.",
		"If set, the property is marked as deprecated and the given message is shown as an explanation.",
		"If set, the property is marked as deprecated and the given message is shown as an explanation in the markdown format.",
		"The value will be shown in an inputbox.",
		"The value will be shown in a textarea.",
		"When specified, controls the presentation format of the string setting.",
		"When specified, gives the order of this setting relative to other settings within the same category. Settings with an order property will be placed before settings without this property set.",
		"Cannot register configuration defaults for '{0}'. Only defaults for machine-overridable, window, resource and language overridable scoped settings are supported.",
		"Contributes configuration settings.",
		"'configuration.title' must be a string",
		"'configuration.properties' must be an object",
		"Cannot register '{0}'. This property is already registered.",
		"configuration.properties property '{0}' must be an object",
		"'configuration.allOf' is deprecated and should no longer be used. Instead, pass multiple configuration sections as an array to the 'configuration' contribution point.",
		"List of folders to be loaded in the workspace.",
		"A file path. e.g. `/root/folderA` or `./folderA` for a relative path that will be resolved against the location of the workspace file.",
		"An optional name for the folder. ",
		"URI of the folder",
		"An optional name for the folder. ",
		"Workspace settings",
		"Workspace launch configurations",
		"Workspace task configurations",
		"Workspace extensions",
		"The remote server where the workspace is located.",
		"A transient workspace will disappear when restarting or reloading.",
		"Unknown workspace configuration property"
	],
	"vs/workbench/api/common/jsonValidationExtensionPoint": [
		"Contributes json schema configuration.",
		"The file pattern (or an array of patterns) to match, for example \"package.json\" or \"*.launch\". Exclusion patterns start with '!'",
		"A schema URL ('http:', 'https:') or relative path to the extension folder ('./').",
		"'configuration.jsonValidation' must be a array",
		"'configuration.jsonValidation.fileMatch' must be defined as a string or an array of strings.",
		"'configuration.jsonValidation.url' must be a URL or relative path",
		"Expected `contributes.{0}.url` ({1}) to be included inside extension's folder ({2}). This might make the extension non-portable.",
		"'configuration.jsonValidation.url' is an invalid relative URL: {0}",
		"'configuration.jsonValidation.url' must be an absolute URL or start with './'  to reference schemas located in the extension."
	],
	"vs/workbench/browser/actions/developerActions": [
		"Inspect Context Keys",
		"Toggle Screencast Mode",
		"Log Storage Database Contents",
		"Log Working Copies",
		"Screencast Mode",
		"Controls the vertical offset of the screencast mode overlay from the bottom as a percentage of the workbench height.",
		"Controls the font size (in pixels) of the screencast mode keyboard.",
		"Keys.",
		"Command title.",
		"Command title prefixed by its group.",
		"Command title and keys.",
		"Command title and keys, with the command prefixed by its group.",
		"Controls what is displayed in the keyboard overlay when showing shortcuts.",
		"Only show keyboard shortcuts in screencast mode.",
		"Controls how long (in milliseconds) the keyboard overlay is shown in screencast mode.",
		"Controls the color in hex (#RGB, #RGBA, #RRGGBB or #RRGGBBAA) of the mouse indicator in screencast mode.",
		"Controls the size (in pixels) of the mouse indicator in screencast mode."
	],
	"vs/workbench/browser/actions/helpActions": [
		"Keyboard Shortcuts Reference",
		"&&Keyboard Shortcuts Reference",
		"Video Tutorials",
		"&&Video Tutorials",
		"Tips and Tricks",
		"Tips and Tri&&cks",
		"Documentation",
		"&&Documentation",
		"Signup for the VS Code Newsletter",
		"Join Us on Twitter",
		"&&Join Us on Twitter",
		"Search Feature Requests",
		"&&Search Feature Requests",
		"View License",
		"View &&License",
		"Privacy Statement",
		"Privac&&y Statement"
	],
	"vs/workbench/browser/actions/layoutActions": [
		"Represents the menu bar",
		"Represents the activity bar in the left position",
		"Represents the activity bar in the right position",
		"Represents the side bar or side panel in the left position",
		"Represents the side bar or side panel in the right position",
		"Represents the bottom panel",
		"Represents the status bar",
		"Represents the bottom panel alignment set to the left",
		"Represents the bottom panel alignment set to the right",
		"Represents the bottom panel alignment set to the center",
		"Represents the bottom panel alignment set to justified",
		"Represents full screen",
		"Represents centered layout mode",
		"Represents zen mode",
		"Close Side Bar",
		"Toggle Activity Bar Visibility",
		"Show &&Activity Bar",
		"Toggle Centered Layout",
		"&&Centered Layout",
		"Move Side Bar Right",
		"Move Side Bar Left",
		"Toggle Side Bar Position",
		"Move Side Bar Right",
		"Move Side Bar Left",
		"Toggle Side Bar Position",
		"Icon represents workbench layout configuration.",
		"Configure Layout",
		"Move Side Bar Right",
		"Move Side Bar Right",
		"Move Side Bar Left",
		"Move Side Bar Left",
		"&&Move Side Bar Right",
		"&&Move Side Bar Left",
		"Toggle Editor Area Visibility",
		"Show &&Editor Area",
		"&&Appearance",
		"Toggle Side Bar Visibility",
		"Hide Side Bar",
		"Hide Side Bar",
		"Show &&Side Bar",
		"Show Side Bar",
		"Toggle Side Bar",
		"Toggle Side Bar",
		"Toggle Status Bar Visibility",
		"Show S&&tatus Bar",
		"Toggle Tab Visibility",
		"Toggle Zen Mode",
		"Zen Mode",
		"Toggle Menu Bar",
		"Show Menu &&Bar",
		"Reset View Locations",
		"Move View",
		"Side Bar / {0}",
		"Panel / {0}",
		"Side Panel / {0}",
		"Select a View to Move",
		"Move Focused View",
		"There is no view currently focused.",
		"The currently focused view is not movable.",
		"Select a Destination for the View",
		"View: Move {0}",
		"New Panel Entry",
		"New Side Bar Entry",
		"New Side Panel Entry",
		"Side Bar",
		"Panel",
		"Side Panel",
		"Reset Focused View Location",
		"There is no view currently focused.",
		"Increase Current View Size",
		"Increase Editor Width",
		"Increase Editor Height",
		"Decrease Current View Size",
		"Decrease Editor Width",
		"Decrease Editor Height",
		"Visible",
		"Hidden",
		"Active",
		"Menu Bar",
		"Activity Bar",
		"Side Bar",
		"Panel",
		"Side Panel",
		"Status Bar",
		"Left",
		"Right",
		"Left",
		"Right",
		"Center",
		"Justify",
		"Full Screen",
		"Zen Mode",
		"Centered Layout",
		"Customize Layout...",
		"Visibility",
		"Side Bar Position",
		"Panel Alignment",
		"Modes",
		"Customize Layout",
		"Close"
	],
	"vs/workbench/browser/actions/navigationActions": [
		"Navigate to the View on the Left",
		"Navigate to the View on the Right",
		"Navigate to the View Above",
		"Navigate to the View Below",
		"Focus Next Part",
		"Focus Previous Part"
	],
	"vs/workbench/browser/actions/quickAccessActions": [
		"Go to File...",
		"Navigate Next in Quick Open",
		"Navigate Previous in Quick Open",
		"Select Next in Quick Open",
		"Select Previous in Quick Open"
	],
	"vs/workbench/browser/actions/textInputActions": [
		"Undo",
		"Redo",
		"Cut",
		"Copy",
		"Paste",
		"Select All"
	],
	"vs/workbench/browser/actions/windowActions": [
		"File",
		"Remove from Recently Opened",
		"Folder With Unsaved Files",
		"Workspace With Unsaved Files",
		"folders & workspaces",
		"folders",
		"files",
		"Select to open (hold Cmd-key to force new window or Alt-key for same window)",
		"Select to open (hold Ctrl-key to force new window or Alt-key for same window)",
		"Workspace with Unsaved Files",
		"Folder with Unsaved Files",
		"Do you want to open the workspace to review the unsaved files?",
		"Do you want to open the folder to review the unsaved files?",
		"Workspaces with unsaved files cannot be removed until all unsaved files have been saved or reverted.",
		"Folders with unsaved files cannot be removed until all unsaved files have been saved or reverted.",
		"{0}, workspace with unsaved changes",
		"{0}, folder with unsaved changes",
		"Open Recent...",
		"&&More...",
		"Quick Open Recent...",
		"Toggle Full Screen",
		"&&Full Screen",
		"Reload Window",
		"About",
		"&&About",
		"New Window",
		"New &&Window",
		"Remove keyboard focus from focused element",
		"Confirm Before Close",
		"Open &&Recent"
	],
	"vs/workbench/browser/actions/workspaceActions": [
		"Workspaces",
		"File",
		"Open File...",
		"Open Folder...",
		"Open Folder...",
		"Open...",
		"Open Workspace from File...",
		"Close Workspace",
		"Open Workspace Configuration File",
		"Remove Folder from Workspace...",
		"Save Workspace As...",
		"Duplicate As Workspace in New Window",
		"&&Open File...",
		"Open &&Folder...",
		"Open &&Folder...",
		"&&Open...",
		"Open Wor&&kspace from File...",
		"A&&dd Folder to Workspace...",
		"Save Workspace As...",
		"Duplicate Workspace",
		"Close &&Folder",
		"Close &&Workspace"
	],
	"vs/workbench/browser/actions/workspaceCommands": [
		"Add Folder to Workspace...",
		"&&Add",
		"Add Folder to Workspace",
		"Select workspace folder"
	],
	"vs/workbench/browser/client": [
		"{0} is being accessed in an insecure context. Web views, the clipboard, and other functionality may not work as expected.",
		"I understand",
		"Sign out of {0}"
	],
	"vs/workbench/browser/codeeditor": [
		"Open Workspace"
	],
	"vs/workbench/browser/dnd": [
		"File is too large to open as untitled editor. Please upload it first into the file explorer and then try again."
	],
	"vs/workbench/browser/editor": [
		"{0}, preview",
		"{0}, pinned"
	],
	"vs/workbench/browser/parts/activitybar/activitybarActions": [
		"Manage Trusted Extensions",
		"Sign Out",
		"{0} is currently unavailable",
		"You are not signed in to any accounts",
		"Hide Accounts",
		"Previous Side Bar View",
		"Next Side Bar View",
		"Focus Activity Bar"
	],
	"vs/workbench/browser/parts/activitybar/activitybarPart": [
		"Settings icon in the view bar.",
		"Accounts icon in the view bar.",
		"Menu",
		"Hide Menu",
		"Accounts",
		"Hide Activity Bar",
		"Reset Location",
		"Reset Location",
		"Manage",
		"Manage",
		"Accounts",
		"Accounts"
	],
	"vs/workbench/browser/parts/auxiliarybar/auxiliaryBarActions": [
		"Icon to toggle the auxiliary bar in its right position.",
		"Icon to toggle the auxiliary bar in its left position.",
		"Toggle Side Panel",
		"Focus into Side Panel",
		"Show Side Panel",
		"Toggle Side Panel",
		"Toggle Side Panel",
		"Show Si&&de Panel",
		"Hide Side Panel"
	],
	"vs/workbench/browser/parts/auxiliarybar/auxiliaryBarPart": [
		"Move Views to Panel",
		"Hide Side Panel"
	],
	"vs/workbench/browser/parts/banner/bannerPart": [
		"Focus Banner"
	],
	"vs/workbench/browser/parts/compositeBar": [
		"Active View Switcher"
	],
	"vs/workbench/browser/parts/compositeBarActions": [
		"{0} ({1})",
		"{0} - {1}",
		"Additional Views",
		"{0} ({1})",
		"Manage Extension",
		"Hide '{0}'",
		"Keep '{0}'",
		"Toggle View Pinned"
	],
	"vs/workbench/browser/parts/compositePart": [
		"{0} actions",
		"Views and More Actions...",
		"{0} ({1})"
	],
	"vs/workbench/browser/parts/dialogs/dialogHandler": [
		"&&Yes",
		"Cancel",
		"code-server: v{4}\nCode: {0}\nCommit: {1}\nDate: {2}\nBrowser: {3}",
		"Copy",
		"OK"
	],
	"vs/workbench/browser/parts/editor/binaryDiffEditor": [
		"{0} ↔ {1}"
	],
	"vs/workbench/browser/parts/editor/binaryEditor": [
		"Binary Viewer",
		"The file is not displayed in the editor because it is either binary or uses an unsupported text encoding.",
		"Do you want to open it anyway?"
	],
	"vs/workbench/browser/parts/editor/breadcrumbs": [
		"Breadcrumb Navigation",
		"Enable/disable navigation breadcrumbs.",
		"Controls whether and how file paths are shown in the breadcrumbs view.",
		"Show the file path in the breadcrumbs view.",
		"Do not show the file path in the breadcrumbs view.",
		"Only show the last element of the file path in the breadcrumbs view.",
		"Controls whether and how symbols are shown in the breadcrumbs view.",
		"Show all symbols in the breadcrumbs view.",
		"Do not show symbols in the breadcrumbs view.",
		"Only show the current symbol in the breadcrumbs view.",
		"Controls how symbols are sorted in the breadcrumbs outline view.",
		"Show symbol outline in file position order.",
		"Show symbol outline in alphabetical order.",
		"Show symbol outline in symbol type order.",
		"Render breadcrumb items with icons.",
		"When enabled breadcrumbs show `file`-symbols.",
		"When enabled breadcrumbs show `module`-symbols.",
		"When enabled breadcrumbs show `namespace`-symbols.",
		"When enabled breadcrumbs show `package`-symbols.",
		"When enabled breadcrumbs show `class`-symbols.",
		"When enabled breadcrumbs show `method`-symbols.",
		"When enabled breadcrumbs show `property`-symbols.",
		"When enabled breadcrumbs show `field`-symbols.",
		"When enabled breadcrumbs show `constructor`-symbols.",
		"When enabled breadcrumbs show `enum`-symbols.",
		"When enabled breadcrumbs show `interface`-symbols.",
		"When enabled breadcrumbs show `function`-symbols.",
		"When enabled breadcrumbs show `variable`-symbols.",
		"When enabled breadcrumbs show `constant`-symbols.",
		"When enabled breadcrumbs show `string`-symbols.",
		"When enabled breadcrumbs show `number`-symbols.",
		"When enabled breadcrumbs show `boolean`-symbols.",
		"When enabled breadcrumbs show `array`-symbols.",
		"When enabled breadcrumbs show `object`-symbols.",
		"When enabled breadcrumbs show `key`-symbols.",
		"When enabled breadcrumbs show `null`-symbols.",
		"When enabled breadcrumbs show `enumMember`-symbols.",
		"When enabled breadcrumbs show `struct`-symbols.",
		"When enabled breadcrumbs show `event`-symbols.",
		"When enabled breadcrumbs show `operator`-symbols.",
		"When enabled breadcrumbs show `typeParameter`-symbols."
	],
	"vs/workbench/browser/parts/editor/breadcrumbsControl": [
		"Icon for the separator in the breadcrumbs.",
		"Whether the editor can show breadcrumbs",
		"Whether breadcrumbs are currently visible",
		"Whether breadcrumbs have focus",
		"no elements",
		"Toggle Breadcrumbs",
		"Show &&Breadcrumbs",
		"Focus Breadcrumbs"
	],
	"vs/workbench/browser/parts/editor/breadcrumbsPicker": [
		"Breadcrumbs"
	],
	"vs/workbench/browser/parts/editor/editor.contribution": [
		"Text Editor",
		"Text Diff Editor",
		"Binary Diff Editor",
		"Side by Side Editor",
		"Type the name of an editor to open it.",
		"Show Editors in Active Group by Most Recently Used",
		"Type the name of an editor to open it.",
		"Show All Opened Editors By Appearance",
		"Type the name of an editor to open it.",
		"Show All Opened Editors By Most Recently Used",
		"File",
		"Unlock Group",
		"Close Group",
		"Split Up",
		"Split Down",
		"Split Left",
		"Split Right",
		"Lock Group",
		"Close",
		"Close",
		"Close Others",
		"Close to the Right",
		"Close Saved",
		"Close All",
		"Reopen Editor With...",
		"Keep Open",
		"Pin",
		"Unpin",
		"Split Up",
		"Split Down",
		"Split Left",
		"Split Right",
		"Split in Group",
		"Join in Group",
		"Inline View",
		"Show Opened Editors",
		"Close All",
		"Close Saved",
		"Keep Editors Open",
		"Lock Group",
		"Split Editor Right",
		"Split Editor Down",
		"Split Editor Down",
		"Split Editor Right",
		"Toggle Layout",
		"Close",
		"Close All",
		"Close",
		"Close All",
		"Unpin",
		"Close",
		"Unpin",
		"Close",
		"Unlock Group",
		"Icon for the previous change action in the diff editor.",
		"Icon for the next change action in the diff editor.",
		"Icon for the toggle whitespace action in the diff editor.",
		"Previous Change",
		"Next Change",
		"Ignore Leading/Trailing Whitespace Differences",
		"Show Leading/Trailing Whitespace Differences",
		"Keep Editor",
		"Pin Editor",
		"Unpin Editor",
		"Close Editor",
		"Close Pinned Editor",
		"Close All Editors in Group",
		"Close Saved Editors in Group",
		"Close Other Editors in Group",
		"Close Editors to the Right in Group",
		"Close Editor Group",
		"Reopen Editor With...",
		"&&Reopen Closed Editor",
		"&&Clear Recently Opened",
		"Editor &&Layout",
		"Split Up",
		"Split &&Up",
		"Split Down",
		"Split &&Down",
		"Split Left",
		"Split &&Left",
		"Split Right",
		"Split &&Right",
		"Split in Group",
		"Split in &&Group",
		"Join in Group",
		"Join in &&Group",
		"Single",
		"&&Single",
		"Two Columns",
		"&&Two Columns",
		"Three Columns",
		"T&&hree Columns",
		"Two Rows",
		"T&&wo Rows",
		"Three Rows",
		"Three &&Rows",
		"Grid (2x2)",
		"&&Grid (2x2)",
		"Two Rows Right",
		"Two R&&ows Right",
		"Two Columns Bottom",
		"Two &&Columns Bottom",
		"&&Back",
		"&&Forward",
		"&&Last Edit Location",
		"&&First Side in Editor",
		"&&Second Side in Editor",
		"&&Next Editor",
		"&&Previous Editor",
		"&&Next Used Editor",
		"&&Previous Used Editor",
		"&&Next Editor in Group",
		"&&Previous Editor in Group",
		"&&Next Used Editor in Group",
		"&&Previous Used Editor in Group",
		"Switch &&Editor",
		"Group &&1",
		"Group &&2",
		"Group &&3",
		"Group &&4",
		"Group &&5",
		"&&Next Group",
		"&&Previous Group",
		"Group &&Left",
		"Group &&Right",
		"Group &&Above",
		"Group &&Below",
		"Switch &&Group"
	],
	"vs/workbench/browser/parts/editor/editorActions": [
		"Split Editor",
		"Split Editor Orthogonal",
		"Split Editor Left",
		"Split Editor Right",
		"Split Editor Up",
		"Split Editor Down",
		"Join Editor Group with Next Group",
		"Join All Editor Groups",
		"Navigate Between Editor Groups",
		"Focus Active Editor Group",
		"Focus First Editor Group",
		"Focus Last Editor Group",
		"Focus Next Editor Group",
		"Focus Previous Editor Group",
		"Focus Left Editor Group",
		"Focus Right Editor Group",
		"Focus Editor Group Above",
		"Focus Editor Group Below",
		"Close Editor",
		"Unpin Editor",
		"Close",
		"Revert and Close Editor",
		"Close Editors to the Left in Group",
		"Close All Editors",
		"Close All Editor Groups",
		"Close Editors in Other Groups",
		"Close Editor in All Groups",
		"Move Editor Group Left",
		"Move Editor Group Right",
		"Move Editor Group Up",
		"Move Editor Group Down",
		"Duplicate Editor Group Left",
		"Duplicate Editor Group Right",
		"Duplicate Editor Group Up",
		"Duplicate Editor Group Down",
		"Maximize Editor Group",
		"Reset Editor Group Sizes",
		"Toggle Editor Group Sizes",
		"Maximize Editor Group and Hide Side Bar",
		"Open Next Editor",
		"Open Previous Editor",
		"Open Next Editor in Group",
		"Open Previous Editor in Group",
		"Open First Editor in Group",
		"Open Last Editor in Group",
		"Go Forward",
		"Go Back",
		"Go Previous",
		"Go Forward in Edit Locations",
		"Go Back in Edit Locations",
		"Go Previous in Edit Locations",
		"Go to Last Edit Location",
		"Go Forward in Navigation Locations",
		"Go Back in Navigation Locations",
		"Go Previous in Navigation Locations",
		"Go to Last Navigation Location",
		"Reopen Closed Editor",
		"Clear Recently Opened",
		"Show Editors in Active Group By Most Recently Used",
		"Show All Editors By Appearance",
		"Show All Editors By Most Recently Used",
		"Quick Open Previous Recently Used Editor",
		"Quick Open Least Recently Used Editor",
		"Quick Open Previous Recently Used Editor in Group",
		"Quick Open Least Recently Used Editor in Group",
		"Quick Open Previous Editor from History",
		"Open Next Recently Used Editor",
		"Open Previous Recently Used Editor",
		"Open Next Recently Used Editor In Group",
		"Open Previous Recently Used Editor In Group",
		"Clear Editor History",
		"Move Editor Left",
		"Move Editor Right",
		"Move Editor into Previous Group",
		"Move Editor into Next Group",
		"Move Editor into Group Above",
		"Move Editor into Group Below",
		"Move Editor into Left Group",
		"Move Editor into Right Group",
		"Move Editor into First Group",
		"Move Editor into Last Group",
		"Split Editor into Previous Group",
		"Split Editor into Next Group",
		"Split Editor into Group Above",
		"Split Editor into Group Below",
		"Split Editor into Left Group",
		"Split Editor into Right Group",
		"Split Editor into First Group",
		"Split Editor into Last Group",
		"Single Column Editor Layout",
		"Two Columns Editor Layout",
		"Three Columns Editor Layout",
		"Two Rows Editor Layout",
		"Three Rows Editor Layout",
		"Grid Editor Layout (2x2)",
		"Two Columns Bottom Editor Layout",
		"Two Rows Right Editor Layout",
		"New Editor Group to the Left",
		"New Editor Group to the Right",
		"New Editor Group Above",
		"New Editor Group Below",
		"Toggle Editor Type",
		"Reopen Editor With Text Editor"
	],
	"vs/workbench/browser/parts/editor/editorCommands": [
		"Move the active editor by tabs or groups",
		"Active editor move argument",
		"Argument Properties:\n\t* 'to': String value providing where to move.\n\t* 'by': String value providing the unit for move (by tab or by group).\n\t* 'value': Number value providing how many positions or an absolute position to move.",
		"Copy the active editor by groups",
		"Active editor copy argument",
		"Argument Properties:\n\t* 'to': String value providing where to copy.\n\t* 'value': Number value providing how many positions or an absolute position to copy.",
		"Toggle Inline View",
		"Compare",
		"Split Editor in Group",
		"Join Editor in Group",
		"Toggle Split Editor in Group",
		"Toggle Split Editor in Group Layout",
		"Focus First Side in Active Editor",
		"Focus Second Side in Active Editor",
		"Focus Other Side in Active Editor",
		"Toggle Editor Group Lock",
		"Lock Editor Group",
		"Unlock Editor Group"
	],
	"vs/workbench/browser/parts/editor/editorConfiguration": [
		"Markdown Preview",
		"If an editor matching one of the listed types is opened as the first in an editor group and more than one group is open, the group is automatically locked. Locked groups will only be used for opening editors when explicitly chosen by user gesture (e.g. drag and drop), but not by default. Consequently the active editor in a locked group is less likely to be replaced accidentally with a different editor."
	],
	"vs/workbench/browser/parts/editor/editorGroupView": [
		"Empty editor group actions",
		"{0} (empty)",
		"Group {0}",
		"Editor Group {0}",
		"OK",
		"Cancel",
		"Unable to open '{0}'",
		"Unable to open '{0}': {1}."
	],
	"vs/workbench/browser/parts/editor/editorPlaceholder": [
		"Workspace Trust Required",
		"The file is not displayed in the editor because trust has not been granted to the folder.",
		"The file is not displayed in the editor because trust has not been granted to the workspace.",
		"Manage Workspace Trust",
		"Try Again",
		"Unknown Error Editor",
		"The editor could not be opened due to an unexpected error.",
		"Unavailable Resource Error Editor",
		"The editor could not be opened because the file was not found."
	],
	"vs/workbench/browser/parts/editor/editorQuickAccess": [
		"No matching editors",
		"{0}, unsaved changes, {1}",
		"{0}, {1}",
		"{0}, unsaved changes",
		"Close Editor"
	],
	"vs/workbench/browser/parts/editor/editorStatus": [
		"Ln {0}, Col {1} ({2} selected)",
		"Ln {0}, Col {1}",
		"{0} selections ({1} characters selected)",
		"{0} selections",
		"LF",
		"CRLF",
		"Are you using a screen reader to operate VS Code? (word wrap is disabled when using a screen reader)",
		"Yes",
		"No",
		"No text editor active at this time",
		"The active code editor is read-only.",
		"convert file",
		"change view",
		"Select Action",
		"Tab Moves Focus",
		"Accessibility Mode",
		"Disable Accessibility Mode",
		"Column Selection",
		"Column Selection Mode",
		"Disable Column Selection Mode",
		"Screen Reader Optimized",
		"Screen Reader Mode",
		"Editor Selection",
		"Go to Line/Column",
		"Editor Indentation",
		"Select Indentation",
		"Editor Encoding",
		"Select Encoding",
		"Editor End of Line",
		"Select End of Line Sequence",
		"Editor Language",
		"Select Language Mode",
		"File Information",
		"File Information",
		"Spaces: {0}",
		"Tab Size: {0}",
		"Current Problem",
		"Current Problem",
		"Search Marketplace Extensions for '{0}'...",
		"Change Language Mode",
		"No text editor active at this time",
		"({0}) - Configured Language",
		"({0})",
		"languages (identifier)",
		"Configure '{0}' language based settings...",
		"Configure File Association for '{0}'...",
		"Auto Detect",
		"Select Language Mode",
		"Current Association",
		"Select Language Mode to Associate with '{0}'",
		"Change End of Line Sequence",
		"No text editor active at this time",
		"The active code editor is read-only.",
		"Select End of Line Sequence",
		"Change File Encoding",
		"No text editor active at this time",
		"No text editor active at this time",
		"No file active at this time",
		"Save with Encoding",
		"Reopen with Encoding",
		"Select Action",
		"Guessed from content",
		"Select File Encoding to Reopen File",
		"Select File Encoding to Save with"
	],
	"vs/workbench/browser/parts/editor/sideBySideEditor": [
		"Side by Side Editor"
	],
	"vs/workbench/browser/parts/editor/tabsTitleControl": [
		"Tab actions"
	],
	"vs/workbench/browser/parts/editor/textDiffEditor": [
		"Text Diff Editor"
	],
	"vs/workbench/browser/parts/editor/textEditor": [
		"Editor"
	],
	"vs/workbench/browser/parts/editor/textResourceEditor": [
		"Text Editor"
	],
	"vs/workbench/browser/parts/editor/titleControl": [
		"Editor actions",
		"{0} (+{1})"
	],
	"vs/workbench/browser/parts/notifications/notificationsActions": [
		"Icon for the clear action in notifications.",
		"Icon for the clear all action in notifications.",
		"Icon for the hide action in notifications.",
		"Icon for the expand action in notifications.",
		"Icon for the collapse action in notifications.",
		"Icon for the configure action in notifications.",
		"Clear Notification",
		"Clear All Notifications",
		"Hide Notifications",
		"Expand Notification",
		"Collapse Notification",
		"Configure Notification",
		"Copy Text"
	],
	"vs/workbench/browser/parts/notifications/notificationsAlerts": [
		"Error: {0}",
		"Warning: {0}",
		"Info: {0}"
	],
	"vs/workbench/browser/parts/notifications/notificationsCenter": [
		"No new notifications",
		"Notifications",
		"Notification Center Actions",
		"Notifications Center"
	],
	"vs/workbench/browser/parts/notifications/notificationsCommands": [
		"Notifications",
		"Show Notifications",
		"Hide Notifications",
		"Clear All Notifications",
		"Focus Notification Toast"
	],
	"vs/workbench/browser/parts/notifications/notificationsList": [
		"{0}, notification",
		"{0}, source: {1}, notification",
		"Notifications List"
	],
	"vs/workbench/browser/parts/notifications/notificationsStatus": [
		"Notifications",
		"Notifications",
		"Hide Notifications",
		"No Notifications",
		"No New Notifications",
		"1 New Notification",
		"{0} New Notifications",
		"No New Notifications ({0} in progress)",
		"1 New Notification ({0} in progress)",
		"{0} New Notifications ({1} in progress)",
		"Status Message"
	],
	"vs/workbench/browser/parts/notifications/notificationsToasts": [
		"{0}, notification",
		"{0}, source: {1}, notification"
	],
	"vs/workbench/browser/parts/notifications/notificationsViewer": [
		"Click to execute command '{0}'",
		"Notification Actions",
		"Source: {0}"
	],
	"vs/workbench/browser/parts/panel/panelActions": [
		"Icon to maximize a panel.",
		"Icon to restore a panel.",
		"Icon to close a panel.",
		"Icon to toggle the panel.",
		"Toggle Panel",
		"Focus into Panel",
		"Move Panel Left",
		"Left",
		"Move Panel Right",
		"Right",
		"Move Panel To Bottom",
		"Bottom",
		"Set Panel Alignment to Left",
		"Left",
		"Set Panel Alignment to Right",
		"Right",
		"Set Panel Alignment to Center",
		"Center",
		"Set Panel Alignment to Justify",
		"Justify",
		"Panel Position",
		"Align Panel",
		"Previous Panel View",
		"Next Panel View",
		"Toggle Maximized Panel",
		"Maximize Panel Size",
		"Restore Panel Size",
		"Maximizing the panel is only supported when it is center aligned.",
		"Close Panel",
		"Close Side Panel",
		"Show &&Panel",
		"Show Panel",
		"Toggle Panel",
		"Hide Panel",
		"Move Panel Views To Side Panel",
		"Move Side Panel Views To Panel"
	],
	"vs/workbench/browser/parts/panel/panelPart": [
		"Reset Location",
		"Reset Location",
		"Drag a view into the panel to display.",
		"More Actions...",
		"Move Views to Side Panel",
		"Hide Panel"
	],
	"vs/workbench/browser/parts/sidebar/sidebarActions": [
		"Focus into Side Bar"
	],
	"vs/workbench/browser/parts/statusbar/statusbarActions": [
		"Hide '{0}'",
		"Focus Status Bar"
	],
	"vs/workbench/browser/parts/statusbar/statusbarPart": [
		"Hide Status Bar"
	],
	"vs/workbench/browser/parts/titlebar/menubarControl": [
		"&&File",
		"&&Edit",
		"&&Selection",
		"&&View",
		"&&Go",
		"&&Terminal",
		"&&Help",
		"Preferences",
		"Accessibility support is enabled for you. For the most accessible experience, we recommend the custom title bar style.",
		"Open Settings",
		"Focus Application Menu",
		"Check for &&Updates...",
		"Checking for Updates...",
		"D&&ownload Update",
		"Downloading Update...",
		"Install &&Update...",
		"Installing Update...",
		"Restart to &&Update"
	],
	"vs/workbench/browser/parts/titlebar/titlebarPart": [
		"[Unsupported]",
		"[Administrator]",
		"[Superuser]",
		"[Extension Development Host]"
	],
	"vs/workbench/browser/parts/views/treeView": [
		"There is no data provider registered that can provide view data.",
		"Whether the the tree view with id {0} enables collapse all.",
		"Whether collapse all is toggled for the tree view with id {0}.",
		"Whether the tree view with id {0} enables refresh.",
		"Refresh",
		"Collapse All",
		"Error running command {1}: {0}. This is likely caused by the extension that contributes {1}."
	],
	"vs/workbench/browser/parts/views/viewPane": [
		"Icon for an expanded view pane container.",
		"Icon for a collapsed view pane container.",
		"{0} actions"
	],
	"vs/workbench/browser/parts/views/viewPaneContainer": [
		"Views",
		"Move View Up",
		"Move View Left",
		"Move View Down",
		"Move View Right",
		"Move Views"
	],
	"vs/workbench/browser/parts/views/viewsService": [
		"Show {0}",
		"Toggle {0}",
		"Show {0}",
		"Toggle {0}",
		"Focus on {0} View",
		"Reset Location"
	],
	"vs/workbench/browser/quickaccess": [
		"Whether keyboard focus is inside the quick open control"
	],
	"vs/workbench/browser/web.main": [
		"Reset User Data",
		"Would you like to reset your data (settings, keybindings, extensions, snippets and UI State) and reload?"
	],
	"vs/workbench/browser/window": [
		"An unexpected error occurred that requires a reload of this page.",
		"Reload",
		"The workbench was unexpectedly disposed while running.",
		"The browser interrupted the opening of a new tab or window. Press 'Open' to open it anyway.",
		"Open",
		"Learn More",
		"Cancel"
	],
	"vs/workbench/browser/workbench": [
		"Failed to load a required file. Please restart the application to try again. Details: {0}"
	],
	"vs/workbench/browser/workbench.contribution": [
		"The default size.",
		"Increases the size, so it can be grabbed more easily with the mouse.",
		"Controls the height of the scrollbars used for tabs and breadcrumbs in the editor title area.",
		"Controls whether opened editors should show in tabs or not.",
		"Controls whether tabs should be wrapped over multiple lines when exceeding available space or whether a scrollbar should appear instead. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"Controls whether scrolling over tabs will open them or not. By default tabs will only reveal upon scrolling, but not open. You can press and hold the Shift-key while scrolling to change this behavior for that duration. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"Controls whether a top border is drawn on tabs for editors that have unsaved changes. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"Controls whether editor file decorations should use badges.",
		"Controls whether editor file decorations should use colors.",
		"Show the name of the file. When tabs are enabled and two files have the same name in one group the distinguishing sections of each file's path are added. When tabs are disabled, the path relative to the workspace folder is shown if the editor is active.",
		"Show the name of the file followed by its directory name.",
		"Show the name of the file followed by its path relative to the workspace folder.",
		"Show the name of the file followed by its absolute path.",
		"Controls the format of the label for an editor.",
		"The name of the untitled file is derived from the contents of its first line unless it has an associated file path. It will fallback to the name in case the line is empty or contains no word characters.",
		"The name of the untitled file is not derived from the contents of the file.",
		"Controls the format of the label for an untitled editor.",
		"Controls if the untitled hint should be inline text in the editor or a floating button or hidden.",
		"Controls whether the language in a text editor is automatically detected unless the language has been explicitly set by the language picker. This can also be scoped by language so you can specify which languages you do not want to be switched off of. This is useful for languages like Markdown that often contain other languages that might trick language detection into thinking it's the embedded language and not Markdown.",
		"Enables use of editor history in language detection. This causes automatic language detection to favor languages that have been recently opened and allows for automatic language detection to operate with smaller inputs.",
		"Controls the position of the editor's tabs close buttons, or disables them when set to 'off'. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"Always keep tabs large enough to show the full editor label.",
		"Allow tabs to get smaller when the available space is not enough to show all tabs at once.",
		"Controls the sizing of editor tabs. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"A pinned tab inherits the look of non pinned tabs.",
		"A pinned tab will show in a compact form with only icon or first letter of the editor name.",
		"A pinned tab shrinks to a compact fixed size showing parts of the editor name.",
		"Controls the sizing of pinned editor tabs. Pinned tabs are sorted to the beginning of all opened tabs and typically do not close until unpinned. This value is ignored when `#workbench.editor.showTabs#` is disabled.",
		"Splits all the editor groups to equal parts.",
		"Splits the active editor group to equal parts.",
		"Controls the sizing of editor groups when splitting them.",
		"Controls if editor groups can be split from drag and drop operations by dropping an editor or file on the edges of the editor area.",
		"Controls whether tabs are closed in most recently used order or from left to right.",
		"Controls whether opened editors should show with an icon or not. This requires a file icon theme to be enabled as well.",
		"Controls whether opened editors show as preview editors. Preview editors do not stay open, are reused until explicitly set to be kept open (e.g. via double click or editing), and show file names in italics.",
		"Controls whether editors opened from Quick Open show as preview editors. Preview editors do not stay open, and are reused until explicitly set to be kept open (e.g. via double click or editing). This value is ignored when `#workbench.editor.enablePreview#` is disabled.",
		"Controls whether editors remain in preview when a code navigation is started from them. Preview editors do not stay open, and are reused until explicitly set to be kept open (e.g. via double click or editing). This value is ignored when `#workbench.editor.enablePreview#` is disabled.",
		"Controls whether editors showing a file that was opened during the session should close automatically when getting deleted or renamed by some other process. Disabling this will keep the editor open  on such an event. Note that deleting from within the application will always close the editor and that editors with unsaved changes will never close to preserve your data.",
		"Controls where editors open. Select `left` or `right` to open editors to the left or right of the currently active one. Select `first` or `last` to open editors independently from the currently active one.",
		"Controls the default direction of editors that are opened side by side (for example, from the Explorer). By default, editors will open on the right hand side of the currently active one. If changed to `down`, the editors will open below the currently active one.",
		"Controls the behavior of empty editor groups when the last tab in the group is closed. When enabled, empty groups will automatically close. When disabled, empty groups will remain part of the grid.",
		"Controls whether an editor is revealed in any of the visible groups if opened. If disabled, an editor will prefer to open in the currently active editor group. If enabled, an already opened editor will be revealed instead of opened again in the currently active editor group. Note that there are some cases where this setting is ignored, e.g. when forcing an editor to open in a specific group or to the side of the currently active group.",
		"Enables the use of mouse buttons four and five for commands 'Go Back' and 'Go Forward'.",
		"Controls the scope of history navigation in editors for commands such as 'Go Back' and 'Go Forward'.",
		"Navigate across all opened editors and editor groups.",
		"Navigate only in editors of the active editor group.",
		"Navigate only in the active editor.",
		"Restores the last editor view state (e.g. scroll position) when re-opening editors after they have been closed. Editor view state is stored per editor group and discarded when a group closes. Use the `#workbench.editor.sharedViewState#` setting to use the last known view state across all editor groups in case no previous view state was found for a editor group.",
		"Preserves the most recent editor view state (e.g. scroll position) across all editor groups and restores that if no specific editor view state is found for the editor group.",
		"Controls the layout for when an editor is split in an editor group to be either vertical or horizontal.",
		"Editors are positioned from top to bottom.",
		"Editors are positioned from left to right.",
		"Controls if the centered layout should automatically resize to maximum width when more than one group is open. Once only one group is open it will resize back to the original centered width.",
		"Controls if the number of opened editors should be limited or not. When enabled, less recently used editors will close to make space for newly opening editors.",
		"Controls the maximum number of opened editors. Use the `#workbench.editor.limit.perEditorGroup#` setting to control this limit per editor group or across all groups.",
		"Controls if the limit of maximum opened editors should apply per editor group or across all editor groups.",
		"Controls the number of recently used commands to keep in history for the command palette. Set to 0 to disable command history.",
		"Controls whether the last typed input to the command palette should be restored when opening it the next time.",
		"Controls whether Quick Open should close automatically once it loses focus.",
		"Controls whether the last typed input to Quick Open should be restored when opening it the next time.",
		"Controls whether opening settings also opens an editor showing all default settings.",
		"Controls whether to use the split JSON editor when editing settings as JSON.",
		"Controls whether opening keybinding settings also opens an editor showing all default keybindings.",
		"Controls the location of the sidebar and activity bar. They can either show on the left or right of the workbench.",
		"Controls the default location of the panel (terminal, debug console, output, problems) in a new workspace. It can either show at the bottom, right, or left of the editor area.",
		"Controls whether the panel opens maximized. It can either always open maximized, never open maximized, or open to the last state it was in before being closed.",
		"Always maximize the panel when opening it.",
		"Never maximize the panel when opening it. The panel will open un-maximized.",
		"Open the panel to the state that it was in, before it was closed.",
		"Controls the visibility of the status bar at the bottom of the workbench.",
		"Controls the visibility of the activity bar in the workbench.",
		"Controls the behavior of clicking an activity bar icon in the workbench.",
		"Hide the side bar if the clicked item is already visible.",
		"Focus side bar if the clicked item is already visible.",
		"Controls the visibility of view header actions. View header actions may either be always visible, or only visible when that view is focused or hovered over.",
		"Controls font aliasing method in the workbench.",
		"Sub-pixel font smoothing. On most non-retina displays this will give the sharpest text.",
		"Smooth the font on the level of the pixel, as opposed to the subpixel. Can make the font appear lighter overall.",
		"Disables font smoothing. Text will show with jagged sharp edges.",
		"Applies `default` or `antialiased` automatically based on the DPI of displays.",
		"Use the settings UI editor.",
		"Use the JSON file editor.",
		"Determines which settings editor to use by default.",
		"Controls the delay in milliseconds after which the hover is shown for workbench items (ex. some extension provided tree view items). Already visible items may require a refresh before reflecting this setting change.",
		"Controls whether the layout controls in the custom title bar is enabled via {0}.",
		"Shows a single button with a dropdown of layout options.",
		"Shows several buttons for toggling the visibility of the panels and side bar.",
		"Shows both the dropdown and toggle buttons.",
		"Controls whether the layout control in the custom title bar is displayed as a single menu button or with multiple UI toggles.",
		"Controls the window title based on the active editor. Variables are substituted based on the context:",
		"`${activeEditorShort}`: the file name (e.g. myFile.txt).",
		"`${activeEditorMedium}`: the path of the file relative to the workspace folder (e.g. myFolder/myFileFolder/myFile.txt).",
		"`${activeEditorLong}`: the full path of the file (e.g. /Users/Development/myFolder/myFileFolder/myFile.txt).",
		"`${activeFolderShort}`: the name of the folder the file is contained in (e.g. myFileFolder).",
		"`${activeFolderMedium}`: the path of the folder the file is contained in, relative to the workspace folder (e.g. myFolder/myFileFolder).",
		"`${activeFolderLong}`: the full path of the folder the file is contained in (e.g. /Users/Development/myFolder/myFileFolder).",
		"`${folderName}`: name of the workspace folder the file is contained in (e.g. myFolder).",
		"`${folderPath}`: file path of the workspace folder the file is contained in (e.g. /Users/Development/myFolder).",
		"`${rootName}`: name of the opened workspace or folder (e.g. myFolder or myWorkspace).",
		"`${rootPath}`: file path of the opened workspace or folder (e.g. /Users/Development/myWorkspace).",
		"`${appName}`: e.g. VS Code.",
		"`${remoteName}`: e.g. SSH",
		"`${dirty}`: an indicator for when the active editor has unsaved changes.",
		"`${separator}`: a conditional separator (\" - \") that only shows when surrounded by variables with values or static text.",
		"Window",
		"Separator used by `window.title`.",
		"Menu is displayed at the top of the window and only hidden in full screen mode.",
		"Menu is always visible at the top of the window even in full screen mode.",
		"Menu is hidden but can be displayed at the top of the window by executing the `Focus Application Menu` command.",
		"Menu is hidden but can be displayed at the top of the window via the Alt key.",
		"Menu is always hidden.",
		"Menu is displayed as a compact button in the sidebar. This value is ignored when `#window.titleBarStyle#` is `native`.",
		"Control the visibility of the menu bar. A setting of 'toggle' means that the menu bar is hidden and executing `Focus Application Menu` will show it. A setting of 'compact' will move the menu into the sidebar.",
		"Control the visibility of the menu bar. A setting of 'toggle' means that the menu bar is hidden and a single press of the Alt key will show it. A setting of 'compact' will move the menu into the sidebar.",
		"Controls whether the main menus can be opened via Alt-key shortcuts. Disabling mnemonics allows to bind these Alt-key shortcuts to editor commands instead.",
		"Controls whether the menu bar will be focused by pressing the Alt-key. This setting has no effect on toggling the menu bar with the Alt-key.",
		"Files will open in a new window.",
		"Files will open in the window with the files' folder open or the last active window.",
		"Files will open in the window with the files' folder open or the last active window unless opened via the Dock or from Finder.",
		"Files will open in a new window unless picked from within the application (e.g. via the File menu).",
		"Controls whether files should open in a new window. \nNote that there can still be cases where this setting is ignored (e.g. when using the `--new-window` or `--reuse-window` command line option).",
		"Controls whether files should open in a new window.\nNote that there can still be cases where this setting is ignored (e.g. when using the `--new-window` or `--reuse-window` command line option).",
		"Folders will open in a new window.",
		"Folders will replace the last active window.",
		"Folders will open in a new window unless a folder is picked from within the application (e.g. via the File menu).",
		"Controls whether folders should open in a new window or replace the last active window.\nNote that there can still be cases where this setting is ignored (e.g. when using the `--new-window` or `--reuse-window` command line option).",
		"Always try to ask for confirmation. Note that browsers may still decide to close a tab or window without confirmation.",
		"Only ask for confirmation if a keybinding was detected. Note that detection may not be possible in some cases.",
		"Never explicitly ask for confirmation unless data loss is imminent.",
		"Controls whether to show a confirmation dialog before closing the browser tab or window. Note that even if enabled, browsers may still decide to close a tab or window without confirmation and that this setting is only a hint that may not work in all cases.",
		"Zen Mode",
		"Controls whether turning on Zen Mode also puts the workbench into full screen mode.",
		"Controls whether turning on Zen Mode also centers the layout.",
		"Controls whether turning on Zen Mode also hides workbench tabs.",
		"Controls whether turning on Zen Mode also hides the status bar at the bottom of the workbench.",
		"Controls whether turning on Zen Mode also hides the activity bar either at the left or right of the workbench.",
		"Controls whether turning on Zen Mode also hides the editor line numbers.",
		"Controls whether a window should restore to zen mode if it was exited in zen mode.",
		"Controls whether notifications are shown while in zen mode. If true, only error notifications will pop out."
	],
	"vs/workbench/common/actions": [
		"View",
		"Help",
		"Test",
		"Preferences",
		"Developer"
	],
	"vs/workbench/common/configuration": [
		"Workbench"
	],
	"vs/workbench/common/contextkeys": [
		"The kind of workspace opened in the window, either 'empty' (no workspace), 'folder' (single folder) or 'workspace' (multi-root workspace)",
		"The number of root folders in the workspace",
		"Whether there are any working copies with unsaved changes",
		"The name of the remote the window is connected to or an empty string if not connected to any remote",
		"The scheme of the current workspace if is from a virtual file system or an empty string.",
		"Whether the window is in fullscreen mode",
		"Whether the active editor has unsaved changes",
		"Whether the active editor is not in preview mode",
		"Whether the active editor is pinned",
		"Whether the active editor is readonly",
		"Whether the active editor can revert",
		"The identifier of the active editor",
		"The available editor identifiers that are usable for the active editor",
		"Whether a text compare editor is visible",
		"Whether a text compare editor is active",
		"Whether a side by side editor is active",
		"The number of opened editor groups",
		"Whether the active editor group is empty",
		"The index of the active editor group",
		"Whether the active editor group is the last group",
		"Whether the active editor group is locked",
		"Whether there are multiple editor groups opened",
		"Whether an editor is open",
		"Whether Zen mode is enabled",
		"Whether centered layout is enabled",
		"Whether editors split vertically",
		"Whether the editor area is visible",
		"Whether editor tabs are visible",
		"Whether the sidebar is visible",
		"Whether the sidebar has keyboard focus",
		"The identifier of the active viewlet",
		"Whether the status bar has keyboard focus",
		"Whether the banner has keyboard focus",
		"Whether a notification has keyboard focus",
		"Whether the notifications center is visible",
		"Whether a notification toast is visible",
		"The identifier of the active auxiliary panel",
		"Whether the auxiliary bar has keyboard focus",
		"Whether the auxiliary bar is visible",
		"The identifier of the active panel",
		"Whether the panel has keyboard focus",
		"The position of the panel, always 'bottom'",
		"The alignment of the panel, either 'center', 'left', 'right' or 'justify'",
		"Whether the panel is visible",
		"Whether the panel is maximized",
		"The identifier of the view that has keyboard focus",
		"The scheme of the rsource",
		"The file name of the resource",
		"The folder name the resource is contained in",
		"The full path of the resource",
		"The language identifier of the resource",
		"The full value of the resource including scheme and path",
		"The extension name of the resource",
		"Whether a resource is present or not",
		"Whether the resource is backed by a file system provider"
	],
	"vs/workbench/common/editor": [
		"Text Editor",
		"Built-in"
	],
	"vs/workbench/common/editor/diffEditorInput": [
		"{0} ↔ {1}"
	],
	"vs/workbench/common/editor/sideBySideEditorInput": [
		"{0} - {1}"
	],
	"vs/workbench/common/editor/textEditorModel": [
		"Language {0} was automatically detected and set as the language mode."
	],
	"vs/workbench/common/theme": [
		"Active tab background color in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Active tab background color in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Inactive tab background color in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Inactive tab background color in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Active tab foreground color in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Inactive tab foreground color in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Active tab foreground color in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Inactive tab foreground color in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Tab background color when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Tab background color in an unfocused group when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Tab foreground color when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Tab foreground color in an unfocused group when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to separate tabs from each other. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to separate pinned tabs from other tabs. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the bottom of an active tab. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the bottom of an active tab in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to the top of an active tab. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to the top of an active tab in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to highlight tabs when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border to highlight tabs in an unfocused group when hovering. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the top of modified active tabs in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the top of modified inactive tabs in an active group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the top of modified active tabs in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Border on the top of modified inactive tabs in an unfocused group. Tabs are the containers for editors in the editor area. Multiple tabs can be opened in one editor group. There can be multiple editor groups.",
		"Background color of the editor pane visible on the left and right side of the centered editor layout.",
		"Background color of an empty editor group. Editor groups are the containers of editors.",
		"Border color of an empty editor group that is focused. Editor groups are the containers of editors.",
		"Background color of the editor group title header when tabs are enabled. Editor groups are the containers of editors.",
		"Border color of the editor group title header when tabs are enabled. Editor groups are the containers of editors.",
		"Background color of the editor group title header when tabs are disabled (`\"workbench.editor.showTabs\": false`). Editor groups are the containers of editors.",
		"Border color of the editor group title header. Editor groups are the containers of editors.",
		"Color to separate multiple editor groups from each other. Editor groups are the containers of editors.",
		"Background color when dragging editors around. The color should have transparency so that the editor contents can still shine through.",
		"Color to separate two editors from each other when shown side by side in an editor group from top to bottom.",
		"Color to separate two editors from each other when shown side by side in an editor group from left to right.",
		"Panel background color. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Panel border color to separate the panel from the editor. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Title color for the active panel. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Title color for the inactive panel. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Border color for the active panel title. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Input box border for inputs in the panel.",
		"Drag and drop feedback color for the panel titles. Panels are shown below the editor area and contain views like output and integrated terminal.",
		"Drag and drop feedback color for the panel sections. The color should have transparency so that the panel sections can still shine through. Panels are shown below the editor area and contain views like output and integrated terminal. Panel sections are views nested within the panels.",
		"Panel section header background color. Panels are shown below the editor area and contain views like output and integrated terminal. Panel sections are views nested within the panels.",
		"Panel section header foreground color. Panels are shown below the editor area and contain views like output and integrated terminal. Panel sections are views nested within the panels.",
		"Panel section header border color used when multiple views are stacked vertically in the panel. Panels are shown below the editor area and contain views like output and integrated terminal. Panel sections are views nested within the panels.",
		"Panel section border color used when multiple views are stacked horizontally in the panel. Panels are shown below the editor area and contain views like output and integrated terminal. Panel sections are views nested within the panels.",
		"Banner background color. The banner is shown under the title bar of the window.",
		"Banner foreground color. The banner is shown under the title bar of the window.",
		"Banner icon color. The banner is shown under the title bar of the window.",
		"Status bar foreground color when a workspace or folder is opened. The status bar is shown in the bottom of the window.",
		"Status bar foreground color when no folder is opened. The status bar is shown in the bottom of the window.",
		"Status bar background color when a workspace or folder is opened. The status bar is shown in the bottom of the window.",
		"Status bar background color when no folder is opened. The status bar is shown in the bottom of the window.",
		"Status bar border color separating to the sidebar and editor. The status bar is shown in the bottom of the window.",
		"Status bar border color when focused on keyboard navigation. The status bar is shown in the bottom of the window.",
		"Status bar border color separating to the sidebar and editor when no folder is opened. The status bar is shown in the bottom of the window.",
		"Status bar item background color when clicking. The status bar is shown in the bottom of the window.",
		"Status bar item border color when focused on keyboard navigation. The status bar is shown in the bottom of the window.",
		"Status bar item background color when hovering. The status bar is shown in the bottom of the window.",
		"Status bar item background color when hovering an item that contains two hovers. The status bar is shown in the bottom of the window.",
		"Status bar prominent items foreground color. Prominent items stand out from other status bar entries to indicate importance. Change mode `Toggle Tab Key Moves Focus` from command palette to see an example. The status bar is shown in the bottom of the window.",
		"Status bar prominent items background color. Prominent items stand out from other status bar entries to indicate importance. Change mode `Toggle Tab Key Moves Focus` from command palette to see an example. The status bar is shown in the bottom of the window.",
		"Status bar prominent items background color when hovering. Prominent items stand out from other status bar entries to indicate importance. Change mode `Toggle Tab Key Moves Focus` from command palette to see an example. The status bar is shown in the bottom of the window.",
		"Status bar error items background color. Error items stand out from other status bar entries to indicate error conditions. The status bar is shown in the bottom of the window.",
		"Status bar error items foreground color. Error items stand out from other status bar entries to indicate error conditions. The status bar is shown in the bottom of the window.",
		"Status bar warning items background color. Warning items stand out from other status bar entries to indicate warning conditions. The status bar is shown in the bottom of the window.",
		"Status bar warning items foreground color. Warning items stand out from other status bar entries to indicate warning conditions. The status bar is shown in the bottom of the window.",
		"Activity bar background color. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar item foreground color when it is active. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar item foreground color when it is inactive. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar border color separating to the side bar. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar border color for the active item. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar focus border color for the active item. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity bar background color for the active item. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Drag and drop feedback color for the activity bar items. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity notification badge background color. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Activity notification badge foreground color. The activity bar is showing on the far left or right and allows to switch between views of the side bar.",
		"Background color for the remote indicator on the status bar.",
		"Foreground color for the remote indicator on the status bar.",
		"Background color for the remote badge in the extensions view.",
		"Foreground color for the remote badge in the extensions view.",
		"Side bar background color. The side bar is the container for views like explorer and search.",
		"Side bar foreground color. The side bar is the container for views like explorer and search.",
		"Side bar border color on the side separating to the editor. The side bar is the container for views like explorer and search.",
		"Side bar title foreground color. The side bar is the container for views like explorer and search.",
		"Drag and drop feedback color for the side bar sections. The color should have transparency so that the side bar sections can still shine through. The side bar is the container for views like explorer and search. Side bar sections are views nested within the side bar.",
		"Side bar section header background color. The side bar is the container for views like explorer and search. Side bar sections are views nested within the side bar.",
		"Side bar section header foreground color. The side bar is the container for views like explorer and search. Side bar sections are views nested within the side bar.",
		"Side bar section header border color. The side bar is the container for views like explorer and search. Side bar sections are views nested within the side bar.",
		"Title bar foreground when the window is active.",
		"Title bar foreground when the window is inactive.",
		"Title bar background when the window is active.",
		"Title bar background when the window is inactive.",
		"Title bar border color.",
		"Foreground color of the selected menu item in the menubar.",
		"Background color of the selected menu item in the menubar.",
		"Border color of the selected menu item in the menubar.",
		"Notifications center border color. Notifications slide in from the bottom right of the window.",
		"Notification toast border color. Notifications slide in from the bottom right of the window.",
		"Notifications foreground color. Notifications slide in from the bottom right of the window.",
		"Notifications background color. Notifications slide in from the bottom right of the window.",
		"Notification links foreground color. Notifications slide in from the bottom right of the window.",
		"Notifications center header foreground color. Notifications slide in from the bottom right of the window.",
		"Notifications center header background color. Notifications slide in from the bottom right of the window.",
		"Notifications border color separating from other notifications in the notifications center. Notifications slide in from the bottom right of the window.",
		"The color used for the icon of error notifications. Notifications slide in from the bottom right of the window.",
		"The color used for the icon of warning notifications. Notifications slide in from the bottom right of the window.",
		"The color used for the icon of info notifications. Notifications slide in from the bottom right of the window.",
		"The color used for the border of the window when it is active. Only supported in the desktop client when using the custom title bar.",
		"The color used for the border of the window when it is inactive. Only supported in the desktop client when using the custom title bar."
	],
	"vs/workbench/common/views": [
		"Default view icon.",
		"A view with id '{0}' is already registered"
	],
	"vs/workbench/contrib/audioCues/browser/audioCueService": [
		"Error on Line",
		"Warning on Line",
		"Folded Area on Line",
		"Breakpoint on Line",
		"Inline Suggestion on Line",
		"Debugger Stopped on Breakpoint",
		"No Inlay Hints on Line"
	],
	"vs/workbench/contrib/audioCues/browser/audioCues.contribution": [
		"Enable audio cue when a screen reader is attached.",
		"Enable audio cue.",
		"Disable audio cue.",
		"Plays a sound when the active line has a breakpoint.",
		"Plays a sound when the active line has an inline suggestion.",
		"Plays a sound when the active line has an error.",
		"Plays a sound when the active line has a folded area that can be unfolded.",
		"Plays a sound when the active line has a warning.",
		"Plays a sound when the debugger stopped on a breakpoint.",
		"Plays a sound when trying to read a line with inlay hints that has no inlay hints."
	],
	"vs/workbench/contrib/audioCues/browser/commands": [
		"Help: List Audio Cues",
		"Disabled",
		"Enable/Disable Audio Cue",
		"Select an audio cue to play"
	],
	"vs/workbench/contrib/bulkEdit/browser/bulkEditService": [
		"Made no edits",
		"Made {0} text edits in {1} files",
		"Made {0} text edits in one file",
		"Made {0} text edits in {1} files, also created or deleted {2} files",
		"Workspace Edit",
		"Workspace Edit",
		"Made no edits",
		"File operation",
		"Close Window",
		"Change Workspace",
		"Reload Window",
		"Quit",
		"Are you sure you want to {0}? '{1}' is in progress."
	],
	"vs/workbench/contrib/bulkEdit/browser/preview/bulkEdit.contribution": [
		"Another refactoring is being previewed.",
		"Cancel",
		"Continue",
		"Press 'Continue' to discard the previous refactoring and continue with the current refactoring.",
		"Apply Refactoring",
		"Refactor Preview",
		"Discard Refactoring",
		"Refactor Preview",
		"Toggle Change",
		"Refactor Preview",
		"Group Changes By File",
		"Refactor Preview",
		"Group Changes By Type",
		"Refactor Preview",
		"Group Changes By Type",
		"Refactor Preview",
		"View icon of the refactor preview view.",
		"Refactor Preview",
		"Refactor Preview"
	],
	"vs/workbench/contrib/bulkEdit/browser/preview/bulkEditPane": [
		"Apply",
		"Discard",
		"Invoke a code action, like rename, to see a preview of its changes here.",
		"Cannot apply refactoring because '{0}' has changed in the meantime.",
		"Cannot apply refactoring because {0} other files have changed in the meantime.",
		"{0} (delete, refactor preview)",
		"rename",
		"create",
		"{0} ({1}, refactor preview)",
		"{0} (refactor preview)"
	],
	"vs/workbench/contrib/bulkEdit/browser/preview/bulkEditPreview": [
		"Other"
	],
	"vs/workbench/contrib/bulkEdit/browser/preview/bulkEditTree": [
		"Bulk Edit",
		"Renaming {0} to {1}, also making text edits",
		"Creating {0}, also making text edits",
		"Deleting {0}, also making text edits",
		"{0}, making text edits",
		"Renaming {0} to {1}",
		"Creating {0}",
		"Deleting {0}",
		"line {0}, replacing {1} with {2}",
		"line {0}, removing {1}",
		"line {0}, inserting {1}",
		"{0} → {1}",
		"(renaming)",
		"(creating)",
		"(deleting)",
		"{0} - {1}"
	],
	"vs/workbench/contrib/callHierarchy/browser/callHierarchy.contribution": [
		"Whether a call hierarchy provider is available",
		"Whether call hierarchy peek is currently showing",
		"Whether call hierarchy shows incoming or outgoing calls",
		"No results",
		"Failed to show call hierarchy",
		"Peek Call Hierarchy",
		"Show Incoming Calls",
		"Icon for incoming calls in the call hierarchy view.",
		"Show Outgoing Calls",
		"Icon for outgoing calls in the call hierarchy view.",
		"Refocus Call Hierarchy",
		"Close"
	],
	"vs/workbench/contrib/callHierarchy/browser/callHierarchyPeek": [
		"Calls from '{0}'",
		"Callers of '{0}'",
		"Loading...",
		"No calls from '{0}'",
		"No callers of '{0}'"
	],
	"vs/workbench/contrib/callHierarchy/browser/callHierarchyTree": [
		"Call Hierarchy",
		"calls from {0}",
		"callers of {0}"
	],
	"vs/workbench/contrib/codeActions/browser/codeActionsContribution": [
		"Controls whether auto fix action should be run on file save.",
		"Code action kinds to be run on save.",
		"Controls whether '{0}' actions should be run on file save."
	],
	"vs/workbench/contrib/codeActions/common/codeActionsExtensionPoint": [
		"Configure which editor to use for a resource.",
		"Language modes that the code actions are enabled for.",
		"`CodeActionKind` of the contributed code action.",
		"Label for the code action used in the UI.",
		"Description of what the code action does."
	],
	"vs/workbench/contrib/codeActions/common/documentationExtensionPoint": [
		"Contributed documentation.",
		"Contributed documentation for refactorings.",
		"Contributed documentation for refactoring.",
		"Label for the documentation used in the UI.",
		"When clause.",
		"Command executed."
	],
	"vs/workbench/contrib/codeEditor/browser/accessibility/accessibility": [
		"Now changing the setting `editor.accessibilitySupport` to 'on'.",
		"Now opening the VS Code Accessibility documentation page.",
		"Thank you for trying out VS Code's accessibility options.",
		"Status:",
		"To configure the editor to be permanently optimized for usage with a Screen Reader press Command+E now.",
		"To configure the editor to be permanently optimized for usage with a Screen Reader press Control+E now.",
		"The editor is configured to use platform APIs to detect when a Screen Reader is attached, but the current runtime does not support this.",
		"The editor has automatically detected a Screen Reader is attached.",
		"The editor is configured to automatically detect when a Screen Reader is attached, which is not the case at this time.",
		"The editor is configured to be permanently optimized for usage with a Screen Reader - you can change this by editing the setting `editor.accessibilitySupport`.",
		"The editor is configured to never be optimized for usage with a Screen Reader.",
		"Pressing Tab in the current editor will move focus to the next focusable element. Toggle this behavior by pressing {0}.",
		"Pressing Tab in the current editor will move focus to the next focusable element. The command {0} is currently not triggerable by a keybinding.",
		"Pressing Tab in the current editor will insert the tab character. Toggle this behavior by pressing {0}.",
		"Pressing Tab in the current editor will insert the tab character. The command {0} is currently not triggerable by a keybinding.",
		"Press Command+H now to open a browser window with more VS Code information related to Accessibility.",
		"Press Control+H now to open a browser window with more VS Code information related to Accessibility.",
		"You can dismiss this tooltip and return to the editor by pressing Escape or Shift+Escape.",
		"Show Accessibility Help"
	],
	"vs/workbench/contrib/codeEditor/browser/diffEditorHelper": [
		"The diff algorithm was stopped early (after {0} ms.)",
		"Remove Limit",
		"Show Whitespace Differences"
	],
	"vs/workbench/contrib/codeEditor/browser/find/simpleFindWidget": [
		"Find",
		"Find",
		"Previous Match",
		"Next Match",
		"Close"
	],
	"vs/workbench/contrib/codeEditor/browser/inspectEditorTokens/inspectEditorTokens": [
		"Developer: Inspect Editor Tokens and Scopes",
		"Loading..."
	],
	"vs/workbench/contrib/codeEditor/browser/inspectKeybindings": [
		"Inspect Key Mappings",
		"Inspect Key Mappings (JSON)"
	],
	"vs/workbench/contrib/codeEditor/browser/languageConfigurationExtensionPoint": [
		"Errors parsing {0}: {1}",
		"{0}: Invalid format, JSON object expected.",
		"The opening bracket character or string sequence.",
		"The closing bracket character or string sequence.",
		"Defines the comment symbols",
		"Defines how block comments are marked.",
		"The character sequence that starts a block comment.",
		"The character sequence that ends a block comment.",
		"The character sequence that starts a line comment.",
		"Defines the bracket symbols that increase or decrease the indentation.",
		"Defines the bracket pairs that are colorized by their nesting level if bracket pair colorization is enabled.",
		"Defines the bracket pairs. When a opening bracket is entered, the closing bracket is inserted automatically.",
		"Defines a list of scopes where the auto pairs are disabled.",
		"Defines what characters must be after the cursor in order for bracket or quote autoclosing to occur when using the 'languageDefined' autoclosing setting. This is typically the set of characters which can not start an expression.",
		"Defines the bracket pairs that can be used to surround a selected string.",
		"Defines what is considered to be a word in the programming language.",
		"The RegExp pattern used to match words.",
		"The RegExp flags used to match words.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"The language's indentation settings.",
		"If a line matches this pattern, then all the lines after it should be indented once (until another rule matches).",
		"The RegExp pattern for increaseIndentPattern.",
		"The RegExp flags for increaseIndentPattern.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"If a line matches this pattern, then all the lines after it should be unindented once (until another rule matches).",
		"The RegExp pattern for decreaseIndentPattern.",
		"The RegExp flags for decreaseIndentPattern.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"If a line matches this pattern, then **only the next line** after it should be indented once.",
		"The RegExp pattern for indentNextLinePattern.",
		"The RegExp flags for indentNextLinePattern.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"If a line matches this pattern, then its indentation should not be changed and it should not be evaluated against the other rules.",
		"The RegExp pattern for unIndentedLinePattern.",
		"The RegExp flags for unIndentedLinePattern.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"The language's folding settings.",
		"A language adheres to the off-side rule if blocks in that language are expressed by their indentation. If set, empty lines belong to the subsequent block.",
		"Language specific folding markers such as '#region' and '#endregion'. The start and end regexes will be tested against the contents of all lines and must be designed efficiently",
		"The RegExp pattern for the start marker. The regexp must start with '^'.",
		"The RegExp pattern for the end marker. The regexp must start with '^'.",
		"The language's rules to be evaluated when pressing Enter.",
		"The language's rules to be evaluated when pressing Enter.",
		"This rule will only execute if the text before the cursor matches this regular expression.",
		"The RegExp pattern for beforeText.",
		"The RegExp flags for beforeText.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"This rule will only execute if the text after the cursor matches this regular expression.",
		"The RegExp pattern for afterText.",
		"The RegExp flags for afterText.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"This rule will only execute if the text above the line matches this regular expression.",
		"The RegExp pattern for previousLineText.",
		"The RegExp flags for previousLineText.",
		"Must match the pattern `/^([gimuy]+)$/`.",
		"The action to execute.",
		"Describe what to do with the indentation",
		"Insert new line and copy the previous line's indentation.",
		"Insert new line and indent once (relative to the previous line's indentation).",
		"Insert two new lines:\n - the first one indented which will hold the cursor\n - the second one at the same indentation level",
		"Insert new line and outdent once (relative to the previous line's indentation).",
		"Describes text to be appended after the new line and after the indentation.",
		"Describes the number of characters to remove from the new line's indentation."
	],
	"vs/workbench/contrib/codeEditor/browser/largeFileOptimizations": [
		"{0}: tokenization, wrapping and folding have been turned off for this large file in order to reduce memory usage and avoid freezing or crashing.",
		"Forcefully Enable Features",
		"Please reopen file in order for this setting to take effect."
	],
	"vs/workbench/contrib/codeEditor/browser/outline/documentSymbolsOutline": [
		"Document Symbols"
	],
	"vs/workbench/contrib/codeEditor/browser/outline/documentSymbolsTree": [
		"{0} ({1})",
		"1 problem in this element",
		"{0} problems in this element",
		"Contains elements with problems",
		"array",
		"boolean",
		"class",
		"constant",
		"constructor",
		"enumeration",
		"enumeration member",
		"event",
		"field",
		"file",
		"function",
		"interface",
		"key",
		"method",
		"module",
		"namespace",
		"null",
		"number",
		"object",
		"operator",
		"package",
		"property",
		"string",
		"struct",
		"type parameter",
		"variable"
	],
	"vs/workbench/contrib/codeEditor/browser/quickaccess/gotoLineQuickAccess": [
		"Type the line number and optional column to go to (e.g. 42:5 for line 42 and column 5).",
		"Go to Line/Column",
		"Go to Line/Column..."
	],
	"vs/workbench/contrib/codeEditor/browser/quickaccess/gotoSymbolQuickAccess": [
		"No matching entries",
		"Type the name of a symbol to go to.",
		"Go to Symbol in Editor",
		"Go to Symbol in Editor by Category",
		"Go to Symbol in Editor...",
		"Go to &&Symbol in Editor..."
	],
	"vs/workbench/contrib/codeEditor/browser/saveParticipants": [
		"Running '{0}' Formatter ([configure]({1})).",
		"Quick Fixes",
		"Getting code actions from '{0}' ([configure]({1})).",
		"Applying code action '{0}'."
	],
	"vs/workbench/contrib/codeEditor/browser/toggleColumnSelection": [
		"Toggle Column Selection Mode",
		"Column &&Selection Mode"
	],
	"vs/workbench/contrib/codeEditor/browser/toggleMinimap": [
		"Toggle Minimap",
		"Show &&Minimap"
	],
	"vs/workbench/contrib/codeEditor/browser/toggleMultiCursorModifier": [
		"Toggle Multi-Cursor Modifier",
		"Switch to Alt+Click for Multi-Cursor",
		"Switch to Cmd+Click for Multi-Cursor",
		"Switch to Ctrl+Click for Multi-Cursor"
	],
	"vs/workbench/contrib/codeEditor/browser/toggleRenderControlCharacter": [
		"Toggle Control Characters",
		"Render &&Control Characters"
	],
	"vs/workbench/contrib/codeEditor/browser/toggleRenderWhitespace": [
		"Toggle Render Whitespace",
		"&&Render Whitespace"
	],
	"vs/workbench/contrib/codeEditor/browser/toggleWordWrap": [
		"Whether the editor is currently using word wrapping.",
		"View: Toggle Word Wrap",
		"Disable wrapping for this file",
		"Enable wrapping for this file",
		"&&Word Wrap"
	],
	"vs/workbench/contrib/codeEditor/browser/untitledTextEditorHint": [
		"Select a language",
		"{0}",
		" to get started. Start typing to dismiss, or ",
		"don't show",
		" this again."
	],
	"vs/workbench/contrib/comments/browser/commentGlyphWidget": [
		"Editor gutter decoration color for commenting ranges."
	],
	"vs/workbench/contrib/comments/browser/commentNode": [
		"Toggle Reaction",
		"Toggling the comment reaction failed: {0}.",
		"Toggling the comment reaction failed",
		"Deleting the comment reaction failed: {0}.",
		"Deleting the comment reaction failed",
		"Deleting the comment reaction failed: {0}.",
		"Deleting the comment reaction failed"
	],
	"vs/workbench/contrib/comments/browser/commentThreadWidget": [
		"Icon to collapse a review comment.",
		"Collapse",
		"Start discussion",
		"Reply...",
		"Reply...",
		"Reply...",
		"Type a new comment"
	],
	"vs/workbench/contrib/comments/browser/comments.contribution": [
		"Comments",
		"Controls when the comments panel should open.",
		"Determines if relative time will be used in comment timestamps (ex. '1 day ago')."
	],
	"vs/workbench/contrib/comments/browser/commentsEditorContribution": [
		"Select Comment Provider",
		"Go to Next Comment Thread"
	],
	"vs/workbench/contrib/comments/browser/commentsTreeViewer": [
		"{0} comments",
		"1 comment",
		"Image: {0}",
		"Image",
		"Last reply from {0}"
	],
	"vs/workbench/contrib/comments/browser/commentsView": [
		"Comments for current workspace",
		"Comments in {0}, full path {1}",
		"Comment from ${0} at line {1} column {2} in {3}, source: {4}",
		"Collapse All"
	],
	"vs/workbench/contrib/comments/browser/reactionsAction": [
		"Pick Reactions..."
	],
	"vs/workbench/contrib/comments/common/commentModel": [
		"There are no comments in this workspace yet."
	],
	"vs/workbench/contrib/customEditor/common/contributedCustomEditors": [
		"Built-in"
	],
	"vs/workbench/contrib/customEditor/common/customEditor": [
		"The viewType of the currently active custom editor."
	],
	"vs/workbench/contrib/customEditor/common/extensionPoint": [
		"Contributed custom editors.",
		"Identifier for the custom editor. This must be unique across all custom editors, so we recommend including your extension id as part of `viewType`. The `viewType` is used when registering custom editors with `vscode.registerCustomEditorProvider` and in the `onCustomEditor:${id}` [activation event](https://code.visualstudio.com/api/references/activation-events).",
		"Human readable name of the custom editor. This is displayed to users when selecting which editor to use.",
		"Set of globs that the custom editor is enabled for.",
		"Glob that the custom editor is enabled for.",
		"Controls if the custom editor is enabled automatically when the user opens a file. This may be overridden by users using the `workbench.editorAssociations` setting.",
		"The editor is automatically used when the user opens a resource, provided that no other default custom editors are registered for that resource.",
		"The editor is not automatically used when the user opens a resource, but a user can switch to the editor using the `Reopen With` command."
	],
	"vs/workbench/contrib/debug/browser/breakpointEditorContribution": [
		"Logpoint",
		"Breakpoint",
		"This {0} has a {1} that will get lost on remove. Consider enabling the {0} instead.",
		"message",
		"condition",
		"This {0} has a {1} that will get lost on remove. Consider disabling the {0} instead.",
		"message",
		"condition",
		"Remove {0}",
		"{0} {1}",
		"Disable",
		"Enable",
		"Cancel",
		"Logpoint",
		"Breakpoint",
		"Remove {0}",
		"Edit {0}...",
		"Disable {0}",
		"Enable {0}",
		"Remove Breakpoints",
		"Remove Inline Breakpoint on Column {0}",
		"Remove Line Breakpoint",
		"Edit Breakpoints",
		"Edit Inline Breakpoint on Column {0}",
		"Edit Line Breakpoint",
		"Enable/Disable Breakpoints",
		"Disable Inline Breakpoint on Column {0}",
		"Disable Line Breakpoint",
		"Enable Inline Breakpoint on Column {0}",
		"Enable Line Breakpoint",
		"Add Breakpoint",
		"Add Conditional Breakpoint...",
		"Add Logpoint...",
		"Run to Line",
		"Icon color for breakpoints.",
		"Icon color for disabled breakpoints.",
		"Icon color for unverified breakpoints.",
		"Icon color for the current breakpoint stack frame.",
		"Icon color for all breakpoint stack frames."
	],
	"vs/workbench/contrib/debug/browser/breakpointWidget": [
		"Message to log when breakpoint is hit. Expressions within {} are interpolated. 'Enter' to accept, 'esc' to cancel.",
		"Break when hit count condition is met. 'Enter' to accept, 'esc' to cancel.",
		"Break when expression evaluates to true. 'Enter' to accept, 'esc' to cancel.",
		"Expression",
		"Hit Count",
		"Log Message",
		"Breakpoint Type"
	],
	"vs/workbench/contrib/debug/browser/breakpointsView": [
		"Unverified Exception Breakpoint",
		"Expression condition: {0}",
		"Expression: {0} | Hit Count: {1}",
		"Function breakpoints are not supported by this debug type",
		"Data breakpoints are not supported by this debug type",
		"Read",
		"Write",
		"Access",
		"Function to break on",
		"Type function breakpoint.",
		"Break when expression evaluates to true",
		"Type expression. Function breakpoint will break when expression evaluates to true",
		"Break when hit count is met",
		"Type hit count. Function breakpoint will break when hit count is met.",
		"Type exception breakpoint condition",
		"Break when expression evaluates to true",
		"Breakpoints",
		"Disabled Logpoint",
		"Disabled Breakpoint",
		"Unverified Logpoint",
		"Unverified Breakpoint",
		"Data breakpoints not supported by this debug type",
		"Data Breakpoint",
		"Function breakpoints not supported by this debug type",
		"Function Breakpoint",
		"Expression condition: {0}",
		"Hit Count: {0}",
		"Instruction breakpoints not supported by this debug type",
		"Instruction breakpoint at address {0}",
		"Instruction breakpoint",
		"Hit Count: {0}",
		"Breakpoints of this type are not supported by the debugger",
		"Log Message: {0}",
		"Expression condition: {0}",
		"Hit Count: {0}",
		"Breakpoint",
		"Add Function Breakpoint",
		"&&Function Breakpoint...",
		"Toggle Activate Breakpoints",
		"Remove Breakpoint",
		"Remove All Breakpoints",
		"Remove &&All Breakpoints",
		"Enable All Breakpoints",
		"&&Enable All Breakpoints",
		"Disable All Breakpoints",
		"Disable A&&ll Breakpoints",
		"Reapply All Breakpoints",
		"Edit Condition...",
		"Edit Condition...",
		"Edit Hit Count...",
		"Edit Function Breakpoint...",
		"Edit Hit Count..."
	],
	"vs/workbench/contrib/debug/browser/callStackEditorContribution": [
		"Background color for the highlight of line at the top stack frame position.",
		"Background color for the highlight of line at focused stack frame position."
	],
	"vs/workbench/contrib/debug/browser/callStackView": [
		"Running",
		"Show More Stack Frames",
		"Session",
		"Running",
		"Thread",
		"Restart Frame",
		"Load All Stack Frames",
		"Show {0} More: {1}",
		"Show {0} More Stack Frames",
		"Paused on {0}",
		"Paused",
		"Debug Call Stack",
		"Thread {0} {1}",
		"Stack Frame {0}, line {1}, {2}",
		"Running",
		"Session {0} {1}",
		"Show {0} More Stack Frames",
		"Collapse All"
	],
	"vs/workbench/contrib/debug/browser/debug.contribution": [
		"Debug",
		"Type the name of a launch configuration to run.",
		"Start Debugging",
		"Terminate Thread",
		"Focus on Debug Console View",
		"Jump to Cursor",
		"Set Next Statement",
		"Inline Breakpoint",
		"Terminate Thread",
		"Restart Frame",
		"Copy Call Stack",
		"View Binary Data",
		"Set Value",
		"Copy Value",
		"Copy as Expression",
		"Add to Watch",
		"Break on Value Read",
		"Break on Value Change",
		"Break on Value Access",
		"Edit Expression",
		"Set Value",
		"Copy Value",
		"View Binary Data",
		"Remove Expression",
		"Run or Debug...",
		"&&Run",
		"&&Start Debugging",
		"Run &&Without Debugging",
		"&&Stop Debugging",
		"&&Restart Debugging",
		"A&&dd Configuration...",
		"Step &&Over",
		"Step &&Into",
		"Step O&&ut",
		"&&Continue",
		"Inline Breakp&&oint",
		"&&New Breakpoint",
		"&&Install Additional Debuggers...",
		"Debug Console",
		"Debug Console",
		"De&&bug Console",
		"Run and Debug",
		"&&Run",
		"Variables",
		"Watch",
		"Call Stack",
		"Breakpoints",
		"Loaded Scripts",
		"Disassembly",
		"Debug",
		"Allow setting breakpoints in any file.",
		"Automatically open the explorer view at the end of a debug session.",
		"Show variable values inline in editor while debugging.",
		"Always show variable values inline in editor while debugging.",
		"Never show variable values inline in editor while debugging.",
		"Show variable values inline in editor while debugging when the language supports inline value locations.",
		"Controls the location of the debug toolbar. Either `floating` in all views, `docked` in the debug view, or `hidden`.",
		"Never show debug in status bar",
		"Always show debug in status bar",
		"Show debug in status bar only after debug was started for the first time",
		"Controls when the debug status bar should be visible.",
		"Controls if the debug console should be automatically closed when the debug session ends.",
		"Before starting a new debug session in an integrated or external terminal, clear the terminal.",
		"Controls when the debug view should open.",
		"Controls whether the debug sub-sessions are shown in the debug tool bar. When this setting is false the stop command on a sub-session will also stop the parent session.",
		"Controls the font size in pixels in the debug console.",
		"Controls the font family in the debug console.",
		"Controls the line height in pixels in the debug console. Use 0 to compute the line height from the font size.",
		"Controls if the lines should wrap in the debug console.",
		"Controls if the debug console should suggest previously typed input.",
		"Controls if the debug console should collapse identical lines and show a number of occurrences with a badge.",
		"Controls whether suggestions should be accepted on enter in the debug console. enter is also used to evaluate whatever is typed in the debug console.",
		"Global debug launch configuration. Should be used as an alternative to 'launch.json' that is shared across workspaces.",
		"Controls whether the workbench window should be focused when the debugger breaks.",
		"Ignore task errors and start debugging.",
		"Show the Problems view and do not start debugging.",
		"Prompt user.",
		"Cancel debugging.",
		"Controls what to do when errors are encountered after running a preLaunchTask.",
		"Controls whether breakpoints should be shown in the overview ruler.",
		"Controls whether inline breakpoints candidate decorations should be shown in the editor while debugging.",
		"Controls what editors to save before starting a debug session.",
		"Save all editors in the active group before starting a debug session.",
		"Save all editors in the active group except untitled ones before starting a debug session.",
		"Don't save any editors before starting a debug session.",
		"Controls whether to confirm when the window closes if there are active debug sessions.",
		"Never confirm.",
		"Always confirm if there are debug sessions.",
		"Show Source Code in Disassembly View."
	],
	"vs/workbench/contrib/debug/browser/debugActionViewItems": [
		"Debug Launch Configurations",
		"No Configurations",
		"Add Config ({0})...",
		"Add Configuration...",
		"Debug Session"
	],
	"vs/workbench/contrib/debug/browser/debugAdapterManager": [
		"Debugger 'type' can not be omitted and must be of type 'string'.",
		"Name of configuration; appears in the launch configuration dropdown menu.",
		"For debug extension development only: if a port is specified VS Code tries to connect to a debug adapter running in server mode",
		"Task to run before debug session starts.",
		"Task to run after debug session ends.",
		"You don't have an extension for debugging {0}. Should we find a {0} extension in the Marketplace?",
		"Find {0} extension",
		"Cancel",
		"Select environment",
		"Install an extension for {0}...",
		"Install extension..."
	],
	"vs/workbench/contrib/debug/browser/debugColors": [
		"Debug toolbar background color.",
		"Debug toolbar border color.",
		"Debug toolbar icon for start debugging.",
		"Debug toolbar icon for pause.",
		"Debug toolbar icon for stop.",
		"Debug toolbar icon for disconnect.",
		"Debug toolbar icon for restart.",
		"Debug toolbar icon for step over.",
		"Debug toolbar icon for step into.",
		"Debug toolbar icon for step over.",
		"Debug toolbar icon for continue.",
		"Debug toolbar icon for step back."
	],
	"vs/workbench/contrib/debug/browser/debugCommands": [
		"Restart",
		"Step Over",
		"Step Into",
		"Step Out",
		"Pause",
		"Disconnect",
		"Stop",
		"Continue",
		"Focus Session",
		"Select and Start Debugging",
		"Open '{0}'",
		"Start Debugging",
		"Start Without Debugging",
		"Choose the specific location",
		"No executable code is associated at the current cursor position.",
		"Jump to Cursor",
		"Debug",
		"Add Inline Breakpoint",
		"Debug"
	],
	"vs/workbench/contrib/debug/browser/debugConfigurationManager": [
		"Select Launch Configuration",
		"Edit Debug Configuration in launch.json",
		"Unable to create 'launch.json' file inside the '.vscode' folder ({0}).",
		"workspace",
		"user settings"
	],
	"vs/workbench/contrib/debug/browser/debugEditorActions": [
		"Debug: Toggle Breakpoint",
		"Toggle &&Breakpoint",
		"Debug: Add Conditional Breakpoint...",
		"&&Conditional Breakpoint...",
		"Debug: Add Logpoint...",
		"&&Logpoint...",
		"Open Disassembly View",
		"&&DisassemblyView",
		"Toggle Source Code in Disassembly View",
		"&&ToggleSource",
		"Run to Cursor",
		"Evaluate in Debug Console",
		"Add to Watch",
		"Debug: Show Hover",
		"Step Into Targets...",
		"Debug: Go to Next Breakpoint",
		"Debug: Go to Previous Breakpoint",
		"Close Exception Widget"
	],
	"vs/workbench/contrib/debug/browser/debugEditorContribution": [
		"Color for the debug inline value text.",
		"Color for the debug inline value background.",
		"Add Configuration..."
	],
	"vs/workbench/contrib/debug/browser/debugHover": [
		"Hold {0} key to switch to editor language hover",
		"Debug Hover",
		"{0}, value {1}, variables, debug"
	],
	"vs/workbench/contrib/debug/browser/debugIcons": [
		"View icon of the debug console view.",
		"View icon of the run view.",
		"View icon of the variables view.",
		"View icon of the watch view.",
		"View icon of the call stack view.",
		"View icon of the breakpoints view.",
		"View icon of the loaded scripts view.",
		"Icon for breakpoints.",
		"Icon for disabled breakpoints.",
		"Icon for unverified breakpoints.",
		"Icon for function breakpoints.",
		"Icon for disabled function breakpoints.",
		"Icon for unverified function breakpoints.",
		"Icon for conditional breakpoints.",
		"Icon for disabled conditional breakpoints.",
		"Icon for unverified conditional breakpoints.",
		"Icon for data breakpoints.",
		"Icon for disabled data breakpoints.",
		"Icon for unverified data breakpoints.",
		"Icon for log breakpoints.",
		"Icon for disabled log breakpoint.",
		"Icon for unverified log breakpoints.",
		"Icon for breakpoint hints shown on hover in editor glyph margin.",
		"Icon for unsupported breakpoints.",
		"Icon for a stackframe shown in the editor glyph margin.",
		"Icon for a focused stackframe  shown in the editor glyph margin.",
		"Icon for the debug bar gripper.",
		"Icon for the debug restart frame action.",
		"Icon for the debug stop action.",
		"Icon for the debug disconnect action.",
		"Icon for the debug restart action.",
		"Icon for the debug step over action.",
		"Icon for the debug step into action.",
		"Icon for the debug step out action.",
		"Icon for the debug step back action.",
		"Icon for the debug pause action.",
		"Icon for the debug continue action.",
		"Icon for the debug reverse continue action.",
		"Icon for the run or debug action.",
		"Icon for the debug start action.",
		"Icon for the debug configure action.",
		"Icon for the debug console open action.",
		"Icon for removing debug configurations.",
		"Icon for the collapse all action in the debug views.",
		"Icon for the session icon in the call stack view.",
		"Icon for the clear all action in the debug console.",
		"Icon for the Remove All action in the watch view.",
		"Icon for the add action in the watch view.",
		"Icon for the add function breakpoint action in the watch view.",
		"Icon for the Remove All action in the breakpoints view.",
		"Icon for the activate action in the breakpoints view.",
		"Icon for the debug evaluation input marker.",
		"Icon for the debug evaluation prompt.",
		"Icon for the inspect memory action."
	],
	"vs/workbench/contrib/debug/browser/debugQuickAccess": [
		"No matching launch configurations",
		"Configure Launch Configuration",
		"contributed",
		"Remove Launch Configuration",
		"{0} contributed configurations",
		"configure",
		"Add Config ({0})...",
		"Add Configuration..."
	],
	"vs/workbench/contrib/debug/browser/debugService": [
		"1 active session",
		"{0} active sessions",
		"Running executes build tasks and program code from your workspace.",
		"Debugging executes build tasks and program code from your workspace.",
		"Compound must have \"configurations\" attribute set in order to start multiple configurations.",
		"Could not find launch configuration '{0}' in the workspace.",
		"There are multiple launch configurations '{0}' in the workspace. Use folder name to qualify the configuration.",
		"Can not find folder with name '{0}' for configuration '{1}' in compound '{2}'.",
		"Configuration '{0}' is missing in 'launch.json'.",
		"'launch.json' does not exist for passed workspace folder.",
		"Attribute '{0}' has an unsupported value '{1}' in the chosen debug configuration.",
		"Attribute '{0}' is missing from the chosen debug configuration.",
		"Configured debug type '{0}' is not supported.",
		"Missing property 'type' for the chosen launch configuration.",
		"Install {0} Extension",
		"The active file can not be debugged. Make sure it is saved and that you have a debug extension installed for that file type.",
		"'{0}' is already running. Do you want to start another instance?",
		"Debug adapter process has terminated unexpectedly ({0})",
		"Cancel",
		"{0}:{1}, debugging paused {2}, {3}",
		"Added breakpoint, line {0}, file {1}",
		"Removed breakpoint, line {0}, file {1}"
	],
	"vs/workbench/contrib/debug/browser/debugSession": [
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"Session is not ready for breakpoints",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"No debugger available, can not send '{0}'",
		"Debugging started.",
		"Debugging stopped."
	],
	"vs/workbench/contrib/debug/browser/debugStatus": [
		"Debug",
		"Debug: {0}",
		"Select and start debug configuration"
	],
	"vs/workbench/contrib/debug/browser/debugTaskRunner": [
		"Errors exist after running preLaunchTask '{0}'.",
		"Error exists after running preLaunchTask '{0}'.",
		"The preLaunchTask '{0}' terminated with exit code {1}.",
		"The preLaunchTask '{0}' terminated.",
		"Debug Anyway",
		"Show Errors",
		"Abort",
		"Remember my choice in user settings",
		"Debug Anyway",
		"Cancel",
		"Remember my choice for this task",
		"Task '{0}' can not be referenced from a launch configuration that is in a different workspace folder.",
		"Could not find the task '{0}'.",
		"Could not find the specified task.",
		"The task '{0}' cannot be tracked. Make sure to have a problem matcher defined.",
		"The task '{0}' cannot be tracked. Make sure to have a problem matcher defined."
	],
	"vs/workbench/contrib/debug/browser/debugToolBar": [
		"Step Back",
		"Reverse"
	],
	"vs/workbench/contrib/debug/browser/debugViewlet": [
		"Open &&Configurations",
		"Select a workspace folder to create a launch.json file in or add it to the workspace config file",
		"Debug Console",
		"Start Additional Session"
	],
	"vs/workbench/contrib/debug/browser/disassemblyView": [
		"Disassembly not available.",
		"instructions",
		"from disassembly",
		"Disassembly View",
		"Address",
		"Bytes",
		"Instruction"
	],
	"vs/workbench/contrib/debug/browser/exceptionWidget": [
		"Exception widget border color.",
		"Exception widget background color.",
		"Exception has occurred: {0}",
		"Exception has occurred.",
		"Close"
	],
	"vs/workbench/contrib/debug/browser/linkDetector": [
		"follow link using forwarded port",
		"follow link",
		"Cmd + click to {0}",
		"Ctrl + click to {0}"
	],
	"vs/workbench/contrib/debug/browser/loadedScriptsView": [
		"Debug Session",
		"Debug Loaded Scripts",
		"Workspace folder {0}, loaded script, debug",
		"Session {0}, loaded script, debug",
		"Folder {0}, loaded script, debug",
		"{0}, loaded script, debug"
	],
	"vs/workbench/contrib/debug/browser/rawDebugSession": [
		"No debug adapter, can not start debug session.",
		"The debugger needs to open a new tab or window for the debuggee but the browser prevented this. You must give permission to continue.",
		"Continue",
		"Cancel",
		"No debugger available found. Can not send '{0}'.",
		"More Info"
	],
	"vs/workbench/contrib/debug/browser/repl": [
		"Filter (e.g. text, !exclude)",
		"Debug Console",
		"Please start a debug session to evaluate expressions",
		"REPL Accept Input",
		"REPL Focus Content to Filter",
		"Debug: Console Copy All",
		"Filter",
		"Select Debug Console",
		"Clear Console",
		"Debug console was cleared",
		"Collapse All",
		"Paste",
		"Copy All",
		"Copy"
	],
	"vs/workbench/contrib/debug/browser/replFilter": [
		"Showing {0} of {1}"
	],
	"vs/workbench/contrib/debug/browser/replViewer": [
		"Debug Console",
		"Variable {0}, value {1}",
		", occurred {0} times",
		"Debug console variable {0}, value {1}",
		"Debug console group {0}"
	],
	"vs/workbench/contrib/debug/browser/statusbarColorProvider": [
		"Status bar background color when a program is being debugged. The status bar is shown in the bottom of the window",
		"Status bar foreground color when a program is being debugged. The status bar is shown in the bottom of the window",
		"Status bar border color separating to the sidebar and editor when a program is being debugged. The status bar is shown in the bottom of the window"
	],
	"vs/workbench/contrib/debug/browser/variablesView": [
		"Type new variable value",
		"Debug Variables",
		"Scope {0}",
		"{0}, value {1}",
		"Inspecting binary data requires the Hex Editor extension. Would you like to install it now?",
		"Cancel",
		"Install",
		"Installing the Hex Editor...",
		"Collapse All"
	],
	"vs/workbench/contrib/debug/browser/watchExpressionsView": [
		"Type new value",
		"Type watch expression",
		"Expression to watch",
		"Debug Watch Expressions",
		"{0}, value {1}",
		"{0}, value {1}",
		"Collapse All",
		"Add Expression",
		"Remove All Expressions"
	],
	"vs/workbench/contrib/debug/browser/welcomeView": [
		"Run",
		"[Open a file](command:{0}) which can be debugged or run.",
		"[Run and Debug{0}](command:{1})",
		"[Show all automatic debug configurations](command:{0}).",
		"To customize Run and Debug [create a launch.json file](command:{0}).",
		"To customize Run and Debug, [open a folder](command:{0}) and create a launch.json file.",
		"All debug extensions are disabled. Enable a debug extension or install a new one from the Marketplace."
	],
	"vs/workbench/contrib/debug/common/abstractDebugAdapter": [
		"Timeout after {0} ms for '{1}'"
	],
	"vs/workbench/contrib/debug/common/debug": [
		"Debug type of the active debug session. For example 'python'.",
		"Debug type of the selected launch configuration. For example 'python'.",
		"State that the focused debug session is in. One of the following: 'inactive', 'initializing', 'stopped' or 'running'.",
		"Debug UX state. When there are no debug configurations it is 'simple', otherwise 'default'. Used to decide when to show welcome views in the debug viewlet.",
		"True when debugging, false otherwise.",
		"True when focus is in the debug console, false otherwise.",
		"True when breakpoint editor zone widget is visible, false otherwise.",
		"True when focus is in the breakpoint editor zone widget, false otherwise.",
		"True when the BREAKPOINTS view is focused, false otherwise.",
		"True when the WATCH view is focused, false otherwsie.",
		"True when at least one watch expression exists, false otherwise.",
		"True when the VARIABLES views is focused, false otherwsie",
		"True when an expression input box is open in either the WATCH or the VARIABLES view, false otherwise.",
		"True when the input box has focus in the BREAKPOINTS view.",
		"Represents the item type of the focused element in the CALL STACK view. For example: 'session', 'thread', 'stackFrame'",
		"True when the session in the CALL STACK view is attach, false otherwise. Used internally for inline menus in the CALL STACK view.",
		"True when the focused item in the CALL STACK is stopped. Used internaly for inline menus in the CALL STACK view.",
		"True when the focused session in the CALL STACK view has exactly one thread. Used internally for inline menus in the CALL STACK view.",
		"Represents the item type of the focused element in the WATCH view. For example: 'expression', 'variable'",
		"Indicates whether the item in the view has an associated memory refrence.",
		"Represents the item type of the focused element in the BREAKPOINTS view. For example: 'breakpoint', 'exceptionBreakppint', 'functionBreakpoint', 'dataBreakpoint'",
		"Represents the access type of the focused data breakpoint in the BREAKPOINTS view. For example: 'read', 'readWrite', 'write'",
		"True when the focused breakpoint supports conditions.",
		"True when the focused sessions supports the LOADED SCRIPTS view",
		"Represents the item type of the focused element in the LOADED SCRIPTS view.",
		"True when the focused session is 'attach'.",
		"True when the focused session supports 'stepBack' requests.",
		"True when the focused session supports 'restartFrame' requests.",
		"True when the focused stack frame suppots 'restartFrame'.",
		"True when the focused session supports 'jumpToCursor' request.",
		"True when the focused session supports 'stepIntoTargets' request.",
		"True when at least one breakpoint exists.",
		"True when there is at least one debug extensions active.",
		"True when there is at least one debug extension installed and enabled.",
		"Represents the context the debug adapter sets on the focused variable in the VARIABLES view.",
		"True when the focused session supports 'setVariable' request.",
		"True when the focused session supports 'setExpression' request.",
		"True when the focused session supports to break when value changes.",
		"True when the focused breakpoint supports to break when value is accessed.",
		"True when the focused breakpoint supports to break when value is read.",
		"True when the focused session supports the terminate debuggee capability.",
		"True when the focused variable has an 'evalauteName' field set.",
		"True when the focused variable is readonly.",
		"True when the exception widget is visible.",
		"True when there is more than 1 debug console.",
		"True when there is more than 1 active debug session.",
		"True when the focused sessions supports disassemble request.",
		"True when the Disassembly View is focused.",
		"True when the language in the current editor supports disassemble request.",
		"True when the focused stack frame has instruction pointer reference.",
		"Configured debug type '{0}' is installed but not supported in this environment.",
		"Controls when the internal debug console should open."
	],
	"vs/workbench/contrib/debug/common/debugContentProvider": [
		"Unable to resolve the resource without a debug session",
		"Could not load source '{0}': {1}.",
		"Could not load source '{0}'."
	],
	"vs/workbench/contrib/debug/common/debugLifecycle": [
		"There is an active debug session, are you sure you want to stop it?",
		"There are active debug sessions, are you sure you want to stop them?",
		"Stop Debugging"
	],
	"vs/workbench/contrib/debug/common/debugModel": [
		"Invalid variable attributes",
		"Please start a debug session to evaluate expressions",
		"not available",
		"Paused on {0}",
		"Paused",
		"Running",
		"Unverified breakpoint. File is modified, please restart debug session."
	],
	"vs/workbench/contrib/debug/common/debugSchemas": [
		"Contributes debug adapters.",
		"Unique identifier for this debug adapter.",
		"Display name for this debug adapter.",
		"Path to the debug adapter program. Path is either absolute or relative to the extension folder.",
		"Optional arguments to pass to the adapter.",
		"Optional runtime in case the program attribute is not an executable but requires a runtime.",
		"Optional runtime arguments.",
		"Mapping from interactive variables (e.g. ${action.pickProcess}) in `launch.json` to a command.",
		"Configurations for generating the initial 'launch.json'.",
		"List of languages for which the debug extension could be considered the \"default debugger\".",
		"Snippets for adding new configurations in 'launch.json'.",
		"JSON schema configurations for validating 'launch.json'.",
		"Condition which must be true to enable this type of debugger. Consider using 'shellExecutionSupported', 'virtualWorkspace', 'resourceScheme' or an extension defined context key as appropriate for this.",
		"Windows specific settings.",
		"Runtime used for Windows.",
		"macOS specific settings.",
		"Runtime used for macOS.",
		"Linux specific settings.",
		"Runtime used for Linux.",
		"Contributes breakpoints.",
		"Allow breakpoints for this language.",
		"Presentation options on how to show this configuration in the debug configuration dropdown and the command palette.",
		"Controls if this configuration should be shown in the configuration dropdown and the command palette.",
		"Group that this configuration belongs to. Used for grouping and sorting in the configuration dropdown and the command palette.",
		"Order of this configuration within a group. Used for grouping and sorting in the configuration dropdown and the command palette.",
		"Launch",
		"Version of this file format.",
		"List of configurations. Add new configurations or edit existing ones by using IntelliSense.",
		"List of compounds. Each compound references multiple configurations which will get launched together.",
		"Name of compound. Appears in the launch configuration drop down menu.",
		"Please use unique configuration names.",
		"Name of compound. Appears in the launch configuration drop down menu.",
		"Name of folder in which the compound is located.",
		"Names of configurations that will be started as part of this compound.",
		"Controls whether manually terminating one session will stop all of the compound sessions.",
		"Task to run before any of the compound configurations start."
	],
	"vs/workbench/contrib/debug/common/debugSource": [
		"Unknown Source"
	],
	"vs/workbench/contrib/debug/common/debugger": [
		"Cannot find debug adapter for type '{0}'.",
		"Use IntelliSense to learn about possible attributes.",
		"Hover to view descriptions of existing attributes.",
		"For more information, visit: {0}",
		"Type of configuration.",
		"The debug type is not recognized. Make sure that you have a corresponding debug extension installed and that it is enabled.",
		"\"node2\" is no longer supported, use \"node\" instead and set the \"protocol\" attribute to \"inspector\".",
		"Request type of configuration. Can be \"launch\" or \"attach\".",
		"Windows specific launch configuration attributes.",
		"OS X specific launch configuration attributes.",
		"Linux specific launch configuration attributes."
	],
	"vs/workbench/contrib/debug/common/disassemblyViewInput": [
		"Disassembly"
	],
	"vs/workbench/contrib/debug/common/replModel": [
		"Console was cleared"
	],
	"vs/workbench/contrib/emmet/browser/actions/expandAbbreviation": [
		"Emmet: Expand Abbreviation",
		"Emmet: E&&xpand Abbreviation"
	],
	"vs/workbench/contrib/experiments/browser/experiments.contribution": [
		"Fetches experiments to run from a Microsoft online service."
	],
	"vs/workbench/contrib/extensions/browser/abstractRuntimeExtensionsEditor": [
		"Activated by {0} on start-up",
		"Activated by {1} because a file matching {0} exists in your workspace",
		"Activated by {1} because file {0} exists in your workspace",
		"Activated by {1} because searching for {0} took too long",
		"Activated by {0} after start-up finished",
		"Activated by {1} because you opened a {0} file",
		"Activated by {1} on {0}",
		"Extension has caused the extension host to freeze.",
		"{0} uncaught errors",
		"Runtime Extensions",
		"Disable (Workspace)",
		"Disable",
		"Show Running Extensions"
	],
	"vs/workbench/contrib/extensions/browser/configBasedRecommendations": [
		"This extension is recommended because of the current workspace configuration"
	],
	"vs/workbench/contrib/extensions/browser/dynamicWorkspaceRecommendations": [
		"This extension may interest you because it's popular among users of the {0} repository."
	],
	"vs/workbench/contrib/extensions/browser/exeBasedRecommendations": [
		"This extension is recommended because you have {0} installed."
	],
	"vs/workbench/contrib/extensions/browser/extensionEditor": [
		"Extension Version",
		"Pre-Release",
		"Extension name",
		"Preview",
		"Preview",
		"Built-in",
		"Publisher",
		"Install count",
		"Rating",
		"This publisher has verified ownership of {0}",
		"Details",
		"Extension details, rendered from the extension's 'README.md' file",
		"Feature Contributions",
		"Lists contributions to VS Code by this extension",
		"Changelog",
		"Extension update history, rendered from the extension's 'CHANGELOG.md' file",
		"Dependencies",
		"Lists extensions this extension depends on",
		"Extension Pack",
		"Lists extensions those will be installed together with this extension",
		"Runtime Status",
		"Extension runtime status",
		"You have chosen not to receive recommendations for this extension.",
		"No README available.",
		"Extension Pack ({0})",
		"No README available.",
		"Categories",
		"Marketplace",
		"Repository",
		"License",
		"Resources",
		"Marketplace Info",
		"Released on",
		"Last updated",
		"Identifier",
		"No Changelog available.",
		"No Contributions",
		"No Contributions",
		"No Dependencies",
		"Activation time",
		"Startup",
		"Not yet activated.",
		"Uncaught Errors ({0})",
		"Messages ({0})",
		"No status available.",
		"Settings ({0})",
		"Name",
		"Description",
		"Default",
		"Debuggers ({0})",
		"Name",
		"Type",
		"View Containers ({0})",
		"ID",
		"Title",
		"Where",
		"Views ({0})",
		"ID",
		"Name",
		"Where",
		"Localizations ({0})",
		"Language ID",
		"Language Name",
		"Language Name (Localized)",
		"Custom Editors ({0})",
		"View Type",
		"Priority",
		"Filename Pattern",
		"Code Actions ({0})",
		"Title",
		"Kind",
		"Description",
		"Languages",
		"Authentication ({0})",
		"Label",
		"Id",
		"Color Themes ({0})",
		"File Icon Themes ({0})",
		"Product Icon Themes ({0})",
		"Colors ({0})",
		"Id",
		"Description",
		"Dark Default",
		"Light Default",
		"High Contrast Default",
		"JSON Validation ({0})",
		"File Match",
		"Schema",
		"Commands ({0})",
		"Name",
		"Description",
		"Keyboard Shortcuts",
		"Menu Contexts",
		"Languages ({0})",
		"ID",
		"Name",
		"File Extensions",
		"Grammar",
		"Snippets",
		"Activation Events ({0})",
		"Notebooks ({0})",
		"Id",
		"Name",
		"Notebook Renderers ({0})",
		"Name",
		"Mimetypes",
		"Find",
		"Find Next",
		"Find Previous"
	],
	"vs/workbench/contrib/extensions/browser/extensionRecommendationNotificationService": [
		"Don't Show Again",
		"Do you want to ignore all extension recommendations?",
		"Yes, Ignore All",
		"No",
		"'{0}' extension is recommended for this repository. Do you want to install?",
		"Do you want to install the recommended extensions for this repository?",
		"Install",
		"Install (Do not sync)",
		"Show Recommendations"
	],
	"vs/workbench/contrib/extensions/browser/extensions.contribution": [
		"Press Enter to manage extensions.",
		"Manage Extensions",
		"Extension",
		"Extensions",
		"E&&xtensions",
		"Extensions",
		"All Extensions",
		"Only Enabled Extensions",
		"None",
		"Download and install updates automatically for all extensions.",
		"Download and install updates automatically only for enabled extensions. Disabled extensions will not be updated automatically.",
		"Extensions are not automatically updated.",
		"Controls the automatic update behavior of extensions. The updates are fetched from a Microsoft online service.",
		"When enabled, automatically checks extensions for updates. If an extension has an update, it is marked as outdated in the Extensions view. The updates are fetched from a Microsoft online service.",
		"When enabled, the notifications for extension recommendations will not be shown.",
		"This setting is deprecated. Use extensions.ignoreRecommendations setting to control recommendation notifications. Use Extensions view's visibility actions to hide Recommended view by default.",
		"When enabled, editors with extension details will be automatically closed upon navigating away from the Extensions View.",
		"When an extension is listed here, a confirmation prompt will not be shown when that extension handles a URI.",
		"The Web Worker Extension Host will always be launched.",
		"The Web Worker Extension Host will never be launched.",
		"The Web Worker Extension Host will be launched when a web extension needs it.",
		"Enable web worker extension host.",
		"Override the virtual workspaces support of an extension.",
		"Override the untrusted workspace support of an extension. Extensions using `true` will always be enabled. Extensions using `limited` will always be enabled, and the extension will hide functionality that requires trust. Extensions using `false` will only be enabled only when the workspace is trusted.",
		"Extension will always be enabled.",
		"Extension will only be enabled only when the workspace is trusted.",
		"Extension will always be enabled, and the extension will hide functionality requiring trust.",
		"Defines the untrusted workspace support setting for the extension.",
		"Defines the version of the extension for which the override should be applied. If not specified, the override will be applied independent of the extension version.",
		"Install the given extension",
		"Extension id or VSIX resource uri",
		"When enabled, VS Code installs only newly added extensions from the extension pack VSIX. This option is considered only while installing a VSIX.",
		"When enabled, VS Code installs the pre-release version of the extension if available.",
		"When enabled, VS Code do not sync this extension when Settings Sync is on.",
		"Extension '{0}' not found.",
		"Uninstall the given extension",
		"Id of the extension to uninstall",
		"Extension id required.",
		"Extension '{0}' is not installed. Make sure you use the full extension ID, including the publisher, e.g.: ms-dotnettools.csharp.",
		"Extension '{0}' is a Built-in extension and cannot be installed",
		"Search for a specific extension",
		"Query to use in search",
		"Type the name of an extension to install or search.",
		"Install or Search Extensions",
		"&&Extensions",
		"Extensions",
		"Install Extensions",
		"Keymaps",
		"&&Migrate Keyboard Shortcuts from...",
		"Migrate Keyboard Shortcuts from...",
		"Language Extensions",
		"Check for Extension Updates",
		"All extensions are up to date.",
		"Auto Update Extensions",
		"All Extensions",
		"Only Enabled Extensions",
		"None",
		"Update All Extensions",
		"Disable Auto Update for all extensions",
		"Enable Auto Update for all extensions",
		"Enable All Extensions",
		"Enable All Extensions for this Workspace",
		"Disable All Installed Extensions",
		"Disable All Installed Extensions for this Workspace",
		"Install from VSIX...",
		"Install from VSIX",
		"&&Install",
		"Install Extension VSIX",
		"Completed installing {0} extension from VSIX. Please reload Visual Studio Code to enable it.",
		"Completed installing {0} extension from VSIX.",
		"Reload Now",
		"Install Web Extension...",
		"Install Web Extension from Location",
		"Install",
		"Location of the web extension",
		"Filter Extensions...",
		"Show Featured Extensions",
		"Featured",
		"Show Popular Extensions",
		"Most Popular",
		"Show Recommended Extensions",
		"Recommended",
		"Show Recently Published Extensions",
		"Recently Published",
		"Category",
		"Show Built-in Extensions",
		"Built-in",
		"Show Extensions Unsupported By Workspace",
		"Workspace Unsupported",
		"Show Installed Extensions",
		"Installed",
		"Show Enabled Extensions",
		"Enabled",
		"Show Disabled Extensions",
		"Disabled",
		"Show Outdated Extensions",
		"Outdated",
		"Sort By",
		"Install Count",
		"Rating",
		"Name",
		"Published Date",
		"Clear Extensions Search Results",
		"Refresh",
		"Install Workspace Recommended Extensions",
		"Show Pre-Release Version",
		"Show Release Version",
		"Copy",
		"Name: {0}",
		"Id: {0}",
		"Description: {0}",
		"Version: {0}",
		"Publisher: {0}",
		"VS Marketplace Link: {0}",
		"Copy Extension ID",
		"Extension Settings",
		"Sync This Extension",
		"Ignore Recommendation",
		"Undo Ignored Recommendation",
		"Add to Workspace Recommendations",
		"Remove from Workspace Recommendations",
		"Add Extension to Workspace Recommendations",
		"Extensions",
		"Add Extension to Workspace Folder Recommendations",
		"Extensions",
		"Add Extension to Workspace Ignored Recommendations",
		"Extensions",
		"Add Extension to Workspace Folder Ignored Recommendations",
		"Extensions",
		"Extensions"
	],
	"vs/workbench/contrib/extensions/browser/extensions.web.contribution": [
		"Running Extensions"
	],
	"vs/workbench/contrib/extensions/browser/extensionsActions": [
		"{0} for the Web",
		"The '{0}' extension is not available in {1}. Click 'More Information' to learn more.",
		"Close",
		"More Information",
		"Error while updating '{0}' extension.",
		"Error while installing '{0}' extension.",
		"Would you like to install the release version?",
		"Install Release Version",
		"Please check the [log]({0}) for more details.",
		"Try Downloading Manually...",
		"Once downloaded, please manually install the downloaded VSIX of '{0}'.",
		"Install from VSIX...",
		"Install",
		"Installing extension {0} started. An editor is now open with more details on this extension",
		"Installing extension {0} is completed.",
		"Install Pre-Release",
		"Install Pre-Release Version",
		"Install",
		"Install Release Version",
		"Install",
		"Do not sync",
		"{0} in {1} ({2})",
		"{0} in {1}",
		"{0} Locally ({1})",
		"{0} Locally",
		"Install this extension in all your synced {0} instances",
		"Installing",
		"Install",
		"Installing",
		"Installing extension {0} started. An editor is now open with more details on this extension",
		"Install in {0}",
		"Install Locally",
		"Install in Browser",
		"Uninstall",
		"Uninstalling",
		"Uninstalling extension {0} started.",
		"Please reload Visual Studio Code to complete the uninstallation of the extension {0}.",
		"Updating extension {0} to version {1} started.",
		"Updating extension {0} to version {1} completed.",
		"Update to {0}",
		"Update",
		"Manage",
		"Uninstalling",
		"Manage",
		"Switch to Pre-Release Version",
		"Switch to Release Version",
		"Install Another Version...",
		"This extension has no other versions.",
		"pre-release",
		"current",
		"Select Version to Install",
		"Enable (Workspace)",
		"Enable this extension only in this workspace",
		"Enable",
		"Enable this extension",
		"Disable (Workspace)",
		"Disable this extension only in this workspace",
		"Disable",
		"Disable this extension",
		"Enable",
		"Disable",
		"Reload",
		"Reload Required",
		"Please reload Visual Studio Code to complete the uninstallation of this extension.",
		"Please reload Visual Studio Code to complete the uninstallation of the extension {0}.",
		"Reload Required",
		"Please reload Visual Studio Code to enable the updated extension.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension locally.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension in {0}.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension.",
		"Reload Required",
		"Please reload Visual Studio Code to disable this extension.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension.",
		"Reload Required",
		"Please reload Visual Studio Code to enable this extension.",
		"Installing extension {0} is completed. Please reload Visual Studio Code to enable it.",
		"current",
		"Set Color Theme",
		"Select Color Theme",
		"Set File Icon Theme",
		"Select File Icon Theme",
		"Set Product Icon Theme",
		"Select Product Icon Theme",
		"Show Recommended Extension",
		"Install Recommended Extension",
		"Do not recommend this extension again",
		"Undo",
		"Search Extensions",
		"Unable to create 'extensions.json' file inside the '.vscode' folder ({0}).",
		"Configure Recommended Extensions (Workspace)",
		"Configure Recommended Extensions (Workspace Folder)",
		"Updated",
		"Installed",
		"Uninstalled",
		"Enabled",
		"Disabled",
		"This extension is ignored during sync",
		"This extension is synced",
		"Sync this extension",
		"Do not sync this extension",
		"This extension was reported to be problematic.",
		"This extension no longer supported.",
		"This extension is now part of the {0} extension as a pre-release version.",
		"The '{0}' extension is not available in {1} for {2}.",
		"Learn More",
		"{0} for the Web",
		"The '{0}' extension is not available in {1}.",
		"Learn Why",
		"This extension is disabled by the environment.",
		"This extension is enabled because it is required in the current environment.",
		"This extension has been disabled because it does not support virtual workspaces.",
		"This extension has limited features because the current workspace is virtual.",
		"This extension has been disabled because the current workspace is not trusted.",
		"This extension has limited features because the current workspace is not trusted.",
		"This extension is disabled in this workspace because it is defined to run in the Remote Extension Host. Please install the extension in '{0}' to enable.",
		"Learn More",
		"This extension is disabled in this workspace because it is defined to run in the Local Extension Host. Please install the extension locally to enable.",
		"Learn More",
		"This extension is disabled because it is defined to run only in {0} for the Desktop.",
		"Learn More",
		"This extension is disabled because it is not supported in {0} for the Web.",
		"Learn More",
		"Install the language pack extension on '{0}' to enable it there also.",
		"Install the language pack extension locally to enable it there also.",
		"This extension is enabled in the Remote Extension Host because it prefers to run there.",
		"Learn More",
		"This extension is enabled in the Local Extension Host because it prefers to run there.",
		"Learn More",
		"This extension is enabled in the Web Worker Extension Host because it prefers to run there.",
		"Learn More",
		"This extension has been disabled because it depends on an extension that is disabled.",
		"Extension is enabled on '{0}'",
		"This extension is enabled globally.",
		"This extension is enabled for this workspace by the user.",
		"This extension is disabled globally by the user.",
		"This extension is disabled for this workspace by the user.",
		"Reinstall Extension...",
		"Select Extension to Reinstall",
		"Please reload Visual Studio Code to complete reinstalling the extension {0}.",
		"Reinstalling the extension {0} is completed.",
		"Reload Now",
		"Install Specific Version of Extension...",
		"Select Extension",
		"Select extensions to install",
		"There are no extensions to install.",
		"Installing Extensions...",
		"Successfully installed extensions.",
		"Install Local Extensions in '{0}'...",
		"Install Local Extensions in '{0}'",
		"Install Remote Extensions Locally...",
		"Install Remote Extensions Locally",
		"Button background color for actions extension that stand out (e.g. install button).",
		"Button foreground color for actions extension that stand out (e.g. install button).",
		"Button background hover color for actions extension that stand out (e.g. install button)."
	],
	"vs/workbench/contrib/extensions/browser/extensionsActivationProgress": [
		"Activating Extensions..."
	],
	"vs/workbench/contrib/extensions/browser/extensionsCompletionItemsProvider": [
		"Example"
	],
	"vs/workbench/contrib/extensions/browser/extensionsDependencyChecker": [
		"Extensions",
		"Install Missing Dependencies",
		"Finished installing missing dependencies. Please reload the window now.",
		"Reload Window",
		"There are no missing dependencies to install."
	],
	"vs/workbench/contrib/extensions/browser/extensionsIcons": [
		"View icon of the extensions view.",
		"Icon for the 'Manage' action in the extensions view.",
		"Icon for the 'Clear Search Result' action in the extensions view.",
		"Icon for the 'Refresh' action in the extensions view.",
		"Icon for the 'Filter' action in the extensions view.",
		"Icon for the 'Install Local Extension in Remote' action in the extensions view.",
		"Icon for the 'Install Workspace Recommended Extensions' action in the extensions view.",
		"Icon for the 'Configure Recommended Extensions' action in the extensions view.",
		"Icon to indicate that an extension is synced.",
		"Icon to indicate that an extension is ignored when syncing.",
		"Icon to indicate that an extension is remote in the extensions view and editor.",
		"Icon shown along with the install count in the extensions view and editor.",
		"Icon shown along with the rating in the extensions view and editor.",
		"Icon used for the verified extension publisher in the extensions view and editor.",
		"Icon shown for extensions having pre-release versions in extensions view and editor.",
		"Full star icon used for the rating in the extensions editor.",
		"Half star icon used for the rating in the extensions editor.",
		"Empty star icon used for the rating in the extensions editor.",
		"Icon shown with a error message in the extensions editor.",
		"Icon shown with a warning message in the extensions editor.",
		"Icon shown with an info message in the extensions editor.",
		"Icon shown with a workspace trust message in the extension editor.",
		"Icon shown with a activation time message in the extension editor."
	],
	"vs/workbench/contrib/extensions/browser/extensionsQuickAccess": [
		"Type an extension name to install or search.",
		"Press Enter to search for extension '{0}'.",
		"Press Enter to install extension '{0}'.",
		"Press Enter to manage your extensions."
	],
	"vs/workbench/contrib/extensions/browser/extensionsViewer": [
		"Error",
		"Unknown Extension:",
		"{0}, {1}, {2}, {3}",
		"Extensions"
	],
	"vs/workbench/contrib/extensions/browser/extensionsViewlet": [
		"Installed",
		"Install Local Extensions in '{0}'...",
		"Remote",
		"Install Remote Extensions Locally...",
		"Remote",
		"Popular",
		"Recommended",
		"Enabled",
		"Disabled",
		"Marketplace",
		"Installed",
		"Enabled",
		"Disabled",
		"Outdated",
		"Builtin",
		"Workspace Unsupported",
		"Workspace Recommendations",
		"Other Recommendations",
		"Features",
		"Themes",
		"Programming Languages",
		"Disabled in Restricted Mode",
		"Limited in Restricted Mode",
		"Disabled in Virtual Workspaces",
		"Limited in Virtual Workspaces",
		"Search Extensions in Marketplace",
		"1 extension found in the {0} section.",
		"1 extension found.",
		"{0} extensions found in the {1} section.",
		"{0} extensions found.",
		"Marketplace returned 'ECONNREFUSED'. Please check the 'http.proxy' setting.",
		"Open User Settings",
		"{0} Outdated Extensions",
		"We have uninstalled '{0}' which was reported to be problematic.",
		"Reload Now"
	],
	"vs/workbench/contrib/extensions/browser/extensionsViews": [
		"{0}, {1}, {2}, {3}",
		"Extensions",
		"Unable to search the Marketplace when offline, please check your network connection.",
		"Error while fetching extensions. {0}",
		"No extensions found.",
		"Marketplace returned 'ECONNREFUSED'. Please check the 'http.proxy' setting.",
		"Open User Settings",
		"There are no extensions to install."
	],
	"vs/workbench/contrib/extensions/browser/extensionsWidgets": [
		"Extension in {0}",
		"This extension is ignored during sync.",
		"Activation time",
		"Startup",
		"Pre-Release",
		"This publisher has verified ownership of {0}",
		"Activation time",
		"Startup",
		"1 uncaught error",
		"{0} uncaught errors",
		"1 message",
		"{0} messages",
		"Show Dependencies",
		"Pre-Release version",
		"This extension has a {0} available",
		"The icon color for extension ratings.",
		"The icon color for extension verified publisher.",
		"The icon color for pre-release extension."
	],
	"vs/workbench/contrib/extensions/browser/extensionsWorkbenchService": [
		"Manifest is not found",
		"This extension is reported to be problematic.",
		"Uninstalling extension....",
		"Unable to install extension '{0}' because the requested version '{1}' is not found.",
		"Installing '{0}' extension....",
		"Installing extension....",
		"Disable All",
		"Cannot disable '{0}' extension alone. '{1}' extension depends on this. Do you want to disable all these extensions?",
		"Cannot disable '{0}' extension alone. '{1}' and '{2}' extensions depend on this. Do you want to disable all these extensions?",
		"Cannot disable '{0}' extension alone. '{1}', '{2}' and other extensions depend on this. Do you want to disable all these extensions?"
	],
	"vs/workbench/contrib/extensions/browser/fileBasedRecommendations": [
		"Search Marketplace",
		"This extension is recommended based on the files you recently opened.",
		"Do you want to install the recommended extensions for {0}?",
		"The Marketplace has extensions that can help with '.{0}' files",
		"Don't Show Again for '.{0}' files"
	],
	"vs/workbench/contrib/extensions/browser/webRecommendations": [
		"This extension is recommended for {0} for the Web"
	],
	"vs/workbench/contrib/extensions/browser/workspaceRecommendations": [
		"This extension is recommended by users of the current workspace."
	],
	"vs/workbench/contrib/extensions/common/extensionsFileTemplate": [
		"Extensions",
		"List of extensions which should be recommended for users of this workspace. The identifier of an extension is always '${publisher}.${name}'. For example: 'vscode.csharp'.",
		"Expected format '${publisher}.${name}'. Example: 'vscode.csharp'.",
		"List of extensions recommended by VS Code that should not be recommended for users of this workspace. The identifier of an extension is always '${publisher}.${name}'. For example: 'vscode.csharp'.",
		"Expected format '${publisher}.${name}'. Example: 'vscode.csharp'."
	],
	"vs/workbench/contrib/extensions/common/extensionsInput": [
		"Extension: {0}"
	],
	"vs/workbench/contrib/extensions/common/extensionsUtils": [
		"Disable other keymaps ({0}) to avoid conflicts between keybindings?",
		"Yes",
		"No"
	],
	"vs/workbench/contrib/extensions/common/runtimeExtensionsInput": [
		"Running Extensions"
	],
	"vs/workbench/contrib/externalTerminal/browser/externalTerminal.contribution": [
		"Open in Terminal",
		"Open in Integrated Terminal",
		"Open in Integrated Terminal",
		"Open in Windows Terminal",
		"Open in External Terminal"
	],
	"vs/workbench/contrib/externalUriOpener/common/configuration": [
		"Configure the opener to use for external URIs (http, https).",
		"Map URI pattern to an opener id.\nExample patterns: \n{0}",
		"Map URI pattern to an opener id.\nExample patterns: \n{0}",
		"Open using VS Code's standard opener."
	],
	"vs/workbench/contrib/externalUriOpener/common/externalUriOpenerService": [
		"Open in new browser window",
		"Open in default browser",
		"Configure default opener...",
		"How would you like to open: {0}"
	],
	"vs/workbench/contrib/feedback/browser/feedback": [
		"Tweet us your feedback.",
		"Close",
		"Your installation is corrupt.",
		"Please specify this if you submit a bug.",
		"How was your experience?",
		"Happy Feedback Sentiment",
		"Happy Feedback Sentiment",
		"Sad Feedback Sentiment",
		"Sad Feedback Sentiment",
		"Other ways to contact us",
		"Submit a bug",
		"Request a missing feature",
		"Tell us why?",
		"Tell us your feedback",
		"Show Feedback Icon in Status Bar",
		"Tweet",
		"Tweet Feedback",
		"character left",
		"characters left"
	],
	"vs/workbench/contrib/feedback/browser/feedbackStatusbarItem": [
		"Tweet Feedback",
		"Feedback",
		"Tweet Feedback",
		"Tweet Feedback"
	],
	"vs/workbench/contrib/files/browser/editors/binaryFileEditor": [
		"Binary File Viewer"
	],
	"vs/workbench/contrib/files/browser/editors/textFileEditor": [
		"Text File Editor",
		"File is a directory",
		"File not found",
		"Create File"
	],
	"vs/workbench/contrib/files/browser/editors/textFileSaveErrorHandler": [
		"Use the actions in the editor tool bar to either undo your changes or overwrite the content of the file with your changes.",
		"Failed to save '{0}': The content of the file is newer. Please compare your version with the file contents or overwrite the content of the file with your changes.",
		"Failed to save '{0}': File is read-only. Select 'Overwrite as Admin' to retry as administrator.",
		"Failed to save '{0}': File is read-only. Select 'Overwrite as Sudo' to retry as superuser.",
		"Failed to save '{0}': File is read-only. Select 'Overwrite' to attempt to make it writeable.",
		"Failed to save '{0}': Insufficient permissions. Select 'Retry as Admin' to retry as administrator.",
		"Failed to save '{0}': Insufficient permissions. Select 'Retry as Sudo' to retry as superuser.",
		"Failed to save '{0}': {1}",
		"Learn More",
		"Don't Show Again",
		"Compare",
		"{0} (in file) ↔ {1} (in {2}) - Resolve save conflict",
		"Overwrite as Admin...",
		"Overwrite as Sudo...",
		"Retry as Admin...",
		"Retry as Sudo...",
		"Retry",
		"Discard",
		"Overwrite",
		"Overwrite",
		"Configure"
	],
	"vs/workbench/contrib/files/browser/explorerViewlet": [
		"View icon of the explorer view.",
		"View icon of the open editors view.",
		"Folders",
		"Explorer",
		"Explorer",
		"&&Explorer",
		"Open Folder",
		"add a folder",
		"Open Recent",
		"You have not yet added a folder to the workspace.\n{0}",
		"You have not yet opened a folder.\n{0}\n{1}",
		"Connected to remote.\n{0}",
		"You have not yet opened a folder.\n{0}\nOpening a folder will close all currently open editors. To keep them open, {1} instead.",
		"You have not yet opened a folder.\n{0}"
	],
	"vs/workbench/contrib/files/browser/fileActions": [
		"New File",
		"New Folder",
		"Rename",
		"Delete",
		"Copy",
		"Paste",
		"Download...",
		"Upload...",
		"&&Move to Recycle Bin",
		"&&Move to Trash",
		"&&Delete",
		"You are deleting files with unsaved changes. Do you want to continue?",
		"You are deleting a folder {0} with unsaved changes in 1 file. Do you want to continue?",
		"You are deleting a folder {0} with unsaved changes in {1} files. Do you want to continue?",
		"You are deleting {0} with unsaved changes. Do you want to continue?",
		"Your changes will be lost if you don't save them.",
		"This action is irreversible!",
		"You can restore these files using the Undo command",
		"You can restore this file using the Undo command",
		"You can restore these files from the Recycle Bin.",
		"You can restore this file from the Recycle Bin.",
		"You can restore these files from the Trash.",
		"You can restore this file from the Trash.",
		"Do not ask me again",
		"Delete {0} files",
		"Delete {0}",
		"Deleting {0} files",
		"Deleting {0}",
		"Failed to delete using the Recycle Bin. Do you want to permanently delete instead?",
		"Failed to delete using the Trash. Do you want to permanently delete instead?",
		"&&Delete Permanently",
		"&&Retry",
		"Are you sure you want to delete the following {0} files/directories and their contents?",
		"Are you sure you want to delete the following {0} directories and their contents?",
		"Are you sure you want to delete the following {0} files?",
		"Are you sure you want to delete '{0}' and its contents?",
		"Are you sure you want to delete '{0}'?",
		"Are you sure you want to permanently delete the following {0} files/directories and their contents?",
		"Are you sure you want to permanently delete the following {0} directories and their contents?",
		"Are you sure you want to permanently delete the following {0} files?",
		"Are you sure you want to permanently delete '{0}' and its contents?",
		"Are you sure you want to permanently delete '{0}'?",
		"Compare Active File With...",
		"Toggle Auto Save",
		"Save All in Group",
		"Close Group",
		"Focus on Files Explorer",
		"Reveal Active File in Side Bar",
		"Open Active File in New Window",
		"The active editor must contain an openable resource.",
		"A file or folder name must be provided.",
		"A file or folder name cannot start with a slash.",
		"A file or folder **{0}** already exists at this location. Please choose a different name.",
		"The name **{0}** is not valid as a file or folder name. Please choose a different name.",
		"Leading or trailing whitespace detected in file or folder name.",
		"Compare Active File with Clipboard",
		"Clipboard ↔ {0}",
		"Retry",
		"Create {0}",
		"Creating {0}",
		"Rename {0} to {1}",
		"Renaming {0} to {1}",
		"File to paste is an ancestor of the destination folder",
		"Moving {0} files",
		"Moving {0}",
		"Move {0} files",
		"Move {0}",
		"Copying {0} files",
		"Copying {0}",
		"Paste {0} files",
		"Paste {0}",
		"The file(s) to paste have been deleted or moved since you copied them. {0}"
	],
	"vs/workbench/contrib/files/browser/fileActions.contribution": [
		"File",
		"Copy Path",
		"Copy Relative Path",
		"Reveal in Side Bar",
		"Use your changes and overwrite file contents",
		"Discard your changes and revert to file contents",
		"Copy Path of Active File",
		"Copy Relative Path of Active File",
		"Save All in Group",
		"Save All Files",
		"Revert File",
		"Compare Active File with Saved",
		"Open to the Side",
		"Revert File",
		"Save All",
		"Compare with Saved",
		"Compare with Selected",
		"Select for Compare",
		"Compare Selected",
		"Close",
		"Close Others",
		"Close Saved",
		"Close All",
		"Open With...",
		"Cut",
		"Delete Permanently",
		"Delete Permanently",
		"New File",
		"Open File...",
		"&&New File",
		"&&Save",
		"Save &&As...",
		"Save A&&ll",
		"A&&uto Save",
		"Re&&vert File",
		"&&Close Editor",
		"Go to &&File..."
	],
	"vs/workbench/contrib/files/browser/fileCommands": [
		"Save As...",
		"Save",
		"Save without Formatting",
		"Save All",
		"Remove Folder from Workspace",
		"New Untitled File",
		"{0} (in file) ↔ {1}",
		"Failed to save '{0}': {1}",
		"Retry",
		"Discard",
		"Failed to revert '{0}': {1}"
	],
	"vs/workbench/contrib/files/browser/fileImportExport": [
		"Uploading",
		"Overwrite {0}",
		"Overwriting {0}",
		"{0} of {1} files ({2}/s)",
		"{0} ({1} of {2}, {3}/s)",
		"Copying...",
		"&&Copy Folders",
		"&&Copy Folder",
		"Cancel",
		"&&Add Folders to Workspace",
		"&&Add Folder to Workspace",
		"Do you want to copy the folders or add the folders to the workspace?",
		"Do you want to copy '{0}' or add '{0}' as a folder to the workspace?",
		"Are you sure to want to copy folders?",
		"Are you sure to want to copy '{0}'?",
		"Some or all of the dropped files could not be accessed for import.",
		"The dropped file could not be accessed for import.",
		"Import {0}",
		"Import {0} resources",
		"Copying {0}",
		"Copying {0} resources",
		"Downloading",
		"{0} of {1} files ({2}/s)",
		"{0} ({1} of {2}, {3}/s)",
		"Download",
		"Choose Where to Download",
		"Download {0}",
		"Downloading {0}",
		"A file or folder with the name '{0}' already exists in the destination folder. Do you want to replace it?",
		"This action is irreversible!",
		"&&Replace",
		"The following {0} files and/or folders already exist in the destination folder. Do you want to replace them?",
		"This action is irreversible!",
		"&&Replace"
	],
	"vs/workbench/contrib/files/browser/files.contribution": [
		"Binary File Editor",
		"Disable hot exit. A prompt will show when attempting to close a window with editors that have unsaved changes.",
		"Hot exit will be triggered when the last window is closed on Windows/Linux or when the `workbench.action.quit` command is triggered (command palette, keybinding, menu). All windows without folders opened will be restored upon next launch. A list of previously opened windows with unsaved files can be accessed via `File > Open Recent > More...`",
		"Hot exit will be triggered when the last window is closed on Windows/Linux or when the `workbench.action.quit` command is triggered (command palette, keybinding, menu), and also for any window with a folder opened regardless of whether it's the last window. All windows without folders opened will be restored upon next launch. A list of previously opened windows with unsaved files can be accessed via `File > Open Recent > More...`",
		"Controls whether unsaved files are remembered between sessions, allowing the save prompt when exiting the editor to be skipped.",
		"Disable hot exit. A prompt will show when attempting to close a window with editors that have unsaved changes.",
		"Hot exit will be triggered when the browser quits or the window or tab is closed.",
		"Controls whether unsaved files are remembered between sessions, allowing the save prompt when exiting the editor to be skipped.",
		"Files",
		"Configure [glob patterns](https://code.visualstudio.com/docs/editor/codebasics#_advanced-search-options) for excluding files and folders. For example, the file explorer decides which files and folders to show or hide based on this setting. Refer to the `#search.exclude#` setting to define search-specific excludes.",
		"The glob pattern to match file paths against. Set to true or false to enable or disable the pattern.",
		"Additional check on the siblings of a matching file. Use $(basename) as variable for the matching file name.",
		"Configure file associations to languages (e.g. `\"*.extension\": \"html\"`). These have precedence over the default associations of the languages installed.",
		"The default character set encoding to use when reading and writing files. This setting can also be configured per language.",
		"When enabled, the editor will attempt to guess the character set encoding when opening files. This setting can also be configured per language. Note, this setting is not respected by text search. Only `#files.encoding#` is respected.",
		"LF",
		"CRLF",
		"Uses operating system specific end of line character.",
		"The default end of line character.",
		"Moves files/folders to the OS trash (recycle bin on Windows) when deleting. Disabling this will delete files/folders permanently.",
		"When enabled, will trim trailing whitespace when saving a file.",
		"When enabled, insert a final new line at the end of the file when saving it.",
		"When enabled, will trim all new lines after the final new line at the end of the file when saving it.",
		"An editor with changes is never automatically saved.",
		"An editor with changes is automatically saved after the configured `#files.autoSaveDelay#`.",
		"An editor with changes is automatically saved when the editor loses focus.",
		"An editor with changes is automatically saved when the window loses focus.",
		"Controls [auto save](https://code.visualstudio.com/docs/editor/codebasics#_save-auto-save) of editors that have unsaved changes.",
		"Controls the delay in milliseconds after which an editor with unsaved changes is saved automatically. Only applies when `#files.autoSave#` is set to `{0}`.",
		"Configure paths or glob patterns to exclude from file watching. Paths that are relative (for example `build/output`) will be resolved to an absolute path using the currently opened workspace. Glob patterns must match on absolute paths (i.e. prefix with `**/` or the full path and suffix with `/**` to match files within a path) to match properly (for example `**/build/output/**` or `/Users/name/workspaces/project/build/output/**`). When you experience the file watcher process consuming a lot of CPU, make sure to exclude large folders that are of less interest (such as build output folders).",
		"Configure extra paths to watch for changes inside the workspace. By default, all workspace folders will be watched recursively, except for folders that are symbolic links. You can explicitly add absolute or relative paths to support watching folders that are symbolic links. Relative paths will be resolved to an absolute path using the currently opened workspace.",
		"The default language identifier that is assigned to new files. If configured to `${activeEditorLanguage}`, will use the language identifier of the currently active text editor if any.",
		"Controls the memory available to VS Code after restart when trying to open large files. Same effect as specifying `--max-memory=NEWSIZE` on the command line.",
		"Restore the undo stack when a file is reopened.",
		"Will refuse to save and ask for resolving the save conflict manually.",
		"Will resolve the save conflict by overwriting the file on disk with the changes in the editor.",
		"A save conflict can occur when a file is saved to disk that was changed by another program in the meantime. To prevent data loss, the user is asked to compare the changes in the editor with the version on disk. This setting should only be changed if you frequently encounter save conflict errors and may result in data loss if used without caution.",
		"Enables the simple file dialog. The simple file dialog replaces the system file dialog when enabled.",
		"Format a file on save. A formatter must be available, the file must not be saved after delay, and the editor must not be shutting down.",
		"Format the whole file.",
		"Format modifications (requires source control).",
		"Will attempt to format modifications only (requires source control). If source control can't be used, then the whole file will be formatted.",
		"Controls if format on save formats the whole file or only modifications. Only applies when `#editor.formatOnSave#` is enabled.",
		"File Explorer",
		"Number of editors shown in the Open Editors pane. Setting this to 0 hides the Open Editors pane.",
		"Controls the sorting order of editors in the Open Editors pane.",
		"Editors are ordered in the same order editor tabs are shown.",
		"Editors are ordered alphabetically by tab name inside each editor group.",
		"Editors are ordered alphabetically by full path inside each editor group.",
		"Files will be revealed and selected.",
		"Files will not be revealed and selected.",
		"Files will not be scrolled into view, but will still be focused.",
		"Controls whether the explorer should automatically reveal and select files when opening them.",
		"Controls whether the explorer should allow to move files and folders via drag and drop. This setting only effects drag and drop from inside the explorer.",
		"Controls whether the explorer should ask for confirmation to move files and folders via drag and drop.",
		"Controls whether the explorer should ask for confirmation when deleting a file via the trash.",
		"Controls whether the explorer should support undoing file and folder operations.",
		"Controls whether the explorer should ask for confirmation when undoing.",
		"Explorer will prompt before all undo operations.",
		"Explorer will prompt before destructive undo operations.",
		"Explorer will not prompt before undo operations when focused.",
		"Controls whether the explorer should expand multi-root workspaces containing only one folder during initilization",
		"Files and folders are sorted by their names. Folders are displayed before files.",
		"Files and folders are sorted by their names. Files are interwoven with folders.",
		"Files and folders are sorted by their names. Files are displayed before folders.",
		"Files and folders are grouped by extension type then sorted by their names. Folders are displayed before files.",
		"Files and folders are sorted by last modified date in descending order. Folders are displayed before  files.",
		"Files and folders are sorted by their names. Folders are displayed before files. Files with nested children are displayed before other files.",
		"Controls the property-based sorting of files and folders in the explorer. When `#explorer.experimental.fileNesting.enabled#` is enabled, also controls sorting of nested files.",
		"Uppercase and lowercase names are mixed together.",
		"Uppercase names are grouped together before lowercase names.",
		"Lowercase names are grouped together before uppercase names.",
		"Names are sorted in unicode order.",
		"Controls the lexicographic sorting of file and folder names in the Explorer.",
		"Controls whether file decorations should use colors.",
		"Controls whether file decorations should use badges.",
		"Appends the word \"copy\" at the end of the duplicated name potentially followed by a number",
		"Adds a number at the end of the duplicated name. If some number is already part of the name, tries to increase that number",
		"Controls what naming strategy to use when a giving a new name to a duplicated explorer item on paste.",
		"Controls whether the explorer should render folders in a compact form. In such a form, single child folders will be compressed in a combined tree element. Useful for Java package structures, for example.",
		"Use slash as path separation character.",
		"Use backslash as path separation character.",
		"Uses operating system specific path separation character.",
		"The path separation character used when copying relative file paths.",
		"Experimental. Controls whether file nesting is enabled in the explorer. File nesting allows for related files in a directory to be visually grouped together under a single parent file.",
		"Experimental. Controls whether file nests are automatically expanded. `#explorer.experimental.fileNesting.enabled#` must be set for this to take effect.",
		"Experimental. Controls nesting of files in the explorer. `#explorer.experimental.fileNesting.enabled#` must be set for this to take effect. Each key describes a parent file pattern and each value should be a comma separated list of children file patterns that will be nested under the parent.\n\nA single `*` in a parent pattern may be used to capture any substring, which can then be matched against using `$​(capture)` in a child pattern. Child patterns may also contain one `*` to match any substring.\n\nFor example, given the configuration `*.ts => $(capture).js, $(capture).*.ts`, and a directory containing `a.ts, a.js, a.d.ts`, and `b.js`, nesting would apply as follows: \n- `*.ts` matches `a.ts`, capturing `a`. This causes any sibilings matching `a.js` or `a.*.ts` to be nested under `a.ts`\n    - `a.js` matches `a.js` exactly, so is nested under `a.ts`\n    - `a.d.ts` matches `a.*.ts`, so is also nested under `a.ts`\n\nThe final directory will be rendered with `a.ts` containg `a.js` and `a.d.ts` as nested children, and `b.js` as normal file.",
		"Key patterns may contain a single `*` capture group which matches any string. Each value pattern may contain one `$​(capture)` token to be substituted with the parent capture group and one `*` token to match any string"
	],
	"vs/workbench/contrib/files/browser/files.web.contribution": [
		"Text File Editor"
	],
	"vs/workbench/contrib/files/browser/views/emptyView": [
		"No Folder Opened"
	],
	"vs/workbench/contrib/files/browser/views/explorerDecorationsProvider": [
		"Unable to resolve workspace folder",
		"Symbolic Link",
		"Unknown File Type",
		"Explorer"
	],
	"vs/workbench/contrib/files/browser/views/explorerView": [
		"Explorer Section: {0}",
		"New File",
		"New Folder",
		"Refresh Explorer",
		"Collapse Folders in Explorer"
	],
	"vs/workbench/contrib/files/browser/views/explorerViewer": [
		"Files Explorer",
		"Type file name. Press Enter to confirm or Escape to cancel.",
		"Are you sure you want to change the order of multiple root folders in your workspace?",
		"Are you sure you want to move the following {0} files into '{1}'?",
		"Are you sure you want to change the order of root folder '{0}' in your workspace?",
		"Are you sure you want to move '{0}' into '{1}'?",
		"Do not ask me again",
		"&&Move",
		"Copy {0}",
		"Copying {0}",
		"Move {0}",
		"Moving {0}",
		"{0} folders",
		"{0} files"
	],
	"vs/workbench/contrib/files/browser/views/openEditorsView": [
		"Open Editors",
		"{0} unsaved",
		"Open Editors",
		"Toggle Vertical/Horizontal Editor Layout",
		"Flip Layout",
		"Flip &&Layout",
		"New Untitled File"
	],
	"vs/workbench/contrib/files/browser/workspaceWatcher": [
		"Unable to watch for file changes in this large workspace folder. Please follow the instructions link to resolve this issue.",
		"Instructions",
		"File changes watcher stopped unexpectedly. A reload of the window may enable the watcher again unless the workspace cannot be watched for file changes.",
		"Reload"
	],
	"vs/workbench/contrib/files/common/dirtyFilesIndicator": [
		"1 unsaved file",
		"{0} unsaved files"
	],
	"vs/workbench/contrib/files/common/files": [
		"True when the EXPLORER viewlet is visible.",
		"True when the focused item in the EXPLORER is a folder.",
		"True when the focused item in the EXPLORER is readonly.",
		"True when the focused item in the EXPLORER is a root folder.",
		"True when an item in the EXPLORER has been cut for cut and paste.",
		"True when the focused item in the EXPLORER can be moved to trash.",
		"True when the focus is inside the EXPLORER view.",
		"True when the OPEN EDITORS view is visible.",
		"True when the focus is inside the OPEN EDITORS view.",
		"True when the focus is inside the EXPLORER viewlet.",
		"True when the focused item in the EXPLORER view is a compact item.",
		"True when the focus is inside a compact item's first part in the EXPLORER view.",
		"True when the focus is inside a compact item's last part in the EXPLORER view."
	],
	"vs/workbench/contrib/format/browser/formatActionsMultiple": [
		"None",
		"None",
		"Extension '{0}' is configured as formatter but it cannot format '{1}'-files",
		"Change Default Formatter",
		"Configure...",
		"Cancel",
		"There are multiple formatters for '{0}' files. Select a default formatter to continue.",
		"Extension '{0}' is configured as formatter but not available. Select a different default formatter to continue.",
		"Configure...",
		"Cancel",
		"Configure...",
		"Select a default formatter for '{0}' files",
		"Defines a default formatter which takes precedence over all other formatter settings. Must be the identifier of an extension contributing a formatter.",
		"(default)",
		"Configure Default Formatter...",
		"Select a formatter",
		"Select a default formatter for '{0}' files",
		"Format Document With...",
		"Format Selection With..."
	],
	"vs/workbench/contrib/format/browser/formatActionsNone": [
		"Format Document",
		"This file cannot be formatted because it is too large",
		"There is no formatter for '{0}' files installed.",
		"Cancel",
		"Install Formatter..."
	],
	"vs/workbench/contrib/format/browser/formatModified": [
		"Format Modified Lines"
	],
	"vs/workbench/contrib/inlayHints/browser/inlayHintsAccessibilty": [
		"Whether the current line and its inlay hints are currently focused",
		"Code with Inlay Hint Information",
		"Read Line With Inline Hints",
		"Stop Inlay Hints Reading"
	],
	"vs/workbench/contrib/interactive/browser/interactive.contribution": [
		"Open Interactive Window",
		"Open Interactive Window",
		"Execute Code",
		"Clear the interactive window input editor contents",
		"Previous value in history",
		"Next value in history",
		"Scroll to Top",
		"Scroll to Bottom",
		"The border color for the current interactive code cell when the editor has focus.",
		"The border color for the current interactive code cell when the editor does not have focus."
	],
	"vs/workbench/contrib/interactive/browser/interactiveEditor": [
		"Type '{0}' code here and press {1} to run"
	],
	"vs/workbench/contrib/issue/browser/issue.web.contribution": [
		"Report Issue",
		"The --status argument is not yet supported in browsers."
	],
	"vs/workbench/contrib/keybindings/browser/keybindings.contribution": [
		"Toggle Keyboard Shortcuts Troubleshooting"
	],
	"vs/workbench/contrib/languageStatus/browser/languageStatus.contribution": [
		"Editor Language Status",
		"Editor Language Status: {0}",
		"Add to Status Bar",
		"Remove from Status Bar",
		"{0}, {1}",
		"{0}",
		"{0} (Language Status)"
	],
	"vs/workbench/contrib/localizations/browser/localizations.contribution": [
		"Would you like to change VS Code's UI language to {0} and restart?",
		"In order to use VS Code in {0}, VS Code needs to restart.",
		"Change Language and Restart",
		"Restart",
		"Don't Change Language",
		"Don't Restart",
		"Don't Show Again",
		"Contributes localizations to the editor",
		"Id of the language into which the display strings are translated.",
		"Name of the language in English.",
		"Name of the language in contributed language.",
		"List of translations associated to the language.",
		"Id of VS Code or Extension for which this translation is contributed to. Id of VS Code is always `vscode` and of extension should be in format `publisherId.extensionName`.",
		"Id should be `vscode` or in format `publisherId.extensionName` for translating VS code or an extension respectively.",
		"A relative path to a file containing translations for the language."
	],
	"vs/workbench/contrib/localizations/browser/localizationsActions": [
		"Configure Display Language",
		"Install Additional Languages...",
		"Select Display Language",
		"A restart is required for the change in display language to take effect.",
		"Press the restart button to restart {0} and change the display language.",
		"&&Restart"
	],
	"vs/workbench/contrib/localizations/browser/minimalTranslations": [
		"Search language packs in the Marketplace to change the display language to {0}.",
		"Search Marketplace",
		"Install language pack to change the display language to {0}.",
		"Install and Restart"
	],
	"vs/workbench/contrib/logs/common/logs.contribution": [
		"Settings Sync",
		"Window",
		"Telemetry",
		"Show Window Log",
		"Main",
		"Shared"
	],
	"vs/workbench/contrib/logs/common/logsActions": [
		"Set Log Level...",
		"Trace",
		"Debug",
		"Info",
		"Warning",
		"Error",
		"Critical",
		"Off",
		"Select log level",
		"Default & Current",
		"Default",
		"Current",
		"Open Window Log File (Session)...",
		"Current",
		"Select Session",
		"Select Log file"
	],
	"vs/workbench/contrib/markers/browser/markers": [
		"Total {0} Problems"
	],
	"vs/workbench/contrib/markers/browser/markers.contribution": [
		"View icon of the markers view.",
		"&&Problems",
		"Copy",
		"Copy Message",
		"Copy Message",
		"Focus problems view",
		"Focus problems filter",
		"Show message in multiple lines",
		"Problems",
		"Show message in single line",
		"Problems",
		"Clear filters text",
		"Problems",
		"Collapse All",
		"Filter",
		"Problems",
		"Errors: {0}",
		"Warnings: {0}",
		"Infos: {0}",
		"No Problems",
		"10K+"
	],
	"vs/workbench/contrib/markers/browser/markersFileDecorations": [
		"Problems",
		"1 problem in this file",
		"{0} problems in this file",
		"Show Errors & Warnings on files and folder."
	],
	"vs/workbench/contrib/markers/browser/markersTreeViewer": [
		"Problems View",
		"Icon indicating that multiple lines are shown in the markers view.",
		"Icon indicating that multiple lines are collapsed in the markers view.",
		"Show message in single line",
		"Show message in multiple lines"
	],
	"vs/workbench/contrib/markers/browser/markersView": [
		"Showing {0} problems",
		"Showing {0} of {1} problems",
		"Clear Filters"
	],
	"vs/workbench/contrib/markers/browser/markersViewActions": [
		"Icon for the filter configuration in the markers view.",
		"Showing {0} of {1}"
	],
	"vs/workbench/contrib/markers/browser/messages": [
		"Toggle Problems (Errors, Warnings, Infos)",
		"Focus Problems (Errors, Warnings, Infos)",
		"Problems View",
		"Controls whether Problems view should automatically reveal files when opening them.",
		"When enabled shows the current problem in the status bar.",
		"Controls the order in which problems are navigated.",
		"Navigate problems ordered by severity",
		"Navigate problems ordered by position",
		"Problems",
		"No problems have been detected in the workspace.",
		"No problems have been detected in the current file.",
		"No results found with provided filter criteria.",
		"More Filters...",
		"Show Errors",
		"Show Warnings",
		"Show Infos",
		"Hide Excluded Files",
		"Show Active File Only",
		"Filter Problems",
		"Show fixes",
		"Filter Problems",
		"Filter (e.g. text, **/*.ts, !**/node_modules/**)",
		"errors",
		"warnings",
		"infos",
		"1 Error",
		"{0} Errors",
		"1 Warning",
		"{0} Warnings",
		"1 Info",
		"{0} Infos",
		"1 Unknown",
		"{0} Unknowns",
		"[{0}, {1}]",
		"{0} problems in file {1} of folder {2}",
		" This problem has references to {0} locations.",
		"Error generated by {0}: {1} at line {2} and character {3}.{4}",
		"Error: {0} at line {1} and character {2}.{3}",
		"Warning generated by {0}: {1} at line {2} and character {3}.{4}",
		"Warning: {0} at line {1} and character {2}.{3}",
		"Info generated by {0}: {1} at line {2} and character {3}.{4}",
		"Info: {0} at line {1} and character {2}.{3}",
		"Problem generated by {0}: {1} at line {2} and character {3}.{4}",
		"Problem: {0} at line {1} and character {2}.{3}",
		"{0} at line {1} and character {2} in {3}",
		"Show Errors and Warnings"
	],
	"vs/workbench/contrib/notebook/browser/contrib/cellCommands/cellCommands": [
		"Move Cell Up",
		"Move Cell Down",
		"Copy Cell Up",
		"Copy Cell Down",
		"Split Cell",
		"Join With Previous Cell",
		"Join With Next Cell",
		"Change Cell to Code",
		"Change Cell to Markdown",
		"Collapse Cell Input",
		"Expand Cell Input",
		"Collapse Cell Output",
		"Expand Cell Output",
		"Toggle Outputs",
		"Toggle Outputs",
		"Collapse All Cell Inputs",
		"Expand All Cell Inputs",
		"Collapse All Cell Outputs",
		"Expand All Cell Outputs"
	],
	"vs/workbench/contrib/notebook/browser/contrib/cellStatusBar/executionStatusBarItemController": [
		"Success",
		"Failed",
		"Pending",
		"Executing"
	],
	"vs/workbench/contrib/notebook/browser/contrib/cellStatusBar/statusBarProviders": [
		"Select Cell Language Mode"
	],
	"vs/workbench/contrib/notebook/browser/contrib/clipboard/notebookClipboard": [
		"Copy Cell",
		"Cut Cell",
		"Paste Cell",
		"Paste Cell Above",
		"Toggle Notebook Clipboard Troubleshooting"
	],
	"vs/workbench/contrib/notebook/browser/contrib/editorStatusBar/editorStatusBar": [
		"Select Notebook Kernel",
		"Notebook Kernel Args",
		"Set as default for '{0}' notebooks",
		"Currently Selected",
		"{0} - Currently Selected",
		"Install kernels from the marketplace",
		"Suggested",
		"Other",
		"Change kernel for '{0}'",
		"Select kernel for '{0}'",
		"Notebook Kernel Info",
		"{0} (suggestion)",
		"Notebook Kernel Selection",
		"Select Kernel",
		"Select Kernel",
		"Notebook Editor Selections",
		"Cell {0} ({1} selected)",
		"Cell {0} of {1}"
	],
	"vs/workbench/contrib/notebook/browser/contrib/find/findController": [
		"{0} found",
		"{0} found for '{1}'",
		"{0} found for '{1}'",
		"Hide Find in Notebook",
		"Find in Notebook"
	],
	"vs/workbench/contrib/notebook/browser/contrib/find/notebookFindReplaceWidget": [
		"Find",
		"Find",
		"Previous Match",
		"Next Match",
		"Close",
		"Toggle Replace",
		"Replace",
		"Replace",
		"Replace",
		"Replace All",
		"Icon for Find Filter in find widget.",
		"Find Filters",
		"Markdown Source",
		"Rendered Markdown",
		"Code Cell Source",
		"Cell Output"
	],
	"vs/workbench/contrib/notebook/browser/contrib/format/formatting": [
		"Format Notebook",
		"Format Notebook",
		"Format Cell"
	],
	"vs/workbench/contrib/notebook/browser/contrib/gettingStarted/notebookGettingStarted": [
		"Reset notebook getting started"
	],
	"vs/workbench/contrib/notebook/browser/contrib/layout/layoutActions": [
		"Toggle Cell Toolbar Position"
	],
	"vs/workbench/contrib/notebook/browser/contrib/navigation/arrow": [
		"Focus Next Cell Editor",
		"Focus Previous Cell Editor",
		"Focus First Cell",
		"Focus Last Cell",
		"Focus In Active Cell Output",
		"Focus Out Active Cell Output",
		"Center Active Cell",
		"Cell Cursor Page Up",
		"Cell Cursor Page Up Select",
		"Cell Cursor Page Down",
		"Cell Cursor Page Down Select",
		"When enabled cursor can navigate to the next/previous cell when the current cursor in the cell editor is at the first/last line."
	],
	"vs/workbench/contrib/notebook/browser/contrib/outline/notebookOutline": [
		"empty cell",
		"When enabled notebook outline shows code cells.",
		"When enabled notebook breadcrumbs contain code cells."
	],
	"vs/workbench/contrib/notebook/browser/contrib/profile/notebookProfile": [
		"Set Profile"
	],
	"vs/workbench/contrib/notebook/browser/controller/coreActions": [
		"Notebook",
		"Insert Cell",
		"Notebook Cell"
	],
	"vs/workbench/contrib/notebook/browser/controller/editActions": [
		"Delete Cell",
		"Edit Cell",
		"Stop Editing Cell",
		"Delete Cell",
		"Clear Cell Outputs",
		"Clear Outputs of All Cells",
		"Change Cell Language",
		"Change Cell Language",
		"({0}) - Current Language",
		"({0})",
		"Auto Detect",
		"languages (identifier)",
		"Select Language Mode"
	],
	"vs/workbench/contrib/notebook/browser/controller/executeActions": [
		"Render All Markdown Cells",
		"Run All",
		"Run All",
		"Execute Cell",
		"Execute Cell",
		"Execute Above Cells",
		"Execute Cell and Below",
		"Execute Cell and Focus Container",
		"Execute Cell and Focus Container",
		"Stop Cell Execution",
		"Stop Cell Execution",
		"Execute Notebook Cell and Select Below",
		"Execute Notebook Cell and Insert Below",
		"Stop Execution",
		"Stop Execution",
		"Go To Running Cell"
	],
	"vs/workbench/contrib/notebook/browser/controller/foldingController": [
		"Fold Cell",
		"Unfold Cell",
		"Fold Cell"
	],
	"vs/workbench/contrib/notebook/browser/controller/insertCellActions": [
		"Insert Code Cell Above",
		"Insert Code Cell Above and Focus Container",
		"Insert Code Cell Below",
		"Insert Code Cell Below and Focus Container",
		"Insert Markdown Cell Above",
		"Insert Markdown Cell Below",
		"Add Code Cell At Top",
		"Add Markdown Cell At Top",
		"$(add) Code",
		"Add Code Cell",
		"Add Code",
		"Add Code Cell",
		"Code",
		"Add Code Cell",
		"$(add) Code",
		"Add Code Cell",
		"Add Code",
		"Add Code Cell",
		"$(add) Markdown",
		"Add Markdown Cell",
		"Markdown",
		"Add Markdown Cell",
		"$(add) Markdown",
		"Add Markdown Cell"
	],
	"vs/workbench/contrib/notebook/browser/controller/layoutActions": [
		"Select between Notebook Layouts",
		"Customize Notebook Layout",
		"Customize Notebook Layout",
		"Customize Notebook...",
		"Toggle Notebook Line Numbers",
		"Show Notebook Line Numbers",
		"Toggle Cell Toolbar Position",
		"Toggle Breadcrumbs",
		"Toggle Breadcrumbs",
		"Save Mimetype Display Order",
		"Settings file to save in",
		"User Settings",
		"Workspace Settings"
	],
	"vs/workbench/contrib/notebook/browser/diff/diffElementOutputs": [
		"Choose a different output mimetype, available mimetypes: {0}",
		"Cell has no output",
		"No renderer could be found for output. It has the following mimetypes: {0}",
		"Currently Active",
		"Select mimetype to render for current output. Rich mimetypes are available only when the notebook is trusted",
		"Select mimetype to render for current output",
		"built-in"
	],
	"vs/workbench/contrib/notebook/browser/diff/notebookDiffActions": [
		"Open Text Diff Editor",
		"Revert Metadata",
		"Switch Output Rendering",
		"Revert Outputs",
		"Revert Input",
		"Show Outputs Differences",
		"Show Metadata Differences",
		"Hide Metadata Differences",
		"Hide Outputs Differences"
	],
	"vs/workbench/contrib/notebook/browser/diff/notebookTextDiffEditor": [
		"Notebook Text Diff"
	],
	"vs/workbench/contrib/notebook/browser/extensionPoint": [
		"Contributes notebook document provider.",
		"Type of the notebook.",
		"Human readable name of the notebook.",
		"Set of globs that the notebook is for.",
		"Glob that the notebook is enabled for.",
		"Glob that the notebook is disabled for.",
		"Controls if the custom editor is enabled automatically when the user opens a file. This may be overridden by users using the `workbench.editorAssociations` setting.",
		"The editor is automatically used when the user opens a resource, provided that no other default custom editors are registered for that resource.",
		"The editor is not automatically used when the user opens a resource, but a user can switch to the editor using the `Reopen With` command.",
		"Contributes notebook output renderer provider.",
		"Unique identifier of the notebook output renderer.",
		"Human readable name of the notebook output renderer.",
		"Set of globs that the notebook is for.",
		"File to load in the webview to render the extension.",
		"List of kernel dependencies the renderer requires. If any of the dependencies are present in the `NotebookKernel.preloads`, the renderer can be used.",
		"List of soft kernel dependencies the renderer can make use of. If any of the dependencies are present in the `NotebookKernel.preloads`, the renderer will be preferred over renderers that don't interact with the kernel.",
		"Messaging is required. The renderer will only be used when it's part of an extension that can be run in an extension host.",
		"The renderer is better with messaging available, but it's not requried.",
		"The renderer does not require messaging.",
		"Defines how and if the renderer needs to communicate with an extension host, via `createRendererMessaging`. Renderers with stronger messaging requirements may not work in all environments."
	],
	"vs/workbench/contrib/notebook/browser/notebook.contribution": [
		"Settings for code editors used in notebooks. This can be used to customize most editor.* settings.",
		"Notebook",
		"Priority list for output mime types",
		"Where the cell toolbar should be shown, or whether it should be hidden.",
		"Configure the cell toolbar position for for specific file types",
		"Whether the cell status bar should be shown.",
		"The cell Status bar is always hidden.",
		"The cell Status bar is always visible.",
		"The cell Status bar is hidden until the cell has executed. Then it becomes visible to show the execution status.",
		"Whether to use the enhanced text diff editor for notebook.",
		"Whether the cell toolbar should appear on hover or click.",
		"Whether to use separate undo/redo stack for each cell.",
		"Control whether the notebook editor should be rendered in a compact form. For example, when turned on, it will decrease the left margin width.",
		"Controls where the focus indicator is rendered, either along the cell borders or on the left gutter",
		"Control where the insert cell actions should appear.",
		"A toolbar that appears on hover between cells.",
		"The toolbar at the top of the notebook editor.",
		"Both toolbars.",
		"The insert actions don't appear anywhere.",
		"Control whether to render a global toolbar inside the notebook editor.",
		"Control whether outputs action should be rendered in the output toolbar.",
		"Controls when the Markdown header folding arrow is shown.",
		"The folding controls are always visible.",
		"The folding controls are visible only on mouseover.",
		"Control whether the notebook editor should allow moving cells through drag and drop.",
		"Control whether extra actions are shown in a dropdown next to the run button.",
		"Control whether the actions on the notebook toolbar should render label or not.",
		"Control how many lines of text in a text output is rendered.",
		"Controls the font size in pixels of rendered markup in notebooks. When set to `0`, 120% of `#editor.fontSize#` is used.",
		"Controls whether code cells in the interactive window are collapsed by default."
	],
	"vs/workbench/contrib/notebook/browser/notebookEditor": [
		"Cannot open resource with notebook editor type '{0}', please check if you have the right extension installed and enabled.",
		"Open in Text Editor"
	],
	"vs/workbench/contrib/notebook/browser/notebookEditorWidget": [
		"Notebook",
		"The border color for notebook cells.",
		"The color of the notebook cell editor border.",
		"The error icon color of notebook cells in the cell status bar.",
		"The error icon color of notebook cells in the cell status bar.",
		"The running icon color of notebook cells in the cell status bar.",
		"The border color of the notebook output container.",
		"The color of the notebook output container background.",
		"The color of the separator in the cell bottom toolbar",
		"The background color of a cell when the cell is focused.",
		"The background color of a cell when the cell is selected.",
		"The background color of a cell when the cell is hovered.",
		"The color of the cell's top and bottom border when the cell is selected but not focused.",
		"The color of the cell's borders when multiple cells are selected.",
		"The color of the cell's focus indicator borders when the cell is focused.",
		"The color of the cell's top and bottom border when a cell is focused while the primary focus is outside of the editor.",
		"The background color of notebook cell status bar items.",
		"The color of the notebook cell insertion indicator.",
		"Notebook scrollbar slider background color.",
		"Notebook scrollbar slider background color when hovering.",
		"Notebook scrollbar slider background color when clicked on.",
		"Background color of highlighted cell",
		"Cell editor background color."
	],
	"vs/workbench/contrib/notebook/browser/notebookExecutionServiceImpl": [
		"Executing a notebook cell will run code from this workspace."
	],
	"vs/workbench/contrib/notebook/browser/notebookIcons": [
		"Configure icon in kernel configuration widget in notebook editors.",
		"Configure icon to select a kernel in notebook editors.",
		"Icon to execute in notebook editors.",
		"Icon to execute above cells in notebook editors.",
		"Icon to execute below cells in notebook editors.",
		"Icon to stop an execution in notebook editors.",
		"Icon to delete a cell in notebook editors.",
		"Icon to execute all cells in notebook editors.",
		"Icon to edit a cell in notebook editors.",
		"Icon to stop editing a cell in notebook editors.",
		"Icon to move up a cell in notebook editors.",
		"Icon to move down a cell in notebook editors.",
		"Icon to clear cell outputs in notebook editors.",
		"Icon to split a cell in notebook editors.",
		"Icon to unfold a cell in notebook editors.",
		"Icon to indicate a success state in notebook editors.",
		"Icon to indicate an error state in notebook editors.",
		"Icon to indicate a pending state in notebook editors.",
		"Icon to indicate an executing state in notebook editors.",
		"Icon to annotate a collapsed section in notebook editors.",
		"Icon to annotate an expanded section in notebook editors.",
		"Icon to open the notebook in a text editor.",
		"Icon to revert in notebook editors.",
		"Icon to render output in diff editor.",
		"Icon for a mime type in notebook editors."
	],
	"vs/workbench/contrib/notebook/browser/notebookKeymapServiceImpl": [
		"Disable other keymaps ({0}) to avoid conflicts between keybindings?",
		"Yes",
		"No"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/cellEditorOptions": [
		"Controls the display of line numbers in the cell editor.",
		"Toggle Notebook Line Numbers",
		"Show Notebook Line Numbers",
		"Show Cell Line Numbers"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/cellOutput": [
		"Cell has no output",
		"No renderer could be found for output. It has the following mimetypes: {0}",
		"Change Presentation",
		"Currently Active",
		"Install additional renderers from the marketplace",
		"Select mimetype to render for current output",
		"Select mimetype to render for current output",
		"renderer not available"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/codeCell": [
		"Double click to expand cell input ({0})",
		"Expand Cell Input ({0})"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/codeCellExecutionIcon": [
		"Success",
		"Failed",
		"Pending",
		"Executing"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/codeCellRunToolbar": [
		"More..."
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/foldedCellHint": [
		"1 cell hidden",
		"{0} cells hidden"
	],
	"vs/workbench/contrib/notebook/browser/view/cellParts/markdownCell": [
		"Double click to expand cell input ({0})",
		"Expand Cell Input ({0})"
	],
	"vs/workbench/contrib/notebook/browser/view/renderers/backLayerWebView": [
		"Empty markdown cell, double click or press enter to edit.",
		"No renderer found for '$0' a"
	],
	"vs/workbench/contrib/notebook/browser/view/renderers/cellRenderer": [
		"Execution Order",
		"Outputs are collapsed",
		"Double click to expand cell output ({0})",
		"Expand Cell Output (${0})"
	],
	"vs/workbench/contrib/notebook/browser/viewParts/notebookKernelActionViewItem": [
		"Select Kernel"
	],
	"vs/workbench/contrib/notebook/common/notebookEditorModel": [
		"The contents of the file has changed on disk. Would you like to open the updated version or overwrite the file with your changes?",
		"Revert",
		"Overwrite"
	],
	"vs/workbench/contrib/offline/browser/offline.contribution": [
		"Status bar background color when the workbench is offline. The status bar is shown in the bottom of the window",
		"Status bar foreground color when the workbench is offline. The status bar is shown in the bottom of the window",
		"Status bar border color separating to the sidebar and editor when the workbench is offline. The status bar is shown in the bottom of the window",
		"Network appears to be offline, certain features might be unavailable."
	],
	"vs/workbench/contrib/outline/browser/outline.contribution": [
		"View icon of the outline view.",
		"Outline",
		"Outline",
		"Render Outline Elements with Icons.",
		"Show Errors & Warnings on Outline Elements.",
		"Use colors for Errors & Warnings.",
		"Use badges for Errors & Warnings.",
		"When enabled outline shows `file`-symbols.",
		"When enabled outline shows `module`-symbols.",
		"When enabled outline shows `namespace`-symbols.",
		"When enabled outline shows `package`-symbols.",
		"When enabled outline shows `class`-symbols.",
		"When enabled outline shows `method`-symbols.",
		"When enabled outline shows `property`-symbols.",
		"When enabled outline shows `field`-symbols.",
		"When enabled outline shows `constructor`-symbols.",
		"When enabled outline shows `enum`-symbols.",
		"When enabled outline shows `interface`-symbols.",
		"When enabled outline shows `function`-symbols.",
		"When enabled outline shows `variable`-symbols.",
		"When enabled outline shows `constant`-symbols.",
		"When enabled outline shows `string`-symbols.",
		"When enabled outline shows `number`-symbols.",
		"When enabled outline shows `boolean`-symbols.",
		"When enabled outline shows `array`-symbols.",
		"When enabled outline shows `object`-symbols.",
		"When enabled outline shows `key`-symbols.",
		"When enabled outline shows `null`-symbols.",
		"When enabled outline shows `enumMember`-symbols.",
		"When enabled outline shows `struct`-symbols.",
		"When enabled outline shows `event`-symbols.",
		"When enabled outline shows `operator`-symbols.",
		"When enabled outline shows `typeParameter`-symbols."
	],
	"vs/workbench/contrib/outline/browser/outlinePane": [
		"The active editor cannot provide outline information.",
		"Loading document symbols for '{0}'...",
		"No symbols found in document '{0}'",
		"Collapse All",
		"Follow Cursor",
		"Filter on Type",
		"Sort By: Position",
		"Sort By: Name",
		"Sort By: Category"
	],
	"vs/workbench/contrib/output/browser/logViewer": [
		"Log viewer"
	],
	"vs/workbench/contrib/output/browser/output.contribution": [
		"View icon of the output view.",
		"Output",
		"Output",
		"&&Output",
		"Log Viewer",
		"Switch to Output",
		"Clear Output",
		"Output was cleared",
		"Toggle Auto Scrolling",
		"Turn Auto Scrolling Off",
		"Turn Auto Scrolling On",
		"Open Log Output File",
		"Show Logs...",
		"Select Log",
		"Open Log File...",
		"Select Log file",
		"Output",
		"Enable/disable the ability of smart scrolling in the output view. Smart scrolling allows you to lock scrolling automatically when you click in the output view and unlocks when you click in the last line."
	],
	"vs/workbench/contrib/output/browser/outputView": [
		"{0} - Output",
		"Output channel for '{0}'",
		"Output",
		"{0}, Output panel",
		"Output panel",
		"Output Channels.",
		"Log ({0})"
	],
	"vs/workbench/contrib/performance/browser/performance.contribution": [
		"Startup Performance"
	],
	"vs/workbench/contrib/performance/browser/perfviewEditor": [
		"Startup Performance"
	],
	"vs/workbench/contrib/preferences/browser/keybindingWidgets": [
		"Press desired key combination and then press ENTER.",
		"1 existing command has this keybinding",
		"{0} existing commands have this keybinding",
		"chord to"
	],
	"vs/workbench/contrib/preferences/browser/keybindingsEditor": [
		"Record Keys",
		"Sort by Precedence (Highest first)",
		"Type to search in keybindings",
		"Recording Keys. Press Escape to exit",
		"Clear Keybindings Search Input",
		"Recording Keys",
		"Command",
		"Keybinding",
		"When",
		"Source",
		"Showing {0} Keybindings in precedence order",
		"Showing {0} Keybindings in alphabetical order",
		"Change Keybinding...",
		"Add Keybinding...",
		"Add Keybinding...",
		"Change When Expression",
		"Remove Keybinding",
		"Reset Keybinding",
		"Show Same Keybindings",
		"Copy",
		"Copy Command ID",
		"Copy Command Title",
		"Error '{0}' while editing the keybinding. Please open 'keybindings.json' file and check for errors.",
		"Change Keybinding {0}",
		"Change Keybinding",
		"Add Keybinding {0}",
		"Add Keybinding",
		"{0} ({1})",
		"Type when context. Press Enter to confirm or Escape to cancel.",
		"Keybindings",
		"No Keybinding assigned.",
		"No when context."
	],
	"vs/workbench/contrib/preferences/browser/keybindingsEditorContribution": [
		"Define Keybinding",
		"You won't be able to produce this key combination under your current keyboard layout.",
		"**{0}** for your current keyboard layout (**{1}** for US standard).",
		"**{0}** for your current keyboard layout."
	],
	"vs/workbench/contrib/preferences/browser/keyboardLayoutPicker": [
		"Keyboard Layout",
		"Layout: {0}",
		"Layout: {0}",
		"Layout: {0}",
		"Change Keyboard Layout",
		"Defines the keyboard layout used in VS Code in the browser environment.",
		"Open VS Code and run \"Developer: Inspect Key Mappings (JSON)\" from Command Palette.",
		"Keyboard Layouts ({0})",
		"Configure Keyboard Layout",
		"Auto Detect",
		"Select Keyboard Layout",
		"Unable to create '{0}' ({1}).",
		"Preferences"
	],
	"vs/workbench/contrib/preferences/browser/preferences.contribution": [
		"Settings Editor 2",
		"Keybindings Editor",
		"Open Settings (UI)",
		"Preferences",
		"Settings",
		"&&Settings",
		"Open Settings (UI)",
		"Open Settings (JSON)",
		"Open User Settings",
		"Open Default Settings (JSON)",
		"Open Settings (JSON)",
		"Open Workspace Settings",
		"Open Workspace Settings (JSON)",
		"Open Folder Settings",
		"Open Folder Settings (JSON)",
		"Open Folder Settings",
		"Show modified settings",
		"Show settings for online services",
		"&&Online Services Settings",
		"Online Services Settings",
		"Telemetry Settings",
		"Show untrusted workspace settings",
		"Open Remote Settings ({0})",
		"Open Remote Settings (JSON) ({0})",
		"Focus Settings Search",
		"Clear Settings Search Results",
		"Focus settings file",
		"Focus settings file",
		"Focus settings list",
		"Focus Settings Table of Contents",
		"Focus Setting Control",
		"Show Setting Context Menu",
		"Move Focus Up One Level",
		"Preferences",
		"Open Keyboard Shortcuts",
		"Keyboard Shortcuts",
		"Keyboard Shortcuts",
		"Open Default Keyboard Shortcuts (JSON)",
		"Open Keyboard Shortcuts (JSON)",
		"Show Default Keybindings",
		"Show Extension Keybindings",
		"Show User Keybindings",
		"Clear Search Results",
		"&&Preferences"
	],
	"vs/workbench/contrib/preferences/browser/preferencesActions": [
		"Configure Language Specific Settings...",
		"({0})",
		"Select Language"
	],
	"vs/workbench/contrib/preferences/browser/preferencesIcons": [
		"Icon for an expanded section in the split JSON Settings editor.",
		"Icon for a collapsed section in the split JSON Settings editor.",
		"Icon for the folder dropdown button in the split JSON Settings editor.",
		"Icon for the 'more actions' action in the Settings UI.",
		"Icon for the 'record keys' action in the keybinding UI.",
		"Icon for the 'sort by precedence' toggle in the keybinding UI.",
		"Icon for the edit action in the keybinding UI.",
		"Icon for the add action in the keybinding UI.",
		"Icon for the edit action in the Settings UI.",
		"Icon for the add action in the Settings UI.",
		"Icon for the remove action in the Settings UI.",
		"Icon for the discard action in the Settings UI.",
		"Icon for clear input in the Settings and keybinding UI.",
		"Icon for open settings commands."
	],
	"vs/workbench/contrib/preferences/browser/preferencesRenderers": [
		"Edit",
		"Replace in Settings",
		"Copy to Settings",
		"Unknown Configuration Setting",
		"This setting cannot be applied in this window. It will be applied when you open a local window.",
		"This setting cannot be applied in this workspace. It will be applied when you open the containing workspace folder directly.",
		"This setting can be applied only in application user settings",
		"This setting can only be applied in user settings in local window or in remote settings in remote window.",
		"This setting can only be applied in a trusted workspace.",
		"Manage Workspace Trust",
		"Manage Workspace Trust",
		"Unsupported Property"
	],
	"vs/workbench/contrib/preferences/browser/preferencesWidgets": [
		"Settings Switcher",
		"User",
		"Remote",
		"Workspace",
		"Folder",
		"Workspace",
		"User"
	],
	"vs/workbench/contrib/preferences/browser/settingsEditor2": [
		"Search settings",
		"Clear Settings Search Input",
		"No Settings Found",
		"Clear Filters",
		"Settings",
		"Workspace Trust",
		"No Settings Found",
		"1 Setting Found",
		"{0} Settings Found",
		"Turn on Settings Sync",
		"Last synced: {0}"
	],
	"vs/workbench/contrib/preferences/browser/settingsLayout": [
		"Commonly Used",
		"Text Editor",
		"Cursor",
		"Find",
		"Font",
		"Formatting",
		"Diff Editor",
		"Minimap",
		"Suggestions",
		"Files",
		"Workbench",
		"Appearance",
		"Breadcrumbs",
		"Editor Management",
		"Settings Editor",
		"Zen Mode",
		"Screencast Mode",
		"Window",
		"New Window",
		"Features",
		"Explorer",
		"Search",
		"Debug",
		"Testing",
		"SCM",
		"Extensions",
		"Terminal",
		"Task",
		"Problems",
		"Output",
		"Comments",
		"Remote",
		"Timeline",
		"Notebook",
		"Audio Cues",
		"Application",
		"Proxy",
		"Keyboard",
		"Update",
		"Telemetry",
		"Settings Sync",
		"Security",
		"Workspace"
	],
	"vs/workbench/contrib/preferences/browser/settingsTree": [
		"Extensions",
		"Modified",
		"More Actions... ",
		"Show matching extensions",
		"Edit in settings.json",
		"default",
		"Modified",
		"Manage Workspace Trust",
		"This setting can only be applied in a trusted workspace",
		"Reset Setting",
		"Validation Error.",
		"Validation Error.",
		"Sync: Ignored",
		"Settings sync does not sync this setting",
		"Also modified in",
		"Modified in",
		"Default value overridden by {0}",
		"$(wrench) Overridden by: {0}",
		"Default value overridden by {0}",
		"$(wrench) Overridden by: {0}",
		"Modified.",
		"Settings",
		"Also modified in",
		"Modified in",
		"Settings sync does not sync this setting",
		"Default value overridden by {0}",
		"Default value overridden by {0}",
		"Copy Setting ID",
		"Copy Setting as JSON",
		"Sync This Setting"
	],
	"vs/workbench/contrib/preferences/browser/settingsTreeModels": [
		"Workspace",
		"Remote",
		"User"
	],
	"vs/workbench/contrib/preferences/browser/settingsWidgets": [
		"OK",
		"Cancel",
		"List item `{0}`",
		"List item `{0}` with sibling `${1}`",
		"Remove Item",
		"Edit Item",
		"Add Item",
		"Item...",
		"Sibling...",
		"Exclude files matching `{0}`",
		"Exclude files matching `{0}`, only when a file matching `{1}` is present",
		"Remove Exclude Item",
		"Edit Exclude Item",
		"Add Pattern",
		"Exclude Pattern...",
		"When Pattern Is Present...",
		"OK",
		"Cancel",
		"Key",
		"Value",
		"The property `{0}` is set to `{1}`.",
		"Remove Item",
		"Reset Item",
		"Edit Item",
		"Add Item",
		"Item",
		"Value",
		"The property `{0}` is set to `{1}`.",
		"Remove Item",
		"Reset Item",
		"Edit Item",
		"Add Item",
		"Item",
		"Value"
	],
	"vs/workbench/contrib/preferences/browser/tocTree": [
		"Settings Table of Contents",
		"{0}, group"
	],
	"vs/workbench/contrib/preferences/common/preferencesContribution": [
		"Split Settings Editor",
		"Controls whether to enable the natural language search mode for settings. The natural language search is provided by a Microsoft online service.",
		"Hide the Table of Contents while searching.",
		"Filter the Table of Contents to just categories that have matching settings. Clicking a category will filter the results to that category.",
		"Controls the behavior of the settings editor Table of Contents while searching."
	],
	"vs/workbench/contrib/preferences/common/settingsEditorColorRegistry": [
		"The foreground color for a section header or active title.",
		"The color of the modified setting indicator.",
		"The color of the header container border.",
		"The color of the Settings editor splitview sash border.",
		"Settings editor dropdown background.",
		"Settings editor dropdown foreground.",
		"Settings editor dropdown border.",
		"Settings editor dropdown list border. This surrounds the options and separates the options from the description.",
		"Settings editor checkbox background.",
		"Settings editor checkbox foreground.",
		"Settings editor checkbox border.",
		"Settings editor text input box background.",
		"Settings editor text input box foreground.",
		"Settings editor text input box border.",
		"Settings editor number input box background.",
		"Settings editor number input box foreground.",
		"Settings editor number input box border.",
		"The background color of a settings row when focused.",
		"The background color of a settings row when hovered.",
		"The color of the row's top and bottom border when the row is focused."
	],
	"vs/workbench/contrib/quickaccess/browser/commandsQuickAccess": [
		"No matching commands",
		"Configure Keybinding",
		"{0}: {1}",
		"Show All Commands",
		"Clear Command History"
	],
	"vs/workbench/contrib/quickaccess/browser/quickAccess.contribution": [
		"Type '{0}' to get help on the actions you can take from here.",
		"Show all Quick Access Providers",
		"Type the name of a view, output channel or terminal to open.",
		"Open View",
		"Type the name of a command to run.",
		"Show and Run Commands",
		"&&Command Palette...",
		"Show All Commands",
		"&&Open View...",
		"Go to &&Line/Column...",
		"Command Palette...",
		"Command Palette..."
	],
	"vs/workbench/contrib/quickaccess/browser/viewQuickAccess": [
		"No matching views",
		"Side Bar",
		"Panel",
		"Side Panel",
		"{0}: {1}",
		"Terminal",
		"Log ({0})",
		"Output",
		"Open View",
		"Quick Open View"
	],
	"vs/workbench/contrib/relauncher/browser/relauncher.contribution": [
		"A setting has changed that requires a restart to take effect.",
		"A setting has changed that requires a reload to take effect.",
		"Press the restart button to restart {0} and enable the setting.",
		"Press the reload button to reload {0} and enable the setting.",
		"&&Restart",
		"&&Reload"
	],
	"vs/workbench/contrib/remote/browser/explorerViewItems": [
		"Switch Remote",
		"Switch Remote"
	],
	"vs/workbench/contrib/remote/browser/remote": [
		"Contributes help information for Remote",
		"The url, or a command that returns the url, to your project's Getting Started page",
		"The url, or a command that returns the url, to your project's documentation page",
		"The url, or a command that returns the url, to your project's feedback reporter",
		"The url, or a command that returns the url, to your project's issues list",
		"Get Started",
		"Read Documentation",
		"Provide Feedback",
		"Review Issues",
		"Report Issue",
		"Select url to open",
		"Help and feedback",
		"Remote Help",
		"Remote Explorer",
		"Remote Explorer",
		"Attempting to reconnect in {0} second...",
		"Attempting to reconnect in {0} seconds...",
		"Reconnect Now",
		"Reload Window",
		"Connection Lost",
		"Disconnected. Attempting to reconnect...",
		"Cannot reconnect. Please reload the window.",
		"Reload Window",
		"Cancel"
	],
	"vs/workbench/contrib/remote/browser/remoteExplorer": [
		"Ports",
		"1 forwarded port",
		"{0} forwarded ports",
		"No Ports Forwarded",
		"Forwarded Ports: {0}",
		"Forwarded Ports",
		"Your application running on port {0} is available.  ",
		"[See all forwarded ports]({0})",
		"You'll need to run as superuser to use port {0} locally.  ",
		"Use Port {0} as Sudo..."
	],
	"vs/workbench/contrib/remote/browser/remoteIcons": [
		"Getting started icon in the remote explorer view.",
		"Documentation icon in the remote explorer view.",
		"Feedback icon in the remote explorer view.",
		"Review issue icon in the remote explorer view.",
		"Report issue icon in the remote explorer view.",
		"View icon of the remote explorer view.",
		"View icon of the remote ports view.",
		"Icon representing a remote port.",
		"Icon representing a private remote port.",
		"Icon for the forward action.",
		"Icon for the stop forwarding action.",
		"Icon for the open browser action.",
		"Icon for the open preview action.",
		"Icon for the copy local address action.",
		"Icon for the label port action.",
		"Icon for forwarded ports that don't have a running process.",
		"Icon for forwarded ports that do have a running process."
	],
	"vs/workbench/contrib/remote/browser/remoteIndicator": [
		"Remote",
		"Show Remote Menu",
		"Close Remote Connection",
		"Close Re&&mote Connection",
		"Install Remote Development Extensions",
		"Opening Remote...",
		"Opening Remote...",
		"Reconnecting to {0}...",
		"Disconnected from {0}",
		"Editing on {0}",
		"Editing on {0}",
		"Some [features are not available]({0}) for resources located on a virtual file system.",
		"Open a Remote Window",
		"Remote Host",
		"Close Remote Connection",
		"Reload Window",
		"Close Remote Workspace",
		"Install Additional Remote Extensions..."
	],
	"vs/workbench/contrib/remote/browser/tunnelFactory": [
		"Private",
		"Public"
	],
	"vs/workbench/contrib/remote/browser/tunnelView": [
		"Whether the Ports view is enabled.",
		"Add Port",
		"Private",
		"Port",
		"The label and remote port number of the forwarded port.",
		"Local Address",
		"The address that the forwarded port is available at locally.",
		"option + click",
		"alt + click",
		"cmd + click",
		"ctrl + click",
		"Running Process",
		"The command line of the process that is using the port.",
		"Origin",
		"The source that a forwarded port originates from. Can be an extension, user forwarded, statically forwarded, or automatically forwarded.",
		"Visibility",
		"The availability of the forwarded port.",
		"Press Enter to confirm or Escape to cancel.",
		"Process information unavailable",
		"Remote port {0}:{1} forwarded to local address {2}. ",
		"Remote port {0}:{1} not forwarded. ",
		"Port has running process.",
		"No running process.",
		"Port labeled {0}. ",
		"Unknown",
		"Private",
		"Whether the Ports view has focus.",
		"Ports",
		"Tunnel View",
		"Set Port Label",
		"Port label",
		"Forwarded port should be a number or a host:port.",
		"Port number must be ≥ 0 and < {0}.",
		"May Require Sudo",
		"Port is already forwarded",
		"Forward a Port",
		"Forward Port",
		"Port number or address (eg. 3000 or 10.10.10.10:2000).",
		"Unable to forward {0}:{1}. The host may not be available or that remote port may already be forwarded",
		"No ports currently forwarded. Try running the {0} command",
		"Stop Forwarding Port",
		"Choose a port to stop forwarding",
		"Open in Browser",
		"Preview in Editor",
		"Open Port in Browser",
		"No ports currently forwarded. Open the Ports view to get started.",
		"Open the Ports view...",
		"Choose the port to open",
		"Copy Local Address",
		"Copy Forwarded Port Address",
		"Choose a forwarded port",
		"Change Local Address Port",
		"The local port {0} is not available. Port number {1} has been used instead",
		"New local port",
		"HTTP",
		"HTTPS",
		"Port Visibility",
		"Change Port Protocol",
		"The color of the icon for a port that has an associated running process."
	],
	"vs/workbench/contrib/remote/common/remote.contribution": [
		"Remote Server",
		"Workspace does not exist",
		"The workspace does not exist. Please select another workspace to open.",
		"&&Open Workspace...",
		"&&Cancel",
		"Connection: Trigger Reconnect",
		"Connection: Pause socket writing",
		"UI extension kind. In a remote window, such extensions are enabled only when available on the local machine.",
		"Workspace extension kind. In a remote window, such extensions are enabled only when available on the remote.",
		"Remote",
		"Override the kind of an extension. `ui` extensions are installed and run on the local machine while `workspace` extensions are run on the remote. By overriding an extension's default kind using this setting, you specify if that extension should be installed and enabled locally or remotely.",
		"Restores the ports you forwarded in a workspace.",
		"When enabled, new running processes are detected and ports that they listen on are automatically forwarded. Disabling this setting will not prevent all ports from being forwarded. Even when disabled, extensions will still be able to cause ports to be forwarded, and opening some URLs will still cause ports to forwarded.",
		"Sets the source from which ports are automatically forwarded when `remote.autoForwardPorts` is true. On Windows and Mac remotes, the `process` option has no effect and `output` will be used. Requires a reload to take effect.",
		"Ports will be automatically forwarded when discovered by watching for processes that are started and include a port.",
		"Ports will be automatically forwarded when discovered by reading terminal and debug output. Not all processes that use ports will print to the integrated terminal or debug console, so some ports will be missed. Ports forwarded based on output will not be \"un-forwarded\" until reload or until the port is closed by the user in the Ports view.",
		"A port, range of ports (ex. \"40000-55000\"), host and port (ex. \"db:1234\"), or regular expression (ex. \".+\\\\/server.js\").  For a port number or range, the attributes will apply to that port number or range of port numbers. Attributes which use a regular expression will apply to ports whose associated process command line matches the expression.",
		"Shows a notification when a port is automatically forwarded.",
		"Opens the browser when the port is automatically forwarded. Depending on your settings, this could open an embedded browser.",
		"Opens the browser when the port is automatically forwarded, but only the first time the port is forward during a session. Depending on your settings, this could open an embedded browser.",
		"Opens a preview in the same window when the port is automatically forwarded.",
		"Shows no notification and takes no action when this port is automatically forwarded.",
		"This port will not be automatically forwarded.",
		"Defines the action that occurs when the port is discovered for automatic forwarding",
		"Automatically prompt for elevation (if needed) when this port is forwarded. Elevate is required if the local port is a privileged port.",
		"Label that will be shown in the UI for this port.",
		"Application",
		"When true, a modal dialog will show if the chosen local port isn't used for forwarding.",
		"The protocol to use when forwarding this port.",
		"Application",
		"Set properties that are applied when a specific port number is forwarded. For example:\n\n```\n\"3000\": {\n  \"label\": \"Application\"\n},\n\"40000-55000\": {\n  \"onAutoForward\": \"ignore\"\n},\n\".+\\\\/server.js\": {\n \"onAutoForward\": \"openPreview\"\n}\n```",
		"Must be a port number, range of port numbers, or regular expression.",
		"Shows a notification when a port is automatically forwarded.",
		"Opens the browser when the port is automatically forwarded. Depending on your settings, this could open an embedded browser.",
		"Opens a preview in the same window when the port is automatically forwarded.",
		"Shows no notification and takes no action when this port is automatically forwarded.",
		"This port will not be automatically forwarded.",
		"Defines the action that occurs when the port is discovered for automatic forwarding",
		"Automatically prompt for elevation (if needed) when this port is forwarded. Elevate is required if the local port is a privileged port.",
		"Label that will be shown in the UI for this port.",
		"Application",
		"When true, a modal dialog will show if the chosen local port isn't used for forwarding.",
		"The protocol to use when forwarding this port.",
		"Set default properties that are applied to all ports that don't get properties from the setting `remote.portsAttributes`. For example:\n\n```\n{\n  \"onAutoForward\": \"ignore\"\n}\n```",
		"Specifies the local host name that will be used for port forwarding."
	],
	"vs/workbench/contrib/sash/browser/sash.contribution": [
		"Controls the feedback area size in pixels of the dragging area in between views/editors. Set it to a larger value if you feel it's hard to resize views using the mouse.",
		"Controls the hover feedback delay in milliseconds of the dragging area in between views/editors."
	],
	"vs/workbench/contrib/scm/browser/activity": [
		"Source Control",
		"{0} pending changes"
	],
	"vs/workbench/contrib/scm/browser/dirtydiffDecorator": [
		"{0} of {1} changes",
		"{0} of {1} change",
		"Close",
		"Show Previous Change",
		"Show Next Change",
		"Next &&Change",
		"Previous &&Change",
		"Go to Previous Change",
		"Go to Next Change",
		"Editor gutter background color for lines that are modified.",
		"Editor gutter background color for lines that are added.",
		"Editor gutter background color for lines that are deleted.",
		"Minimap gutter background color for lines that are modified.",
		"Minimap gutter background color for lines that are added.",
		"Minimap gutter background color for lines that are deleted.",
		"Overview ruler marker color for modified content.",
		"Overview ruler marker color for added content.",
		"Overview ruler marker color for deleted content."
	],
	"vs/workbench/contrib/scm/browser/scm.contribution": [
		"View icon of the Source Control view.",
		"Source Control",
		"No source control providers registered.",
		"None of the registered source control providers work in Restricted Mode.",
		"Manage Workspace Trust",
		"Source Control",
		"S&&CM",
		"Source Control Repositories",
		"SCM",
		"Show the diff decorations in all available locations.",
		"Show the diff decorations only in the editor gutter.",
		"Show the diff decorations only in the overview ruler.",
		"Show the diff decorations only in the minimap.",
		"Do not show the diff decorations.",
		"Controls diff decorations in the editor.",
		"Controls the width(px) of diff decorations in gutter (added & modified).",
		"Show the diff decorator in the gutter at all times.",
		"Show the diff decorator in the gutter only on hover.",
		"Controls the visibility of the Source Control diff decorator in the gutter.",
		"Show the inline diff peek view on click.",
		"Do nothing.",
		"Controls the behavior of Source Control diff gutter decorations.",
		"Ignore leading and trailing whitespace.",
		"Do not ignore leading and trailing whitespace.",
		"Inherit from `diffEditor.ignoreTrimWhitespace`.",
		"Controls whether leading and trailing whitespace is ignored in Source Control diff gutter decorations.",
		"Controls whether inline actions are always visible in the Source Control view.",
		"Show the sum of all Source Control Provider count badges.",
		"Show the count badge of the focused Source Control Provider.",
		"Disable the Source Control count badge.",
		"Controls the count badge on the Source Control icon on the Activity Bar.",
		"Hide Source Control Provider count badges.",
		"Only show count badge for Source Control Provider when non-zero.",
		"Show Source Control Provider count badges.",
		"Controls the count badges on Source Control Provider headers. These headers only appear when there is more than one provider.",
		"Show the repository changes as a tree.",
		"Show the repository changes as a list.",
		"Controls the default Source Control repository view mode.",
		"Sort the repository changes by file name.",
		"Sort the repository changes by path.",
		"Sort the repository changes by SCM status.",
		"Controls the default Source Control repository sort mode.",
		"Controls whether the SCM view should automatically reveal and select files when opening them.",
		"Controls the font for the input message. Use `default` for the workbench user interface font family, `editor` for the `#editor.fontFamily#`'s value, or a custom font family.",
		"Controls the font size for the input message in pixels.",
		"Controls whether repositories should always be visible in the SCM view.",
		"Controls how many repositories are visible in the Source Control Repositories section. Set to `0` to be able to manually resize the view.",
		"Controls whether an action button can be shown in the SCM view.",
		"SCM: Accept Input",
		"SCM: View Next Commit",
		"SCM: View Previous Commit",
		"Open In Terminal"
	],
	"vs/workbench/contrib/scm/browser/scmRepositoriesViewPane": [
		"Source Control Repositories"
	],
	"vs/workbench/contrib/scm/browser/scmViewPane": [
		"Source Control Management",
		"Source Control Input",
		"View & Sort",
		"Repositories",
		"View as List",
		"View as Tree",
		"Sort by Name",
		"Sort by Path",
		"Sort by Status",
		"Collapse All Repositories",
		"Expand All Repositories",
		"SCM Provider separator border."
	],
	"vs/workbench/contrib/scm/browser/scmViewPaneContainer": [
		"Source Control"
	],
	"vs/workbench/contrib/search/browser/anythingQuickAccess": [
		"No matching results",
		"recently opened",
		"file and symbol results",
		"file results",
		"{0} unsaved changes",
		"Open to the Side",
		"Open to the Bottom",
		"Remove from Recently Opened"
	],
	"vs/workbench/contrib/search/browser/patternInputWidget": [
		"input",
		"Search only in Open Editors",
		"Use Exclude Settings and Ignore Files"
	],
	"vs/workbench/contrib/search/browser/replaceService": [
		"{0} ↔ {1} (Replace Preview)"
	],
	"vs/workbench/contrib/search/browser/search.contribution": [
		"Search",
		"Copy",
		"Copy Path",
		"Copy All",
		"Cancel Search",
		"Refresh",
		"Collapse All",
		"Expand All",
		"Clear Search Results",
		"Reveal in Side Bar",
		"Clear Search History",
		"Focus List",
		"Find in Folder...",
		"Find in Workspace...",
		"Go to Symbol in Workspace...",
		"Search",
		"Search",
		"&&Search",
		"Open a workspace search",
		"A set of options for the search",
		"Find in Files",
		"Find &&in Files",
		"Replace &&in Files",
		"Search files by name (append {0} to go to line or {1} to go to symbol)",
		"Go to File",
		"Type the name of a symbol to open.",
		"Go to Symbol in Workspace",
		"Search",
		"Configure [glob patterns](https://code.visualstudio.com/docs/editor/codebasics#_advanced-search-options) for excluding files and folders in fulltext searches and quick open. Inherits all glob patterns from the `#files.exclude#` setting.",
		"The glob pattern to match file paths against. Set to true or false to enable or disable the pattern.",
		"Additional check on the siblings of a matching file. Use $(basename) as variable for the matching file name.",
		"Controls where new `Search: Find in Files` and `Find in Folder` operations occur: either in the sidebar's search view, or in a search editor",
		"Search in the search view, either in the panel or sidebar.",
		"Search in an existing search editor if present, otherwise in a new search editor.",
		"Search in a new search editor.",
		"This setting is deprecated and now falls back on \"search.usePCRE2\".",
		"Deprecated. Consider \"search.usePCRE2\" for advanced regex feature support.",
		"The search cache is kept in the extension host which never shuts down, so this setting is no longer needed.",
		"When enabled, the searchService process will be kept alive instead of being shut down after an hour of inactivity. This will keep the file search cache in memory.",
		"Controls whether to use `.gitignore` and `.ignore` files when searching for files.",
		"Controls whether to use global `.gitignore` and `.ignore` files when searching for files. Requires `#search.useIgnoreFiles#` to be enabled.",
		"Controls whether to use `.gitignore` and `.ignore` files in parent directories when searching for files. Requires `#search.useIgnoreFiles#` to be enabled.",
		"Whether to include results from a global symbol search in the file results for Quick Open.",
		"Whether to include results from recently opened files in the file results for Quick Open.",
		"History entries are sorted by relevance based on the filter value used. More relevant entries appear first.",
		"History entries are sorted by recency. More recently opened entries appear first.",
		"Controls sorting order of editor history in quick open when filtering.",
		"Controls whether to follow symlinks while searching.",
		"Search case-insensitively if the pattern is all lowercase, otherwise, search case-sensitively.",
		"Controls whether the search view should read or modify the shared find clipboard on macOS.",
		"Controls whether the search will be shown as a view in the sidebar or as a panel in the panel area for more horizontal space.",
		"This setting is deprecated. You can drag the search icon to a new location instead.",
		"Controls the maximum number of search results, this can be set to `null` (empty) to return unlimited results.",
		"Files with less than 10 results are expanded. Others are collapsed.",
		"Controls whether the search results will be collapsed or expanded.",
		"Controls whether to open Replace Preview when selecting or replacing a match.",
		"Controls whether to show line numbers for search results.",
		"Whether to use the PCRE2 regex engine in text search. This enables using some advanced regex features like lookahead and backreferences. However, not all PCRE2 features are supported - only features that are also supported by JavaScript.",
		"Deprecated. PCRE2 will be used automatically when using regex features that are only supported by PCRE2.",
		"Position the actionbar to the right when the search view is narrow, and immediately after the content when the search view is wide.",
		"Always position the actionbar to the right.",
		"Controls the positioning of the actionbar on rows in the search view.",
		"Search all files as you type.",
		"Enable seeding search from the word nearest the cursor when the active editor has no selection.",
		"Update the search query to the editor's selected text when focusing the search view. This happens either on click or when triggering the `workbench.views.search.focus` command.",
		"When `#search.searchOnType#` is enabled, controls the timeout in milliseconds between a character being typed and the search starting. Has no effect when `search.searchOnType` is disabled.",
		"Double clicking selects the word under the cursor.",
		"Double clicking opens the result in the active editor group.",
		"Double clicking opens the result in the editor group to the side, creating one if it does not yet exist.",
		"Configure effect of double clicking a result in a search editor.",
		"When enabled, new Search Editors will reuse the includes, excludes, and flags of the previously opened Search Editor.",
		"The default number of surrounding context lines to use when creating new Search Editors. If using `#search.searchEditor.reusePriorSearchConfiguration#`, this can be set to `null` (empty) to use the prior Search Editor's configuration.",
		"Results are sorted by folder and file names, in alphabetical order.",
		"Results are sorted by file names ignoring folder order, in alphabetical order.",
		"Results are sorted by file extensions, in alphabetical order.",
		"Results are sorted by file last modified date, in descending order.",
		"Results are sorted by count per file, in descending order.",
		"Results are sorted by count per file, in ascending order.",
		"Controls sorting order of search results.",
		"Go to Symbol in &&Workspace..."
	],
	"vs/workbench/contrib/search/browser/searchActions": [
		"Replace in Files",
		"Toggle Search on Type",
		"Focus Next Search Result",
		"Focus Previous Search Result",
		"Dismiss",
		"Replace All",
		"Replace All",
		"Replace"
	],
	"vs/workbench/contrib/search/browser/searchIcons": [
		"Icon to make search details visible.",
		"Icon for toggle the context in the search editor.",
		"Icon to collapse the replace section in the search view.",
		"Icon to expand the replace section in the search view.",
		"Icon for replace all in the search view.",
		"Icon for replace in the search view.",
		"Icon to remove a search result.",
		"Icon for refresh in the search view.",
		"Icon for collapse results in the search view.",
		"Icon for expand results in the search view.",
		"Icon for clear results in the search view.",
		"Icon for stop in the search view.",
		"View icon of the search view.",
		"Icon for the action to open a new search editor."
	],
	"vs/workbench/contrib/search/browser/searchMessage": [
		"Unable to open command link from untrusted source: {0}",
		"Unable to open unknown link: {0}"
	],
	"vs/workbench/contrib/search/browser/searchResultsView": [
		"Other files",
		"{0} files found",
		"{0} file found",
		"{0} matches found",
		"{0} match found",
		"From line {0}",
		"{0} more lines",
		"Search",
		"{0} matches in folder root {1}, Search result",
		"{0} matches outside of the workspace, Search result",
		"{0} matches in file {1} of folder {2}, Search result",
		"Replace '{0}' with '{1}' at column {2} in line {3}",
		"Found '{0}' at column {1} in line '{2}'"
	],
	"vs/workbench/contrib/search/browser/searchView": [
		"Search was canceled before any results could be found - ",
		"Toggle Search Details",
		"files to include",
		"e.g. *.ts, src/**/include",
		"files to exclude",
		"e.g. *.ts, src/**/exclude",
		"Replace All",
		"&&Replace",
		"Replaced {0} occurrence across {1} file with '{2}'.",
		"Replaced {0} occurrence across {1} file.",
		"Replaced {0} occurrence across {1} files with '{2}'.",
		"Replaced {0} occurrence across {1} files.",
		"Replaced {0} occurrences across {1} file with '{2}'.",
		"Replaced {0} occurrences across {1} file.",
		"Replaced {0} occurrences across {1} files with '{2}'.",
		"Replaced {0} occurrences across {1} files.",
		"Replace {0} occurrence across {1} file with '{2}'?",
		"Replace {0} occurrence across {1} file?",
		"Replace {0} occurrence across {1} files with '{2}'?",
		"Replace {0} occurrence across {1} files?",
		"Replace {0} occurrences across {1} file with '{2}'?",
		"Replace {0} occurrences across {1} file?",
		"Replace {0} occurrences across {1} files with '{2}'?",
		"Replace {0} occurrences across {1} files?",
		"Empty Search",
		"The search results have been cleared",
		"Search path not found: {0}",
		"No results found in open editors matching '{0}' excluding '{1}' - ",
		"No results found in open editors matching '{0}' - ",
		"No results found in open editors excluding '{0}' - ",
		"No results found in open editors. Review your settings for configured exclusions and check your gitignore files - ",
		"No results found in '{0}' excluding '{1}' - ",
		"No results found in '{0}' - ",
		"No results found excluding '{0}' - ",
		"No results found. Review your settings for configured exclusions and check your gitignore files - ",
		"Search again",
		"Search again in all files",
		"Open Settings",
		"Learn More",
		"Search returned {0} results in {1} files",
		"The result set only contains a subset of all matches. Be more specific in your search to narrow down the results.",
		" - Search: {0}",
		"exclude settings and ignore files are disabled",
		"enable",
		"Use Exclude Settings and Ignore Files",
		"searching only in open files",
		"disable",
		"Search in entire workspace",
		"Copy current search results to an editor",
		"Open in editor",
		"{0} result in {1} file",
		"{0} result in {1} files",
		"{0} results in {1} file",
		"{0} results in {1} files",
		"You have not opened or specified a folder. Only open files are currently searched - ",
		"Open Folder"
	],
	"vs/workbench/contrib/search/browser/searchWidget": [
		"Replace All (Submit Search to Enable)",
		"Replace All",
		"Toggle Replace",
		"Search: Type Search Term and press Enter to search",
		"Search",
		"Toggle Context Lines",
		"Replace: Type replace term and press Enter to preview",
		"Replace"
	],
	"vs/workbench/contrib/search/browser/symbolsQuickAccess": [
		"No matching workspace symbols",
		"Open to the Side",
		"Open to the Bottom"
	],
	"vs/workbench/contrib/searchEditor/browser/searchEditor": [
		"Toggle Search Details",
		"files to include",
		"Search Include Patterns",
		"files to exclude",
		"Search Exclude Patterns",
		"Run Search",
		"Matched {0} at {1} in file {2}",
		"Search",
		"Search editor text input box border."
	],
	"vs/workbench/contrib/searchEditor/browser/searchEditor.contribution": [
		"Search Editor",
		"Search Editor",
		"Search Editor",
		"Delete File Results",
		"New Search Editor",
		"Open Search Editor",
		"Open new Search Editor to the Side",
		"Open Results in Editor",
		"Search Again",
		"Focus Search Editor Input",
		"Toggle Match Case",
		"Toggle Match Whole Word",
		"Toggle Use Regular Expression",
		"Toggle Context Lines",
		"Increase Context Lines",
		"Decrease Context Lines",
		"Select All Matches",
		"Open New Search Editor"
	],
	"vs/workbench/contrib/searchEditor/browser/searchEditorInput": [
		"Search: {0}",
		"Search: {0}",
		"Search"
	],
	"vs/workbench/contrib/searchEditor/browser/searchEditorSerialization": [
		"All backslashes in Query string must be escaped (\\\\)",
		"{0} files",
		"1 file",
		"{0} results",
		"1 result",
		"No Results",
		"The result set only contains a subset of all matches. Be more specific in your search to narrow down the results."
	],
	"vs/workbench/contrib/snippets/browser/configureSnippets": [
		"(global)",
		"({0})",
		"Type snippet file name",
		"Invalid file name",
		"'{0}' is not a valid file name",
		"'{0}' already exists",
		"global",
		"New Global Snippets file...",
		"{0} workspace",
		"New Snippets file for '{0}'...",
		"Existing Snippets",
		"New Snippets",
		"New Snippets",
		"Select Snippets File or Create Snippets",
		"Configure User Snippets",
		"Preferences",
		"User &&Snippets",
		"User Snippets"
	],
	"vs/workbench/contrib/snippets/browser/insertSnippet": [
		"Insert Snippet"
	],
	"vs/workbench/contrib/snippets/browser/snippetCompletionProvider": [
		"{0} ({1})",
		"{0}, {1}",
		"{0}, {1}"
	],
	"vs/workbench/contrib/snippets/browser/snippetPicker": [
		"User Snippets",
		"Workspace Snippets",
		"Hide from IntelliSense",
		"(hidden from IntelliSense)",
		"Show in IntelliSense",
		"Select a snippet"
	],
	"vs/workbench/contrib/snippets/browser/snippets.contribution": [
		"The prefix to use when selecting the snippet in intellisense",
		"The snippet content. Use `$1`, `${1:defaultText}` to define cursor positions, use `$0` for the final cursor position. Insert variable values with `${varName}` and `${varName:defaultText}`, e.g. `This is file: $TM_FILENAME`.",
		"The snippet description.",
		"Empty snippet",
		"User snippet configuration",
		"Empty snippet",
		"User snippet configuration",
		"A list of language names to which this snippet applies, e.g. 'typescript,javascript'."
	],
	"vs/workbench/contrib/snippets/browser/snippetsFile": [
		"Workspace Snippet",
		"Global User Snippet",
		"User Snippet"
	],
	"vs/workbench/contrib/snippets/browser/snippetsService": [
		"Expected string in `contributes.{0}.path`. Provided value: {1}",
		"When omitting the language, the value of `contributes.{0}.path` must be a `.code-snippets`-file. Provided value: {1}",
		"Unknown language in `contributes.{0}.language`. Provided value: {1}",
		"Expected `contributes.{0}.path` ({1}) to be included inside extension's folder ({2}). This might make the extension non-portable.",
		"Contributes snippets.",
		"Language identifier for which this snippet is contributed to.",
		"Path of the snippets file. The path is relative to the extension folder and typically starts with './snippets/'.",
		"One or more snippets from the extension '{0}' very likely confuse snippet-variables and snippet-placeholders (see https://code.visualstudio.com/docs/editor/userdefinedsnippets#_snippet-syntax for more details)",
		"The snippet file \"{0}\" could not be read."
	],
	"vs/workbench/contrib/snippets/browser/surroundWithSnippet": [
		"Surround With Snippet..."
	],
	"vs/workbench/contrib/surveys/browser/ces.contribution": [
		"Got a moment to help the VS Code team? Please tell us about your experience with VS Code so far.",
		"Give Feedback",
		"Remind Me later"
	],
	"vs/workbench/contrib/surveys/browser/languageSurveys.contribution": [
		"Help us improve our support for {0}",
		"Take Short Survey",
		"Remind Me later",
		"Don't Show Again"
	],
	"vs/workbench/contrib/surveys/browser/nps.contribution": [
		"Do you mind taking a quick feedback survey?",
		"Take Survey",
		"Remind Me later",
		"Don't Show Again"
	],
	"vs/workbench/contrib/tasks/browser/abstractTaskService": [
		"Configure Task",
		"Tasks",
		"Select the build task (there is no default build task defined)",
		"There are task errors. See the output for details.",
		"Show output",
		"The folder {0} is ignored since it uses task version 0.1.0",
		"Warning: {0} tasks are unavailable in the current environment.\n",
		"No build task defined. Mark a task with 'isBuildCommand' in the tasks.json file.",
		"No build task defined. Mark a task with as a 'build' group in the tasks.json file.",
		"No test task defined. Mark a task with 'isTestCommand' in the tasks.json file.",
		"No test task defined. Mark a task with as a 'test' group in the tasks.json file.",
		"Task to execute is undefined",
		"associate",
		"Continue without scanning the task output",
		"Never scan the task output for this task",
		"Never scan the task output for {0} tasks",
		"Learn more about scanning the task output",
		"Select for which kind of errors and warnings to scan the task output",
		"The current task configuration has errors. Please fix the errors first before customizing a task.",
		"\t// See https://go.microsoft.com/fwlink/?LinkId=733558 \n\t// for the documentation about the tasks.json format",
		"There are many build tasks defined in the tasks.json. Executing the first one.\n",
		"Save all editors?",
		"Save",
		"Don't save",
		"Do you want to save all editors before running the task?",
		"The task '{0}' is already active.",
		"Terminate Task",
		"Restart Task",
		"There is already a task running. Terminate it first before executing another task.",
		"Failed to terminate and restart task {0}",
		"The task provider for \"{0}\" tasks unexpectedly provided a task of type \"{1}\".\n",
		"Warning: {0} tasks are unavailable in the current environment.\n",
		"Error: The {0} task detection didn't contribute a task for the following configuration:\n{1}\nThe task will be ignored.\n",
		"Error: the provided task configuration has validation errors and can't not be used. Please correct the errors first.",
		"Error: The content of the tasks json in {0} has syntax errors. Please correct them before executing a task.\n",
		"workspace file",
		"Only tasks version 2.0.0 permitted in workspace configuration files.",
		"user settings",
		"Only tasks version 2.0.0 permitted in user settings.",
		"Error: the provided task configuration has validation errors and can't not be used. Please correct the errors first.",
		"Ignoring task configurations for workspace folder {0}. Multi folder workspace task support requires that all folders use task version 2.0.0\n",
		"Error: The content of the tasks.json file has syntax errors. Please correct them before executing a task.\n",
		"Terminate Task",
		"An error has occurred while running a task. See task log for details.",
		"Configure Task",
		"recently used tasks",
		"configured tasks",
		"detected tasks",
		"The following workspace folders are ignored since they use task version 0.1.0: {0}",
		"Don't Show Again",
		"Listing and running tasks requires that some of the files in this workspace be executed as code.",
		"Select the task to run",
		"$(plus) Configure a Task",
		"$(plus) Configure a Task",
		"Fetching build tasks...",
		"Select the build task to run",
		"No build task to run found. Configure Build Task...",
		"Fetching test tasks...",
		"Select the test task to run",
		"No test task to run found. Configure Tasks...",
		"Select a task to terminate",
		"No task is currently running",
		"All Running Tasks",
		"The launched process doesn't exist anymore. If the task spawned background tasks exiting VS Code might result in orphaned processes.",
		"Failed to terminate running task",
		"Select the task to restart",
		"No task to restart",
		"Select a Task Template",
		"User",
		"Create tasks.json file from template",
		"Open tasks.json file",
		"Select a task to configure",
		"{0} is already marked as the default build task",
		"Select the task to be used as the default build task",
		"{0} is already marked as the default test task.",
		"Select the task to be used as the default test task",
		"Select the task to show its output",
		"No task is running",
		"The deprecated tasks version 0.1.0 has been removed. Your tasks have been upgraded to version 2.0.0. Open the diff to review the upgrade.",
		"The deprecated tasks version 0.1.0 has been removed. Your tasks have been upgraded to version 2.0.0. Open the diffs to review the upgrade.",
		"Open diff",
		"Open diffs"
	],
	"vs/workbench/contrib/tasks/browser/runAutomaticTasks": [
		"This workspace has tasks ({0}) defined ({1}) that run automatically when you open this workspace. Do you allow automatic tasks to run when you open this workspace?",
		"Allow and run",
		"Disallow",
		"Open file",
		"Open files",
		"Manage Automatic Tasks in Folder",
		"Allow Automatic Tasks in Folder",
		"Disallow Automatic Tasks in Folder"
	],
	"vs/workbench/contrib/tasks/browser/task.contribution": [
		"Building...",
		"Running Tasks",
		"{0} running tasks",
		"Show Running Tasks",
		"&&Run Task...",
		"Run &&Build Task...",
		"Show Runnin&&g Tasks...",
		"R&&estart Running Task...",
		"&&Terminate Task...",
		"&&Configure Tasks...",
		"Configure De&&fault Build Task...",
		"Open Workspace Tasks",
		"Show Task Log",
		"Run Task",
		"Rerun Last Task",
		"Restart Running Task",
		"Show Running Tasks",
		"Terminate Task",
		"Run Build Task",
		"Run Test Task",
		"Configure Default Build Task",
		"Configure Default Test Task",
		"Open User Tasks",
		"Type the name of a task to run.",
		"Run Task",
		"Tasks",
		"Configures whether to show the problem matcher prompt when running a task. Set to `true` to never prompt, or use a dictionary of task types to turn off prompting only for specific task types.",
		"Sets problem matcher prompting behavior for all tasks.",
		"An object containing task type-boolean pairs to never prompt for problem matchers on.",
		"Controls enablement of `provideTasks` for all task provider extension. If the Tasks: Run Task command is slow, disabling auto detect for task providers may help. Individual extensions may also provide settings that disable auto detection.",
		"Configures whether a warning is shown when a provider is slow",
		"Sets the slow provider warning for all tasks.",
		"An array of task types to never show the slow provider warning.",
		"Controls the number of recent items tracked in task quick open dialog.",
		"Controls whether to show the task detail for tasks that have a detail in task quick picks, such as Run Task.",
		"Controls whether the task quick pick is skipped when there is only one task to pick from.",
		"Causes the Tasks: Run Task command to use the slower \"show all\" behavior instead of the faster two level picker where tasks are grouped by provider.",
		"Save all dirty editors before running a task.",
		"Always saves all editors before running.",
		"Never saves editors before running.",
		"Prompts whether to save editors before running."
	],
	"vs/workbench/contrib/tasks/browser/taskQuickPick": [
		"Show All Tasks...",
		"Configuration icon in the tasks selection list.",
		"Icon for remove in the tasks selection list.",
		"Configure Task",
		"contributed",
		"All {0} tasks",
		"Remove Recently Used Task",
		"recently used",
		"configured",
		"configured",
		"No",
		"Yes",
		"Task detection for {0} tasks causes files in any workspace you open to be run as code. Enabling {0} task detection is a user setting and will apply to any workspace you open. Do you want to enable {0} task detection for all workspaces?",
		"Select the task to run",
		"$(gear) {0} task detection is turned off. Enable {1} task detection...",
		"Go back ↩",
		"No {0} tasks found. Go back ↩",
		"There is no task provider registered for tasks of type \"{0}\"."
	],
	"vs/workbench/contrib/tasks/browser/taskService": [
		"Process task system is not support in the web."
	],
	"vs/workbench/contrib/tasks/browser/taskTerminalStatus": [
		"Task is running",
		"Task succeeded",
		"Task succeeded and waiting...",
		"Task has errors",
		"Task has errors and is waiting...",
		"Task has warnings",
		"Task has warnings and is waiting...",
		"Task has infos",
		"Task has infos and is waiting..."
	],
	"vs/workbench/contrib/tasks/browser/tasksQuickAccess": [
		"No matching tasks",
		"Select the task to run"
	],
	"vs/workbench/contrib/tasks/browser/terminalTaskSystem": [
		"A unknown error has occurred while executing a task. See task output log for details.",
		"There are issues with task \"{0}\". See the output for more details.",
		"There is a dependency cycle. See task \"{0}\".",
		"Couldn't resolve dependent task '{0}' in workspace folder '{1}'",
		"Task {0} is a background task but uses a problem matcher without a background pattern",
		"Press any key to close the terminal.",
		"Terminal will be reused by tasks, press any key to close it.",
		"Can't execute a shell command on an UNC drive using cmd.exe.",
		"Problem matcher {0} can't be resolved. The matcher will be ignored"
	],
	"vs/workbench/contrib/tasks/common/jsonSchemaCommon": [
		"Additional command options",
		"The current working directory of the executed program or script. If omitted Code's current workspace root is used.",
		"The environment of the executed program or shell. If omitted the parent process' environment is used.",
		"Unrecognized problem matcher. Is the extension that contributes this problem matcher installed?",
		"Unrecognized problem matcher. Is the extension that contributes this problem matcher installed?",
		"Configures the shell to be used.",
		"The shell to be used.",
		"The shell arguments.",
		"The command to be executed. Can be an external program or a shell command.",
		"Arguments passed to the command when this task is invoked.",
		"The task's name",
		"The command to be executed. Can be an external program or a shell command.",
		"Arguments passed to the command when this task is invoked.",
		"Windows specific command configuration",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"Mac specific command configuration",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"Linux specific command configuration",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"Controls whether the task name is added as an argument to the command. If omitted the globally defined value is used.",
		"Controls whether the output of the running task is shown or not. If omitted the globally defined value is used.",
		"Controls whether the executed command is echoed to the output. Default is false.",
		"Deprecated. Use isBackground instead.",
		"Whether the executed task is kept alive and is watching the file system.",
		"Whether the executed task is kept alive and is running in the background.",
		"Whether the user is prompted when VS Code closes with a running task.",
		"Maps this task to Code's default build command.",
		"Maps this task to Code's default test command.",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"The command to be executed. Can be an external program or a shell command.",
		"Additional arguments passed to the command.",
		"Controls whether the output of the running task is shown or not. If omitted 'always' is used.",
		"Deprecated. Use isBackground instead.",
		"Whether the executed task is kept alive and is watching the file system.",
		"Whether the executed task is kept alive and is running in the background.",
		"Whether the user is prompted when VS Code closes with a running background task.",
		"Controls whether the executed command is echoed to the output. Default is false.",
		"Controls whether the task name is added as an argument to the command. Default is false.",
		"Prefix to indicate that an argument is task.",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"The task configurations. Usually these are enrichments of task already defined in the external task runner."
	],
	"vs/workbench/contrib/tasks/common/jsonSchema_v1": [
		"Task version 0.1.0 is deprecated. Please use 2.0.0",
		"The config's version number",
		"The runner has graduated. Use the official runner property",
		"Defines whether the task is executed as a process and the output is shown in the output window or inside the terminal.",
		"Windows specific command configuration",
		"Mac specific command configuration",
		"Linux specific command configuration",
		"Specifies whether the command is a shell command or an external program. Defaults to false if omitted."
	],
	"vs/workbench/contrib/tasks/common/jsonSchema_v2": [
		"Specifies whether the command is a shell command or an external program. Defaults to false if omitted.",
		"The property isShellCommand is deprecated. Use the type property of the task and the shell property in the options instead. See also the 1.14 release notes.",
		"The task identifier.",
		"Another task this task depends on.",
		"The other tasks this task depends on.",
		"Either a string representing another task or an array of other tasks that this task depends on.",
		"Run all dependsOn tasks in parallel.",
		"Run all dependsOn tasks in sequence.",
		"Determines the order of the dependsOn tasks for this task. Note that this property is not recursive.",
		"An optional description of a task that shows in the Run Task quick pick as a detail.",
		"Configures the panel that is used to present the task's output and reads its input.",
		"Controls whether the executed command is echoed to the panel. Default is true.",
		"Controls whether the panel takes focus. Default is false. If set to true the panel is revealed as well.",
		"Always reveals the problems panel when this task is executed.",
		"Only reveals the problems panel if a problem is found.",
		"Never reveals the problems panel when this task is executed.",
		"Controls whether the problems panel is revealed when running this task or not. Takes precedence over option \"reveal\". Default is \"never\".",
		"Always reveals the terminal when this task is executed.",
		"Only reveals the terminal if the task exits with an error or the problem matcher finds an error.",
		"Never reveals the terminal when this task is executed.",
		"Controls whether the terminal running the task is revealed or not. May be overridden by option \"revealProblems\". Default is \"always\".",
		"Controls if the panel is shared between tasks, dedicated to this task or a new one is created on every run.",
		"Controls whether to show the `Terminal will be reused by tasks, press any key to close it` message.",
		"Controls whether the terminal is cleared before executing the task.",
		"Controls whether the task is executed in a specific terminal group using split panes.",
		"Controls whether the terminal the task runs in is closed when the task exits.",
		"The terminal property is deprecated. Use presentation instead",
		"Marks the task as a build task accessible through the 'Run Build Task' command.",
		"Marks the task as a test task accessible through the 'Run Test Task' command.",
		"Assigns the task to no group",
		"The task's execution group.",
		"Defines if this task is the default task in the group.",
		"Marks the task as the default build task.",
		"Marks the task as the default test task.",
		"Defines to which execution group this task belongs to. It supports \"build\" to add it to the build group and \"test\" to add it to the test group.",
		"Defines whether the task is run as a process or as a command inside a shell.",
		"The shell command to be executed. Array items will be joined using a space character",
		"The shell command to be executed. Array items will be joined using a space character",
		"The actual command value",
		"Escapes characters using the shell's escape character (e.g. ` under PowerShell and \\ under bash).",
		"Quotes the argument using the shell's strong quote character (e.g. ' under PowerShell and bash).",
		"Quotes the argument using the shell's weak quote character (e.g. \" under PowerShell and bash).",
		"How the command value should be quoted.",
		"The command to be executed. Can be an external program or a shell command.",
		"The actual argument value",
		"Escapes characters using the shell's escape character (e.g. ` under PowerShell and \\ under bash).",
		"Quotes the argument using the shell's strong quote character (e.g. ' under PowerShell and bash).",
		"Quotes the argument using the shell's weak quote character (e.g. \" under PowerShell and bash).",
		"How the argument value should be quoted.",
		"Arguments passed to the command when this task is invoked.",
		"The task's user interface label",
		"The config's version number.",
		"A user defined identifier to reference the task in launch.json or a dependsOn clause.",
		"User defined identifiers are deprecated. For custom task use the name as a reference and for tasks provided by extensions use their defined task identifier.",
		"Whether to reevaluate task variables on rerun.",
		"Configures when the task should be run. If set to folderOpen, then the task will be run automatically when the folder is opened.",
		"The number of instances of the task that are allowed to run simultaneously.",
		"The task's run related options",
		"The task's label",
		"The task's name",
		"The task's name property is deprecated. Use the label property instead.",
		"Whether the executed task is kept alive and is running in the background.",
		"Whether the user is prompted when VS Code closes with a running task.",
		"The problem matcher(s) to use. Can either be a string or a problem matcher definition or an array of strings and problem matchers.",
		"The task type to customize",
		"The customize property is deprecated. See the 1.14 release notes on how to migrate to the new task customization approach",
		"The task's name property is deprecated. Use the label property instead.",
		"The property showOutput is deprecated. Use the reveal property inside the presentation property instead. See also the 1.14 release notes.",
		"The property echoCommand is deprecated. Use the echo property inside the presentation property instead. See also the 1.14 release notes.",
		"The property suppressTaskName is deprecated. Inline the command with its arguments into the task instead. See also the 1.14 release notes.",
		"The property isBuildCommand is deprecated. Use the group property instead. See also the 1.14 release notes.",
		"The property isTestCommand is deprecated. Use the group property instead. See also the 1.14 release notes.",
		"Defines whether the task is run as a process or as a command inside a shell.",
		"The property suppressTaskName is deprecated. Inline the command with its arguments into the task instead. See also the 1.14 release notes.",
		"The property taskSelector is deprecated. Inline the command with its arguments into the task instead. See also the 1.14 release notes.",
		"Windows specific command configuration",
		"Mac specific command configuration",
		"Linux specific command configuration"
	],
	"vs/workbench/contrib/tasks/common/problemMatcher": [
		"The problem pattern is missing a regular expression.",
		"The loop property is only supported on the last line matcher.",
		"The problem pattern is invalid. The kind property must be provided only in the first element",
		"The problem pattern is invalid. It must have at least have a file and a message.",
		"The problem pattern is invalid. It must either have kind: \"file\" or have a line or location match group.",
		"Error: The string {0} is not a valid regular expression.\n",
		"The regular expression to find an error, warning or info in the output.",
		"whether the pattern matches a location (file and line) or only a file.",
		"The match group index of the filename. If omitted 1 is used.",
		"The match group index of the problem's location. Valid location patterns are: (line), (line,column) and (startLine,startColumn,endLine,endColumn). If omitted (line,column) is assumed.",
		"The match group index of the problem's line. Defaults to 2",
		"The match group index of the problem's line character. Defaults to 3",
		"The match group index of the problem's end line. Defaults to undefined",
		"The match group index of the problem's end line character. Defaults to undefined",
		"The match group index of the problem's severity. Defaults to undefined",
		"The match group index of the problem's code. Defaults to undefined",
		"The match group index of the message. If omitted it defaults to 4 if location is specified. Otherwise it defaults to 5.",
		"In a multi line matcher loop indicated whether this pattern is executed in a loop as long as it matches. Can only specified on a last pattern in a multi line pattern.",
		"The name of the problem pattern.",
		"The name of the problem multi line problem pattern.",
		"The actual patterns.",
		"Contributes problem patterns",
		"Invalid problem pattern. The pattern will be ignored.",
		"Invalid problem pattern. The pattern will be ignored.",
		"Error: the description can't be converted into a problem matcher:\n{0}\n",
		"Error: the description doesn't define a valid problem pattern:\n{0}\n",
		"Error: the description doesn't define an owner:\n{0}\n",
		"Error: the description doesn't define a file location:\n{0}\n",
		"Info: unknown severity {0}. Valid values are error, warning and info.\n",
		"Error: the pattern with the identifier {0} doesn't exist.",
		"Error: the pattern property refers to an empty identifier.",
		"Error: the pattern property {0} is not a valid pattern variable name.",
		"A problem matcher must define both a begin pattern and an end pattern for watching.",
		"Error: The string {0} is not a valid regular expression.\n",
		"The regular expression to detect the begin or end of a background task.",
		"The match group index of the filename. Can be omitted.",
		"The name of a contributed or predefined pattern",
		"A problem pattern or the name of a contributed or predefined problem pattern. Can be omitted if base is specified.",
		"The name of a base problem matcher to use.",
		"The owner of the problem inside Code. Can be omitted if base is specified. Defaults to 'external' if omitted and base is not specified.",
		"A human-readable string describing the source of this diagnostic, e.g. 'typescript' or 'super lint'.",
		"The default severity for captures problems. Is used if the pattern doesn't define a match group for severity.",
		"Controls if a problem reported on a text document is applied only to open, closed or all documents.",
		"Defines how file names reported in a problem pattern should be interpreted. A relative fileLocation may be an array, where the second element of the array is the path the relative file location.",
		"Patterns to track the begin and end of a matcher active on a background task.",
		"If set to true the background monitor is in active mode when the task starts. This is equals of issuing a line that matches the beginsPattern",
		"If matched in the output the start of a background task is signaled.",
		"If matched in the output the end of a background task is signaled.",
		"The watching property is deprecated. Use background instead.",
		"Patterns to track the begin and end of a watching matcher.",
		"If set to true the watcher is in active mode when the task starts. This is equals of issuing a line that matches the beginPattern",
		"If matched in the output the start of a watching task is signaled.",
		"If matched in the output the end of a watching task is signaled.",
		"This property is deprecated. Use the watching property instead.",
		"A regular expression signaling that a watched tasks begins executing triggered through file watching.",
		"This property is deprecated. Use the watching property instead.",
		"A regular expression signaling that a watched tasks ends executing.",
		"The name of the problem matcher used to refer to it.",
		"A human readable label of the problem matcher.",
		"Contributes problem matchers",
		"Microsoft compiler problems",
		"Less problems",
		"Gulp TSC Problems",
		"JSHint problems",
		"JSHint stylish problems",
		"ESLint compact problems",
		"ESLint stylish problems",
		"Go problems"
	],
	"vs/workbench/contrib/tasks/common/taskConfiguration": [
		"Warning: options.cwd must be of type string. Ignoring value {0}\n",
		"Error: command argument must either be a string or a quoted string. Provided value is:\n{0}",
		"Warning: shell configuration is only supported when executing tasks in the terminal.",
		"Error: Problem Matcher in declare scope must have a name:\n{0}\n",
		"Warning: the defined problem matcher is unknown. Supported types are string | ProblemMatcher | Array<string | ProblemMatcher>.\n{0}\n",
		"Error: Invalid problemMatcher reference: {0}\n",
		"Error: tasks configuration must have a type property. The configuration will be ignored.\n{0}\n",
		"Error: there is no registered task type '{0}'. Did you miss installing an extension that provides a corresponding task provider?",
		"Error: the task configuration '{0}' is missing the required property 'type'. The task configuration will be ignored.",
		"Error: the task configuration '{0}' is using an unknown type. The task configuration will be ignored.",
		"Error: tasks is not declared as a custom task. The configuration will be ignored.\n{0}\n",
		"Error: a task must provide a label property. The task will be ignored.\n{0}\n",
		"Warning: {0} tasks are unavailable in the current environment.\n",
		"Error: the task '{0}' neither specifies a command nor a dependsOn property. The task will be ignored. Its definition is:\n{1}",
		"Error: the task '{0}' doesn't define a command. The task will be ignored. Its definition is:\n{1}",
		"Task version 2.0.0 doesn't support global OS specific tasks. Convert them to a task with a OS specific command. Affected tasks are:\n{0}"
	],
	"vs/workbench/contrib/tasks/common/taskDefinitionRegistry": [
		"The actual task type. Please note that types starting with a '$' are reserved for internal usage.",
		"Additional properties of the task type",
		"Condition which must be true to enable this type of task. Consider using `shellExecutionSupported`, `processExecutionSupported`, and `customExecutionSupported` as appropriate for this task definition. See the [API documentation](https://code.visualstudio.com/api/extension-guides/task-provider#when-clause) for more information.",
		"The task type configuration is missing the required 'taskType' property",
		"Contributes task kinds"
	],
	"vs/workbench/contrib/tasks/common/taskService": [
		"Whether CustomExecution tasks are supported. Consider using in the when clause of a 'taskDefinition' contribution.",
		"Whether ShellExecution tasks are supported. Consider using in the when clause of a 'taskDefinition' contribution.",
		"Whether ProcessExecution tasks are supported. Consider using in the when clause of a 'taskDefinition' contribution."
	],
	"vs/workbench/contrib/tasks/common/taskTemplates": [
		"Executes .NET Core build command",
		"Executes the build target",
		"Example to run an arbitrary external command",
		"Executes common maven commands"
	],
	"vs/workbench/contrib/tasks/common/tasks": [
		"Whether a task is currently running.",
		"Tasks",
		"Error: the task identifier '{0}' is missing the required property '{1}'. The task identifier will be ignored."
	],
	"vs/workbench/contrib/terminal/browser/baseTerminalBackend": [
		"Restart pty host",
		"The connection to the terminal's pty host process is unresponsive, the terminals may stop working."
	],
	"vs/workbench/contrib/terminal/browser/environmentVariableInfo": [
		"Extensions want to make the following changes to the terminal's environment:",
		"Extensions want to remove these existing changes from the terminal's environment:",
		"Relaunch terminal",
		"Extensions have made changes to this terminal's environment"
	],
	"vs/workbench/contrib/terminal/browser/links/terminalLink": [
		"Open file in editor",
		"Focus folder in explorer",
		"Open folder in new window"
	],
	"vs/workbench/contrib/terminal/browser/links/terminalLinkDetectorAdapter": [
		"Search workspace",
		"Open file in editor",
		"Focus folder in explorer",
		"Open folder in new window",
		"Follow link"
	],
	"vs/workbench/contrib/terminal/browser/links/terminalLinkManager": [
		"option + click",
		"alt + click",
		"cmd + click",
		"ctrl + click",
		"Follow link using forwarded port",
		"Follow link",
		"Link"
	],
	"vs/workbench/contrib/terminal/browser/links/terminalLinkQuickpick": [
		"Select the link to open",
		"Url",
		"Local File",
		"Workspace Search"
	],
	"vs/workbench/contrib/terminal/browser/links/terminalShellIntegrationLinkDetector": [
		"Learn about shell integration"
	],
	"vs/workbench/contrib/terminal/browser/terminal.contribution": [
		"Type the name of a terminal to open.",
		"Show All Opened Terminals",
		"Terminal",
		"Terminal",
		"&&Terminal"
	],
	"vs/workbench/contrib/terminal/browser/terminalActions": [
		"Show Tabs",
		"Select current working directory for new terminal",
		"Open Help",
		"Create New Terminal (In Active Workspace)",
		"Create New Terminal in Editor Area",
		"Create New Terminal in Editor Area to the Side",
		"Show Tabs",
		"Focus Previous Terminal in Terminal Group",
		"Focus Next Terminal in Terminal Group",
		"Run Recent Command",
		"Go to Recent Directory",
		"Resize Terminal Left",
		"Resize Terminal Right",
		"Resize Terminal Up",
		"Resize Terminal Down",
		"Focus Terminal Tabs View",
		"Focus Next Terminal Group",
		"Focus Previous Terminal Group",
		"Run Selected Text In Active Terminal",
		"Run Active File In Active Terminal",
		"Only files on disk can be run in the terminal",
		"Scroll Down (Line)",
		"Scroll Down (Page)",
		"Scroll to Bottom",
		"Scroll Up (Line)",
		"Scroll Up (Page)",
		"Scroll to Top",
		"Exit Navigation Mode",
		"Focus Previous Line (Navigation Mode)",
		"Focus Next Line (Navigation Mode)",
		"Clear Selection",
		"Focus Find",
		"Hide Find",
		"Detach Session",
		"Attach to Session",
		"There are no unattached terminals to attach to",
		"Switch Active Terminal",
		"Scroll To Previous Command",
		"Scroll To Next Command",
		"Select To Previous Command",
		"Select To Next Command",
		"Select To Previous Line",
		"Select To Next Line",
		"Toggle Escape Sequence Logging",
		"Send Custom Sequence To Terminal",
		"Create New Terminal Starting in a Custom Working Directory",
		"The directory to start the terminal at",
		"Rename the Currently Active Terminal",
		"The new name for the terminal",
		"No name argument provided",
		"Toggle Find Using Regex",
		"Toggle Find Using Whole Word",
		"Toggle Find Using Case Sensitive",
		"Find Next",
		"Find Previous",
		"Search Workspace",
		"Relaunch Active Terminal",
		"Show Environment Information",
		"Join Terminals",
		"Join Terminals",
		"Insufficient terminals for the join action",
		"All terminals are joined already",
		"Split Terminal (In Active Workspace)",
		"Select All",
		"Create New Terminal",
		"Select current working directory for new terminal",
		"Kill the Active Terminal Instance",
		"Kill All Terminals",
		"Kill the Active Terminal in Editor Area",
		"Clear",
		"Open Detected Link...",
		"Open Last Url Link",
		"Open Last Local File Link",
		"Select Default Profile",
		"Configure Terminal Settings",
		"Set Fixed Dimensions",
		"Toggle Size to Content Width",
		"Clear Command History",
		"Copy Selection",
		"Paste into Active Terminal",
		"Paste Selection into Active Terminal",
		"Switch Terminal",
		"Providing no name will reset it to the default value",
		"Create New Terminal (With Profile)",
		"The name of the profile to create",
		"Select current working directory for new terminal"
	],
	"vs/workbench/contrib/terminal/browser/terminalConfigHelper": [
		"The '{0}' extension is recommended for opening a terminal in WSL.",
		"Install"
	],
	"vs/workbench/contrib/terminal/browser/terminalDecorationsProvider": [
		"Terminal"
	],
	"vs/workbench/contrib/terminal/browser/terminalEditorInput": [
		"Do you want to terminate running processes?",
		"&&Terminate",
		"Cancel",
		"Closing will terminate the running processes in the terminals.",
		"Closing will terminate the running processes in this terminal."
	],
	"vs/workbench/contrib/terminal/browser/terminalIcons": [
		"View icon of the terminal view.",
		"Icon for rename in the terminal quick menu.",
		"Icon for killing a terminal instance.",
		"Icon for creating a new terminal instance.",
		"Icon for creating a new terminal profile."
	],
	"vs/workbench/contrib/terminal/browser/terminalInstance": [
		"Terminal input",
		"Too much output to announce, navigate to rows manually to read",
		"Task",
		"Local",
		"Bell",
		"Remove from Command History",
		"View Command Output",
		"Some keybindings don't go to the terminal by default and are handled by {0} instead.",
		"Configure Terminal Settings",
		"The terminal has no selection to copy",
		"Preview:",
		"Are you sure you want to paste {0} lines of text into the terminal?",
		"&&Paste",
		"Do not ask me again",
		"Lost connection to process",
		"Cannot launch a terminal process in an untrusted workspace",
		"Cannot launch a terminal process in an untrusted workspace with cwd {0} and userHome {1}",
		"Creating a terminal process requires executing code",
		"Terminal {0}, {1}",
		"Terminal {0}",
		"Use {0} and {1} to navigate the terminal buffer",
		"Set Fixed Dimensions: Column",
		"Set Fixed Dimensions: Row",
		"Terminal {0} environment is stale, run the 'Show Environment Information' command for more information",
		"Enter terminal name",
		"The terminal process \"{0}\" failed to launch (exit code: {1}). Disabling shell integration with `terminal.integrated.shellIntegration.enabled` might help.",
		"The terminal process failed to launch (exit code: {0}). Disabling shell integration with `terminal.integrated.shellIntegration.enabled` might help.",
		"The terminal process \"{0}\" failed to launch (exit code: {1}).",
		"The terminal process failed to launch (exit code: {0}).",
		"The terminal process \"{0}\" terminated with exit code: {1}.",
		"The terminal process terminated with exit code: {0}.",
		"The terminal process failed to launch: {0}."
	],
	"vs/workbench/contrib/terminal/browser/terminalMenus": [
		"&&New Terminal",
		"&&Split Terminal",
		"Run &&Active File",
		"Run &&Selected Text",
		"New Terminal",
		"Copy",
		"Paste",
		"Clear",
		"Show Tabs",
		"Select All",
		"New Terminal",
		"Copy",
		"Paste",
		"Clear",
		"Select All",
		"New Terminal With Profile",
		"New Terminal",
		"Select Default Profile",
		"Configure Terminal Settings",
		"Switch Terminal",
		"Toggle Size to Content Width",
		"Rename...",
		"Change Icon...",
		"Change Color...",
		"Toggle Size to Content Width",
		"Join Terminals",
		"{0} (Default)",
		"{0} (Default)",
		"{0} (Default)",
		"Split Terminal",
		"New Terminal"
	],
	"vs/workbench/contrib/terminal/browser/terminalProcessManager": [
		"Restarting the terminal because the connection to the shell process was lost..."
	],
	"vs/workbench/contrib/terminal/browser/terminalProfileQuickpick": [
		"Select the terminal profile to create",
		"Select your default terminal profile",
		"Enter terminal profile name",
		"A terminal profile already exists with that name",
		"profiles",
		"contributed",
		"detected",
		"Configure Terminal Profile"
	],
	"vs/workbench/contrib/terminal/browser/terminalProfileResolverService": [
		"The terminal is using deprecated shell/shellArgs settings, do you want to migrate it to a profile?",
		"Migrate"
	],
	"vs/workbench/contrib/terminal/browser/terminalQuickAccess": [
		"Create New Terminal",
		"Create New Terminal With Profile",
		"Rename Terminal"
	],
	"vs/workbench/contrib/terminal/browser/terminalService": [
		"Do you want to terminate the active terminal session?",
		"Do you want to terminate the {0} active terminal sessions?",
		"Terminate",
		"⚠ : This shell is open to a {0}local{1} folder, NOT to the virtual folder",
		"⚠ : This shell is running on your {0}local{1} machine, NOT on the connected remote machine"
	],
	"vs/workbench/contrib/terminal/browser/terminalTabbedView": [
		"Move Tabs Right",
		"Move Tabs Left",
		"Hide Tabs"
	],
	"vs/workbench/contrib/terminal/browser/terminalTabsList": [
		"Type terminal name. Press Enter to confirm or Escape to cancel.",
		"Terminal tabs",
		"Terminal {0} {1}, split {2} of {3}",
		"Terminal {0} {1}"
	],
	"vs/workbench/contrib/terminal/browser/terminalTooltip": [
		"Current working directory detection",
		"Command detection",
		"Command detection (partial)",
		"Shell integration is enabled"
	],
	"vs/workbench/contrib/terminal/browser/terminalView": [
		"Use 'monospace'",
		"The terminal only supports monospace fonts. Be sure to restart VS Code if this is a newly installed font.",
		"Open Terminals.",
		"Starting..."
	],
	"vs/workbench/contrib/terminal/browser/xterm/decorationAddon": [
		"Show Command Actions",
		"Command executed {0} and failed",
		"Command executed {0} and failed (Exit Code {1})",
		"Command executed {0}",
		"Copy Output",
		"Re-run Command"
	],
	"vs/workbench/contrib/terminal/browser/xterm/xtermTerminal": [
		"Yes",
		"No",
		"Don't Show Again",
		"Terminal GPU acceleration appears to be slow on your computer. Would you like to switch to disable it which may improve performance? [Read more about terminal settings](https://code.visualstudio.com/docs/editor/integrated-terminal#_changing-how-the-terminal-is-rendered)."
	],
	"vs/workbench/contrib/terminal/common/terminal": [
		"Terminal",
		"Contributes terminal functionality.",
		"Defines additional terminal types that the user can create.",
		"Command to execute when the user creates this type of terminal.",
		"Title for this type of terminal.",
		"A codicon, URI, or light and dark URIs to associate with this terminal type.",
		"Icon path when a light theme is used",
		"Icon path when a dark theme is used",
		"Defines additional terminal profiles that the user can create.",
		"The ID of the terminal profile provider.",
		"Title for this terminal profile.",
		"A codicon, URI, or light and dark URIs to associate with this terminal type.",
		"Icon path when a light theme is used",
		"Icon path when a dark theme is used"
	],
	"vs/workbench/contrib/terminal/common/terminalColorRegistry": [
		"The background color of the terminal, this allows coloring the terminal differently to the panel.",
		"The foreground color of the terminal.",
		"The foreground color of the terminal cursor.",
		"The background color of the terminal cursor. Allows customizing the color of a character overlapped by a block cursor.",
		"The selection background color of the terminal.",
		"The default terminal command decoration background color.",
		"The terminal command decoration background color for successful commands.",
		"The terminal command decoration background color for error commands.",
		"The color of the border that separates split panes within the terminal. This defaults to panel.border.",
		"Background color when dragging on top of terminals. The color should have transparency so that the terminal contents can still shine through.",
		"Border on the side of the terminal tab in the panel. This defaults to tab.activeBorder.",
		"'{0}' ANSI color in the terminal."
	],
	"vs/workbench/contrib/terminal/common/terminalConfiguration": [
		"the terminal's current working directory",
		"the terminal's current working directory, displayed for multi-root workspaces or in a single root workspace when the value differs from the initial working directory. On Windows, this will only be displayed when shell integration is enabled.",
		"the workspace in which the terminal was launched",
		"indicates a local terminal in a remote workspace",
		"the name of the terminal process",
		"a conditional separator (\" - \") that only shows when surrounded by variables with values or static text.",
		"the name provided to xterm.js by the process",
		"indicates this terminal is associated with a task",
		"Controls the terminal title. Variables are substituted based on the context:",
		"Controls the terminal description, which appears to the right of the title. Variables are substituted based on the context:",
		"Integrated Terminal",
		"Dispatches most keybindings to the terminal instead of the workbench, overriding `#terminal.integrated.commandsToSkipShell#`, which can be used alternatively for fine tuning.",
		"Controls whether terminal tabs display as a list to the side of the terminal. When this is disabled a dropdown will display instead.",
		"Controls whether terminal tab statuses support animation (eg. in progress tasks).",
		"Controls whether the terminal tabs view will hide under certain conditions.",
		"Never hide the terminal tabs view",
		"Hide the terminal tabs view when there is only a single terminal opened",
		"Hide the terminal tabs view when there is only a single terminal group opened",
		"Shows the active terminal information in the view, this is particularly useful when the title within the tabs aren't visible.",
		"Always show the active terminal",
		"Show the active terminal when it is the only terminal opened",
		"Show the active terminal when it is the only terminal opened or when the tabs view is in its narrow textless state",
		"Never show the active terminal",
		"Controls whether terminal split and kill buttons are displays next to the new terminal button.",
		"Always show the actions",
		"Show the actions when it is the only terminal opened",
		"Show the actions when it is the only terminal opened or when the tabs view is in its narrow textless state",
		"Never show the actions",
		"Show the terminal tabs view to the left of the terminal",
		"Show the terminal tabs view to the right of the terminal",
		"Controls the location of the terminal tabs, either to the left or right of the actual terminal(s).",
		"Create terminals in the editor",
		"Create terminals in the terminal view",
		"Controls where newly created terminals will appear.",
		"Controls the icon that will be used for each command in terminals with shell integration enabled that do not have an associated exit code. Set to `''` to hide the icon or disable decorations with `#terminal.integrated.shellIntegration.decorationsEnabled#`",
		"Controls the icon that will be used for each command in terminals with shell integration enabled that do have an associated exit code. Set to `''` to hide the icon or disable decorations with `#terminal.integrated.shellIntegration.decorationsEnabled#`.",
		"Controls the icon that will be used for skipped/empty commands. Set to `''` to hide the icon or disable decorations with `#terminal.integrated.shellIntegration.decorationsEnabled#`",
		"Focus the terminal when clicking a terminal tab",
		"Focus the terminal when double clicking a terminal tab",
		"Controls whether focusing the terminal of a tab happens on double or single click.",
		"Controls whether to treat the option key as the meta key in the terminal on macOS.",
		"Controls whether to force selection when using Option+click on macOS. This will force a regular (line) selection and disallow the use of column selection mode. This enables copying and pasting using the regular terminal selection, for example, when mouse mode is enabled in tmux.",
		"If enabled, alt/option + click will reposition the prompt cursor to underneath the mouse when `#editor.multiCursorModifier#` is set to `'alt'` (the default value). This may not work reliably depending on your shell.",
		"Controls whether text selected in the terminal will be copied to the clipboard.",
		"Show a warning dialog when pasting multiple lines into the terminal. The dialog does not show when:\n\n- Bracketed paste mode is enabled (the shell supports multi-line paste natively)\n- The paste is handled by the shell's readline (in the case of pwsh)",
		"Controls whether bold text in the terminal will always use the \"bright\" ANSI color variant.",
		"Controls the font family of the terminal, this defaults to `#editor.fontFamily#`'s value.",
		"Controls the font size in pixels of the terminal.",
		"Controls the letter spacing of the terminal, this is an integer value which represents the amount of additional pixels to add between characters.",
		"Controls the line height of the terminal, this number is multiplied by the terminal font size to get the actual line-height in pixels.",
		"When set the foreground color of each cell will change to try meet the contrast ratio specified. Example values:\n\n- 1: The default, do nothing.\n- 4.5: [WCAG AA compliance (minimum)](https://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast-contrast.html).\n- 7: [WCAG AAA compliance (enhanced)](https://www.w3.org/TR/UNDERSTANDING-WCAG20/visual-audio-contrast7.html).\n- 21: White on black or black on white.",
		"Scrolling speed multiplier when pressing `Alt`.",
		"A multiplier to be used on the `deltaY` of mouse wheel scroll events.",
		"The number of milliseconds to show the bell within a terminal tab when triggered.",
		"Only \"normal\" and \"bold\" keywords or numbers between 1 and 1000 are allowed.",
		"The font weight to use within the terminal for non-bold text. Accepts \"normal\" and \"bold\" keywords or numbers between 1 and 1000.",
		"Only \"normal\" and \"bold\" keywords or numbers between 1 and 1000 are allowed.",
		"The font weight to use within the terminal for bold text. Accepts \"normal\" and \"bold\" keywords or numbers between 1 and 1000.",
		"Controls whether the terminal cursor blinks.",
		"Controls the style of terminal cursor.",
		"Controls the width of the cursor when `#terminal.integrated.cursorStyle#` is set to `line`.",
		"Controls the maximum amount of lines the terminal keeps in its buffer.",
		"Controls whether to detect and set the `$LANG` environment variable to a UTF-8 compliant option since VS Code's terminal only supports UTF-8 encoded data coming from the shell.",
		"Set the `$LANG` environment variable if the existing variable does not exist or it does not end in `'.UTF-8'`.",
		"Do not set the `$LANG` environment variable.",
		"Always set the `$LANG` environment variable.",
		"Let VS Code detect which renderer will give the best experience.",
		"Enable GPU acceleration within the terminal.",
		"Disable GPU acceleration within the terminal.",
		"Use the fallback canvas renderer within the terminal. This uses a 2d context instead of webgl and may be better on some systems.",
		"Controls whether the terminal will leverage the GPU to do its rendering.",
		"Separator used by {0} and {0}.",
		"Show the context menu.",
		"Copy when there is a selection, otherwise paste.",
		"Paste on right click.",
		"Select the word under the cursor and show the context menu.",
		"Controls how terminal reacts to right click.",
		"An explicit start path where the terminal will be launched, this is used as the current working directory (cwd) for the shell process. This may be particularly useful in workspace settings if the root directory is not a convenient cwd.",
		"Controls whether to confirm when the window closes if there are active terminal sessions.",
		"Never confirm.",
		"Always confirm if there are terminals.",
		"Confirm if there are any terminals that have child processes.",
		"Controls whether to confirm killing terminals when they have child processes. When set to editor, terminals in the editor area will be marked as changed when they have child processes. Note that child process detection may not work well for shells like Git Bash which don't run their processes as child processes of the shell.",
		"Never confirm.",
		"Confirm if the terminal is in the editor.",
		"Confirm if the terminal is in the panel.",
		"Confirm if the terminal is either in the editor or panel.",
		"Controls whether the terminal bell is enabled, this shows up as a visual bell next to the terminal's name.",
		"A set of command IDs whose keybindings will not be sent to the shell but instead always be handled by VS Code. This allows keybindings that would normally be consumed by the shell to act instead the same as when the terminal is not focused, for example `Ctrl+P` to launch Quick Open.\n\n&nbsp;\n\nMany commands are skipped by default. To override a default and pass that command's keybinding to the shell instead, add the command prefixed with the `-` character. For example add `-workbench.action.quickOpen` to allow `Ctrl+P` to reach the shell.\n\n&nbsp;\n\nThe following list of default skipped commands is truncated when viewed in Settings Editor. To see the full list, {1} and search for the first command from the list below.\n\n&nbsp;\n\nDefault Skipped Commands:\n\n{0}",
		"open the default settings JSON",
		"Open Default Settings (JSON)",
		"Whether or not to allow chord keybindings in the terminal. Note that when this is true and the keystroke results in a chord it will bypass `#terminal.integrated.commandsToSkipShell#`, setting this to false is particularly useful when you want ctrl+k to go to your shell (not VS Code).",
		"Whether to allow menubar mnemonics (eg. alt+f) to trigger the open the menubar. Note that this will cause all alt keystrokes to skip the shell when true. This does nothing on macOS.",
		"Object with environment variables that will be added to the VS Code process to be used by the terminal on macOS. Set to `null` to delete the environment variable.",
		"Object with environment variables that will be added to the VS Code process to be used by the terminal on Linux. Set to `null` to delete the environment variable.",
		"Object with environment variables that will be added to the VS Code process to be used by the terminal on Windows. Set to `null` to delete the environment variable.",
		"Whether to display the environment changes indicator on each terminal which explains whether extensions have made, or want to make changes to the terminal's environment.",
		"Disable the indicator.",
		"Enable the indicator.",
		"Only show the warning indicator when a terminal's environment is 'stale', not the information indicator that shows a terminal has had its environment modified by an extension.",
		"Whether to relaunch terminals automatically if extension want to contribute to their environment and have not been interacted with yet.",
		"Controls whether to show the alert \"The terminal process terminated with exit code\" when exit code is non-zero.",
		"Controls the working directory a split terminal starts with.",
		"A new split terminal will use the workspace root as the working directory. In a multi-root workspace a choice for which root folder to use is offered.",
		"A new split terminal will use the working directory that the parent terminal started with.",
		"On macOS and Linux, a new split terminal will use the working directory of the parent terminal. On Windows, this behaves the same as initial.",
		"Whether to use ConPTY for Windows terminal process communication (requires Windows 10 build number 18309+). Winpty will be used if this is false.",
		"A string containing all characters to be considered word separators by the double click to select word feature.",
		"Whether to enable file links in the terminal. Links can be slow when working on a network drive in particular because each file link is verified against the file system. Changing this will take effect only in new terminals.",
		"Version 6 of unicode, this is an older version which should work better on older systems.",
		"Version 11 of unicode, this version provides better support on modern systems that use modern versions of unicode.",
		"Controls what version of unicode to use when evaluating the width of characters in the terminal. If you experience emoji or other wide characters not taking up the right amount of space or backspace either deleting too much or too little then you may want to try tweaking this setting.",
		"Length of network delay, in milliseconds, where local edits will be echoed on the terminal without waiting for server acknowledgement. If '0', local echo will always be on, and if '-1' it will be disabled.",
		"When local echo should be enabled. This will override `#terminal.integrated.localEchoLatencyThreshold#`",
		"Always enabled",
		"Always disabled",
		"Enabled only for remote workspaces",
		"Local echo will be disabled when any of these program names are found in the terminal title.",
		"Terminal style of locally echoed text; either a font style or an RGB color.",
		"Persist terminal sessions for the workspace across window reloads.",
		"When the terminal process must be shutdown (eg. on window or application close), this determines when the previous terminal session contents should be restored and processes be recreated when the workspace is next opened.\n\nCaveats:\n\n- Restoring of the process current working directory depends on whether it is supported by the shell.\n- Time to persist the session during shutdown is limited, so it may be aborted when using high-latency remote connections.",
		"Revive the processes after the last window is closed on Windows/Linux or when the `workbench.action.quit` command is triggered (command palette, keybinding, menu).",
		"Revive the processes after the last window is closed on Windows/Linux or when the `workbench.action.quit` command is triggered (command palette, keybinding, menu), or when the window is closed.",
		"Never restore the terminal buffers or recreate the process.",
		"Whether to draw custom glyphs for block element and box drawing characters instead of using the font, which typically yields better rendering with continuous lines. Note that this doesn't work with the DOM renderer",
		"A set of messages that when encountered in the terminal will be automatically responded to. Provided the message is specific enough, this can help automate away common responses.\n\nRemarks:\n\n- Use {0} to automatically respond to the terminate batch job prompt on Windows.\n- The message includes escape sequences so the reply might not happen with styled text.\n- Each reply can only happen once every second.\n- Use {1} in the reply to mean the enter key.\n- To unset a default key, set the value to null.\n- Restart VS Code if new don't apply.",
		"The reply to send to the process.",
		"Enable the experimental shell integration feature which will turn on certain features like enhanced command tracking and current working directory detection. Shell integration works by injecting a script that is run when the shell is initialized which lets the terminal gain additional insights into what is happening within the terminal, the script injection may not work if you have custom arguments defined in the terminal profile.\n\nSupported shells:\n\n- Linux/macOS: bash, pwsh, zsh\n - Windows: pwsh\n\nThis setting applies only when terminals are created, you will need to restart terminals for the setting to take effect.",
		"When shell integration is enabled, adds a decoration for each command.",
		"Whether to show the shell integration activated welcome message in the terminal when the feature is enabled.",
		"Controls the number of recently used commands to keep in the terminal command history. Set to 0 to disable terminal command history."
	],
	"vs/workbench/contrib/terminal/common/terminalContextKey": [
		"Whether the terminal is focused.",
		"Whether a terminal in the editor area is focused.",
		"The current number of terminals.",
		"Whether the terminal tabs widget is focused.",
		"The shell type of the active terminal, this is set to the last known value when no terminals exist.",
		"Whether the terminal's alt buffer is active.",
		"Whether the terminal view is showing",
		"Whether text is selected in the active terminal.",
		"Whether terminal processes can be launched in the current workspace.",
		"Whether one terminal is selected in the terminal tabs list.",
		"Whether the focused tab's terminal is a split terminal."
	],
	"vs/workbench/contrib/terminal/common/terminalStrings": [
		"Terminal",
		"Do Not Show Again",
		"current session",
		"previous session",
		"Focus Terminal",
		"Kill Terminal",
		"Kill",
		"Move Terminal into Editor Area",
		"Move Terminal into Panel",
		"Change Icon...",
		"Change Color...",
		"Split Terminal",
		"Split",
		"Unsplit Terminal",
		"Rename...",
		"Toggle Size to Content Width"
	],
	"vs/workbench/contrib/testing/browser/icons": [
		"View icon of the test view.",
		"Icon of the \"run test\" action.",
		"Icon of the \"run all tests\" action.",
		"Icon of the \"debug all tests\" action.",
		"Icon of the \"debug test\" action.",
		"Icon to cancel ongoing test runs.",
		"Icon for the 'Filter' action in the testing view.",
		"Icon for the 'Autorun' toggle in the testing view.",
		"Icon shown beside hidden tests, when they've been shown.",
		"Icon shown when the test explorer is disabled as a tree.",
		"Icon shown when the test explorer is disabled as a list.",
		"Icon shown to update test profiles.",
		"Icon on the button to refresh tests.",
		"Icon on the button to cancel refreshing tests.",
		"Icon shown for tests that have an error.",
		"Icon shown for tests that failed.",
		"Icon shown for tests that passed.",
		"Icon shown for tests that are queued.",
		"Icon shown for tests that are skipped.",
		"Icon shown for tests that are in an unset state."
	],
	"vs/workbench/contrib/testing/browser/testExplorerActions": [
		"Hide Test",
		"Unhide Test",
		"Debug Test",
		"Execute Using Profile...",
		"Run Test",
		"Select Default Profile",
		"Configure Test Profiles",
		"Select a profile to update",
		"Run Tests",
		"Debug Tests",
		"Discovering Tests",
		"Run All Tests",
		"No tests found in this workspace. You may need to install a test provider extension",
		"Debug All Tests",
		"No debuggable tests found in this workspace. You may need to install a test provider extension",
		"Cancel Test Run",
		"View as List",
		"View as Tree",
		"Sort by Status",
		"Sort by Location",
		"Sort by Duration",
		"Show Output",
		"Collapse All Tests",
		"Clear All Results",
		"Go to Test",
		"Turn On Auto Run",
		"Turn Off Auto Run",
		"Run Test at Cursor",
		"Debug Test at Cursor",
		"Run Tests in Current File",
		"Debug Tests in Current File",
		"Rerun Failed Tests",
		"Debug Failed Tests",
		"Rerun Last Run",
		"Debug Last Run",
		"Search for Test Extension",
		"Peek Output",
		"Toggle Inline Test Output",
		"Refresh Tests",
		"Cancel Test Refresh"
	],
	"vs/workbench/contrib/testing/browser/testing.contribution": [
		"Testing",
		"T&&esting",
		"No tests have been found in this workspace yet.",
		"Install Additional Test Extensions...",
		"Test Explorer"
	],
	"vs/workbench/contrib/testing/browser/testingConfigurationUi": [
		"Pick a test profile to use",
		"Update Test Configuration"
	],
	"vs/workbench/contrib/testing/browser/testingDecorations": [
		"Peek Test Output",
		"Expected",
		"Actual",
		"Click for test options",
		"Click to debug tests, right click for more options",
		"Click to run tests, right click for more options",
		"Run Test",
		"Debug Test",
		"Execute Using Profile...",
		"Peek Error",
		"Reveal in Test Explorer",
		"Run All Tests",
		"Debug All Tests"
	],
	"vs/workbench/contrib/testing/browser/testingExplorerFilter": [
		"Show Only Failed Tests",
		"Show Only Executed Tests",
		"Show in Active File Only",
		"Show Hidden Tests",
		"More Filters...",
		"Filter text for tests in the explorer",
		"Filter (e.g. text, !exclude, @tag)",
		"Show Hidden Tests",
		"Unhide All Tests",
		"Filter"
	],
	"vs/workbench/contrib/testing/browser/testingExplorerView": [
		"{0} (Default)",
		"Select Default Profile",
		"Configure Test Profiles",
		"No tests were found in this file.",
		"Show Workspace Tests",
		"{0}, in {1}",
		"{0}, outdated result",
		"Test Explorer"
	],
	"vs/workbench/contrib/testing/browser/testingOutputPeek": [
		"Expected result",
		"Actual result",
		"Close",
		"Unnamed Task",
		"+ {0} more lines",
		"+ 1 more line",
		"Test Result Messages",
		"Show Result Output",
		"Rerun Test Run",
		"Debug Test Run",
		"Go to File",
		"Reveal in Test Explorer",
		"Run Test",
		"Debug Test",
		"Go to Next Test Failure",
		"Go to Previous Test Failure",
		"Open in Editor",
		"Toggle Test History in Peek"
	],
	"vs/workbench/contrib/testing/browser/testingOutputTerminalService": [
		"Test Output at {0}",
		"Test Output",
		"\r\nNo tests have been run, yet.\r\n",
		"The test run did not record any output.",
		"Test run finished at {0}"
	],
	"vs/workbench/contrib/testing/browser/testingProgressUiService": [
		"Running tests...",
		"Running tests, {0}/{1} passed ({2}%)",
		"Running tests, {0}/{1} tests passed ({2}%, {3} skipped)",
		"{0}/{1} tests passed ({2}%)",
		"{0}/{1} tests passed ({2}%, {3} skipped)"
	],
	"vs/workbench/contrib/testing/browser/testingViewPaneContainer": [
		"Testing"
	],
	"vs/workbench/contrib/testing/browser/theme": [
		"Color for the 'failed' icon in the test explorer.",
		"Color for the 'Errored' icon in the test explorer.",
		"Color for the 'passed' icon in the test explorer.",
		"Color for 'run' icons in the editor.",
		"Color for the 'Queued' icon in the test explorer.",
		"Color for the 'Unset' icon in the test explorer.",
		"Color for the 'Skipped' icon in the test explorer.",
		"Color of the peek view borders and arrow.",
		"Color of the peek view borders and arrow.",
		"Text color of test error messages shown inline in the editor.",
		"Margin color beside error messages shown inline in the editor.",
		"Text color of test info messages shown inline in the editor.",
		"Margin color beside info messages shown inline in the editor."
	],
	"vs/workbench/contrib/testing/common/configuration": [
		"Testing",
		"Controls which tests are automatically run.",
		"Automatically runs all discovered test when auto-run is toggled. Reruns individual tests when they are changed.",
		"Reruns individual tests when they are changed. Will not automatically run any tests that have not been already executed.",
		"How long to wait, in milliseconds, after a test is marked as outdated and starting a new run.",
		"Configures when the error peek view is automatically opened.",
		"Open automatically no matter where the failure is.",
		"Open automatically when a test fails in a visible document.",
		"Never automatically open.",
		"Controls whether to automatically open the peek view during auto-run mode.",
		"Controls whether the running test should be followed in the test explorer view",
		"Controls the action to take when left-clicking on a test decoration in the gutter.",
		"Run the test.",
		"Debug the test.",
		"Open the context menu for more options.",
		"Controls whether test decorations are shown in the editor gutter.",
		"Control whether save all dirty editors before running a test.",
		"Never automatically open the testing view",
		"Open the testing view when tests start",
		"Open the testing view on any test failure",
		"Controls when the testing view should open."
	],
	"vs/workbench/contrib/testing/common/constants": [
		"Errored",
		"Failed",
		"Passed",
		"Queued",
		"Running",
		"Skipped",
		"Not yet run",
		"{0} ({1})",
		"Debug",
		"Run",
		"Coverage"
	],
	"vs/workbench/contrib/testing/common/testResult": [
		"Test run at {0}"
	],
	"vs/workbench/contrib/testing/common/testServiceImpl": [
		"Running tests may execute code in your workspace.",
		"An error occurred attempting to run tests: {0}"
	],
	"vs/workbench/contrib/testing/common/testingContextKeys": [
		"Indicates whether any test controller has an attached refresh handler.",
		"Indicates whether any test controller is currently refreshing tests.",
		"Indicates whether any test controller has registered a debug configuration",
		"Indicates whether any test controller has registered a run configuration",
		"Indicates whether any test controller has registered a coverage configuration",
		"Indicates whether any test controller has registered a non-default configuration",
		"Indicates whether any test configuration can be configured",
		"Type of the item in the output peek view. Either a \"test\", \"message\", \"task\", or \"result\".",
		"Controller ID of the current test item",
		"ID of the current test item, set when creating or opening menus on test items",
		"Boolean indicating whether the test item has a URI defined",
		"Boolean indicating whether the test item is hidden"
	],
	"vs/workbench/contrib/themes/browser/themes.contribution": [
		"Icon for the 'Manage' action in the theme selection quick pick.",
		"Type to Search More. Select to Install. Up/Down Keys to Preview",
		"Installing Extension {0}...",
		"Color Theme",
		"Install Additional Color Themes...",
		"Browse Additional Color Themes...",
		"Select Color Theme (Up/Down Keys to Preview)",
		"light themes",
		"dark themes",
		"high contrast themes",
		"File Icon Theme",
		"Install Additional File Icon Themes...",
		"Select File Icon Theme (Up/Down Keys to Preview)",
		"file icon themes",
		"None",
		"Disable File Icons",
		"Product Icon Theme",
		"Install Additional Product Icon Themes...",
		"Browse Additional Product Icon Themes...",
		"Select Product Icon Theme (Up/Down Keys to Preview)",
		"product icon themes",
		"Default",
		"Manage Extension",
		"Generate Color Theme From Current Settings",
		"&&Color Theme",
		"File &&Icon Theme",
		"&&Product Icon Theme",
		"Color Theme",
		"File Icon Theme",
		"Product Icon Theme"
	],
	"vs/workbench/contrib/timeline/browser/timeline.contribution": [
		"View icon of the timeline view.",
		"Icon for the open timeline action.",
		"Timeline",
		"An array of Timeline sources that should be excluded from the Timeline view.",
		"The number of items to show in the Timeline view by default and when loading more items. Setting to `null` (the default) will automatically choose a page size based on the visible area of the Timeline view.",
		"Experimental. Controls whether the Timeline view will load the next page of items when you scroll to the end of the list.",
		"Open Timeline"
	],
	"vs/workbench/contrib/timeline/browser/timelinePane": [
		"Loading...",
		"Load more",
		"Timeline",
		"The active editor cannot provide timeline information.",
		"No timeline information was provided.",
		"The active editor cannot provide timeline information.",
		"{0}: {1}",
		"Timeline",
		"Loading timeline for {0}...",
		"Icon for the refresh timeline action.",
		"Icon for the pin timeline action.",
		"Icon for the unpin timeline action.",
		"Refresh",
		"Timeline",
		"Pin the Current Timeline",
		"Timeline",
		"Unpin the Current Timeline",
		"Timeline",
		"Include: {0}",
		"Timeline"
	],
	"vs/workbench/contrib/typeHierarchy/browser/typeHierarchy.contribution": [
		"Whether a type hierarchy provider is available",
		"Whether type hierarchy peek is currently showing",
		"whether type hierarchy shows super types or subtypes",
		"No results",
		"Failed to show type hierarchy",
		"Peek Type Hierarchy",
		"Show Supertypes",
		"Show Subtypes",
		"Refocus Type Hierarchy",
		"Close"
	],
	"vs/workbench/contrib/typeHierarchy/browser/typeHierarchyPeek": [
		"Supertypes of '{0}'",
		"Subtypes of '{0}'",
		"Loading...",
		"No supertypes of '{0}'",
		"No subtypes of '{0}'"
	],
	"vs/workbench/contrib/typeHierarchy/browser/typeHierarchyTree": [
		"Type Hierarchy",
		"supertypes of {0}",
		"subtypes of {0}"
	],
	"vs/workbench/contrib/update/browser/releaseNotesEditor": [
		"Release Notes: {0}",
		"unassigned"
	],
	"vs/workbench/contrib/update/browser/update": [
		"Release Notes",
		"This version of {0} does not have release notes online",
		"Release Notes",
		"Show Release Notes",
		"Welcome to {0} v{1}! Would you like to read the Release Notes?",
		"Release Notes",
		"New {0} update available.",
		"Checking for Updates...",
		"Downloading...",
		"Updating...",
		"Update Service",
		"There are currently no updates available.",
		"There is an available update.",
		"Download Update",
		"Later",
		"Release Notes",
		"There's an update available: {0} {1}",
		"Install Update",
		"Later",
		"Release Notes",
		"Update Now",
		"Later",
		"Release Notes",
		"Restart {0} to apply the latest update.",
		"Check for Updates...",
		"Checking for Updates...",
		"Download Update (1)",
		"Downloading Update...",
		"Install Update... (1)",
		"Installing Update...",
		"Restart to Update (1)",
		"Switch to Insiders Version...",
		"Switch to Stable Version...",
		"Changing the version requires a reload to take effect",
		"Press the reload button to switch to the Insiders version of VS Code.",
		"Press the reload button to switch to the Stable version of VS Code.",
		"&&Reload",
		"Choose the settings sync service to use after changing the version",
		"Insiders",
		"Stable (current)",
		"Cancel",
		"The Insiders version of VS Code will synchronize your settings, keybindings, extensions, snippets and UI State using separate insiders settings sync service by default.",
		"Check for Updates..."
	],
	"vs/workbench/contrib/update/browser/update.contribution": [
		"Download Update",
		"Install Update",
		"Restart to Update",
		"&&Release Notes"
	],
	"vs/workbench/contrib/url/browser/trustedDomains": [
		"Manage Trusted Domains",
		"Trust {0}",
		"Trust {0} on all ports",
		"Trust {0} and all its subdomains",
		"Trust all domains (disables link protection)",
		"Manage Trusted Domains"
	],
	"vs/workbench/contrib/url/browser/trustedDomainsValidator": [
		"Do you want {0} to open the external website?",
		"Open",
		"Copy",
		"Cancel",
		"Configure Trusted Domains"
	],
	"vs/workbench/contrib/url/browser/url.contribution": [
		"Open URL",
		"URL to open",
		"When enabled, trusted domain prompts will appear when opening links in trusted workspaces."
	],
	"vs/workbench/contrib/userDataSync/browser/userDataSync": [
		"{0}: Turn On...",
		"{0}: Turn Off",
		"{0}: Configure...",
		"{0}: Show Settings Conflicts",
		"{0}: Show Keybindings Conflicts",
		"{0}: Show User Snippets Conflicts",
		"{0}: Show User Tasks Conflicts",
		"{0}: Sync Now",
		"syncing",
		"synced {0}",
		"{0}: Show Settings",
		"{0}: Show Synced Data",
		"Unable to sync due to conflicts in {0}. Please resolve them to continue.",
		"Replace Remote",
		"Replace Local",
		"Show Conflicts",
		"Error while accepting changes. Please check [logs]({0}) for more details.",
		"Error while accepting changes. Please check [logs]({0}) for more details.",
		"Settings sync was turned off because current session is expired, please sign in again to turn on sync.",
		"Turn on Settings Sync...",
		"Settings sync was turned off from another device, please turn on sync again.",
		"Turn on Settings Sync...",
		"Disabled syncing {0} because size of the {1} file to sync is larger than {2}. Please open the file and reduce the size and enable sync",
		"Settings sync is disabled because the current version ({0}, {1}) is not compatible with the sync service. Please update before turning on sync.",
		"Operation Id: {0}",
		"Settings sync is disabled because your data in the cloud is older than that of the client. Please clear your data in the cloud before turning on sync.",
		"Clear Data in Cloud...",
		"Show Synced Data",
		"Settings Sync has been switched to insiders service",
		"Settings Sync has been switched to stable service",
		"Settings sync now uses a separate service, more information is available in the [Settings Sync Documentation](https://aka.ms/vscode-settings-sync-help#_syncing-stable-versus-insiders).",
		"Settings sync was turned off because {0} now uses a separate service. Please turn on sync again.",
		"Turn on Settings Sync...",
		"Operation Id: {0}",
		"Open {0} File",
		"Unable to sync {0} because the content in the file is not valid. Please open the file and correct it.",
		"Open {0} File",
		"{0}: Conflicts Detected",
		"Turning on Settings Sync...",
		"Settings Sync is Off",
		"Sign in to Sync Settings",
		"Settings Sync is Off",
		"Turn On Settings Sync",
		"Cancel",
		"Your settings, keybindings, extensions, snippets and UI State were initialized but are not getting synced. Do you want to turn on Settings Sync?",
		"You can always change this later.",
		"Learn More",
		"No authentication providers are available.",
		"Settings sync cannot be turned on because size of the {0} file to sync is larger than {1}. Please open the file and reduce the size and turn on sync",
		"Settings sync cannot be turned on because the current version ({0}, {1}) is not compatible with the sync service. Please update before turning on sync.",
		"Operation Id: {0}",
		"Settings sync cannot be turned on because your data in the cloud is older than that of the client. Please clear your data in the cloud before turning on sync.",
		"Clear Data in Cloud...",
		"Show Synced Data",
		"Error while turning on Settings Sync: Authentication failed.",
		"Error while turning on Settings Sync. Please check [logs]({0}) for more details.",
		"Error while turning on Settings Sync. {0}",
		"Sign in & Turn on",
		"Please sign in to synchronize your data across devices.",
		"for each platform",
		"{0}: Configure...",
		"Choose what to sync",
		"Do you want to turn off sync?",
		"Your settings, keybindings, extensions, snippets and UI State will no longer be synced.",
		"&&Turn off",
		"Turn off sync on all your devices and clear the data from the cloud.",
		"{0} (Remote)",
		"{0} (Merges)",
		"{0} ↔ {1}",
		"Settings Sync",
		"{0}: Select Service",
		"Ensure you are using the same settings sync service when syncing with multiple environments",
		"Default",
		"Insiders",
		"Stable",
		"Turn on Settings Sync...",
		"Turn on Settings Sync...",
		"Turn on Settings Sync...",
		"Settings Sync is Off (1)",
		"Turning on Settings Sync...",
		"Sign in to Sync Settings",
		"Sign in to Sync Settings (1)",
		"{0}: Show Settings Conflicts (1)",
		"{0}: Show Settings Conflicts (1)",
		"{0}: Show Keybindings Conflicts (1)",
		"{0}: Show Keybindings Conflicts (1)",
		"{0}: Show User Tasks Conflicts (1)",
		"{0}: Show User Tasks Conflicts (1)",
		"{0}: Show User Snippets Conflicts ({1})",
		"{0}: Show User Snippets Conflicts ({1})",
		"Settings Sync is On",
		"Show Synced Data",
		"Error while turning off Settings Sync. Please check [logs]({0}) for more details.",
		"Configure...",
		"{0}: Show Log",
		"Show Log",
		"Clear Data in Cloud...",
		"Accept Remote",
		"Accept Merges",
		"Accept &&Remote",
		"Accept &&Merges",
		"{0}: {1}",
		"{0}: {1}",
		"Would you like to accept remote {0} and replace local {1}?",
		"Would you like to accept merges and replace remote {0}?",
		"Could not resolve conflicts as there is new local version available. Please try again.",
		"Error while accepting changes. Please check [logs]({0}) for more details."
	],
	"vs/workbench/contrib/userDataSync/browser/userDataSync.contribution": [
		"Settings sync is suspended temporarily because the current device is making too many requests. Please reload {0} to resume.",
		"Settings sync is suspended temporarily because the current device is making too many requests. Please restart {0} to resume.",
		"Show Log",
		"Reload",
		"Restart",
		"Operation Id: {0}",
		"Settings sync is disabled because the current device is making too many requests. Please wait for 10 minutes and turn on sync.",
		"Settings Sync. Operation Id: {0}",
		"Show Log"
	],
	"vs/workbench/contrib/userDataSync/browser/userDataSyncMergesView": [
		"Please go through each entry and merge to enable sync.",
		"Turn on Settings Sync",
		"Cancel",
		"Accept Remote",
		"Accept Local",
		"Merge",
		"Discard",
		"Open Changes",
		"Conflicts Detected",
		"Unable to merge due to conflicts. Please resolve them to continue.",
		"Turning on...",
		"{0} (Preview)",
		"{0} (Remote)",
		"{0} (Merges)",
		"{0} (Local)",
		"{0} ↔ {1}",
		"Settings Sync",
		"UserDataSyncResources",
		"Conflicts Detected",
		"Accepted",
		"Accept Remote",
		"Accept Local",
		"Accept Merges"
	],
	"vs/workbench/contrib/userDataSync/browser/userDataSyncViews": [
		"Merges",
		"Synced Machines",
		"Edit Name",
		"Turn off Settings Sync",
		"Sync Activity (Remote)",
		"Sync Activity (Local)",
		"Show raw JSON sync data",
		"Compare with Local",
		"{0} ↔ {1}",
		"{0} (Remote)",
		"{0} (Local)",
		"Restore",
		"Would you like to replace your current {0} with selected?",
		"Troubleshoot",
		"Reset Synced Data",
		"{0} ↔ {1}",
		"Current",
		"No Machines",
		"Current",
		"machine not found with id: {0}",
		"Are you sure you want to turn off sync on selected machines?",
		"Are you sure you want to turn off sync on {0}?",
		"&&Turn off",
		"Enter the name of the machine",
		"machine not found with id: {0}",
		"Machine name should be unique and not empty",
		"Logs",
		"Last Synced Remotes",
		"Current"
	],
	"vs/workbench/contrib/watermark/browser/watermark": [
		"Show All Commands",
		"Go to File",
		"Open File",
		"Open Folder",
		"Open File or Folder",
		"Open Recent",
		"New Untitled File",
		"Find in Files",
		"Toggle Terminal",
		"Start Debugging",
		"Toggle Full Screen",
		"Show Settings",
		"When enabled, will show the watermark tips when no editor is open."
	],
	"vs/workbench/contrib/webview/browser/webview.contribution": [
		"Cut",
		"Copy",
		"Paste"
	],
	"vs/workbench/contrib/webview/browser/webviewElement": [
		"Error loading webview: {0}"
	],
	"vs/workbench/contrib/webviewPanel/browser/webviewCommands": [
		"Show find",
		"Stop find",
		"Find next",
		"Find previous",
		"Reload Webviews"
	],
	"vs/workbench/contrib/webviewPanel/browser/webviewPanel.contribution": [
		"webview editor"
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStarted": [
		"Overview of how to get up to speed with your editor.",
		"Open Walkthrough...",
		"Get Started",
		"When checked, this page will be shown on startup.",
		"Show welcome page on startup",
		"Editing evolved",
		"Open folder {0} with path {1}",
		"Recent",
		"Show All Recent Folders {0}",
		"Start",
		"New",
		"Updated",
		"Hide",
		"Walkthroughs",
		"More...",
		"All {0} steps complete!",
		"{0} of {1} steps complete",
		"Image showing {0}",
		"Mark Done",
		"Next Section",
		"privacy statement",
		"opt out",
		"{0} collects usage data. Read our {1} and learn how to {2}."
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStarted.contribution": [
		"Get Started",
		"Help",
		"Get Started",
		"Get Started",
		"Go Back",
		"Mark Step Complete",
		"Mark Step Incomplete",
		"Open Walkthrough...",
		"Open Walkthrough...",
		"When enabled, reduce motion in welcome page.",
		"When enabled, reduce motion in welcome page.",
		"The platform of the current workspace, which in remote or serverless contexts may be different from the platform of the UI",
		"When enabled, an extension's walkthrough will open upon install of the extension.",
		"When enabled, the get started page has additional links to video tutorials."
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStartedColors": [
		"Background color for the Welcome page.",
		"Background color for the tiles on the Get Started page.",
		"Hover background color for the tiles on the Get Started.",
		"Shadow color for the Welcome page walkthrough category buttons.",
		"Foreground color for the Welcome page progress bars.",
		"Background color for the Welcome page progress bars."
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStartedExtensionPoint": [
		"Title",
		"Contribute walkthroughs to help users getting started with your extension.",
		"Unique identifier for this walkthrough.",
		"Title of walkthrough.",
		"Description of walkthrough.",
		"Walkthroughs that match one of these glob patterns appear as 'featured' in workspaces with the specified files. For example, a walkthrough for TypeScript projects might specify `tsconfig.json` here.",
		"Context key expression to control the visibility of this walkthrough.",
		"Steps to complete as part of this walkthrough.",
		"Unique identifier for this step. This is used to keep track of which steps have been completed.",
		"Title of step.",
		"Description of step. Supports ``preformatted``, __italic__, and **bold** text. Use markdown-style links for commands or external links: {0}, {1}, or {2}. Links on their own line will be rendered as buttons.",
		"Deprecated. Use markdown links in the description instead, i.e. {0}, {1}, or {2}",
		"Media to show alongside this step, either an image or markdown content.",
		"Deprecated. Please use `image` or `markdown` instead",
		"Path to an image - or object consisting of paths to light, dark, and hc images - relative to extension directory. Depending on context, the image will be displayed from 400px to 800px wide, with similar bounds on height. To support HIDPI displays, the image will be rendered at 1.5x scaling, for example a 900 physical pixels wide image will be displayed as 600 logical pixels wide.",
		"Path to the image for dark themes, relative to extension directory.",
		"Path to the image for light themes, relative to extension directory.",
		"Path to the image for hc themes, relative to extension directory.",
		"Alternate text to display when the image cannot be loaded or in screen readers.",
		"Path to an svg, color tokens are supported in variables to support theming to match the workbench.",
		"Alternate text to display when the image cannot be loaded or in screen readers.",
		"Deprecated. Please use `image` or `markdown` instead",
		"Path to the markdown document, relative to extension directory.",
		"Events that should trigger this step to become checked off. If empty or not defined, the step will check off when any of the step's buttons or links are clicked; if the step has no buttons or links it will check on when it is selected.",
		"Check off step when a given command is executed anywhere in VS Code.",
		"Check off step when a given link is opened via a walkthrough step.",
		"Check off step when a given view is opened",
		"Check off step when a given setting is changed",
		"Check off step when a context key expression is true.",
		"Check off step when an extension with the given id is installed. If the extension is already installed, the step will start off checked.",
		"Check off step as soon as it is selected.",
		"Signal to mark step as complete.",
		"doneOn is deprecated. By default steps will be checked off when their buttons are clicked, to configure further use completionEvents",
		"Mark step done when the specified command is executed.",
		"Context key expression to control the visibility of this step."
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStartedIcons": [
		"Used to represent walkthrough steps which have not been completed",
		"Used to represent walkthrough steps which have been completed"
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStartedInput": [
		"Get Started"
	],
	"vs/workbench/contrib/welcomeGettingStarted/browser/gettingStartedService": [
		"Built-In"
	],
	"vs/workbench/contrib/welcomeGettingStarted/common/gettingStartedContent": [
		"Icon used for the setup category of welcome page",
		"Icon used for the beginner category of welcome page",
		"Icon used for the intermediate category of welcome page",
		"New File...",
		"Open a new untitled file, notebook, or custom editor.",
		"Open...",
		"Open a file or folder to start working",
		"Open File...",
		"Open a file to start working",
		"Open Folder...",
		"Open a folder to start working",
		"Open Folder...",
		"Open a folder to start working",
		"Clone Git Repository...",
		"Clone a remote repository to a local folder",
		"Open Repository...",
		"Connect to a remote repository or pull request to browse, search, edit, and commit",
		"Open a Walkthrough...",
		"View a walkthrough on the editor or an extension",
		"Watch Video Tutorials",
		"Watch our series of short & practical video tutorials for VS Code's key features.",
		"Watch Video Tutorials",
		"Watch our series of short & practical video tutorials for VS Code's key features.",
		"Get Started with VS Code",
		"Discover the best customizations to make VS Code yours.",
		"Choose the look you want",
		"The right color palette helps you focus on your code, is easy on your eyes, and is simply more fun to use.\n{0}",
		"Browse Color Themes",
		"Sync to and from other devices",
		"Keep your essential VS Code customizations backed up and updated across all your devices.\n{0}",
		"Enable Settings Sync",
		"One shortcut to access everything",
		"Commands are the keyboard way to accomplish any task in VS Code. **Practice** by looking up your frequent ones to save time.\n{0}\n__Try searching for 'view toggle'.__",
		"Open Command Palette",
		"Limitless extensibility",
		"Extensions are VS Code's power-ups. A growing number are becoming available in the web.\n{0}",
		"Browse Popular Web Extensions",
		"Rich support for all your languages",
		"Code smarter with syntax highlighting, code completion, linting and debugging. While many languages are built-in, many more can be added as extensions.\n{0}",
		"Browse Language Extensions",
		"Open up your code",
		"You're all set to start coding. Open a project folder to get your files into VS Code.\n{0}",
		"Pick a Folder",
		"Open up your code",
		"You're all set to start coding. Open a project folder to get your files into VS Code.\n{0}",
		"Pick a Folder",
		"Quickly navigate between your files",
		"Navigate between files in an instant with one keystroke. Tip: Open multiple files by pressing the right arrow key.\n{0}",
		"Quick Open a File",
		"Get Started with VS Code in the Web",
		"Discover the best customizations to make VS Code in the Web yours.",
		"Choose the look you want",
		"The right color palette helps you focus on your code, is easy on your eyes, and is simply more fun to use.\n{0}",
		"Browse Color Themes",
		"Sync to and from other devices",
		"Keep your essential VS Code customizations backed up and updated across all your devices.\n{0}",
		"Enable Settings Sync",
		"One shortcut to access everything",
		"Commands are the keyboard way to accomplish any task in VS Code. **Practice** by looking up your frequent ones to save time.\n{0}\n__Try searching for 'view toggle'.__",
		"Open Command Palette",
		"Just the right amount of UI",
		"The full menu bar is available in the dropdown menu to make room for your code. Toggle its apperance for faster access. \n{0}",
		"Toggle Menu Bar",
		"Limitless extensibility",
		"Extensions are VS Code's power-ups. A growing number are becoming available in the web.\n{0}",
		"Browse Popular Web Extensions",
		"Rich support for all your languages",
		"Code smarter with syntax highlighting, code completion, linting and debugging. While many languages are built-in, many more can be added as extensions.\n{0}",
		"Browse Language Extensions",
		"Open up your code",
		"You're all set to start coding. You can open a local project or a remote repository to get your files into VS Code.\n{0}\n{1}",
		"Open Folder",
		"Open Repository",
		"Quickly navigate between your files",
		"Navigate between files in an instant with one keystroke. Tip: Open multiple files by pressing the right arrow key.\n{0}",
		"Quick Open a File",
		"Learn the Fundamentals",
		"Jump right into VS Code and get an overview of the must-have features.",
		"Redefine your editing skills",
		"Want to code faster and smarter? Practice powerful code editing features in the interactive playground.\n{0}",
		"Open Editor Playground",
		"Convenient built-in terminal",
		"Quickly run shell commands and monitor build output, right next to your code.\n{0}",
		"Show Terminal Panel",
		"Limitless extensibility",
		"Extensions are VS Code's power-ups. They range from handy productivity hacks, expanding out-of-the-box features, to adding completely new capabilities.\n{0}",
		"Browse Recommended Extensions",
		"Tune your settings",
		"Tweak every aspect of VS Code and your extensions to your liking. Commonly used settings are listed first to get you started.\n{0}",
		"Tweak my Settings",
		"Safely browse and edit code",
		"{0} lets you decide whether your project folders should **allow or restrict** automatic code execution __(required for extensions, debugging, etc)__.\nOpening a file/folder will prompt to grant trust. You can always {1} later.",
		"Workspace Trust",
		"enable trust",
		"Lean back and learn",
		"Watch the first in a series of short & practical video tutorials for VS Code's key features.\n{0}",
		"Watch Tutorial",
		"Boost your Productivity",
		"Optimize your development workflow with these tips & tricks.",
		"Side by side editing",
		"Make the most of your screen estate by opening files side by side, vertically and horizontally.\n{0}",
		"Split Editor",
		"Watch your code in action",
		"Accelerate your edit, build, test, and debug loop by setting up a launch configuration.\n{0}",
		"Run your Project",
		"Track your code with Git",
		"Set up the built-in version control for your project to track your changes and collaborate with others.\n{0}",
		"Clone Repository",
		"Track your code with Git",
		"Set up the built-in version control for your project to track your changes and collaborate with others.\n{0}",
		"Initialize Git Repository",
		"Track your code with Git",
		"No more looking up Git commands! Git and GitHub workflows are seamlessly integrated.\n{0}",
		"Open Source Control",
		"Install Git",
		"Install Git to track changes in your projects.\n{0}",
		"Install Git",
		"Automate your project tasks",
		"Create tasks for your common workflows and enjoy the integrated experience of running scripts and automatically checking results.\n{0}",
		"Run Auto-detected Tasks",
		"Customize your shortcuts",
		"Once you have discovered your favorite commands, create custom keyboard shortcuts for instant access.\n{0}",
		"Keyboard Shortcuts",
		"Customize Notebooks",
		"Select the layout for your notebooks",
		"Get notebooks to feel just the way you prefer"
	],
	"vs/workbench/contrib/welcomeGettingStarted/common/media/example_markdown_media": [
		"Light",
		"Dark",
		"High Contrast",
		"See More Themes..."
	],
	"vs/workbench/contrib/welcomeGettingStarted/common/media/notebookProfile": [
		"Default",
		"Jupyter",
		"Colab"
	],
	"vs/workbench/contrib/welcomeOverlay/browser/welcomeOverlay": [
		"File explorer",
		"Search across files",
		"Source code management",
		"Launch and debug",
		"Manage extensions",
		"View errors and warnings",
		"Toggle integrated terminal",
		"Find and run all commands",
		"Show notifications",
		"User Interface Overview",
		"Hide Interface Overview"
	],
	"vs/workbench/contrib/welcomePage/browser/welcomePage.contribution": [
		"Start without an editor.",
		"Open the Welcome page, with content to aid in getting started with VS Code and extensions.",
		"Open the README when opening a folder that contains one, fallback to 'welcomePage' otherwise. Note: This is only observed as a global configuration, it will be ignored if set in a workspace or folder configuration.",
		"Open a new untitled file (only applies when opening an empty window).",
		"Open the Welcome page when opening an empty workbench.",
		"Controls which editor is shown at startup, if none are restored from the previous session."
	],
	"vs/workbench/contrib/welcomeViews/common/newFile.contribution": [
		"Create",
		"New File...",
		"Built-In",
		"Create New...",
		"File",
		"Notebook",
		"Configure Keybinding",
		"Text File"
	],
	"vs/workbench/contrib/welcomeViews/common/viewsWelcomeContribution": [
		"The viewsWelcome contribution in '{0}' requires 'enabledApiProposals: [\"contribViewsWelcome\"]' in order to use the 'group' proposed property."
	],
	"vs/workbench/contrib/welcomeViews/common/viewsWelcomeExtensionPoint": [
		"Contributed views welcome content. Welcome content will be rendered in tree based views whenever they have no meaningful content to display, ie. the File Explorer when no folder is open. Such content is useful as in-product documentation to drive users to use certain features before they are available. A good example would be a `Clone Repository` button in the File Explorer welcome view.",
		"Contributed welcome content for a specific view.",
		"Target view identifier for this welcome content. Only tree based views are supported.",
		"Target view identifier for this welcome content. Only tree based views are supported.",
		"Welcome content to be displayed. The format of the contents is a subset of Markdown, with support for links only.",
		"Condition when the welcome content should be displayed.",
		"Group to which this welcome content belongs. Proposed API.",
		"Condition when the welcome content buttons and command links should be enabled."
	],
	"vs/workbench/contrib/welcomeWalkthrough/browser/editor/editorWalkThrough": [
		"Editor Playground",
		"Interactive Editor Playground"
	],
	"vs/workbench/contrib/welcomeWalkthrough/browser/walkThrough.contribution": [
		"Playground",
		"Editor Playgrou&&nd"
	],
	"vs/workbench/contrib/welcomeWalkthrough/browser/walkThroughPart": [
		"unbound",
		"It looks like Git is not installed on your system.",
		"Background color for the embedded editors on the Interactive Playground."
	],
	"vs/workbench/contrib/workspace/browser/workspace.contribution": [
		"You are trying to open untrusted files in a workspace which is trusted.",
		"You are trying to open untrusted files in a window which is trusted.",
		"If you don't trust the authors of these files, we recommend to open them in Restricted Mode in a new window as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more.",
		"Do you trust the authors of these files?",
		"Open",
		"Open in Restricted Mode",
		"Cancel",
		"Remember my decision for all workspaces",
		"Do you trust the authors of the files in this workspace?",
		"Do you trust the authors of the files in this folder?",
		"A feature you are trying to use may be a security risk if you do not trust the source of the files or folders you currently have open.",
		"Trust Workspace & Continue",
		"Trust Folder & Continue",
		"Manage",
		"Cancel",
		"If you don't trust the authors of these files, we do not recommend continuing as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more.",
		"Do you trust the authors of the files in this folder?",
		"Yes",
		"No",
		"You are adding files to a trusted workspace that are not currently trusted. Do you trust the authors of these new files?",
		"Do you trust the authors of the files in this workspace?",
		"Do you trust the authors of the files in this folder?",
		"Trust the authors of all files in the parent folder '{0}'",
		"Yes, I trust the authors",
		"Trust folder and enable all features",
		"Trust workspace and enable all features",
		"No, I don't trust the authors",
		"Browse folder in restricted mode",
		"Browse workspace in restricted mode",
		"{0} provides features that may automatically execute files in this workspace.",
		"{0} provides features that may automatically execute files in this folder.",
		"If you don't trust the authors of these files, we recommend to continue in restricted mode as the files may be malicious. See [our docs](https://aka.ms/vscode-workspace-trust) to learn more.",
		"Manage",
		"Learn More",
		"Restricted Mode is intended for safe code browsing. Trust this window to enable all features. Use navigation keys to access banner actions.",
		"Restricted Mode is intended for safe code browsing. Trust this folder to enable all features. Use navigation keys to access banner actions.",
		"Restricted Mode is intended for safe code browsing. Trust this workspace to enable all features. Use navigation keys to access banner actions.",
		"Restricted Mode is intended for safe code browsing. Trust this window to enable all features.",
		"Restricted Mode is intended for safe code browsing. Trust this folder to enable all features.",
		"Restricted Mode is intended for safe code browsing. Trust this workspace to enable all features.",
		"This window is trusted.",
		"Restricted Mode: Some features are disabled because this window is not trusted.",
		"Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [window is not trusted]({1}).",
		"This folder is trusted.",
		"Restricted Mode: Some features are disabled because this folder is not trusted.",
		"Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [folder is not trusted]({1}).",
		"This workspace is trusted.",
		"Restricted Mode: Some features are disabled because this workspace is not trusted.",
		"Running in Restricted Mode\n\nSome [features are disabled]({0}) because this [workspace is not trusted]({1}).",
		"Workspace Trust",
		"Workspace Trust Editor",
		"Configure Workspace Trust",
		"Workspaces",
		"Manage Workspace Trust",
		"Workspaces",
		"Security",
		"Controls whether or not workspace trust is enabled within VS Code.",
		"Controls when the startup prompt to trust a workspace is shown.",
		"Ask for trust every time an untrusted workspace is opened.",
		"Ask for trust the first time an untrusted workspace is opened.",
		"Do not ask for trust when an untrusted workspace is opened.",
		"Controls when the restricted mode banner is shown.",
		"Show the banner every time an untrusted workspace is open.",
		"Show the banner when an untrusted workspace is opened until dismissed.",
		"Do not show the banner when an untrusted workspace is open.",
		"Controls how to handle opening untrusted files in a trusted workspace. This setting also applies to opening files in an empty window which is trusted via `#{0}#`.",
		"Ask how to handle untrusted files for each workspace. Once untrusted files are introduced to a trusted workspace, you will not be prompted again.",
		"Always allow untrusted files to be introduced to a trusted workspace without prompting.",
		"Always open untrusted files in a separate window in restricted mode without prompting.",
		"Controls whether or not the empty window is trusted by default within VS Code. When used with `#{0}#`, you can enable the full functionality of VS Code without prompting in an empty window."
	],
	"vs/workbench/contrib/workspace/browser/workspaceTrustEditor": [
		"Icon for workspace trust ion the banner.",
		"Icon for the checkmark in the workspace trust editor.",
		"Icon for the cross in the workspace trust editor.",
		"Icon for the pick folder icon in the workspace trust editor.",
		"Icon for the edit folder icon in the workspace trust editor.",
		"Icon for the remove folder icon in the workspace trust editor.",
		"Host",
		"Path",
		"{0}, trusted",
		"{0} on {1}, trusted",
		"Trusted Folders & Workspaces",
		"Add Folder",
		"Add Folder",
		"Trust Folder",
		"Select Folder To Trust",
		"You trust the following folders, their subfolders, and workspace files.",
		"You haven't trusted any folders or workspace files yet.",
		"You will trust all repositories on {0}.",
		"You will trust all repositories and forks under '{0}' on {1}.",
		"You cannot trust individual folders within a repository.",
		"Trust Folder",
		"Select Folder To Trust",
		"Edit Path",
		"Open File Picker",
		"Delete Path",
		"Local",
		"This window is trusted",
		"You trust this window",
		"You trust this folder",
		"You trust this workspace",
		"You are in Restricted Mode",
		"In a Trusted Window",
		"In Restricted Mode",
		"You trust the authors of the files in the current window. All features are enabled:",
		"You do not trust the authors of the files in the current window. The following features are disabled:",
		"In a Trusted Folder",
		"In Restricted Mode",
		"You trust the authors of the files in the current folder. All features are enabled:",
		"You do not trust the authors of the files in the current folder. The following features are disabled:",
		"In a Trusted Workspace",
		"In Restricted Mode",
		"You trust the authors of the files in the current workspace. All features are enabled:",
		"You do not trust the authors of the files in the current workspace. The following features are disabled:",
		"All features are enabled because trust has been granted to the workspace.",
		"{0} is in a restricted mode intended for safe code browsing.",
		"[Configure your settings]({0}) or [learn more](https://aka.ms/vscode-workspace-trust).",
		"Manage Workspace Trust",
		"Trusted Folders & Workspaces",
		"Tasks are allowed to run",
		"Debugging is enabled",
		"All extensions are enabled",
		"Tasks are allowed to run",
		"Debugging is enabled",
		"All workspace settings are applied",
		"All extensions are enabled",
		"Tasks are not allowed to run",
		"Debugging is disabled",
		"[{0} extensions]({1}) are disabled or have limited functionality",
		"Tasks are not allowed to run",
		"Debugging is disabled",
		"[{0} workspace settings]({1}) are not applied",
		"Workspace settings requiring trust are not applied",
		"[{0} extensions]({1}) are disabled or have limited functionality",
		"Trust",
		"Trust the authors of all files in the current folder or its parent '{0}'.",
		"Trust Parent",
		"Don't Trust",
		"This workspace is trusted via the bolded entries in the trusted folders below.",
		"This folder is trusted via the bolded entries in the the trusted folders below.",
		"This window is trusted by nature of the workspace that is opened."
	],
	"vs/workbench/contrib/workspace/common/workspace": [
		"Whether the workspace trust feature is enabled.",
		"Whether the current workspace has been trusted by the user."
	],
	"vs/workbench/contrib/workspaces/browser/workspaces.contribution": [
		"This folder contains a workspace file '{0}'. Do you want to open it? [Learn more]({1}) about workspace files.",
		"Open Workspace",
		"This folder contains multiple workspace files. Do you want to open one? [Learn more]({0}) about workspace files.",
		"Select Workspace",
		"Select a workspace to open"
	],
	"vs/workbench/services/actions/common/menusExtensionPoint": [
		"The Command Palette",
		"The touch bar (macOS only)",
		"The editor title menu",
		"Run submenu inside the editor title menu",
		"The editor context menu",
		"'Copy as' submenu in the editor context menu",
		"The file explorer context menu",
		"The editor tabs context menu",
		"The debug callstack view context menu",
		"The debug variables view context menu",
		"The debug toolbar menu",
		"The home indicator context menu (web only)",
		"'Copy as' submenu in the top level Edit menu",
		"The Source Control title menu",
		"The Source Control menu",
		"The Source Control resource state context menu",
		"The Source Control resource folder context menu",
		"The Source Control resource group context menu",
		"The Source Control inline change menu",
		"The remote indicator menu in the status bar",
		"The contributed view title menu",
		"The contributed view item context menu",
		"The contributed comment thread title menu",
		"The contributed comment thread context menu, rendered as buttons below the comment editor",
		"The contributed comment title menu",
		"The contributed comment context menu, rendered as buttons below the comment editor",
		"The contributed notebook toolbar menu",
		"The contributed notebook cell title menu",
		"The contributed notebook cell execution menu",
		"The contributed primary notebook cell execution button",
		"The contributed interactive toolbar menu",
		"The contributed interactive cell title menu",
		"The contributed test item menu",
		"The menu for a gutter decoration for a test item",
		"The extension context menu",
		"The Timeline view title menu",
		"The Timeline view item context menu",
		"The Ports view item context menu",
		"The Ports view item origin inline menu",
		"The Ports view item port inline menu",
		"The 'New File...' quick pick, shown on welcome page and File menu.",
		"The actions shown when hovering on an inline completion",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"submenu items must be an array",
		"submenu items must be an object",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"Identifier of the command to execute. The command must be declared in the 'commands'-section",
		"Identifier of an alternative command to execute. The command must be declared in the 'commands'-section",
		"Condition which must be true to show this item",
		"Group into which this item belongs",
		"Identifier of the submenu to display in this item.",
		"Condition which must be true to show this item",
		"Group into which this item belongs",
		"Identifier of the menu to display as a submenu.",
		"The label of the menu item which leads to this submenu.",
		"(Optional) Icon which is used to represent the submenu in the UI. Either a file path, an object with file paths for dark and light themes, or a theme icon references, like `\\$(zap)`",
		"Icon path when a light theme is used",
		"Icon path when a dark theme is used",
		"Contributes menu items to the editor",
		"Proposed API, requires `enabledApiProposal: [\"{0}\"]` - {1}",
		"Contributes submenu items to the editor",
		"expected non-empty value.",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `icon` can be omitted or must be either a string or a literal like `{dark, light}`",
		"property `{0}` is mandatory and must be of type `string` or `object`",
		"property `{0}` is mandatory and must be of type `string`",
		"properties `{0}` and `{1}` are mandatory and must be of type `string`",
		"Identifier of the command to execute",
		"Title by which the command is represented in the UI",
		"(Optional) Short title by which the command is represented in the UI. Menus pick either `title` or `shortTitle` depending on the context in which they show commands.",
		"(Optional) Category string by which the command is grouped in the UI",
		"(Optional) Condition which must be true to enable the command in the UI (menu and keybindings). Does not prevent executing the command by other means, like the `executeCommand`-api.",
		"(Optional) Icon which is used to represent the command in the UI. Either a file path, an object with file paths for dark and light themes, or a theme icon references, like `\\$(zap)`",
		"Icon path when a light theme is used",
		"Icon path when a dark theme is used",
		"Contributes commands to the command palette.",
		"Command `{0}` appears multiple times in the `commands` section.",
		"`{0}` is not a valid submenu identifier",
		"The `{0}` submenu was already previously registered.",
		"`{0}` is not a valid submenu label",
		"`{0}` is not a valid menu identifier",
		"{0} is a proposed menu identifier. It requires 'package.json#enabledApiProposals: [\"{1}\"]' and is only available when running out of dev or with the following command line switch: --enable-proposed-api {2}",
		"Menu item references a command `{0}` which is not defined in the 'commands' section.",
		"Menu item references an alt-command `{0}` which is not defined in the 'commands' section.",
		"Menu item references the same command as default and alt-command",
		"Menu item references a submenu for a menu which doesn't have submenu support.",
		"Menu item references a submenu `{0}` which is not defined in the 'submenus' section.",
		"The `{0}` submenu was already contributed to the `{1}` menu."
	],
	"vs/workbench/services/authentication/browser/authenticationService": [
		"The id of the authentication provider.",
		"The human readable name of the authentication provider.",
		"Contributes authentication",
		"Loading...",
		"An authentication contribution must specify an id.",
		"An authentication contribution must specify a label.",
		"This authentication id '{0}' has already been registered",
		"Loading...",
		"Sign in requested",
		"The extension '{0}' wants to access the {1} account '{2}'.",
		"Allow",
		"Deny",
		"Cancel",
		"Sign in to another account",
		"The extension '{0}' wants to access a {1} account",
		"Select an account for '{0}' to use or Esc to cancel",
		"Grant access to {0} for {1}... (1)",
		"Sign in with {0} to use {1} (1)"
	],
	"vs/workbench/services/clipboard/browser/clipboardService": [
		"Unable to read from the browser's clipboard. Please make sure you have granted access for this website to read from the clipboard.",
		"Retry",
		"Learn More"
	],
	"vs/workbench/services/configuration/browser/configurationService": [
		"Contribute defaults for configurations",
		"Experiments"
	],
	"vs/workbench/services/configuration/common/configurationEditingService": [
		"Open Tasks Configuration",
		"Open Launch Configuration",
		"Open Settings",
		"Open Tasks Configuration",
		"Open Launch Configuration",
		"Save and Retry",
		"Save and Retry",
		"Open Settings",
		"Unable to write to {0} because {1} is not a registered configuration.",
		"Unable to write {0} to Workspace Settings. This setting can be written only into User settings.",
		"Unable to write {0} to Workspace Settings. This setting can be written only into User settings.",
		"Unable to write to Folder Settings because {0} does not support the folder resource scope.",
		"Unable to write to User Settings because {0} does not support for global scope.",
		"Unable to write to Workspace Settings because {0} does not support for workspace scope in a multi folder workspace.",
		"Unable to write to Folder Settings because no resource is provided.",
		"Unable to write to Language Settings because {0} is not a resource language setting.",
		"Unable to write to {0} because no workspace is opened. Please open a workspace first and try again.",
		"Unable to write into the tasks configuration file. Please open it to correct errors/warnings in it and try again.",
		"Unable to write into the launch configuration file. Please open it to correct errors/warnings in it and try again.",
		"Unable to write into user settings. Please open the user settings to correct errors/warnings in it and try again.",
		"Unable to write into remote user settings. Please open the remote user settings to correct errors/warnings in it and try again.",
		"Unable to write into workspace settings. Please open the workspace settings to correct errors/warnings in the file and try again.",
		"Unable to write into folder settings. Please open the '{0}' folder settings to correct errors/warnings in it and try again.",
		"Unable to write into tasks configuration file because the file has unsaved changes. Please save it first and then try again.",
		"Unable to write into launch configuration file because the file has unsaved changes. Please save it first and then try again.",
		"Unable to write into user settings because the file has unsaved changes. Please save the user settings file first and then try again.",
		"Unable to write into remote user settings because the file has unsaved changes. Please save the remote user settings file first and then try again.",
		"Unable to write into workspace settings because the file has unsaved changes. Please save the workspace settings file first and then try again.",
		"Unable to write into folder settings because the file has unsaved changes. Please save the '{0}' folder settings file first and then try again.",
		"Unable to write into tasks configuration file because the content of the file is newer.",
		"Unable to write into launch configuration file because the content of the file is newer.",
		"Unable to write into user settings because the content of the file is newer.",
		"Unable to write into remote user settings because the content of the file is newer.",
		"Unable to write into workspace settings because the content of the file is newer.",
		"Unable to write into folder settings because the content of the file is newer.",
		"Unable to write to {0} because of an internal error.",
		"User Settings",
		"Remote User Settings",
		"Workspace Settings",
		"Folder Settings"
	],
	"vs/workbench/services/configuration/common/jsonEditingService": [
		"Unable to write into the file. Please open the file to correct errors/warnings in the file and try again.",
		"Unable to write into the file because the file has unsaved changes. Please save the file and try again."
	],
	"vs/workbench/services/configurationResolver/browser/configurationResolverService": [
		"Cannot substitute command variable '{0}' because command did not return a result of type string.",
		"Variable '{0}' must be defined in an '{1}' section of the debug or task configuration.",
		"Input variable '{0}' is of type '{1}' and must include '{2}'.",
		"(Default)",
		"Cannot substitute input variable '{0}' because command '{1}' did not return a result of type string.",
		"Input variable '{0}' can only be of type 'promptString', 'pickString', or 'command'.",
		"Undefined input variable '{0}' encountered. Remove or define '{0}' to continue."
	],
	"vs/workbench/services/configurationResolver/common/configurationResolverSchema": [
		"The input's id is used to associate an input with a variable of the form ${input:id}.",
		"The type of user input prompt to use.",
		"The description is shown when the user is prompted for input.",
		"The default value for the input.",
		"User inputs. Used for defining user input prompts, such as free string input or a choice from several options.",
		"The 'promptString' type opens an input box to ask the user for input.",
		"Controls if a password input is shown. Password input hides the typed text.",
		"The 'pickString' type shows a selection list.",
		"An array of strings that defines the options for a quick pick.",
		"Label for the option.",
		"Value for the option.",
		"The 'command' type executes a command.",
		"The command to execute for this input variable.",
		"Optional arguments passed to the command.",
		"Optional arguments passed to the command.",
		"Optional arguments passed to the command."
	],
	"vs/workbench/services/configurationResolver/common/configurationResolverUtils": [
		"'env.', 'config.' and 'command.' are deprecated, use 'env:', 'config:' and 'command:' instead."
	],
	"vs/workbench/services/configurationResolver/common/variableResolver": [
		"Variable {0} can not be resolved. Please open an editor.",
		"Variable {0}: can not find workspace folder of '{1}'.",
		"Variable {0} can not be resolved. No such folder '{1}'.",
		"Variable {0} can not be resolved in a multi folder workspace. Scope this variable using ':' and a workspace folder name.",
		"Variable {0} can not be resolved. Please open a folder.",
		"Variable {0} can not be resolved because no environment variable name is given.",
		"Variable {0} can not be resolved because setting '{1}' not found.",
		"Variable {0} can not be resolved because '{1}' is a structured value.",
		"Variable {0} can not be resolved because no settings name is given.",
		"Variable {0} can not be resolved. UserHome path is not defined",
		"Variable {0} can not be resolved. Make sure to have a line selected in the active editor.",
		"Variable {0} can not be resolved. Make sure to have some text selected in the active editor.",
		"Variable {0} can not be resolved because the command has no value."
	],
	"vs/workbench/services/decorations/browser/decorationsService": [
		"Contains emphasized items"
	],
	"vs/workbench/services/dialogs/browser/abstractFileDialogService": [
		"Your changes will be lost if you don't save them.",
		"Do you want to save the changes you made to {0}?",
		"Do you want to save the changes to the following {0} files?",
		"&&Save All",
		"&&Save",
		"Do&&n't Save",
		"Cancel",
		"Open File Or Folder",
		"Open File",
		"Open Folder",
		"Open Workspace from File",
		"Workspace",
		"Save As",
		"Save As",
		"All Files",
		"No Extension"
	],
	"vs/workbench/services/dialogs/browser/fileDialogService": [
		"Can't open folders, try adding a folder to the workspace instead.",
		"Can't open folders, try adding a folder to the workspace instead.",
		"Can't open workspaces, try adding a folder to the workspace instead.",
		"Open Remote...",
		"Open Files...",
		"Learn More",
		"Open Remote...",
		"Learn More",
		"Local File System Access is Unsupported",
		"Your current browser doesn't support local file system access.\nYou can either open single files or open a remote repository."
	],
	"vs/workbench/services/dialogs/browser/simpleFileDialog": [
		"Open Local File...",
		"Save Local File...",
		"Open Local Folder...",
		"Open Local...",
		"File system provider for {0} is not available.",
		"Show Local",
		"The path does not exist.",
		"Cancel",
		"Please enter a valid path.",
		"The folder already exists. Please use a new file name.",
		"{0} already exists. Are you sure you want to overwrite it?",
		"Please enter a valid file name.",
		"Please enter a path that exists.",
		"Please enter a path that exists.",
		"Please start the path with a drive letter.",
		"Please select a file.",
		"Please select a folder."
	],
	"vs/workbench/services/editor/browser/editorResolverService": [
		"There are multiple default editors available for the resource.",
		"Configure Default",
		"Keep {0}",
		"Active",
		"Default",
		"Active and Default",
		"Configure default editor for '{0}'...",
		"Select new default editor for '{0}'",
		"Select editor for '{0}'"
	],
	"vs/workbench/services/editor/common/editorResolverService": [
		"Configure glob patterns to editors (e.g. `\"*.hex\": \"hexEditor.hexEdit\"`). These have precedence over the default behavior."
	],
	"vs/workbench/services/extensionManagement/browser/extensionBisect": [
		"Extension Bisect is active and has disabled 1 extension. Check if you can still reproduce the problem and proceed by selecting from these options.",
		"Extension Bisect is active and has disabled {0} extensions. Check if you can still reproduce the problem and proceed by selecting from these options.",
		"Start Extension Bisect",
		"Extension Bisect",
		"Extension Bisect will use binary search to find an extension that causes a problem. During the process the window reloads repeatedly (~{0} times). Each time you must confirm if you are still seeing problems.",
		"Start Extension Bisect",
		"Continue Extension Bisect",
		"Help",
		"Extension Bisect",
		"Extension Bisect is done but no extension has been identified. This might be a problem with {0}.",
		"Extension Bisect",
		"Report Issue & Continue",
		"Continue",
		"Extension Bisect is done and has identified {0} as the extension causing the problem.",
		"Keep this extension disabled",
		"Extension Bisect is active and has disabled {0} extensions. Check if you can still reproduce the problem and proceed by selecting from these options.",
		"Extension Bisect",
		"Good now",
		"This is bad",
		"Stop Bisect",
		"Cancel",
		"Stop Extension Bisect",
		"Help"
	],
	"vs/workbench/services/extensionManagement/browser/extensionEnablementService": [
		"All installed extensions are temporarily disabled.",
		"Reload and Enable Extensions",
		"Cannot change enablement of {0} extension because it contributes language packs.",
		"Cannot change enablement {0} extension because Settings Sync depends on it.",
		"Cannot change enablement of {0} extension because it is enabled in environment",
		"Cannot change enablement of {0} extension because it is disabled in environment",
		"Cannot change enablement of {0} extension because it does not support virtual workspaces",
		"Cannot change enablement of {0} extension because of its extension kind",
		"Cannot enable '{0}' extension because it depends on '{1}' extension that cannot be enabled",
		"No workspace.",
		"Cannot change enablement of {0} extension in workspace because it contributes authentication providers"
	],
	"vs/workbench/services/extensionManagement/browser/webExtensionsScannerService": [
		"Cannot add '{0}' because this extension is not a web extension.",
		"Open Installed Web Extensions Resource"
	],
	"vs/workbench/services/extensionManagement/common/extensionManagementServerService": [
		"Remote",
		"Browser"
	],
	"vs/workbench/services/extensionManagement/common/extensionManagementService": [
		"Cannot uninstall extension '{0}'. Extension '{1}' depends on this.",
		"Cannot uninstall extension '{0}'. Extensions '{1}' and '{2}' depend on this.",
		"Cannot uninstall extension '{0}'. Extensions '{1}', '{2}' and others depend on this.",
		"Installing Extension {0} failed: Manifest is not found.",
		"Cannot install the '{0}' extension because it is not available in this setup.",
		"Install Extension",
		"Install Extensions",
		"Install",
		"Install (Do not sync)",
		"Cancel",
		"Would you like to install and synchronize '{0}' extension across your devices?",
		"Would you like to install and synchronize extensions across your devices?",
		"Enabling this extension requires a trusted workspace.",
		"Trust Workspace & Install",
		"Install",
		"Learn More",
		"{0} for the Web",
		"'{0}' has limited functionality in {1}.",
		"Contains extensions which are not supported.",
		"Install Anyway",
		"Show Extensions",
		"Cancel",
		"Install Anyway",
		"Cancel",
		"'{0}' contains extensions which are not supported in {1}.",
		"Install Anyway",
		"Show Extensions",
		"Cancel"
	],
	"vs/workbench/services/extensionRecommendations/common/workspaceExtensionsConfig": [
		"Remove extension recommendation from",
		"Add extension recommendation to",
		"Remove extension recommendation from",
		"Add extension recommendation to",
		"Workspace Folder",
		"Workspace"
	],
	"vs/workbench/services/extensions/browser/extensionService": [
		"The following extensions contain dependency loops and have been disabled: {0}"
	],
	"vs/workbench/services/extensions/browser/extensionUrlHandler": [
		"Allow an extension to open this URI?",
		"Don't ask again for this extension.",
		"&&Open",
		"Extension '{0}' is not loaded. Would you like to reload the window to load the extension and open the URL?",
		"&&Reload Window and Open",
		"Extension '{0}' is disabled. Would you like to enable the extension and reload the window to open the URL?",
		"&&Enable and Open",
		"Extension '{0}' is not installed. Would you like to install the extension and reload the window to open this URL?",
		"&&Install",
		"Installing Extension '{0}'...",
		"Would you like to reload the window and open the URL '{0}'?",
		"Reload Window and Open",
		"Manage Authorized Extension URIs...",
		"Extensions",
		"There are currently no authorized extension URIs."
	],
	"vs/workbench/services/extensions/browser/webWorkerExtensionHost": [
		"Worker Extension Host"
	],
	"vs/workbench/services/extensions/common/abstractExtensionService": [
		"The following extensions contain dependency loops and have been disabled: {0}",
		"No extension host found that can launch the test runner at {0}."
	],
	"vs/workbench/services/extensions/common/extensionHostManager": [
		"Measure Extension Host Latency"
	],
	"vs/workbench/services/extensions/common/extensionPoints": [
		"Invalid manifest file {0}: Not an JSON object.",
		"Failed to parse {0}: [{1}, {2}] {3}.",
		"Cannot read file {0}: {1}.",
		"Failed to parse {0}: {1}.",
		"Invalid format {0}: JSON object expected.",
		"Couldn't find message for key {0}.",
		"Extension version is not semver compatible.",
		"Got empty extension description",
		"property publisher must be of type `string`.",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `object`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string[]`",
		"property `{0}` can be omitted or must be of type `string[]`",
		"properties `{0}` and `{1}` must both be specified or must both be omitted",
		"property `{0}` can be defined only if property `main` is also defined.",
		"property `{0}` can be omitted or must be of type `string`",
		"Expected `main` ({0}) to be included inside extension's folder ({1}). This might make the extension non-portable.",
		"properties `{0}` and `{1}` must both be specified or must both be omitted",
		"property `{0}` can be omitted or must be of type `string`",
		"Expected `browser` ({0}) to be included inside extension's folder ({1}). This might make the extension non-portable.",
		"properties `{0}` and `{1}` must both be specified or must both be omitted"
	],
	"vs/workbench/services/extensions/common/extensionsRegistry": [
		"UI extension kind. In a remote window, such extensions are enabled only when available on the local machine.",
		"Workspace extension kind. In a remote window, such extensions are enabled only when available on the remote.",
		"Engine compatibility.",
		"For VS Code extensions, specifies the VS Code version that the extension is compatible with. Cannot be *. For example: ^0.10.5 indicates compatibility with a minimum VS Code version of 0.10.5.",
		"The publisher of the VS Code extension.",
		"The display name for the extension used in the VS Code gallery.",
		"The categories used by the VS Code gallery to categorize the extension.",
		"Use 'Programming  Languages' instead",
		"Banner used in the VS Code marketplace.",
		"The banner color on the VS Code marketplace page header.",
		"The color theme for the font used in the banner.",
		"All contributions of the VS Code extension represented by this package.",
		"Sets the extension to be flagged as a Preview in the Marketplace.",
		"Use `enabledApiProposals` instead.",
		"Enable API proposals to try them out. Only valid **during development**. Extensions **cannot be published** with this property. For more details visit: https://code.visualstudio.com/api/advanced-topics/using-proposed-api",
		"Activation events for the VS Code extension.",
		"An activation event emmited when a webview is loaded of a certain viewType",
		"An activation event emitted whenever a file that resolves to the specified language gets opened.",
		"An activation event emitted whenever the specified command gets invoked.",
		"An activation event emitted whenever a user is about to start debugging or about to setup debug configurations.",
		"An activation event emitted whenever a \"launch.json\" needs to be created (and all provideDebugConfigurations methods need to be called).",
		"An activation event emitted whenever a list of all debug configurations needs to be created (and all provideDebugConfigurations methods for the \"dynamic\" scope need to be called).",
		"An activation event emitted whenever a debug session with the specific type is about to be launched (and a corresponding resolveDebugConfiguration method needs to be called).",
		"An activation event emitted whenever a debug session with the specific type is about to be launched and a debug protocol tracker might be needed.",
		"An activation event emitted whenever a folder is opened that contains at least a file matching the specified glob pattern.",
		"An activation event emitted after the start-up finished (after all `*` activated extensions have finished activating).",
		"An activation event emitted whenever tasks of a certain type need to be listed or resolved.",
		"An activation event emitted whenever a file or folder is accessed with the given scheme.",
		"An activation event emitted whenever a search is started in the folder with the given scheme.",
		"An activation event emitted whenever the specified view is expanded.",
		"An activation event emitted whenever the specified user identity.",
		"An activation event emitted whenever a system-wide Uri directed towards this extension is open.",
		"An activation event emitted whenever a external uri (such as an http or https link) is being opened.",
		"An activation event emitted whenever the specified custom editor becomes visible.",
		"An activation event emitted whenever the specified notebook document is opened.",
		"An activation event emitted whenever sessions are requested from the specified authentication provider.",
		"An activation event emitted whenever a notebook output renderer is used.",
		"An activation event emitted when a specific terminal profile is launched.",
		"An activation event emitted when a specified walkthrough is opened.",
		"An activation event emitted on VS Code startup. To ensure a great end user experience, please use this activation event in your extension only when no other activation events combination works in your use-case.",
		"Array of badges to display in the sidebar of the Marketplace's extension page.",
		"Badge image URL.",
		"Badge link.",
		"Badge description.",
		"Controls the Markdown rendering engine used in the Marketplace. Either github (default) or standard.",
		"Controls the Q&A link in the Marketplace. Set to marketplace to enable the default Marketplace Q & A site. Set to a string to provide the URL of a custom Q & A site. Set to false to disable Q & A altogether.",
		"Dependencies to other extensions. The identifier of an extension is always ${publisher}.${name}. For example: vscode.csharp.",
		"A set of extensions that can be installed together. The identifier of an extension is always ${publisher}.${name}. For example: vscode.csharp.",
		"Define the kind of an extension. `ui` extensions are installed and run on the local machine while `workspace` extensions run on the remote.",
		"Define an extension which can run only on the local machine when connected to remote window.",
		"Define an extension which can run only on the remote machine when connected remote window.",
		"Define an extension which can run on either side, with a preference towards running on the local machine.",
		"Define an extension which can run on either side, with a preference towards running on the remote machine.",
		"Define an extension which cannot run in a remote context, neither on the local, nor on the remote machine.",
		"Declare the set of supported capabilities by the extension.",
		"Declares whether the extension should be enabled in virtual workspaces. A virtual workspace is a workspace which is not backed by any on-disk resources. When false, this extension will be automatically disabled in virtual workspaces. Default is true.",
		"Declares the level of support for virtual workspaces by the extension.",
		"The extension will be enabled in virtual workspaces with some functionality disabled.",
		"The extension will be enabled in virtual workspaces with all functionality enabled.",
		"The extension will not be enabled in virtual workspaces.",
		"A description of how virtual workspaces affects the extensions behavior and why it is needed. This only applies when `supported` is not `true`.",
		"Declares how the extension should be handled in untrusted workspaces.",
		"Declares the level of support for untrusted workspaces by the extension.",
		"The extension will be enabled in untrusted workspaces with some functionality disabled.",
		"The extension will be enabled in untrusted workspaces with all functionality enabled.",
		"The extension will not be enabled in untrusted workspaces.",
		"A list of configuration keys contributed by the extension that should not use workspace values in untrusted workspaces.",
		"A description of how workspace trust affects the extensions behavior and why it is needed. This only applies when `supported` is not `true`.",
		"Script executed before the package is published as a VS Code extension.",
		"Uninstall hook for VS Code extension. Script that gets executed when the extension is completely uninstalled from VS Code which is when VS Code is restarted (shutdown and start) after the extension is uninstalled. Only Node scripts are supported.",
		"The path to a 128x128 pixel icon.",
		"Use `extensionEnabledApiProposals` instead.",
		"API proposals that the respective extensions can freely use."
	],
	"vs/workbench/services/extensions/common/extensionsUtil": [
		"Overwriting extension {0} with {1}.",
		"Overwriting extension {0} with {1}.",
		"Loading development extension at {0}"
	],
	"vs/workbench/services/extensions/common/remoteExtensionHost": [
		"Remote Extension Host"
	],
	"vs/workbench/services/history/browser/historyService": [
		"Whether it is possible to navigate back in editor history",
		"Whether it is possible to navigate forward in editor history",
		"Whether it is possible to navigate back in editor navigation locations history",
		"Whether it is possible to navigate forward in editor navigation locations history",
		"Whether it is possible to navigate to the last editor navigation location",
		"Whether it is possible to navigate back in editor edit locations history",
		"Whether it is possible to navigate forward in editor edit locations history",
		"Whether it is possible to navigate to the last editor edit location",
		"Whether it is possible to reopen the last closed editor"
	],
	"vs/workbench/services/host/browser/browserHostService": [
		"The browser interrupted the opening of a new tab or window. Press 'Open' to open it anyway.",
		"Open",
		"Cancel"
	],
	"vs/workbench/services/keybinding/browser/keybindingService": [
		"expected non-empty value.",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"property `{0}` can be omitted or must be of type `string`",
		"Identifier of the command to run when keybinding is triggered.",
		"Arguments to pass to the command to execute.",
		"Key or key sequence (separate keys with plus-sign and sequences with space, e.g. Ctrl+O and Ctrl+L L for a chord).",
		"Mac specific key or key sequence.",
		"Linux specific key or key sequence.",
		"Windows specific key or key sequence.",
		"Condition when the key is active.",
		"Contributes keybindings.",
		"Invalid `contributes.{0}`: {1}",
		"Here are other available commands: ",
		"Keybindings configuration",
		"Key or key sequence (separated by space)",
		"Name of the command to execute",
		"Condition when the key is active.",
		"Arguments to pass to the command to execute.",
		"Keyboard",
		"Controls the dispatching logic for key presses to use either `code` (recommended) or `keyCode`."
	],
	"vs/workbench/services/keybinding/browser/keyboardLayoutService": [
		"Keyboard",
		"Control the keyboard layout used in web."
	],
	"vs/workbench/services/keybinding/common/keybindingEditing": [
		"Unable to write because the keybindings configuration file has unsaved changes. Please save it first and then try again.",
		"Unable to write to the keybindings configuration file. Please open it to correct errors/warnings in the file and try again.",
		"Unable to write to the keybindings configuration file. It has an object which is not of type Array. Please open the file to clean up and try again.",
		"Place your key bindings in this file to override the defaults"
	],
	"vs/workbench/services/label/common/labelService": [
		"Contributes resource label formatting rules.",
		"URI scheme on which to match the formatter on. For example \"file\". Simple glob patterns are supported.",
		"URI authority on which to match the formatter on. Simple glob patterns are supported.",
		"Rules for formatting uri resource labels.",
		"Label rules to display. For example: myLabel:/${path}. ${path}, ${scheme} and ${authority} are supported as variables.",
		"Separator to be used in the uri label display. '/' or '' as an example.",
		"Controls whether `${path}` substitutions should have starting separator characters stripped.",
		"Controls if the start of the uri label should be tildified when possible.",
		"Suffix appended to the workspace label.",
		"Untitled (Workspace)",
		"{0} (Workspace)",
		"{0} (Workspace)"
	],
	"vs/workbench/services/language/common/languageService": [
		"Contributes language declarations.",
		"ID of the language.",
		"Name aliases for the language.",
		"File extensions associated to the language.",
		"File names associated to the language.",
		"File name glob patterns associated to the language.",
		"Mime types associated to the language.",
		"A regular expression matching the first line of a file of the language.",
		"A relative path to a file containing configuration options for the language.",
		"A icon to use as file icon, if no icon theme provides one for the language.",
		"Icon path when a light theme is used",
		"Icon path when a dark theme is used",
		"Invalid `contributes.{0}`. Expected an array.",
		"Empty value for `contributes.{0}`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted and must be of type `string[]`",
		"property `{0}` can be omitted and must be of type `string[]`",
		"property `{0}` can be omitted and must be of type `string`",
		"property `{0}` can be omitted and must be of type `string`",
		"property `{0}` can be omitted and must be of type `string[]`",
		"property `{0}` can be omitted and must be of type `string[]`",
		"property `{0}` can be omitted and must be of type `object` with properties `{1}` and `{2}` of type `string`"
	],
	"vs/workbench/services/lifecycle/browser/lifecycleService": [
		"Changes that you made may not be saved. Please check press 'Cancel' and try again."
	],
	"vs/workbench/services/notification/common/notificationService": [
		"Don't Show Again",
		"Don't Show Again"
	],
	"vs/workbench/services/preferences/browser/keybindingsEditorInput": [
		"Keyboard Shortcuts"
	],
	"vs/workbench/services/preferences/browser/keybindingsEditorModel": [
		"Default",
		"Extension",
		"User",
		"{0}: {1}",
		"{0}: {1}",
		"option",
		"meta"
	],
	"vs/workbench/services/preferences/browser/preferencesService": [
		"Open a folder or workspace first to create workspace or folder settings.",
		"Place your key bindings in this file to override the defaults",
		"Default Keybindings",
		"Default Keybindings",
		"Unable to create '{0}' ({1})."
	],
	"vs/workbench/services/preferences/common/preferencesEditorInput": [
		"Settings"
	],
	"vs/workbench/services/preferences/common/preferencesModels": [
		"Commonly Used",
		"Override key bindings by placing them into your key bindings file."
	],
	"vs/workbench/services/preferences/common/preferencesValidation": [
		"Incorrect type. Expected \"boolean\".",
		"Value must be a number.",
		"The enum options should be strings, but there is a non-string option. Please file an issue with the extension author.",
		"Incorrect type. Expected \"string\".",
		"Setting has an invalid type, expected {0}. Fix in JSON.",
		"Value must be {0} or fewer characters long.",
		"Value must be {0} or more characters long.",
		"Value must match regex `{0}`.",
		"Invalid color format. Use #RGB, #RGBA, #RRGGBB or #RRGGBBAA.",
		"URI expected.",
		"URI is expected.",
		"URI with a scheme is expected.",
		"Value is not accepted. Valid values: {0}.",
		"Value must be strictly less than {0}.",
		"Value must be strictly greater than {0}.",
		"Value must be less than or equal to {0}.",
		"Value must be greater than or equal to {0}.",
		"Value must be a multiple of {0}.",
		"Value must be an integer.",
		"Incorrect type. Expected an array.",
		"Array has duplicate items",
		"Array must have at least {0} items",
		"Array must have at most {0} items",
		"Incorrect type. Expected a string array.",
		"Value {0} must match regex {1}.",
		"Value {0} is not one of {1}",
		"Incorrect type. Expected an object.",
		"Property {0} is not allowed.\n"
	],
	"vs/workbench/services/progress/browser/progressService": [
		"{0}: {1}",
		"[{0}] {1}: {2}",
		"[{0}]: {1}",
		"[{0}]: {1}",
		"Progress Message",
		"Cancel",
		"Cancel",
		"Dismiss"
	],
	"vs/workbench/services/remote/browser/remoteAgentService": [
		"An unexpected error occurred that requires a reload of this page.",
		"Reload",
		"The workbench failed to connect to the server (Error: {0})"
	],
	"vs/workbench/services/remote/common/remoteExplorerService": [
		"User Forwarded",
		"Auto Forwarded",
		"Local port {0} could not be used for forwarding to remote port {1}.\n\nThis usually happens when there is already another process using local port {0}.\n\nPort number {2} has been used instead.",
		"Statically Forwarded"
	],
	"vs/workbench/services/search/browser/searchService": [
		"Unable to search with Web Worker text searcher",
		"Unable to search with Web Worker file searcher"
	],
	"vs/workbench/services/search/common/queryBuilder": [
		"Workspace folder does not exist: {0}"
	],
	"vs/workbench/services/textMate/browser/abstractTextMateService": [
		"Already Logging.",
		"Stop",
		"Preparing to log TM Grammar parsing. Press Stop when finished.",
		"Now logging TM Grammar parsing. Press Stop when finished.",
		"Unknown language in `contributes.{0}.language`. Provided value: {1}",
		"Expected string in `contributes.{0}.scopeName`. Provided value: {1}",
		"Expected string in `contributes.{0}.path`. Provided value: {1}",
		"Invalid value in `contributes.{0}.injectTo`. Must be an array of language scope names. Provided value: {1}",
		"Invalid value in `contributes.{0}.embeddedLanguages`. Must be an object map from scope name to language. Provided value: {1}",
		"Invalid value in `contributes.{0}.tokenTypes`. Must be an object map from scope name to token type. Provided value: {1}",
		"Expected `contributes.{0}.path` ({1}) to be included inside extension's folder ({2}). This might make the extension non-portable."
	],
	"vs/workbench/services/textMate/common/TMGrammarFactory": [
		"No TM Grammar registered for this language.",
		"No TM Grammar registered for this language."
	],
	"vs/workbench/services/textMate/common/TMGrammars": [
		"Contributes textmate tokenizers.",
		"Language identifier for which this syntax is contributed to.",
		"Textmate scope name used by the tmLanguage file.",
		"Path of the tmLanguage file. The path is relative to the extension folder and typically starts with './syntaxes/'.",
		"A map of scope name to language id if this grammar contains embedded languages.",
		"A map of scope name to token types.",
		"List of language scope names to which this grammar is injected to."
	],
	"vs/workbench/services/textfile/browser/textFileService": [
		"Text File Model Decorations",
		"Deleted, Read Only",
		"Read Only",
		"Deleted",
		"File seems to be binary and cannot be opened as text",
		"'{0}' already exists. Do you want to replace it?",
		"A file or folder with the name '{0}' already exists in the folder '{1}'. Replacing it will overwrite its current contents.",
		"&&Replace"
	],
	"vs/workbench/services/textfile/common/textFileEditorModelManager": [
		"Failed to save '{0}': {1}"
	],
	"vs/workbench/services/textfile/common/textFileSaveParticipant": [
		"Saving '{0}'"
	],
	"vs/workbench/services/themes/browser/fileIconThemeData": [
		"Problems parsing file icons file: {0}",
		"Invalid format for file icons theme file: Object expected."
	],
	"vs/workbench/services/themes/browser/productIconThemeData": [
		"Problems processing product icons definitions in {0}:\n{1}",
		"Default",
		"Problems parsing product icons file: {0}",
		"Invalid format for product icons theme file: Object expected.",
		"Invalid format for product icons theme file: Must contain iconDefinitions and fonts.",
		"Invalid font weight in font '{0}'. Ignoring setting.",
		"Invalid font style in font '{0}'. Ignoring setting.",
		"Invalid font source in font '{0}'. Ignoring source.",
		"No valid font source in font '{0}'. Ignoring font definition.",
		"Missing or invalid font id '{0}'. Skipping font definition.",
		"Skipping icon definition '{0}'. Unknown font.",
		"Skipping icon definition '{0}'. Unknown fontCharacter."
	],
	"vs/workbench/services/themes/browser/workbenchThemeService": [
		"Unable to load {0}: {1}"
	],
	"vs/workbench/services/themes/common/colorExtensionPoint": [
		"Contributes extension defined themable colors",
		"The identifier of the themable color",
		"Identifiers must only contain letters, digits and dots and can not start with a dot",
		"The description of the themable color",
		"The default color for light themes. Either a color value in hex (#RRGGBB[AA]) or the identifier of a themable color which provides the default.",
		"The default color for dark themes. Either a color value in hex (#RRGGBB[AA]) or the identifier of a themable color which provides the default.",
		"The default color for high contrast themes. Either a color value in hex (#RRGGBB[AA]) or the identifier of a themable color which provides the default.",
		"'configuration.colors' must be a array",
		"{0} must be either a color value in hex (#RRGGBB[AA] or #RGB[A]) or the identifier of a themable color which provides the default.",
		"'configuration.colors.id' must be defined and can not be empty",
		"'configuration.colors.id' must only contain letters, digits and dots and can not start with a dot",
		"'configuration.colors.description' must be defined and can not be empty",
		"'configuration.colors.defaults' must be defined and must contain 'light', 'dark' and 'highContrast'"
	],
	"vs/workbench/services/themes/common/colorThemeData": [
		"Problems parsing JSON theme file: {0}",
		"Invalid format for JSON theme file: Object expected.",
		"Problem parsing color theme file: {0}. Property 'colors' is not of type 'object'.",
		"Problem parsing color theme file: {0}. Property 'tokenColors' should be either an array specifying colors or a path to a TextMate theme file",
		"Problem parsing color theme file: {0}. Property 'semanticTokenColors' contains a invalid selector",
		"Problem parsing tmTheme file: {0}. 'settings' is not array.",
		"Problems parsing tmTheme file: {0}",
		"Problems loading tmTheme file {0}: {1}"
	],
	"vs/workbench/services/themes/common/colorThemeSchema": [
		"Colors and styles for the token.",
		"Foreground color for the token.",
		"Token background colors are currently not supported.",
		"Font style of the rule: 'italic', 'bold', 'underline', 'strikethrough' or a combination. The empty string unsets inherited settings.",
		"Font style must be 'italic', 'bold', 'underline', 'strikethrough' or a combination or the empty string.",
		"None (clear inherited style)",
		"Description of the rule.",
		"Scope selector against which this rule matches.",
		"Colors in the workbench",
		"Path to a tmTheme file (relative to the current file).",
		"Colors for syntax highlighting",
		"Whether semantic highlighting should be enabled for this theme.",
		"Colors for semantic tokens"
	],
	"vs/workbench/services/themes/common/fileIconThemeSchema": [
		"The folder icon for expanded folders. The expanded folder icon is optional. If not set, the icon defined for folder will be shown.",
		"The folder icon for collapsed folders, and if folderExpanded is not set, also for expanded folders.",
		"The default file icon, shown for all files that don't match any extension, filename or language id.",
		"Associates folder names to icons. The object key is the folder name, not including any path segments. No patterns or wildcards are allowed. Folder name matching is case insensitive.",
		"The ID of the icon definition for the association.",
		"Associates folder names to icons for expanded folders. The object key is the folder name, not including any path segments. No patterns or wildcards are allowed. Folder name matching is case insensitive.",
		"The ID of the icon definition for the association.",
		"Associates file extensions to icons. The object key is the file extension name. The extension name is the last segment of a file name after the last dot (not including the dot). Extensions are compared case insensitive.",
		"The ID of the icon definition for the association.",
		"Associates file names to icons. The object key is the full file name, but not including any path segments. File name can include dots and a possible file extension. No patterns or wildcards are allowed. File name matching is case insensitive.",
		"The ID of the icon definition for the association.",
		"Associates languages to icons. The object key is the language id as defined in the language contribution point.",
		"The ID of the icon definition for the association.",
		"Fonts that are used in the icon definitions.",
		"The ID of the font.",
		"The ID must only contain letter, numbers, underscore and minus.",
		"The location of the font.",
		"The font path, relative to the current file icon theme file.",
		"The format of the font.",
		"The weight of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight for valid values.",
		"The style of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-style for valid values.",
		"The default size of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-size for valid values.",
		"Description of all icons that can be used when associating files to icons.",
		"An icon definition. The object key is the ID of the definition.",
		"When using a SVG or PNG: The path to the image. The path is relative to the icon set file.",
		"When using a glyph font: The character in the font to use.",
		"When using a glyph font: The color to use.",
		"When using a font: The font size in percentage to the text font. If not set, defaults to the size in the font definition.",
		"When using a font: The id of the font. If not set, defaults to the first font definition.",
		"Optional associations for file icons in light color themes.",
		"Optional associations for file icons in high contrast color themes.",
		"Configures whether the file explorer's arrows should be hidden when this theme is active.",
		"Configures whether the default language icons should be used if the theme does not define an icon for a language."
	],
	"vs/workbench/services/themes/common/iconExtensionPoint": [
		"Contributes extension defined themable icons",
		"The identifier of the themable icon",
		"Identifiers can only contain letters, digits and minuses and need to consist of at least two segments in the form `component-iconname`.",
		"The description of the themable icon",
		"The path of the icon font that defines the icon.",
		"The character for the icon in the icon font.",
		"The default of the icon. Either a reference to an extisting ThemeIcon or an icon in an icon font.",
		"'configuration.icons' must be an object with the icon names as properties.",
		"'configuration.icons' keys represent the icon id and can only contain letter, digits and minuses. They need to consist of at least two segments in the form `component-iconname`.",
		"'configuration.icons.description' must be defined and can not be empty",
		"Expected `contributes.icons.default.fontPath` to have file extension 'woff', woff2' or 'ttf', is '{0}'.",
		"Expected `contributes.icons.default.fontPath` ({0}) to be included inside extension's folder ({0}).",
		"'configuration.icons.default' must be either a reference to the id of an other theme icon (string) or a icon definition (object) with properties `fontPath` and `fontCharacter`."
	],
	"vs/workbench/services/themes/common/productIconThemeSchema": [
		"The ID of the font.",
		"The ID must only contain letters, numbers, underscore and minus.",
		"The location of the font.",
		"The font path, relative to the current product icon theme file.",
		"The format of the font.",
		"The weight of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight for valid values.",
		"The style of the font. See https://developer.mozilla.org/en-US/docs/Web/CSS/font-style for valid values.",
		"Association of icon name to a font character."
	],
	"vs/workbench/services/themes/common/themeConfiguration": [
		"Specifies the color theme used in the workbench.",
		"Theme is unknown or not installed.",
		"Specifies the preferred color theme for dark OS appearance when `#{0}#` is enabled.",
		"Theme is unknown or not installed.",
		"Specifies the preferred color theme for light OS appearance when `#{0}#` is enabled.",
		"Theme is unknown or not installed.",
		"Specifies the preferred color theme used in high contrast mode when `#{0}#` is enabled.",
		"Theme is unknown or not installed.",
		"If set, automatically switch to the preferred color theme based on the OS appearance. If the OS appearance is dark, the theme specified at `#{0}#` is used, for light `#{1}#`.",
		"Overrides colors from the currently selected color theme.",
		"Specifies the file icon theme used in the workbench or 'null' to not show any file icons.",
		"None",
		"No file icons",
		"File icon theme is unknown or not installed.",
		"Specifies the product icon theme used.",
		"Default",
		"Default",
		"Product icon theme is unknown or not installed.",
		"If enabled, will automatically change to high contrast theme if the OS is using a high contrast theme. The high contrast theme to use is specified by `#{0}#`",
		"Sets the colors and styles for comments",
		"Sets the colors and styles for strings literals.",
		"Sets the colors and styles for keywords.",
		"Sets the colors and styles for number literals.",
		"Sets the colors and styles for type declarations and references.",
		"Sets the colors and styles for functions declarations and references.",
		"Sets the colors and styles for variables declarations and references.",
		"Sets colors and styles using textmate theming rules (advanced).",
		"Whether semantic highlighting should be enabled for this theme.",
		"Use `enabled` in `editor.semanticTokenColorCustomizations` setting instead.",
		"Use `enabled` in `#editor.semanticTokenColorCustomizations#` setting instead.",
		"Overrides editor syntax colors and font style from the currently selected color theme.",
		"Whether semantic highlighting is enabled or disabled for this theme",
		"Semantic token styling rules for this theme.",
		"Overrides editor semantic token color and styles from the currently selected color theme."
	],
	"vs/workbench/services/themes/common/themeExtensionPoints": [
		"Contributes textmate color themes.",
		"Id of the color theme as used in the user settings.",
		"Label of the color theme as shown in the UI.",
		"Base theme defining the colors around the editor: 'vs' is the light color theme, 'vs-dark' is the dark color theme. 'hc-black' is the dark high contrast theme.",
		"Path of the tmTheme file. The path is relative to the extension folder and is typically './colorthemes/awesome-color-theme.json'.",
		"Contributes file icon themes.",
		"Id of the file icon theme as used in the user settings.",
		"Label of the file icon theme as shown in the UI.",
		"Path of the file icon theme definition file. The path is relative to the extension folder and is typically './fileicons/awesome-icon-theme.json'.",
		"Contributes product icon themes.",
		"Id of the product icon theme as used in the user settings.",
		"Label of the product icon theme as shown in the UI.",
		"Path of the product icon theme definition file. The path is relative to the extension folder and is typically './producticons/awesome-product-icon-theme.json'.",
		"Extension point `{0}` must be an array.",
		"Expected string in `contributes.{0}.path`. Provided value: {1}",
		"Expected string in `contributes.{0}.id`. Provided value: {1}",
		"Expected `contributes.{0}.path` ({1}) to be included inside extension's folder ({2}). This might make the extension non-portable."
	],
	"vs/workbench/services/themes/common/tokenClassificationExtensionPoint": [
		"Contributes semantic token types.",
		"The identifier of the semantic token type",
		"Identifiers should be in the form letterOrDigit[_-letterOrDigit]*",
		"The super type of the semantic token type",
		"Super types should be in the form letterOrDigit[_-letterOrDigit]*",
		"The description of the semantic token type",
		"Contributes semantic token modifiers.",
		"The identifier of the semantic token modifier",
		"Identifiers should be in the form letterOrDigit[_-letterOrDigit]*",
		"The description of the semantic token modifier",
		"Contributes semantic token scope maps.",
		"Lists the languge for which the defaults are.",
		"Maps a semantic token (described by semantic token selector) to one or more textMate scopes used to represent that token.",
		"'configuration.{0}.id' must be defined and can not be empty",
		"'configuration.{0}.id' must follow the pattern letterOrDigit[-_letterOrDigit]*",
		"'configuration.{0}.superType' must follow the pattern letterOrDigit[-_letterOrDigit]*",
		"'configuration.{0}.description' must be defined and can not be empty",
		"'configuration.semanticTokenType' must be an array",
		"'configuration.semanticTokenModifier' must be an array",
		"'configuration.semanticTokenScopes' must be an array",
		"'configuration.semanticTokenScopes.language' must be a string",
		"'configuration.semanticTokenScopes.scopes' must be defined as an object",
		"'configuration.semanticTokenScopes.scopes' values must be an array of strings",
		"configuration.semanticTokenScopes.scopes': Problems parsing selector {0}."
	],
	"vs/workbench/services/userDataSync/browser/userDataSyncWorkbenchService": [
		"Settings sync cannot be turned on because there are no authentication providers available.",
		"No account available",
		"No account available",
		"show log",
		"{0} is turned on",
		"Settings Sync is being turned on. Would you like to cancel it?",
		"Settings Sync",
		"&&Yes",
		"&&No",
		"Turning on...",
		"Syncing {0}...",
		"Conflicts Detected",
		"Merge Manually...",
		"Unable to merge due to conflicts. Please merge manually to continue...",
		"Merge or Replace",
		"Merge",
		"Replace Local",
		"Merge Manually...",
		"Cancel",
		"It looks like you last synced from another machine.\nWould you like to merge or replace with your data in the cloud?",
		"This will clear your data in the cloud and stop sync on all your devices.",
		"Clear",
		"&&Reset",
		"Select an account to sign in",
		"Signed in",
		"Last Used with Sync",
		"Others",
		"Sign in with {0}",
		"Settings sync is suspended because of successive authorization failures. Please sign in again to continue synchronizing",
		"Sign in"
	],
	"vs/workbench/services/userDataSync/common/userDataSync": [
		"Settings",
		"Keyboard Shortcuts",
		"User Snippets",
		"User Tasks",
		"Extensions",
		"UI State",
		"Settings Sync",
		"View icon of the Settings Sync view."
	],
	"vs/workbench/services/views/browser/viewDescriptorService": [
		"Hide '{0}'",
		"Reset Location"
	],
	"vs/workbench/services/workingCopy/common/fileWorkingCopyManager": [
		"File Working Copy Decorations",
		"Deleted, Read Only",
		"Read Only",
		"Deleted",
		"'{0}' already exists. Do you want to replace it?",
		"A file or folder with the name '{0}' already exists in the folder '{1}'. Replacing it will overwrite its current contents.",
		"&&Replace"
	],
	"vs/workbench/services/workingCopy/common/storedFileWorkingCopy": [
		"Failed to save '{0}': The content of the file is newer. Do you want to overwrite the file with your changes?",
		"Overwrite",
		"Discard",
		"Overwrite as Admin...",
		"Overwrite as Sudo...",
		"Retry as Admin...",
		"Retry as Sudo...",
		"Overwrite",
		"Retry",
		"Save As...",
		"Discard",
		"Failed to save '{0}': File is read-only. Select 'Overwrite as Admin' to retry as administrator.",
		"Failed to save '{0}': File is read-only. Select 'Overwrite as Sudo' to retry as superuser.",
		"Failed to save '{0}': File is read-only. Select 'Overwrite' to attempt to make it writeable.",
		"Failed to save '{0}': Insufficient permissions. Select 'Retry as Admin' to retry as administrator.",
		"Failed to save '{0}': Insufficient permissions. Select 'Retry as Sudo' to retry as superuser.",
		"Failed to save '{0}': {1}"
	],
	"vs/workbench/services/workingCopy/common/storedFileWorkingCopySaveParticipant": [
		"Saving '{0}'"
	],
	"vs/workbench/services/workspaces/browser/abstractWorkspaceEditingService": [
		"Save",
		"Save Workspace",
		"Unable to write into workspace configuration file. Please open the file to correct errors/warnings in it and try again.",
		"Unable to write into workspace configuration file because the file has unsaved changes. Please save it and try again.",
		"Open Workspace Configuration"
	],
	"vs/workbench/services/workspaces/browser/workspaceTrustEditorInput": [
		"Workspace Trust"
	]
});